//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    token(userLogin: UserLoginDTO): Observable<UserTokenDTO> {
        let url_ = this.baseUrl + "/Token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userLogin);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTokenDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTokenDTO>;
        }));
    }

    protected processToken(response: HttpResponseBase): Observable<UserTokenDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTokenDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AutomaticParkingReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchAutomaticParkingReportData(reportParameterDto: AutomaticParkingReportParameterDTO, clientId: number | null | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfAutomaticParkingReportDTO> {
        let url_ = this.baseUrl + "/api/Reports/SearchAutomaticParkingReportData?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAutomaticParkingReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAutomaticParkingReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfAutomaticParkingReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfAutomaticParkingReportDTO>;
        }));
    }

    protected processSearchAutomaticParkingReportData(response: HttpResponseBase): Observable<PagedResultDTOOfAutomaticParkingReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfAutomaticParkingReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAutomaticParkingReport(saveReport: boolean | undefined, reportParameterDto: AutomaticParkingReportParameterDTO, clientId: number | null | undefined): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/Reports/ExportAutomaticParkingReport?";
        if (saveReport === null)
            throw new globalThis.Error("The parameter 'saveReport' cannot be null.");
        else if (saveReport !== undefined)
            url_ += "saveReport=" + encodeURIComponent("" + saveReport) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAutomaticParkingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAutomaticParkingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processExportAutomaticParkingReport(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AutomaticParkingScheduleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchAutomaticParkingSchedules(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfAutomaticParkingScheduleDTO> {
        let url_ = this.baseUrl + "/api/AutomaticParkingSchedule/SearchAutomaticParkingSchedules?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAutomaticParkingSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAutomaticParkingSchedules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfAutomaticParkingScheduleDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfAutomaticParkingScheduleDTO>;
        }));
    }

    protected processSearchAutomaticParkingSchedules(response: HttpResponseBase): Observable<PagedResultDTOOfAutomaticParkingScheduleDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfAutomaticParkingScheduleDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAutomaticParkingSchedule(parkingSchedule: CreateAutomaticParkingScheduleDTO): Observable<AutomaticParkingScheduleDTO> {
        let url_ = this.baseUrl + "/api/AutomaticParkingSchedule/CreateAutomaticParkingSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parkingSchedule);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAutomaticParkingSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAutomaticParkingSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutomaticParkingScheduleDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutomaticParkingScheduleDTO>;
        }));
    }

    protected processCreateAutomaticParkingSchedule(response: HttpResponseBase): Observable<AutomaticParkingScheduleDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutomaticParkingScheduleDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAutomaticParkingSchedule(parkingSchedule: UpdateAutomaticParkingScheduleDTO): Observable<AutomaticParkingScheduleDTO> {
        let url_ = this.baseUrl + "/api/AutomaticParkingSchedule/UpdateAutomaticParkingSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parkingSchedule);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAutomaticParkingSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAutomaticParkingSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutomaticParkingScheduleDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutomaticParkingScheduleDTO>;
        }));
    }

    protected processUpdateAutomaticParkingSchedule(response: HttpResponseBase): Observable<AutomaticParkingScheduleDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutomaticParkingScheduleDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAutomaticParkingScheduleActiveStatus(parkingScheduleId: number | undefined, isActive: boolean | undefined): Observable<AutomaticParkingScheduleDTO> {
        let url_ = this.baseUrl + "/api/AutomaticParkingSchedule/SetAutomaticParkingScheduleActiveStatus?";
        if (parkingScheduleId === null)
            throw new globalThis.Error("The parameter 'parkingScheduleId' cannot be null.");
        else if (parkingScheduleId !== undefined)
            url_ += "parkingScheduleId=" + encodeURIComponent("" + parkingScheduleId) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAutomaticParkingScheduleActiveStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAutomaticParkingScheduleActiveStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutomaticParkingScheduleDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutomaticParkingScheduleDTO>;
        }));
    }

    protected processSetAutomaticParkingScheduleActiveStatus(response: HttpResponseBase): Observable<AutomaticParkingScheduleDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutomaticParkingScheduleDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAutomaticParkingSchedule(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/AutomaticParkingSchedule/DeleteAutomaticParkingSchedule?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAutomaticParkingSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAutomaticParkingSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAutomaticParkingSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAutomaticParkingScheduleZoneInfos(clientId: number | undefined): Observable<ParkingProcessZoneInfoDTO[]> {
        let url_ = this.baseUrl + "/api/AutomaticParkingSchedule/GetAutomaticParkingScheduleZoneInfos?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutomaticParkingScheduleZoneInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomaticParkingScheduleZoneInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessZoneInfoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessZoneInfoDTO[]>;
        }));
    }

    protected processGetAutomaticParkingScheduleZoneInfos(response: HttpResponseBase): Observable<ParkingProcessZoneInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingProcessZoneInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BIAuditLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getAuditLogs(fromDate: DateTime | null | undefined, untilDate: DateTime | null | undefined, skip: number | undefined, take: number | undefined, clientId: number | null | undefined): Observable<AuditLogDTO[]> {
        let url_ = this.baseUrl + "/api/BIAuditLog/GetAuditLogs?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (untilDate !== undefined && untilDate !== null)
            url_ += "untilDate=" + encodeURIComponent(untilDate ? "" + untilDate.toString() : "") + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditLogDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditLogDTO[]>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<AuditLogDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditLogDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BIReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getClients(skip: number | undefined, take: number | undefined): Observable<PagedResultDTOOfClientDTO> {
        let url_ = this.baseUrl + "/api/BIReports/GetClients?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfClientDTO>;
        }));
    }

    protected processGetClients(response: HttpResponseBase): Observable<PagedResultDTOOfClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParkers(skip: number | undefined, take: number | undefined, clientId: number | null | undefined): Observable<PagedResultDTOOfParkerDTO> {
        let url_ = this.baseUrl + "/api/BIReports/GetParkers?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkerDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkerDTO>;
        }));
    }

    protected processGetParkers(response: HttpResponseBase): Observable<PagedResultDTOOfParkerDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkerDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMonthlyParkerExtractData(parkerId: number | undefined, month: string | undefined): Observable<ParkerExtractFullReportDataDTO> {
        let url_ = this.baseUrl + "/api/BIReports/GetMonthlyParkerExtractData?";
        if (parkerId === null)
            throw new globalThis.Error("The parameter 'parkerId' cannot be null.");
        else if (parkerId !== undefined)
            url_ += "parkerId=" + encodeURIComponent("" + parkerId) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyParkerExtractData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyParkerExtractData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerExtractFullReportDataDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerExtractFullReportDataDTO>;
        }));
    }

    protected processGetMonthlyParkerExtractData(response: HttpResponseBase): Observable<ParkerExtractFullReportDataDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkerExtractFullReportDataDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    createClient(client: CreateClientDTO): Observable<ClientDTO | null> {
        let url_ = this.baseUrl + "/api/Client/CreateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO | null>;
        }));
    }

    protected processCreateClient(response: HttpResponseBase): Observable<ClientDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClientDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateClient(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Client/DeactivateClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteClient(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Client/DeleteClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forceDeleteClient(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Client/ForceDeleteClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceDeleteClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceDeleteClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForceDeleteClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClient(id: number | undefined): Observable<ClientDTO> {
        let url_ = this.baseUrl + "/api/Client/GetClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO>;
        }));
    }

    protected processGetClient(response: HttpResponseBase): Observable<ClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchClients(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfClientDTO | null> {
        let url_ = this.baseUrl + "/api/Client/SearchClients?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfClientDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfClientDTO | null>;
        }));
    }

    protected processSearchClients(response: HttpResponseBase): Observable<PagedResultDTOOfClientDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfClientDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateClient(client: UpdateClientDTO): Observable<ClientDTO> {
        let url_ = this.baseUrl + "/api/Client/UpdateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO>;
        }));
    }

    protected processUpdateClient(response: HttpResponseBase): Observable<ClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigBasedAdminClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getConfigBasedStructuralEntry(id: number | undefined): Observable<ConfigBasedStructuralEntryDTO> {
        let url_ = this.baseUrl + "/api/ConfigBasedAdmin/GetConfigBasedStructuralEntry?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigBasedStructuralEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigBasedStructuralEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigBasedStructuralEntryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigBasedStructuralEntryDTO>;
        }));
    }

    protected processGetConfigBasedStructuralEntry(response: HttpResponseBase): Observable<ConfigBasedStructuralEntryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigBasedStructuralEntryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createConfigBasedStructuralEntry(dto: CreateConfigBasedStructuralEntryDTO): Observable<ConfigBasedStructuralEntryDTO> {
        let url_ = this.baseUrl + "/api/ConfigBasedAdmin/CreateConfigBasedStructuralEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConfigBasedStructuralEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConfigBasedStructuralEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigBasedStructuralEntryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigBasedStructuralEntryDTO>;
        }));
    }

    protected processCreateConfigBasedStructuralEntry(response: HttpResponseBase): Observable<ConfigBasedStructuralEntryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigBasedStructuralEntryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateConfigBasedStructuralEntry(dto: UpdateConfigBasedStructuralEntryDTO): Observable<ConfigBasedStructuralEntryDTO> {
        let url_ = this.baseUrl + "/api/ConfigBasedAdmin/UpdateConfigBasedStructuralEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConfigBasedStructuralEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConfigBasedStructuralEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigBasedStructuralEntryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigBasedStructuralEntryDTO>;
        }));
    }

    protected processUpdateConfigBasedStructuralEntry(response: HttpResponseBase): Observable<ConfigBasedStructuralEntryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigBasedStructuralEntryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteConfigBasedStructuralEntry(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ConfigBasedAdmin/DeleteConfigBasedStructuralEntry?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConfigBasedStructuralEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConfigBasedStructuralEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConfigBasedStructuralEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchConfigBasedStructuralEntries(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfConfigBasedStructuralEntryDTO> {
        let url_ = this.baseUrl + "/api/ConfigBasedAdmin/SearchConfigBasedStructuralEntries?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchConfigBasedStructuralEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchConfigBasedStructuralEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfConfigBasedStructuralEntryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfConfigBasedStructuralEntryDTO>;
        }));
    }

    protected processSearchConfigBasedStructuralEntries(response: HttpResponseBase): Observable<PagedResultDTOOfConfigBasedStructuralEntryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfConfigBasedStructuralEntryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DeviceInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    registerDeviceInfo(model: RegisterDeviceInfoDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/DeviceInfo/RegisterDeviceInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterDeviceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterDeviceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegisterDeviceInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DeviceStatusReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchDeviceStatusReportData(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined): Observable<PagedResultDTOOfDeviceStatusReportDTO | null> {
        let url_ = this.baseUrl + "/api/Reports/SearchDeviceStatusReportData?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDeviceStatusReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDeviceStatusReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfDeviceStatusReportDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfDeviceStatusReportDTO | null>;
        }));
    }

    protected processSearchDeviceStatusReportData(response: HttpResponseBase): Observable<PagedResultDTOOfDeviceStatusReportDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfDeviceStatusReportDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDeviceStatusReport(clientId: number | undefined, fileType: ReportFileType | undefined, saveReport: boolean | undefined, parameterDto: DeviceStatusReportParameterDTO): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/Reports/ExportDeviceStatusReport?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (fileType === null)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (saveReport === null)
            throw new globalThis.Error("The parameter 'saveReport' cannot be null.");
        else if (saveReport !== undefined)
            url_ += "saveReport=" + encodeURIComponent("" + saveReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDeviceStatusReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDeviceStatusReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processExportDeviceStatusReport(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportJobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchExportJobs(clientId: number | null | undefined, companyId: number | null | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfExportJobLimitedDTO> {
        let url_ = this.baseUrl + "/api/ExportJob/SearchExportJobs?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchExportJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExportJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfExportJobLimitedDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfExportJobLimitedDTO>;
        }));
    }

    protected processSearchExportJobs(response: HttpResponseBase): Observable<PagedResultDTOOfExportJobLimitedDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfExportJobLimitedDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createExportJob(dto: CreateExportJobDTO): Observable<ExportJobDTO> {
        let url_ = this.baseUrl + "/api/ExportJob/CreateExportJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportJobDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportJobDTO>;
        }));
    }

    protected processCreateExportJob(response: HttpResponseBase): Observable<ExportJobDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportJobDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExportJob(id: number | undefined): Observable<ExportJobDTO> {
        let url_ = this.baseUrl + "/api/ExportJob/GetExportJob?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportJobDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportJobDTO>;
        }));
    }

    protected processGetExportJob(response: HttpResponseBase): Observable<ExportJobDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportJobDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExportJobTemplate(type: ExportJobType | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ExportJob/GetExportJobTemplate?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportJobTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportJobTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetExportJobTemplate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteExportJob(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportJob/DeleteExportJob?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExportJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadOutputFile(jobId: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ExportJob/DownloadOutputFile?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOutputFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOutputFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadOutputFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMergeFieldsForExportType(type: ExportJobType | undefined): Observable<{ [key: string]: MergeFieldInfoDTO; }> {
        let url_ = this.baseUrl + "/api/ExportJob/GetMergeFieldsForExportType?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMergeFieldsForExportType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMergeFieldsForExportType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: MergeFieldInfoDTO; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: MergeFieldInfoDTO; }>;
        }));
    }

    protected processGetMergeFieldsForExportType(response: HttpResponseBase): Observable<{ [key: string]: MergeFieldInfoDTO; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] ? MergeFieldInfoDTO.fromJS(resultData200[key]) : new MergeFieldInfoDTO();
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExecutionLog(jobId: number | undefined): Observable<ExportJobExecutionLogDTO> {
        let url_ = this.baseUrl + "/api/ExportJob/GetExecutionLog?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExecutionLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExecutionLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportJobExecutionLogDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportJobExecutionLogDTO>;
        }));
    }

    protected processGetExecutionLog(response: HttpResponseBase): Observable<ExportJobExecutionLogDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportJobExecutionLogDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FalseRecordingsReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchFalseRecordingsReportData(clientId: number | undefined, reportParameterDto: FalseRecordingsReportParameterDTO, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfFalseRecordingsReportDTO> {
        let url_ = this.baseUrl + "/api/Reports/SearchFalseRecordingsReportData?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFalseRecordingsReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFalseRecordingsReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfFalseRecordingsReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfFalseRecordingsReportDTO>;
        }));
    }

    protected processSearchFalseRecordingsReportData(response: HttpResponseBase): Observable<PagedResultDTOOfFalseRecordingsReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfFalseRecordingsReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportFalseRecordingsReport(clientId: number | undefined, fileType: ReportFileType | undefined, saveReport: boolean | undefined, reportParameterDto: FalseRecordingsReportParameterDTO): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/Reports/ExportFalseRecordingsReport?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (fileType === null)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (saveReport === null)
            throw new globalThis.Error("The parameter 'saveReport' cannot be null.");
        else if (saveReport !== undefined)
            url_ += "saveReport=" + encodeURIComponent("" + saveReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFalseRecordingsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFalseRecordingsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processExportFalseRecordingsReport(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FastCheckinClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getForeignParkingFastCheckinQuotaInfo(zoneId: number | undefined, selectedSubscriptionId: number | undefined, controlPlateNumber: string | undefined): Observable<ParkingQuotaInfoDTO> {
        let url_ = this.baseUrl + "/api/FastCheckin/GetForeignParkingFastCheckinQuotaInfo?";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (selectedSubscriptionId === null)
            throw new globalThis.Error("The parameter 'selectedSubscriptionId' cannot be null.");
        else if (selectedSubscriptionId !== undefined)
            url_ += "selectedSubscriptionId=" + encodeURIComponent("" + selectedSubscriptionId) + "&";
        if (controlPlateNumber === null)
            throw new globalThis.Error("The parameter 'controlPlateNumber' cannot be null.");
        else if (controlPlateNumber !== undefined)
            url_ += "controlPlateNumber=" + encodeURIComponent("" + controlPlateNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForeignParkingFastCheckinQuotaInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForeignParkingFastCheckinQuotaInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingQuotaInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingQuotaInfoDTO>;
        }));
    }

    protected processGetForeignParkingFastCheckinQuotaInfo(response: HttpResponseBase): Observable<ParkingQuotaInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingQuotaInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateForeignParkingPriceFastCheckin(dto: CalculateForeignParkingPriceFastCheckinDTO): Observable<CalculateParkingPriceResultDTO> {
        let url_ = this.baseUrl + "/api/FastCheckin/CalculateForeignParkingPriceFastCheckin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateForeignParkingPriceFastCheckin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateForeignParkingPriceFastCheckin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateParkingPriceResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateParkingPriceResultDTO>;
        }));
    }

    protected processCalculateForeignParkingPriceFastCheckin(response: HttpResponseBase): Observable<CalculateParkingPriceResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateParkingPriceResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    startForeignParkingPaymentProcessFastCheckin(dto: StartForeignParkingPaymentProcessFastCheckinDTO): Observable<StartForeignParkingPaymentProcessFastCheckinResponseDTO> {
        let url_ = this.baseUrl + "/api/FastCheckin/StartForeignParkingPaymentProcessFastCheckin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartForeignParkingPaymentProcessFastCheckin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartForeignParkingPaymentProcessFastCheckin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartForeignParkingPaymentProcessFastCheckinResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartForeignParkingPaymentProcessFastCheckinResponseDTO>;
        }));
    }

    protected processStartForeignParkingPaymentProcessFastCheckin(response: HttpResponseBase): Observable<StartForeignParkingPaymentProcessFastCheckinResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartForeignParkingPaymentProcessFastCheckinResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkinUserForeignParkingFastCheckinNoPayment(dto: CheckinUserForeignParkingFastCheckinNoPaymentDTO, language: string | undefined): Observable<CheckinUserForeignParkingFastCheckInResultDTO> {
        let url_ = this.baseUrl + "/api/FastCheckin/CheckinUserForeignParkingFastCheckinNoPayment?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckinUserForeignParkingFastCheckinNoPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckinUserForeignParkingFastCheckinNoPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckinUserForeignParkingFastCheckInResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckinUserForeignParkingFastCheckInResultDTO>;
        }));
    }

    protected processCheckinUserForeignParkingFastCheckinNoPayment(response: HttpResponseBase): Observable<CheckinUserForeignParkingFastCheckInResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckinUserForeignParkingFastCheckInResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkoutFastCheckinParking(dto: FastCheckinSessionDTO, language: string | undefined): Observable<FastCheckinParkingSessionInfoDTO> {
        let url_ = this.baseUrl + "/api/FastCheckin/CheckoutFastCheckinParking?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckoutFastCheckinParking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckoutFastCheckinParking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FastCheckinParkingSessionInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FastCheckinParkingSessionInfoDTO>;
        }));
    }

    protected processCheckoutFastCheckinParking(response: HttpResponseBase): Observable<FastCheckinParkingSessionInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FastCheckinParkingSessionInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportFastCheckinParkingSessionReport(dto: FastCheckinSessionDTO, language: string | undefined): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/FastCheckin/ExportFastCheckinParkingSessionReport?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFastCheckinParkingSessionReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFastCheckinParkingSessionReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processExportFastCheckinParkingSessionReport(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFastCheckinParkingSessionInfo(dto: FastCheckinSessionDTO): Observable<FastCheckinParkingSessionInfoDTO | null> {
        let url_ = this.baseUrl + "/api/FastCheckin/GetFastCheckinParkingSessionInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFastCheckinParkingSessionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFastCheckinParkingSessionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FastCheckinParkingSessionInfoDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FastCheckinParkingSessionInfoDTO | null>;
        }));
    }

    protected processGetFastCheckinParkingSessionInfo(response: HttpResponseBase): Observable<FastCheckinParkingSessionInfoDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FastCheckinParkingSessionInfoDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateFastCheckinParkingSession(dto: ValidateFastCheckinSessionDTO, language: string | undefined): Observable<FastCheckinParkingSessionInfoDTO | null> {
        let url_ = this.baseUrl + "/api/FastCheckin/ValidateFastCheckinParkingSession?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateFastCheckinParkingSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateFastCheckinParkingSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FastCheckinParkingSessionInfoDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FastCheckinParkingSessionInfoDTO | null>;
        }));
    }

    protected processValidateFastCheckinParkingSession(response: HttpResponseBase): Observable<FastCheckinParkingSessionInfoDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FastCheckinParkingSessionInfoDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateParkingExtensionPriceFastCheckin(dto: CalculateExtendFastCheckinParkingDTO): Observable<CalculateParkingExtensionPriceResultDTO> {
        let url_ = this.baseUrl + "/api/FastCheckin/CalculateParkingExtensionPriceFastCheckin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateParkingExtensionPriceFastCheckin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateParkingExtensionPriceFastCheckin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateParkingExtensionPriceResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateParkingExtensionPriceResultDTO>;
        }));
    }

    protected processCalculateParkingExtensionPriceFastCheckin(response: HttpResponseBase): Observable<CalculateParkingExtensionPriceResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateParkingExtensionPriceResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    startParkingExtensionPaymentProcessFastCheckin(dto: StartFastCheckinParkingExtensionPaymentProcessDTO): Observable<StartFastCheckinParkingExtensionPaymentProcessResponseDTO> {
        let url_ = this.baseUrl + "/api/FastCheckin/StartParkingExtensionPaymentProcessFastCheckin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartParkingExtensionPaymentProcessFastCheckin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartParkingExtensionPaymentProcessFastCheckin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartFastCheckinParkingExtensionPaymentProcessResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartFastCheckinParkingExtensionPaymentProcessResponseDTO>;
        }));
    }

    protected processStartParkingExtensionPaymentProcessFastCheckin(response: HttpResponseBase): Observable<StartFastCheckinParkingExtensionPaymentProcessResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartFastCheckinParkingExtensionPaymentProcessResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    extendFastCheckinParkingSessionNoPayment(dto: ExtendFastCheckinParkingDTO, language: string | undefined): Observable<ExtendUserParkingResultDTO> {
        let url_ = this.baseUrl + "/api/FastCheckin/ExtendFastCheckinParkingSessionNoPayment?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendFastCheckinParkingSessionNoPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendFastCheckinParkingSessionNoPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendUserParkingResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendUserParkingResultDTO>;
        }));
    }

    protected processExtendFastCheckinParkingSessionNoPayment(response: HttpResponseBase): Observable<ExtendUserParkingResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtendUserParkingResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FinanceClientPriceModelClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getFinanceClientPriceModels(clientId: number | null | undefined): Observable<FinanceClientPriceModelDTO[]> {
        let url_ = this.baseUrl + "/api/FinanceClientPriceModel/GetFinanceClientPriceModels?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinanceClientPriceModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinanceClientPriceModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinanceClientPriceModelDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinanceClientPriceModelDTO[]>;
        }));
    }

    protected processGetFinanceClientPriceModels(response: HttpResponseBase): Observable<FinanceClientPriceModelDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinanceClientPriceModelDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addFinanceClientPriceModel(clientId: number | undefined, financeClientPriceModel: FinanceClientPriceModelDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/FinanceClientPriceModel/AddFinanceClientPriceModel?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(financeClientPriceModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFinanceClientPriceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFinanceClientPriceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddFinanceClientPriceModel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFinanceClientPriceModel(financeClientPriceModel: FinanceClientPriceModelDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/FinanceClientPriceModel/UpdateFinanceClientPriceModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(financeClientPriceModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFinanceClientPriceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinanceClientPriceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFinanceClientPriceModel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFinanceClientPriceModel(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FinanceClientPriceModel/DeleteFinanceClientPriceModel?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFinanceClientPriceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFinanceClientPriceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFinanceClientPriceModel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPriceModels(): Observable<FinancePriceModelDataDTO> {
        let url_ = this.baseUrl + "/api/FinanceClientPriceModel/GetAllPriceModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPriceModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPriceModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancePriceModelDataDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancePriceModelDataDTO>;
        }));
    }

    protected processGetAllPriceModels(response: HttpResponseBase): Observable<FinancePriceModelDataDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancePriceModelDataDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FinanceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getFinancialClients(): Observable<FinancialClientInfoDTO[] | null> {
        let url_ = this.baseUrl + "/api/Finance/GetFinancialClients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialClientInfoDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialClientInfoDTO[] | null>;
        }));
    }

    protected processGetFinancialClients(response: HttpResponseBase): Observable<FinancialClientInfoDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialClientInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFinancialPriceReportForClient(clientId: number | undefined, month: DateTime | undefined): Observable<ClientFinancialPriceReportDTO> {
        let url_ = this.baseUrl + "/api/Finance/GetFinancialPriceReportForClient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent(month ? "" + month.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialPriceReportForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialPriceReportForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientFinancialPriceReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientFinancialPriceReportDTO>;
        }));
    }

    protected processGetFinancialPriceReportForClient(response: HttpResponseBase): Observable<ClientFinancialPriceReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientFinancialPriceReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFinancialParkingSessionsForClient(clientId: number | undefined, month: DateTime | undefined): Observable<FinancialParkingSessionDTO[] | null> {
        let url_ = this.baseUrl + "/api/Finance/GetFinancialParkingSessionsForClient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent(month ? "" + month.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialParkingSessionsForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialParkingSessionsForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialParkingSessionDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialParkingSessionDTO[] | null>;
        }));
    }

    protected processGetFinancialParkingSessionsForClient(response: HttpResponseBase): Observable<FinancialParkingSessionDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialParkingSessionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FleetListClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchFleetList(clientId: number | null | undefined, companyId: number | null | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfFleetListEntryDTO> {
        let url_ = this.baseUrl + "/api/FleetList/SearchFleetList?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFleetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFleetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfFleetListEntryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfFleetListEntryDTO>;
        }));
    }

    protected processSearchFleetList(response: HttpResponseBase): Observable<PagedResultDTOOfFleetListEntryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfFleetListEntryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createFleetListEntry(dto: FleetListEntryDTO): Observable<FleetListEntryDTO> {
        let url_ = this.baseUrl + "/api/FleetList/CreateFleetListEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFleetListEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFleetListEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FleetListEntryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FleetListEntryDTO>;
        }));
    }

    protected processCreateFleetListEntry(response: HttpResponseBase): Observable<FleetListEntryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FleetListEntryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFleetListEntry(dto: FleetListEntryDTO): Observable<FleetListEntryDTO> {
        let url_ = this.baseUrl + "/api/FleetList/UpdateFleetListEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFleetListEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFleetListEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FleetListEntryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FleetListEntryDTO>;
        }));
    }

    protected processUpdateFleetListEntry(response: HttpResponseBase): Observable<FleetListEntryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FleetListEntryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFleetListEntry(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FleetList/DeleteFleetListEntry?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFleetListEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFleetListEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFleetListEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ForeignParkingProcessClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    startForeignParkingPaymentProcess(dto: StartForeignParkingPaymentProcessDTO): Observable<StartForeignParkingPaymentProcessResponseDTO> {
        let url_ = this.baseUrl + "/api/ForeignParkingProcess/StartForeignParkingPaymentProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartForeignParkingPaymentProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartForeignParkingPaymentProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartForeignParkingPaymentProcessResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartForeignParkingPaymentProcessResponseDTO>;
        }));
    }

    protected processStartForeignParkingPaymentProcess(response: HttpResponseBase): Observable<StartForeignParkingPaymentProcessResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartForeignParkingPaymentProcessResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkForeignParkingPayment(dto: CheckForeignParkingPaymentDTO): Observable<CheckForeignParkingPaymentResponseDTO> {
        let url_ = this.baseUrl + "/api/ForeignParkingProcess/CheckForeignParkingPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckForeignParkingPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckForeignParkingPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckForeignParkingPaymentResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckForeignParkingPaymentResponseDTO>;
        }));
    }

    protected processCheckForeignParkingPayment(response: HttpResponseBase): Observable<CheckForeignParkingPaymentResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckForeignParkingPaymentResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelForeignParkingPayment(dto: CancelForeignParkingPaymentDTO): Observable<CancelForeignParkingPaymentResponseDTO> {
        let url_ = this.baseUrl + "/api/ForeignParkingProcess/CancelForeignParkingPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelForeignParkingPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelForeignParkingPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelForeignParkingPaymentResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelForeignParkingPaymentResponseDTO>;
        }));
    }

    protected processCancelForeignParkingPayment(response: HttpResponseBase): Observable<CancelForeignParkingPaymentResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelForeignParkingPaymentResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkinUserForeignParking(checkinDto: CheckinUserForeignParkingDTO): Observable<CheckinUserParkingRegistrationDTO> {
        let url_ = this.baseUrl + "/api/ForeignParkingProcess/CheckinUserForeignParking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkinDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckinUserForeignParking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckinUserForeignParking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckinUserParkingRegistrationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckinUserParkingRegistrationDTO>;
        }));
    }

    protected processCheckinUserForeignParking(response: HttpResponseBase): Observable<CheckinUserParkingRegistrationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckinUserParkingRegistrationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    paymentFailed(dto: PaymentFailedDTO): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ForeignParkingProcess/PaymentFailed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentFailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentFailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPaymentFailed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkerCompanyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    createParkerCompany(companyDto: CreateParkerCompanyDTO): Observable<ParkerCompanyDTO> {
        let url_ = this.baseUrl + "/api/ParkerCompany/CreateParkerCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(companyDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateParkerCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateParkerCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerCompanyDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerCompanyDTO>;
        }));
    }

    protected processCreateParkerCompany(response: HttpResponseBase): Observable<ParkerCompanyDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkerCompanyDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchParkerCompanies(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkerCompanyDTO> {
        let url_ = this.baseUrl + "/api/ParkerCompany/SearchParkerCompanies?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkerCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkerCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkerCompanyDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkerCompanyDTO>;
        }));
    }

    protected processSearchParkerCompanies(response: HttpResponseBase): Observable<PagedResultDTOOfParkerCompanyDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkerCompanyDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateParkerCompany(updateCompany: UpdateParkerCompanyDTO): Observable<ParkerCompanyDTO> {
        let url_ = this.baseUrl + "/api/ParkerCompany/UpdateParkerCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCompany);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParkerCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParkerCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerCompanyDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerCompanyDTO>;
        }));
    }

    protected processUpdateParkerCompany(response: HttpResponseBase): Observable<ParkerCompanyDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkerCompanyDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteParkerCompany(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkerCompany/DeleteParkerCompany?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParkerCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParkerCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParkerCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    createParker(parkerDto: CreateParkerDTO): Observable<ParkerDTO> {
        let url_ = this.baseUrl + "/api/Parker/CreateParker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parkerDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateParker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateParker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerDTO>;
        }));
    }

    protected processCreateParker(response: HttpResponseBase): Observable<ParkerDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkerDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchParkers(clientId: number | null | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined, includeForeignParkingAssignments: boolean | undefined): Observable<PagedResultDTOOfParkerDTO> {
        let url_ = this.baseUrl + "/api/Parker/SearchParkers?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        if (includeForeignParkingAssignments === null)
            throw new globalThis.Error("The parameter 'includeForeignParkingAssignments' cannot be null.");
        else if (includeForeignParkingAssignments !== undefined)
            url_ += "includeForeignParkingAssignments=" + encodeURIComponent("" + includeForeignParkingAssignments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkerDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkerDTO>;
        }));
    }

    protected processSearchParkers(response: HttpResponseBase): Observable<PagedResultDTOOfParkerDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkerDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParker(id: number | undefined, includeForeignParkingAssignments: boolean | undefined): Observable<ParkerDTO> {
        let url_ = this.baseUrl + "/api/Parker/GetParker?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (includeForeignParkingAssignments === null)
            throw new globalThis.Error("The parameter 'includeForeignParkingAssignments' cannot be null.");
        else if (includeForeignParkingAssignments !== undefined)
            url_ += "includeForeignParkingAssignments=" + encodeURIComponent("" + includeForeignParkingAssignments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerDTO>;
        }));
    }

    protected processGetParker(response: HttpResponseBase): Observable<ParkerDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkerDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllParkers(skip: number | undefined, take: number | undefined, isoChangeDateTimeUtc: string | null | undefined): Observable<ParkerLimitedDTO[]> {
        let url_ = this.baseUrl + "/api/Parker/GetAllParkers?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (isoChangeDateTimeUtc !== undefined && isoChangeDateTimeUtc !== null)
            url_ += "isoChangeDateTimeUtc=" + encodeURIComponent("" + isoChangeDateTimeUtc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParkers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParkers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerLimitedDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerLimitedDTO[]>;
        }));
    }

    protected processGetAllParkers(response: HttpResponseBase): Observable<ParkerLimitedDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkerLimitedDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateParker(updateParker: UpdateParkerDTO): Observable<ParkerDTO> {
        let url_ = this.baseUrl + "/api/Parker/UpdateParker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateParker);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerDTO>;
        }));
    }

    protected processUpdateParker(response: HttpResponseBase): Observable<ParkerDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkerDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setParkerStatus(parkerStatusDTO: SetParkerStatusDTO): Observable<ParkerDTO> {
        let url_ = this.baseUrl + "/api/Parker/SetParkerStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parkerStatusDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetParkerStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetParkerStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerDTO>;
        }));
    }

    protected processSetParkerStatus(response: HttpResponseBase): Observable<ParkerDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkerDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteParker(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Parker/DeleteParker?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParker(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    initializeParkerToUserLink(parkerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Parker/InitializeParkerToUserLink?";
        if (parkerId === null)
            throw new globalThis.Error("The parameter 'parkerId' cannot be null.");
        else if (parkerId !== undefined)
            url_ += "parkerId=" + encodeURIComponent("" + parkerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitializeParkerToUserLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitializeParkerToUserLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitializeParkerToUserLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    linkParkerToUser(dto: LinkParkerToUserDTO): Observable<LinkParkerToUserResultDTO> {
        let url_ = this.baseUrl + "/api/Parker/LinkParkerToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkParkerToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkParkerToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkParkerToUserResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkParkerToUserResultDTO>;
        }));
    }

    protected processLinkParkerToUser(response: HttpResponseBase): Observable<LinkParkerToUserResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LinkParkerToUserResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unlinkParkerFromUser(parkerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Parker/UnlinkParkerFromUser?";
        if (parkerId === null)
            throw new globalThis.Error("The parameter 'parkerId' cannot be null.");
        else if (parkerId !== undefined)
            url_ += "parkerId=" + encodeURIComponent("" + parkerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkParkerFromUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkParkerFromUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkParkerFromUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setFavoriteSubscriptionAssignments(parkerId: number | undefined, favoriteSubscriptionAssignmentsDto: SetFavoriteSubscriptionAssignmentsDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/Parker/SetFavoriteSubscriptionAssignments?";
        if (parkerId === null)
            throw new globalThis.Error("The parameter 'parkerId' cannot be null.");
        else if (parkerId !== undefined)
            url_ += "parkerId=" + encodeURIComponent("" + parkerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(favoriteSubscriptionAssignmentsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFavoriteSubscriptionAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFavoriteSubscriptionAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetFavoriteSubscriptionAssignments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkerExtractReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchParkerExtractReportData(clientId: number | undefined, parkerExtractReportParameterDto: ParkerExtractReportParameterDTO, skip: number | undefined, take: number | undefined, sortByAscending: boolean | undefined): Observable<PagedResultDTOOfParkerExtractReportDTO> {
        let url_ = this.baseUrl + "/api/Reports/SearchParkerExtractReportData?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortByAscending === null)
            throw new globalThis.Error("The parameter 'sortByAscending' cannot be null.");
        else if (sortByAscending !== undefined)
            url_ += "sortByAscending=" + encodeURIComponent("" + sortByAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parkerExtractReportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkerExtractReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkerExtractReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkerExtractReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkerExtractReportDTO>;
        }));
    }

    protected processSearchParkerExtractReportData(response: HttpResponseBase): Observable<PagedResultDTOOfParkerExtractReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkerExtractReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportParkerExtractReport(clientId: number | undefined, fileType: ReportFileType | undefined, saveReport: boolean | undefined, parkerExtractReportParameterDto: ParkerExtractReportParameterDTO): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/Reports/ExportParkerExtractReport?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (fileType === null)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (saveReport === null)
            throw new globalThis.Error("The parameter 'saveReport' cannot be null.");
        else if (saveReport !== undefined)
            url_ += "saveReport=" + encodeURIComponent("" + saveReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parkerExtractReportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportParkerExtractReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportParkerExtractReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processExportParkerExtractReport(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    summarizeParkerExtractReport(clientId: number | undefined, parkerExtractReportParameterDto: ParkerExtractReportParameterDTO): Observable<ParkerExtractReportSummaryDTO> {
        let url_ = this.baseUrl + "/api/Reports/SummarizeParkerExtractReport?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parkerExtractReportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSummarizeParkerExtractReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSummarizeParkerExtractReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerExtractReportSummaryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerExtractReportSummaryDTO>;
        }));
    }

    protected processSummarizeParkerExtractReport(response: HttpResponseBase): Observable<ParkerExtractReportSummaryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkerExtractReportSummaryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkerRegistrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getExtendedRegistration(id: number | undefined): Observable<ParkerRegistrationWithParkerInfoDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/GetExtendedRegistration?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExtendedRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExtendedRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerRegistrationWithParkerInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerRegistrationWithParkerInfoDTO>;
        }));
    }

    protected processGetExtendedRegistration(response: HttpResponseBase): Observable<ParkerRegistrationWithParkerInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkerRegistrationWithParkerInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchRegistrations(clientId: number | null | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkerRegistrationWithParkerInfoDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/SearchRegistrations?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchRegistrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchRegistrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkerRegistrationWithParkerInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkerRegistrationWithParkerInfoDTO>;
        }));
    }

    protected processSearchRegistrations(response: HttpResponseBase): Observable<PagedResultDTOOfParkerRegistrationWithParkerInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkerRegistrationWithParkerInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addNonTaggedRegistration(addDto: AddNonTaggedRegistrationDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/AddNonTaggedRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNonTaggedRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNonTaggedRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddNonTaggedRegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param parkingSubscriptionId (optional) 
     * @param startTimeUtc (optional) 
     * @deprecated
     */
    getParkingQuotaInfo(parkingSubscriptionId: number | undefined, startTimeUtc: DateTime | undefined): Observable<ParkingQuotaInfoDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/GetParkingQuotaInfo?";
        if (parkingSubscriptionId === null)
            throw new globalThis.Error("The parameter 'parkingSubscriptionId' cannot be null.");
        else if (parkingSubscriptionId !== undefined)
            url_ += "parkingSubscriptionId=" + encodeURIComponent("" + parkingSubscriptionId) + "&";
        if (startTimeUtc === null)
            throw new globalThis.Error("The parameter 'startTimeUtc' cannot be null.");
        else if (startTimeUtc !== undefined)
            url_ += "startTimeUtc=" + encodeURIComponent(startTimeUtc ? "" + startTimeUtc.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingQuotaInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingQuotaInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingQuotaInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingQuotaInfoDTO>;
        }));
    }

    protected processGetParkingQuotaInfo(response: HttpResponseBase): Observable<ParkingQuotaInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingQuotaInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    calculateParkingPrice(dto: CalculateParkingPriceDTO): Observable<CalculateParkingPriceResultDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/CalculateParkingPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateParkingPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateParkingPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateParkingPriceResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateParkingPriceResultDTO>;
        }));
    }

    protected processCalculateParkingPrice(response: HttpResponseBase): Observable<CalculateParkingPriceResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateParkingPriceResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    calculateForeignParkingPrice(dto: CalculateForeignParkingPriceDTO): Observable<CalculateParkingPriceResultDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/CalculateForeignParkingPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateForeignParkingPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateForeignParkingPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateParkingPriceResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateParkingPriceResultDTO>;
        }));
    }

    protected processCalculateForeignParkingPrice(response: HttpResponseBase): Observable<CalculateParkingPriceResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateParkingPriceResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    startForeignParkingPaymentProcess(dto: StartForeignParkingPaymentProcessDTO): Observable<StartForeignParkingPaymentProcessResponseDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/StartForeignParkingPaymentProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartForeignParkingPaymentProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartForeignParkingPaymentProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartForeignParkingPaymentProcessResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartForeignParkingPaymentProcessResponseDTO>;
        }));
    }

    protected processStartForeignParkingPaymentProcess(response: HttpResponseBase): Observable<StartForeignParkingPaymentProcessResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartForeignParkingPaymentProcessResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    checkForeignParkingPayment(dto: CheckForeignParkingPaymentDTO): Observable<CheckForeignParkingPaymentResponseDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/CheckForeignParkingPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckForeignParkingPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckForeignParkingPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckForeignParkingPaymentResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckForeignParkingPaymentResponseDTO>;
        }));
    }

    protected processCheckForeignParkingPayment(response: HttpResponseBase): Observable<CheckForeignParkingPaymentResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckForeignParkingPaymentResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    cancelForeignParkingPayment(dto: CancelForeignParkingPaymentDTO): Observable<CancelForeignParkingPaymentResponseDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/CancelForeignParkingPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelForeignParkingPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelForeignParkingPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelForeignParkingPaymentResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelForeignParkingPaymentResponseDTO>;
        }));
    }

    protected processCancelForeignParkingPayment(response: HttpResponseBase): Observable<CancelForeignParkingPaymentResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelForeignParkingPaymentResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    checkinUserForeignParking(checkinDto: CheckinUserForeignParkingDTO): Observable<CheckinUserParkingRegistrationDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/CheckinUserForeignParking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkinDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckinUserForeignParking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckinUserForeignParking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckinUserParkingRegistrationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckinUserParkingRegistrationDTO>;
        }));
    }

    protected processCheckinUserForeignParking(response: HttpResponseBase): Observable<CheckinUserParkingRegistrationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckinUserParkingRegistrationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    calculateVisitorParkingCardPrice(dto: CalculateVisitorParkingCardPriceDTO): Observable<CalculateVisitorParkingCardPriceResultDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/CalculateVisitorParkingCardPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateVisitorParkingCardPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateVisitorParkingCardPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateVisitorParkingCardPriceResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateVisitorParkingCardPriceResultDTO>;
        }));
    }

    protected processCalculateVisitorParkingCardPrice(response: HttpResponseBase): Observable<CalculateVisitorParkingCardPriceResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateVisitorParkingCardPriceResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    assignParkingCardToVisitor(dto: AssignParkingCardToVisitorDTO): Observable<ParkingCardDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/AssignParkingCardToVisitor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignParkingCardToVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignParkingCardToVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingCardDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingCardDTO>;
        }));
    }

    protected processAssignParkingCardToVisitor(response: HttpResponseBase): Observable<ParkingCardDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingCardDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    checkinUserParking(checkinDto: CheckinUserParkingDTO): Observable<CheckinUserParkingRegistrationDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/CheckinUserParking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkinDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckinUserParking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckinUserParking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckinUserParkingRegistrationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckinUserParkingRegistrationDTO>;
        }));
    }

    protected processCheckinUserParking(response: HttpResponseBase): Observable<CheckinUserParkingRegistrationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckinUserParkingRegistrationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    checkoutUserParking(checkoutDto: CheckoutUserParkingDTO): Observable<CheckoutUserParkingResultDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/CheckoutUserParking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkoutDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckoutUserParking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckoutUserParking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckoutUserParkingResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckoutUserParkingResultDTO>;
        }));
    }

    protected processCheckoutUserParking(response: HttpResponseBase): Observable<CheckoutUserParkingResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckoutUserParkingResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    calculateParkingExtensionPrice(dto: CalculateExtendUserParkingDTO): Observable<CalculateParkingExtensionPriceResultDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/CalculateParkingExtensionPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateParkingExtensionPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateParkingExtensionPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateParkingExtensionPriceResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateParkingExtensionPriceResultDTO>;
        }));
    }

    protected processCalculateParkingExtensionPrice(response: HttpResponseBase): Observable<CalculateParkingExtensionPriceResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateParkingExtensionPriceResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    startParkingExtensionPaymentProcess(dto: StartParkingExtensionPaymentProcessDTO): Observable<StartParkingExtensionPaymentProcessResponseDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/StartParkingExtensionPaymentProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartParkingExtensionPaymentProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartParkingExtensionPaymentProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartParkingExtensionPaymentProcessResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartParkingExtensionPaymentProcessResponseDTO>;
        }));
    }

    protected processStartParkingExtensionPaymentProcess(response: HttpResponseBase): Observable<StartParkingExtensionPaymentProcessResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartParkingExtensionPaymentProcessResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    extendUserParkingSession(dto: ExtendUserParkingDTO): Observable<ExtendUserParkingResultDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/ExtendUserParkingSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendUserParkingSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendUserParkingSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendUserParkingResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendUserParkingResultDTO>;
        }));
    }

    protected processExtendUserParkingSession(response: HttpResponseBase): Observable<ExtendUserParkingResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtendUserParkingResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param parkerId (optional) 
     * @deprecated
     */
    createParkingPermit(parkerId: number | undefined): Observable<ParkingPermitDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/CreateParkingPermit?";
        if (parkerId === null)
            throw new globalThis.Error("The parameter 'parkerId' cannot be null.");
        else if (parkerId !== undefined)
            url_ += "parkerId=" + encodeURIComponent("" + parkerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateParkingPermit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateParkingPermit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingPermitDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingPermitDTO>;
        }));
    }

    protected processCreateParkingPermit(response: HttpResponseBase): Observable<ParkingPermitDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingPermitDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    validateVisitorSessionByParkingPermit(dto: ValidateVisitorSessionByParkingPermitDTO): Observable<ValidateVisitorSessionByParkingPermitResultDTO> {
        let url_ = this.baseUrl + "/api/ParkerRegistration/ValidateVisitorSessionByParkingPermit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateVisitorSessionByParkingPermit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateVisitorSessionByParkingPermit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateVisitorSessionByParkingPermitResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateVisitorSessionByParkingPermitResultDTO>;
        }));
    }

    protected processValidateVisitorSessionByParkingPermit(response: HttpResponseBase): Observable<ValidateVisitorSessionByParkingPermitResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateVisitorSessionByParkingPermitResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkerRegistrationReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchParkerRegistrationsReportData(clientId: number | undefined, reportParameterDto: ParkerRegistrationsReportParameterDTO, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkerRegistrationReportDTO> {
        let url_ = this.baseUrl + "/api/Reports/SearchParkerRegistrationsReportData?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkerRegistrationsReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkerRegistrationsReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkerRegistrationReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkerRegistrationReportDTO>;
        }));
    }

    protected processSearchParkerRegistrationsReportData(response: HttpResponseBase): Observable<PagedResultDTOOfParkerRegistrationReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkerRegistrationReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportParkerRegistrationsReport(clientId: number | undefined, fileType: ReportFileType | undefined, saveReport: boolean | undefined, reportParameterDto: ParkerRegistrationsReportParameterDTO): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/Reports/ExportParkerRegistrationsReport?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (fileType === null)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (saveReport === null)
            throw new globalThis.Error("The parameter 'saveReport' cannot be null.");
        else if (saveReport !== undefined)
            url_ += "saveReport=" + encodeURIComponent("" + saveReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportParkerRegistrationsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportParkerRegistrationsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processExportParkerRegistrationsReport(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkerTagClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    isIdentificationCodeAlreadyInUse(clientId: number | undefined, identificationCode: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ParkerTag/IsIdentificationCodeAlreadyInUse?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (identificationCode === null)
            throw new globalThis.Error("The parameter 'identificationCode' cannot be null.");
        else if (identificationCode !== undefined)
            url_ += "identificationCode=" + encodeURIComponent("" + identificationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsIdentificationCodeAlreadyInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsIdentificationCodeAlreadyInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsIdentificationCodeAlreadyInUse(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchTags(clientId: number | null | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkerTagDTO> {
        let url_ = this.baseUrl + "/api/ParkerTag/SearchTags?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkerTagDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkerTagDTO>;
        }));
    }

    protected processSearchTags(response: HttpResponseBase): Observable<PagedResultDTOOfParkerTagDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkerTagDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllTags(skip: number | undefined, take: number | undefined, isoChangeDateTimeUtc: string | null | undefined): Observable<ParkerTagDTO[] | null> {
        let url_ = this.baseUrl + "/api/ParkerTag/GetAllTags?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (isoChangeDateTimeUtc !== undefined && isoChangeDateTimeUtc !== null)
            url_ += "isoChangeDateTimeUtc=" + encodeURIComponent("" + isoChangeDateTimeUtc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerTagDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerTagDTO[] | null>;
        }));
    }

    protected processGetAllTags(response: HttpResponseBase): Observable<ParkerTagDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkerTagDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkerTurnoverReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchParkerTurnoverReportData(clientId: number | undefined, reportParameterDto: ParkerTurnoverReportParameterDTO, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkerTurnoverReportDTO> {
        let url_ = this.baseUrl + "/api/Reports/SearchParkerTurnoverReportData?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkerTurnoverReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkerTurnoverReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkerTurnoverReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkerTurnoverReportDTO>;
        }));
    }

    protected processSearchParkerTurnoverReportData(response: HttpResponseBase): Observable<PagedResultDTOOfParkerTurnoverReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkerTurnoverReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportParkerTurnoverReport(clientId: number | undefined, fileType: ReportFileType | undefined, saveReport: boolean | undefined, reportParameterDto: ParkerTurnoverReportParameterDTO): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/Reports/ExportParkerTurnoverReport?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (fileType === null)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (saveReport === null)
            throw new globalThis.Error("The parameter 'saveReport' cannot be null.");
        else if (saveReport !== undefined)
            url_ += "saveReport=" + encodeURIComponent("" + saveReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportParkerTurnoverReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportParkerTurnoverReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processExportParkerTurnoverReport(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    summarizeParkerTurnoverReport(clientId: number | undefined, reportParameterDto: ParkerTurnoverReportParameterDTO): Observable<ParkerTurnoverReportSummaryDTO> {
        let url_ = this.baseUrl + "/api/Reports/SummarizeParkerTurnoverReport?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSummarizeParkerTurnoverReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSummarizeParkerTurnoverReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerTurnoverReportSummaryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerTurnoverReportSummaryDTO>;
        }));
    }

    protected processSummarizeParkerTurnoverReport(response: HttpResponseBase): Observable<ParkerTurnoverReportSummaryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkerTurnoverReportSummaryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingCardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    createParkingCard(parkingCardDto: CreateParkingCardDTO): Observable<ParkingCardDTO> {
        let url_ = this.baseUrl + "/api/ParkingCard/CreateParkingCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parkingCardDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateParkingCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateParkingCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingCardDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingCardDTO>;
        }));
    }

    protected processCreateParkingCard(response: HttpResponseBase): Observable<ParkingCardDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingCardDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchParkingCards(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, issuedToMe: boolean | null | undefined): Observable<PagedResultDTOOfParkingCardDTO> {
        let url_ = this.baseUrl + "/api/ParkingCard/SearchParkingCards?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (issuedToMe !== undefined && issuedToMe !== null)
            url_ += "issuedToMe=" + encodeURIComponent("" + issuedToMe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkingCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkingCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkingCardDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkingCardDTO>;
        }));
    }

    protected processSearchParkingCards(response: HttpResponseBase): Observable<PagedResultDTOOfParkingCardDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkingCardDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchParkingCardsAdmin(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkingCardDTO> {
        let url_ = this.baseUrl + "/api/ParkingCard/SearchParkingCardsAdmin?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkingCardsAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkingCardsAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkingCardDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkingCardDTO>;
        }));
    }

    protected processSearchParkingCardsAdmin(response: HttpResponseBase): Observable<PagedResultDTOOfParkingCardDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkingCardDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateParkingCard(parkingCardDto: UpdateParkingCardDTO): Observable<ParkingCardDTO> {
        let url_ = this.baseUrl + "/api/ParkingCard/UpdateParkingCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parkingCardDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParkingCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParkingCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingCardDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingCardDTO>;
        }));
    }

    protected processUpdateParkingCard(response: HttpResponseBase): Observable<ParkingCardDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingCardDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    revokeParkingCard(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingCard/RevokeParkingCard?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeParkingCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeParkingCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRevokeParkingCard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    /**
     * @deprecated
     */
    getParkingProcessInfo(): Observable<ParkingProcessInfoDTO> {
        let url_ = this.baseUrl + "/api/Parking/GetParkingProcessInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingProcessInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingProcessInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessInfoDTO>;
        }));
    }

    protected processGetParkingProcessInfo(response: HttpResponseBase): Observable<ParkingProcessInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingProcessInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    getParkingProcessInfos(): Observable<ParkingProcessInfoDTO[]> {
        let url_ = this.baseUrl + "/api/Parking/GetParkingProcessInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingProcessInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingProcessInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessInfoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessInfoDTO[]>;
        }));
    }

    protected processGetParkingProcessInfos(response: HttpResponseBase): Observable<ParkingProcessInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingProcessInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientId (optional) 
     * @param includeForeignParkingZones (optional) 
     * @deprecated
     */
    getParkingProcessZoneInfos(clientId: number | undefined, includeForeignParkingZones: boolean | undefined): Observable<ParkingProcessZoneInfoDTO[]> {
        let url_ = this.baseUrl + "/api/Parking/GetParkingProcessZoneInfos?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (includeForeignParkingZones === null)
            throw new globalThis.Error("The parameter 'includeForeignParkingZones' cannot be null.");
        else if (includeForeignParkingZones !== undefined)
            url_ += "includeForeignParkingZones=" + encodeURIComponent("" + includeForeignParkingZones) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingProcessZoneInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingProcessZoneInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessZoneInfoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessZoneInfoDTO[]>;
        }));
    }

    protected processGetParkingProcessZoneInfos(response: HttpResponseBase): Observable<ParkingProcessZoneInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingProcessZoneInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param zoneId (optional) 
     * @deprecated
     */
    getParkingProcessZoneInfo(zoneId: number | undefined): Observable<ParkingProcessZoneInfoDTO> {
        let url_ = this.baseUrl + "/api/Parking/GetParkingProcessZoneInfo?";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingProcessZoneInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingProcessZoneInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessZoneInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessZoneInfoDTO>;
        }));
    }

    protected processGetParkingProcessZoneInfo(response: HttpResponseBase): Observable<ParkingProcessZoneInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingProcessZoneInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param zoneId (optional) 
     * @param companyId (optional) 
     * @deprecated
     */
    getParkingProcessZoneInfoWithSubscriptionsRequiringValidation(zoneId: number | undefined, companyId: number | null | undefined): Observable<ParkingProcessZoneInfoDTO> {
        let url_ = this.baseUrl + "/api/Parking/GetParkingProcessZoneInfoWithSubscriptionsRequiringValidation?";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingProcessZoneInfoWithSubscriptionsRequiringValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingProcessZoneInfoWithSubscriptionsRequiringValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessZoneInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessZoneInfoDTO>;
        }));
    }

    protected processGetParkingProcessZoneInfoWithSubscriptionsRequiringValidation(response: HttpResponseBase): Observable<ParkingProcessZoneInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingProcessZoneInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingEntryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getParkingOffendersForClient(clientId: number | undefined, startTime: DateTime | undefined, skip: number | undefined, take: number | undefined): Observable<ParkingEntryDTO[]> {
        let url_ = this.baseUrl + "/GetParkingOffendersForClient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toString() : "") + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingOffendersForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingOffendersForClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingEntryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingEntryDTO[]>;
        }));
    }

    protected processGetParkingOffendersForClient(response: HttpResponseBase): Observable<ParkingEntryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingEntryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParkingEntriesForSession(parkingRangerSessionId: number | undefined): Observable<ParkingEntryDTO[]> {
        let url_ = this.baseUrl + "/GetParkingEntriesForSession?";
        if (parkingRangerSessionId === null)
            throw new globalThis.Error("The parameter 'parkingRangerSessionId' cannot be null.");
        else if (parkingRangerSessionId !== undefined)
            url_ += "parkingRangerSessionId=" + encodeURIComponent("" + parkingRangerSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingEntriesForSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingEntriesForSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingEntryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingEntryDTO[]>;
        }));
    }

    protected processGetParkingEntriesForSession(response: HttpResponseBase): Observable<ParkingEntryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingEntryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingPaymentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    handleFastCheckinPayment(dto: FastCheckinPaymentDTO, language: string | undefined): Observable<FastCheckinPaymentSessionInfoDTO> {
        let url_ = this.baseUrl + "/api/ParkingPayment/HandleFastCheckinPayment?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleFastCheckinPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleFastCheckinPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FastCheckinPaymentSessionInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FastCheckinPaymentSessionInfoDTO>;
        }));
    }

    protected processHandleFastCheckinPayment(response: HttpResponseBase): Observable<FastCheckinPaymentSessionInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FastCheckinPaymentSessionInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingPermitClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    createParkingPermit(parkerId: number | undefined): Observable<ParkingPermitDTO> {
        let url_ = this.baseUrl + "/api/ParkingPermit/CreateParkingPermit?";
        if (parkerId === null)
            throw new globalThis.Error("The parameter 'parkerId' cannot be null.");
        else if (parkerId !== undefined)
            url_ += "parkerId=" + encodeURIComponent("" + parkerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateParkingPermit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateParkingPermit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingPermitDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingPermitDTO>;
        }));
    }

    protected processCreateParkingPermit(response: HttpResponseBase): Observable<ParkingPermitDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingPermitDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    renewParkingPermit(parkerId: number | undefined): Observable<ParkingPermitDTO> {
        let url_ = this.baseUrl + "/api/ParkingPermit/RenewParkingPermit?";
        if (parkerId === null)
            throw new globalThis.Error("The parameter 'parkerId' cannot be null.");
        else if (parkerId !== undefined)
            url_ += "parkerId=" + encodeURIComponent("" + parkerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewParkingPermit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewParkingPermit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingPermitDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingPermitDTO>;
        }));
    }

    protected processRenewParkingPermit(response: HttpResponseBase): Observable<ParkingPermitDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingPermitDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateVisitorSessionByParkingPermit(dto: ValidateVisitorSessionByParkingPermitDTO): Observable<ValidateVisitorSessionByParkingPermitResultDTO> {
        let url_ = this.baseUrl + "/api/ParkingPermit/ValidateVisitorSessionByParkingPermit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateVisitorSessionByParkingPermit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateVisitorSessionByParkingPermit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateVisitorSessionByParkingPermitResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateVisitorSessionByParkingPermitResultDTO>;
        }));
    }

    protected processValidateVisitorSessionByParkingPermit(response: HttpResponseBase): Observable<ValidateVisitorSessionByParkingPermitResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateVisitorSessionByParkingPermitResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrintableParkingPermit(parkerId: number | undefined): Observable<PrintableParkingPermitDTO> {
        let url_ = this.baseUrl + "/api/ParkingPermit/GetPrintableParkingPermit?";
        if (parkerId === null)
            throw new globalThis.Error("The parameter 'parkerId' cannot be null.");
        else if (parkerId !== undefined)
            url_ += "parkerId=" + encodeURIComponent("" + parkerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrintableParkingPermit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrintableParkingPermit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintableParkingPermitDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintableParkingPermitDTO>;
        }));
    }

    protected processGetPrintableParkingPermit(response: HttpResponseBase): Observable<PrintableParkingPermitDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintableParkingPermitDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignParkingCardToVisitor(dto: AssignParkingCardToVisitorDTO): Observable<ParkingCardDTO> {
        let url_ = this.baseUrl + "/api/ParkingPermit/AssignParkingCardToVisitor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignParkingCardToVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignParkingCardToVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingCardDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingCardDTO>;
        }));
    }

    protected processAssignParkingCardToVisitor(response: HttpResponseBase): Observable<ParkingCardDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingCardDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingPriceCalculationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    calculateParkingPrice(dto: CalculateParkingPriceDTO): Observable<CalculateParkingPriceResultDTO> {
        let url_ = this.baseUrl + "/api/ParkingPriceCalculation/CalculateParkingPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateParkingPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateParkingPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateParkingPriceResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateParkingPriceResultDTO>;
        }));
    }

    protected processCalculateParkingPrice(response: HttpResponseBase): Observable<CalculateParkingPriceResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateParkingPriceResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateForeignParkingPrice(dto: CalculateForeignParkingPriceDTO): Observable<CalculateParkingPriceResultDTO> {
        let url_ = this.baseUrl + "/api/ParkingPriceCalculation/CalculateForeignParkingPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateForeignParkingPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateForeignParkingPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateParkingPriceResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateParkingPriceResultDTO>;
        }));
    }

    protected processCalculateForeignParkingPrice(response: HttpResponseBase): Observable<CalculateParkingPriceResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateParkingPriceResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateVisitorParkingCardPrice(dto: CalculateVisitorParkingCardPriceDTO): Observable<CalculateVisitorParkingCardPriceResultDTO> {
        let url_ = this.baseUrl + "/api/ParkingPriceCalculation/CalculateVisitorParkingCardPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateVisitorParkingCardPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateVisitorParkingCardPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateVisitorParkingCardPriceResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateVisitorParkingCardPriceResultDTO>;
        }));
    }

    protected processCalculateVisitorParkingCardPrice(response: HttpResponseBase): Observable<CalculateVisitorParkingCardPriceResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateVisitorParkingCardPriceResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateParkingExtensionPrice(dto: CalculateExtendUserParkingDTO): Observable<CalculateParkingExtensionPriceResultDTO> {
        let url_ = this.baseUrl + "/api/ParkingPriceCalculation/CalculateParkingExtensionPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateParkingExtensionPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateParkingExtensionPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateParkingExtensionPriceResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateParkingExtensionPriceResultDTO>;
        }));
    }

    protected processCalculateParkingExtensionPrice(response: HttpResponseBase): Observable<CalculateParkingExtensionPriceResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateParkingExtensionPriceResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingProcessInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getParkingProcessInfo(): Observable<ParkingProcessInfoDTO> {
        let url_ = this.baseUrl + "/api/ParkingProcessInfo/GetParkingProcessInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingProcessInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingProcessInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessInfoDTO>;
        }));
    }

    protected processGetParkingProcessInfo(response: HttpResponseBase): Observable<ParkingProcessInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingProcessInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParkingProcessInfos(): Observable<ParkingProcessInfoDTO[]> {
        let url_ = this.baseUrl + "/api/ParkingProcessInfo/GetParkingProcessInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingProcessInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingProcessInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessInfoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessInfoDTO[]>;
        }));
    }

    protected processGetParkingProcessInfos(response: HttpResponseBase): Observable<ParkingProcessInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingProcessInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParkingProcessZoneInfos(clientId: number | undefined, includeForeignParkingZones: boolean | undefined): Observable<ParkingProcessZoneInfoDTO[]> {
        let url_ = this.baseUrl + "/api/ParkingProcessInfo/GetParkingProcessZoneInfos?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (includeForeignParkingZones === null)
            throw new globalThis.Error("The parameter 'includeForeignParkingZones' cannot be null.");
        else if (includeForeignParkingZones !== undefined)
            url_ += "includeForeignParkingZones=" + encodeURIComponent("" + includeForeignParkingZones) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingProcessZoneInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingProcessZoneInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessZoneInfoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessZoneInfoDTO[]>;
        }));
    }

    protected processGetParkingProcessZoneInfos(response: HttpResponseBase): Observable<ParkingProcessZoneInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingProcessZoneInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParkingProcessZoneInfo(zoneId: number | undefined): Observable<ParkingProcessZoneInfoDTO> {
        let url_ = this.baseUrl + "/api/ParkingProcessInfo/GetParkingProcessZoneInfo?";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingProcessZoneInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingProcessZoneInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessZoneInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessZoneInfoDTO>;
        }));
    }

    protected processGetParkingProcessZoneInfo(response: HttpResponseBase): Observable<ParkingProcessZoneInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingProcessZoneInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getForeignParkingProcessZoneInfo(zoneId: number | undefined): Observable<ParkingProcessZoneInfoDTO> {
        let url_ = this.baseUrl + "/api/ParkingProcessInfo/GetForeignParkingProcessZoneInfo?";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForeignParkingProcessZoneInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForeignParkingProcessZoneInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessZoneInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessZoneInfoDTO>;
        }));
    }

    protected processGetForeignParkingProcessZoneInfo(response: HttpResponseBase): Observable<ParkingProcessZoneInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingProcessZoneInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getValidatableParkingProcessZoneInfo(zoneId: number | undefined, companyId: number | null | undefined): Observable<ParkingProcessZoneInfoDTO> {
        let url_ = this.baseUrl + "/api/ParkingProcessInfo/GetValidatableParkingProcessZoneInfo?";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidatableParkingProcessZoneInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidatableParkingProcessZoneInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingProcessZoneInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingProcessZoneInfoDTO>;
        }));
    }

    protected processGetValidatableParkingProcessZoneInfo(response: HttpResponseBase): Observable<ParkingProcessZoneInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingProcessZoneInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingQuotaInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getParkingQuotaInfo(parkingSubscriptionId: number | undefined, startTimeUtc: DateTime | undefined): Observable<ParkingQuotaInfoDTO> {
        let url_ = this.baseUrl + "/api/ParkingQuotaInfo/GetParkingQuotaInfo?";
        if (parkingSubscriptionId === null)
            throw new globalThis.Error("The parameter 'parkingSubscriptionId' cannot be null.");
        else if (parkingSubscriptionId !== undefined)
            url_ += "parkingSubscriptionId=" + encodeURIComponent("" + parkingSubscriptionId) + "&";
        if (startTimeUtc === null)
            throw new globalThis.Error("The parameter 'startTimeUtc' cannot be null.");
        else if (startTimeUtc !== undefined)
            url_ += "startTimeUtc=" + encodeURIComponent(startTimeUtc ? "" + startTimeUtc.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingQuotaInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingQuotaInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingQuotaInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingQuotaInfoDTO>;
        }));
    }

    protected processGetParkingQuotaInfo(response: HttpResponseBase): Observable<ParkingQuotaInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingQuotaInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingRangerCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getParkingRangerCheckPreview(zoneId: number | undefined, controlPlateNumber: string | undefined, controlPlateCountryCode: string | null | undefined, controlPlateType: ControlPlateType | null | undefined): Observable<ParkingRangerCheckPreviewResultDTO> {
        let url_ = this.baseUrl + "/api/ParkingRangerCheck/GetParkingRangerCheckPreview?";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "ZoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (controlPlateNumber === null)
            throw new globalThis.Error("The parameter 'controlPlateNumber' cannot be null.");
        else if (controlPlateNumber !== undefined)
            url_ += "ControlPlateNumber=" + encodeURIComponent("" + controlPlateNumber) + "&";
        if (controlPlateCountryCode !== undefined && controlPlateCountryCode !== null)
            url_ += "ControlPlateCountryCode=" + encodeURIComponent("" + controlPlateCountryCode) + "&";
        if (controlPlateType !== undefined && controlPlateType !== null)
            url_ += "ControlPlateType=" + encodeURIComponent("" + controlPlateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingRangerCheckPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingRangerCheckPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingRangerCheckPreviewResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingRangerCheckPreviewResultDTO>;
        }));
    }

    protected processGetParkingRangerCheckPreview(response: HttpResponseBase): Observable<ParkingRangerCheckPreviewResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingRangerCheckPreviewResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerParkingRangerCheck(dto: RegisterParkingRangerCheckDTO): Observable<RegisterParkingRangerCheckResultDTO> {
        let url_ = this.baseUrl + "/api/ParkingRangerCheck/RegisterParkingRangerCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterParkingRangerCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterParkingRangerCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterParkingRangerCheckResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterParkingRangerCheckResultDTO>;
        }));
    }

    protected processRegisterParkingRangerCheck(response: HttpResponseBase): Observable<RegisterParkingRangerCheckResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterParkingRangerCheckResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateParkingRangerCheckRegistration(updateDto: UpdateParkerRegistrationDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingRangerCheck/UpdateParkingRangerCheckRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParkingRangerCheckRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParkingRangerCheckRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateParkingRangerCheckRegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegistrationImage(registrationId: number | undefined, mediaId: string | undefined): Observable<string | null> {
        let url_ = this.baseUrl + "/api/ParkingRangerCheck/GetRegistrationImage?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        if (mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' cannot be null.");
        else if (mediaId !== undefined)
            url_ += "mediaId=" + encodeURIComponent("" + mediaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetRegistrationImage(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRegistrationImage(addDto: AddRegistrationImageDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/ParkingRangerCheck/AddRegistrationImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRegistrationImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRegistrationImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddRegistrationImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRegistrationImage(updateDto: UpdateRegistrationImage): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingRangerCheck/UpdateRegistrationImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRegistrationImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRegistrationImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRegistrationImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRegistrationImage(deleteDto: DeleteRegistrationImageDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingRangerCheck/DeleteRegistrationImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRegistrationImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRegistrationImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRegistrationImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingRangerClientZoneAssignmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchParkingRangerClientZoneAssignments(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkingRangerClientZoneAssignmentDTO> {
        let url_ = this.baseUrl + "/api/ParkingRangerClientZoneAssignment/SearchParkingRangerClientZoneAssignments?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkingRangerClientZoneAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkingRangerClientZoneAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkingRangerClientZoneAssignmentDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkingRangerClientZoneAssignmentDTO>;
        }));
    }

    protected processSearchParkingRangerClientZoneAssignments(response: HttpResponseBase): Observable<PagedResultDTOOfParkingRangerClientZoneAssignmentDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkingRangerClientZoneAssignmentDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createParkingRangerClientZoneAssignments(dto: CreateParkingRangerClientZoneAssignmentDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingRangerClientZoneAssignment/CreateParkingRangerClientZoneAssignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateParkingRangerClientZoneAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateParkingRangerClientZoneAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateParkingRangerClientZoneAssignments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editParkingRangerClientZoneAssignments(dto: EditParkingRangerClientZoneAssignmentDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingRangerClientZoneAssignment/EditParkingRangerClientZoneAssignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditParkingRangerClientZoneAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditParkingRangerClientZoneAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditParkingRangerClientZoneAssignments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteParkingRangerClientZoneAssignment(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingRangerClientZoneAssignment/DeleteParkingRangerClientZoneAssignment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParkingRangerClientZoneAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParkingRangerClientZoneAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParkingRangerClientZoneAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkDeleteParkingRangerClientZoneAssignment(userId: string | undefined, clientId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingRangerClientZoneAssignment/BulkDeleteParkingRangerClientZoneAssignment?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkDeleteParkingRangerClientZoneAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkDeleteParkingRangerClientZoneAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkDeleteParkingRangerClientZoneAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchParkingRangers(searchText: string | undefined, skip: number | undefined, take: number | undefined): Observable<ParkingRangerClientZoneAssignmentUserInfoDTO[]> {
        let url_ = this.baseUrl + "/api/ParkingRangerClientZoneAssignment/SearchParkingRangers?";
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkingRangers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkingRangers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingRangerClientZoneAssignmentUserInfoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingRangerClientZoneAssignmentUserInfoDTO[]>;
        }));
    }

    protected processSearchParkingRangers(response: HttpResponseBase): Observable<ParkingRangerClientZoneAssignmentUserInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingRangerClientZoneAssignmentUserInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchZonesByClient(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO> {
        let url_ = this.baseUrl + "/api/ParkingRangerClientZoneAssignment/SearchZonesByClient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchZonesByClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchZonesByClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO>;
        }));
    }

    protected processSearchZonesByClient(response: HttpResponseBase): Observable<PagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignedZones(): Observable<ParkingRangerZoneInfoDTO[]> {
        let url_ = this.baseUrl + "/api/ParkingRangerClientZoneAssignment/GetAssignedZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingRangerZoneInfoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingRangerZoneInfoDTO[]>;
        }));
    }

    protected processGetAssignedZones(response: HttpResponseBase): Observable<ParkingRangerZoneInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingRangerZoneInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingRangerSessionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getSession(sessionId: number | undefined): Observable<ParkingRangerSessionDTO> {
        let url_ = this.baseUrl + "/api/ParkingRangerSession/GetSession?";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingRangerSessionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingRangerSessionDTO>;
        }));
    }

    protected processGetSession(response: HttpResponseBase): Observable<ParkingRangerSessionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingRangerSessionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSessionFullyExpanded(sessionId: number | undefined): Observable<ExtendedParkingRangerSessionDTO> {
        let url_ = this.baseUrl + "/api/ParkingRangerSession/GetSessionFullyExpanded?";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessionFullyExpanded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessionFullyExpanded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendedParkingRangerSessionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendedParkingRangerSessionDTO>;
        }));
    }

    protected processGetSessionFullyExpanded(response: HttpResponseBase): Observable<ExtendedParkingRangerSessionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtendedParkingRangerSessionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveSession(): Observable<ActiveParkingRangerSessionDTO> {
        let url_ = this.baseUrl + "/api/ParkingRangerSession/GetActiveSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveParkingRangerSessionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveParkingRangerSessionDTO>;
        }));
    }

    protected processGetActiveSession(response: HttpResponseBase): Observable<ActiveParkingRangerSessionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveParkingRangerSessionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchSessions(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkingRangerSessionDTO> {
        let url_ = this.baseUrl + "/api/ParkingRangerSession/SearchSessions?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkingRangerSessionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkingRangerSessionDTO>;
        }));
    }

    protected processSearchSessions(response: HttpResponseBase): Observable<PagedResultDTOOfParkingRangerSessionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkingRangerSessionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAndStartSession(createDto: CreateParkingRangerSessionDTO): Observable<ParkingRangerSessionDTO> {
        let url_ = this.baseUrl + "/api/ParkingRangerSession/CreateAndStartSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndStartSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndStartSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingRangerSessionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingRangerSessionDTO>;
        }));
    }

    protected processCreateAndStartSession(response: HttpResponseBase): Observable<ParkingRangerSessionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingRangerSessionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSession(updateDto: UpdateParkingRangerSessionDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingRangerSession/UpdateSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminateSession(sessionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingRangerSession/TerminateSession?";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminateSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminateSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminateSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSession(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingRangerSession/DeleteSession?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingSessionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchParkingSessions(clientId: number | null | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkingSessionDTO> {
        let url_ = this.baseUrl + "/api/ParkingSession/SearchParkingSessions?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkingSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkingSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkingSessionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkingSessionDTO>;
        }));
    }

    protected processSearchParkingSessions(response: HttpResponseBase): Observable<PagedResultDTOOfParkingSessionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfParkingSessionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recalculateParkingSession(sessionId: number | undefined, newSubscriptionId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingSession/RecalculateParkingSession?";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (newSubscriptionId !== undefined && newSubscriptionId !== null)
            url_ += "newSubscriptionId=" + encodeURIComponent("" + newSubscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecalculateParkingSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateParkingSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecalculateParkingSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    adjustSessionStartTime(dto: AdjustSessionStartTimeDTO): Observable<ParkingSessionDTO> {
        let url_ = this.baseUrl + "/api/ParkingSession/AdjustSessionStartTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustSessionStartTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustSessionStartTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSessionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSessionDTO>;
        }));
    }

    protected processAdjustSessionStartTime(response: HttpResponseBase): Observable<ParkingSessionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingSessionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    adjustSessionEndTime(dto: AdjustSessionEndTimeDTO): Observable<ParkingSessionDTO> {
        let url_ = this.baseUrl + "/api/ParkingSession/AdjustSessionEndTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustSessionEndTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustSessionEndTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSessionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSessionDTO>;
        }));
    }

    protected processAdjustSessionEndTime(response: HttpResponseBase): Observable<ParkingSessionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingSessionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParkingSessionIdsForParker(dto: GetParkingSessionIdsForParkerDTO): Observable<ParkingSessionInfoShortDTO[]> {
        let url_ = this.baseUrl + "/api/ParkingSession/GetParkingSessionIdsForParker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingSessionIdsForParker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingSessionIdsForParker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSessionInfoShortDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSessionInfoShortDTO[]>;
        }));
    }

    protected processGetParkingSessionIdsForParker(response: HttpResponseBase): Observable<ParkingSessionInfoShortDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingSessionInfoShortDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingSubscriptionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getParkingSubscription(id: number | undefined): Observable<ParkingSubscriptionDTO> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/GetParkingSubscription?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSubscriptionDTO>;
        }));
    }

    protected processGetParkingSubscription(response: HttpResponseBase): Observable<ParkingSubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingSubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createParkingSubscription(createParkingSubscriptionDto: CreateParkingSubscriptionDTO): Observable<ParkingSubscriptionDTO> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/CreateParkingSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createParkingSubscriptionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateParkingSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateParkingSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSubscriptionDTO>;
        }));
    }

    protected processCreateParkingSubscription(response: HttpResponseBase): Observable<ParkingSubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingSubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchParkingSubscriptions(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfParkingSubscriptionDTO | null> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/SearchParkingSubscriptions?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkingSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkingSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkingSubscriptionDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkingSubscriptionDTO | null>;
        }));
    }

    protected processSearchParkingSubscriptions(response: HttpResponseBase): Observable<PagedResultDTOOfParkingSubscriptionDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfParkingSubscriptionDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateParkingSubscription(updateParkingSubscription: UpdateParkingSubscriptionDTO): Observable<ParkingSubscriptionDTO> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/UpdateParkingSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateParkingSubscription);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParkingSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParkingSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSubscriptionDTO>;
        }));
    }

    protected processUpdateParkingSubscription(response: HttpResponseBase): Observable<ParkingSubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingSubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteParkingSubscription(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/DeleteParkingSubscription?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParkingSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParkingSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParkingSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveSubscriptionToNewTariff(subscriptionId: number | undefined, oldTariffId: number | null | undefined, newTariffId: number | null | undefined): Observable<ParkingSubscriptionDTO> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/MoveSubscriptionToNewTariff?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (oldTariffId !== undefined && oldTariffId !== null)
            url_ += "oldTariffId=" + encodeURIComponent("" + oldTariffId) + "&";
        if (newTariffId !== undefined && newTariffId !== null)
            url_ += "newTariffId=" + encodeURIComponent("" + newTariffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveSubscriptionToNewTariff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveSubscriptionToNewTariff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSubscriptionDTO>;
        }));
    }

    protected processMoveSubscriptionToNewTariff(response: HttpResponseBase): Observable<ParkingSubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingSubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveToStructuralEntry(subscriptionId: number | undefined, fromStructuralEntryId: number | null | undefined, toStructuralEntryId: number | null | undefined): Observable<ParkingSubscriptionDTO> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/MoveToStructuralEntry?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (fromStructuralEntryId !== undefined && fromStructuralEntryId !== null)
            url_ += "fromStructuralEntryId=" + encodeURIComponent("" + fromStructuralEntryId) + "&";
        if (toStructuralEntryId !== undefined && toStructuralEntryId !== null)
            url_ += "toStructuralEntryId=" + encodeURIComponent("" + toStructuralEntryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveToStructuralEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveToStructuralEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSubscriptionDTO>;
        }));
    }

    protected processMoveToStructuralEntry(response: HttpResponseBase): Observable<ParkingSubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingSubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addToStructuralEntry(subscriptionId: number | undefined, structuralEntryId: number | undefined): Observable<ParkingSubscriptionDTO> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/AddToStructuralEntry?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (structuralEntryId === null)
            throw new globalThis.Error("The parameter 'structuralEntryId' cannot be null.");
        else if (structuralEntryId !== undefined)
            url_ += "structuralEntryId=" + encodeURIComponent("" + structuralEntryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddToStructuralEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddToStructuralEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSubscriptionDTO>;
        }));
    }

    protected processAddToStructuralEntry(response: HttpResponseBase): Observable<ParkingSubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingSubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeFromStructuralEntry(subscriptionId: number | undefined, structuralEntryId: number | undefined): Observable<ParkingSubscriptionDTO> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/RemoveFromStructuralEntry?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (structuralEntryId === null)
            throw new globalThis.Error("The parameter 'structuralEntryId' cannot be null.");
        else if (structuralEntryId !== undefined)
            url_ += "structuralEntryId=" + encodeURIComponent("" + structuralEntryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFromStructuralEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFromStructuralEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSubscriptionDTO>;
        }));
    }

    protected processRemoveFromStructuralEntry(response: HttpResponseBase): Observable<ParkingSubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingSubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isParkingSubscriptionUsedInSessions(subscriptionId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/IsParkingSubscriptionUsedInSessions?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsParkingSubscriptionUsedInSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsParkingSubscriptionUsedInSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsParkingSubscriptionUsedInSessions(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscriptionsForValidationFallback(clientId: number | undefined, subscriptionId: number | undefined): Observable<ParkingSubscriptionLimitedDTO[]> {
        let url_ = this.baseUrl + "/api/ParkingSubscription/GetSubscriptionsForValidationFallback?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionsForValidationFallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionsForValidationFallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingSubscriptionLimitedDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingSubscriptionLimitedDTO[]>;
        }));
    }

    protected processGetSubscriptionsForValidationFallback(response: HttpResponseBase): Observable<ParkingSubscriptionLimitedDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingSubscriptionLimitedDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParkingTariffClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getParkingTariff(id: number | undefined): Observable<ParkingTariffDTO> {
        let url_ = this.baseUrl + "/api/ParkingTariff/GetParkingTariff?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingTariff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingTariff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingTariffDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingTariffDTO>;
        }));
    }

    protected processGetParkingTariff(response: HttpResponseBase): Observable<ParkingTariffDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingTariffDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParkingTariffsForZone(zoneId: number | undefined): Observable<ParkingTariffDTO[]> {
        let url_ = this.baseUrl + "/api/ParkingTariff/GetParkingTariffsForZone?";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingTariffsForZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingTariffsForZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingTariffDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingTariffDTO[]>;
        }));
    }

    protected processGetParkingTariffsForZone(response: HttpResponseBase): Observable<ParkingTariffDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkingTariffDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createParkingTariff(createParkingTariffDto: CreateParkingTariffDTO): Observable<ParkingTariffDTO | null> {
        let url_ = this.baseUrl + "/api/ParkingTariff/CreateParkingTariff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createParkingTariffDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateParkingTariff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateParkingTariff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingTariffDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingTariffDTO | null>;
        }));
    }

    protected processCreateParkingTariff(response: HttpResponseBase): Observable<ParkingTariffDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ParkingTariffDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchParkingTariffs(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined): Observable<PagedResultDTOOfParkingTariffLimitedDTO | null> {
        let url_ = this.baseUrl + "/api/ParkingTariff/SearchParkingTariffs?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchParkingTariffs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchParkingTariffs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfParkingTariffLimitedDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfParkingTariffLimitedDTO | null>;
        }));
    }

    protected processSearchParkingTariffs(response: HttpResponseBase): Observable<PagedResultDTOOfParkingTariffLimitedDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfParkingTariffLimitedDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateParkingTariff(updateParkingTariff: UpdateParkingTariffDTO): Observable<ParkingTariffDTO | null> {
        let url_ = this.baseUrl + "/api/ParkingTariff/UpdateParkingTariff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateParkingTariff);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParkingTariff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParkingTariff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingTariffDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingTariffDTO | null>;
        }));
    }

    protected processUpdateParkingTariff(response: HttpResponseBase): Observable<ParkingTariffDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ParkingTariffDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteParkingTariff(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingTariff/DeleteParkingTariff?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParkingTariff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParkingTariff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParkingTariff(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignNewSubscriptionToTariff(id: number | undefined, subscriptionId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ParkingTariff/AssignNewSubscriptionToTariff?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (subscriptionId !== undefined && subscriptionId !== null)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignNewSubscriptionToTariff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignNewSubscriptionToTariff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignNewSubscriptionToTariff(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveTariffToNewZone(id: number | undefined, oldZoneId: number | null | undefined, newZoneId: number | null | undefined): Observable<ParkingTariffDTO> {
        let url_ = this.baseUrl + "/api/ParkingTariff/MoveTariffToNewZone?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (oldZoneId !== undefined && oldZoneId !== null)
            url_ += "oldZoneId=" + encodeURIComponent("" + oldZoneId) + "&";
        if (newZoneId !== undefined && newZoneId !== null)
            url_ += "newZoneId=" + encodeURIComponent("" + newZoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTariffToNewZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTariffToNewZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkingTariffDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkingTariffDTO>;
        }));
    }

    protected processMoveTariffToNewZone(response: HttpResponseBase): Observable<ParkingTariffDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParkingTariffDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentManagementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getAllPaymentAlias(): Observable<PaymentAliasDTO[] | null> {
        let url_ = this.baseUrl + "/api/PaymentManagement/GetAllPaymentAlias";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaymentAlias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaymentAlias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentAliasDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentAliasDTO[] | null>;
        }));
    }

    protected processGetAllPaymentAlias(response: HttpResponseBase): Observable<PaymentAliasDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentAliasDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePaymentAlias(dto: DeletePaymentAliasDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/PaymentManagement/DeletePaymentAlias";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePaymentAlias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePaymentAlias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePaymentAlias(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPaymentAlias(dto: AddPaymentAliasDTO): Observable<AddPaymentAliasResultDTO> {
        let url_ = this.baseUrl + "/api/PaymentManagement/AddPaymentAlias";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPaymentAlias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPaymentAlias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddPaymentAliasResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddPaymentAliasResultDTO>;
        }));
    }

    protected processAddPaymentAlias(response: HttpResponseBase): Observable<AddPaymentAliasResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPaymentAliasResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notifyAddPaymentAliasFinished(dto: NotifyAddPaymentAliasFinishedDTO): Observable<PaymentAliasDTO> {
        let url_ = this.baseUrl + "/api/PaymentManagement/NotifyAddPaymentAliasFinished";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyAddPaymentAliasFinished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyAddPaymentAliasFinished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentAliasDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentAliasDTO>;
        }));
    }

    protected processNotifyAddPaymentAliasFinished(response: HttpResponseBase): Observable<PaymentAliasDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentAliasDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setFavoritePaymentMethod(paymentAliasId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PaymentManagement/SetFavoritePaymentMethod?";
        if (paymentAliasId === null)
            throw new globalThis.Error("The parameter 'paymentAliasId' cannot be null.");
        else if (paymentAliasId !== undefined)
            url_ += "paymentAliasId=" + encodeURIComponent("" + paymentAliasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFavoritePaymentMethod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFavoritePaymentMethod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetFavoritePaymentMethod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchPaymentReportData(reportParameterDTO: PaymentReportParameterDTO, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfPaymentReportDTO> {
        let url_ = this.baseUrl + "/api/Reports/SearchPaymentReportData?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPaymentReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPaymentReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfPaymentReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfPaymentReportDTO>;
        }));
    }

    protected processSearchPaymentReportData(response: HttpResponseBase): Observable<PagedResultDTOOfPaymentReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfPaymentReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPaymentReport(saveReport: boolean | undefined, reportParameterDto: PaymentReportParameterDTO): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/Reports/ExportPaymentReport?";
        if (saveReport === null)
            throw new globalThis.Error("The parameter 'saveReport' cannot be null.");
        else if (saveReport !== undefined)
            url_ += "saveReport=" + encodeURIComponent("" + saveReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPaymentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPaymentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processExportPaymentReport(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PayTillNowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getUsersZoneInfosAndActiveSessionsForValidationCode(dto: GetUsersZoneInfosAndSessionsForValidationCodeDTO): Observable<ZoneInfosAndActiveParkingSessionsDTO> {
        let url_ = this.baseUrl + "/api/PayTillNow/GetUsersZoneInfosAndActiveSessionsForValidationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersZoneInfosAndActiveSessionsForValidationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersZoneInfosAndActiveSessionsForValidationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneInfosAndActiveParkingSessionsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneInfosAndActiveParkingSessionsDTO>;
        }));
    }

    protected processGetUsersZoneInfosAndActiveSessionsForValidationCode(response: HttpResponseBase): Observable<ZoneInfosAndActiveParkingSessionsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneInfosAndActiveParkingSessionsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParkingProcessZoneInfosForValidationCode(dto: GetParkingProcessZoneInfosForValidationCodeDTO): Observable<ZoneInfosDTO> {
        let url_ = this.baseUrl + "/api/PayTillNow/GetParkingProcessZoneInfosForValidationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParkingProcessZoneInfosForValidationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParkingProcessZoneInfosForValidationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneInfosDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneInfosDTO>;
        }));
    }

    protected processGetParkingProcessZoneInfosForValidationCode(response: HttpResponseBase): Observable<ZoneInfosDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneInfosDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersZoneInfosAndActiveSessionsForZone(dto: GetUsersZoneInfosAndSessionsForZoneDTO): Observable<ZoneInfosAndActiveParkingSessionsDTO> {
        let url_ = this.baseUrl + "/api/PayTillNow/GetUsersZoneInfosAndActiveSessionsForZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersZoneInfosAndActiveSessionsForZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersZoneInfosAndActiveSessionsForZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneInfosAndActiveParkingSessionsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneInfosAndActiveParkingSessionsDTO>;
        }));
    }

    protected processGetUsersZoneInfosAndActiveSessionsForZone(response: HttpResponseBase): Observable<ZoneInfosAndActiveParkingSessionsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneInfosAndActiveParkingSessionsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHWControlledSessionInfoForUserLicensePlate(dto: GetHWControlledSessionInfoForLicensePlateDTO): Observable<HWControlledSessionInfoResultDTO | null> {
        let url_ = this.baseUrl + "/api/PayTillNow/GetHWControlledSessionInfoForUserLicensePlate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHWControlledSessionInfoForUserLicensePlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHWControlledSessionInfoForUserLicensePlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HWControlledSessionInfoResultDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HWControlledSessionInfoResultDTO | null>;
        }));
    }

    protected processGetHWControlledSessionInfoForUserLicensePlate(response: HttpResponseBase): Observable<HWControlledSessionInfoResultDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HWControlledSessionInfoResultDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHWControlledSessionInfoForLicensePlate(dto: GetHWControlledSessionInfoForLicensePlateDTO): Observable<HWControlledSessionInfoResultDTO | null> {
        let url_ = this.baseUrl + "/api/PayTillNow/GetHWControlledSessionInfoForLicensePlate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHWControlledSessionInfoForLicensePlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHWControlledSessionInfoForLicensePlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HWControlledSessionInfoResultDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HWControlledSessionInfoResultDTO | null>;
        }));
    }

    protected processGetHWControlledSessionInfoForLicensePlate(response: HttpResponseBase): Observable<HWControlledSessionInfoResultDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HWControlledSessionInfoResultDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    startPayTillNowUserPayment(dto: PayTillNowStartPaymentDTO): Observable<PayTillNowStartPaymentResultDTO> {
        let url_ = this.baseUrl + "/api/PayTillNow/StartPayTillNowUserPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartPayTillNowUserPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartPayTillNowUserPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayTillNowStartPaymentResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayTillNowStartPaymentResultDTO>;
        }));
    }

    protected processStartPayTillNowUserPayment(response: HttpResponseBase): Observable<PayTillNowStartPaymentResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayTillNowStartPaymentResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    startPayTillNowPayment(dto: PayTillNowStartPaymentDTO): Observable<PayTillNowStartPaymentResultDTO> {
        let url_ = this.baseUrl + "/api/PayTillNow/StartPayTillNowPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartPayTillNowPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartPayTillNowPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayTillNowStartPaymentResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayTillNowStartPaymentResultDTO>;
        }));
    }

    protected processStartPayTillNowPayment(response: HttpResponseBase): Observable<PayTillNowStartPaymentResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayTillNowStartPaymentResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setPayTillNowUserPaymentDone(dto: SetPayTillNowPaymentDoneDTO): Observable<SetPayTillNowPaymentDoneResultDTO> {
        let url_ = this.baseUrl + "/api/PayTillNow/SetPayTillNowUserPaymentDone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPayTillNowUserPaymentDone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPayTillNowUserPaymentDone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetPayTillNowPaymentDoneResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetPayTillNowPaymentDoneResultDTO>;
        }));
    }

    protected processSetPayTillNowUserPaymentDone(response: HttpResponseBase): Observable<SetPayTillNowPaymentDoneResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetPayTillNowPaymentDoneResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPayTillNowParkingSessionInfo(dto: PayTillNowSessionDTO): Observable<PayTillNowParkingSessionInfoDTO | null> {
        let url_ = this.baseUrl + "/api/PayTillNow/GetPayTillNowParkingSessionInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayTillNowParkingSessionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayTillNowParkingSessionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayTillNowParkingSessionInfoDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayTillNowParkingSessionInfoDTO | null>;
        }));
    }

    protected processGetPayTillNowParkingSessionInfo(response: HttpResponseBase): Observable<PayTillNowParkingSessionInfoDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PayTillNowParkingSessionInfoDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProblemReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    reportProblem(dto: CreateProblemReportDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ProblemReport/ReportProblem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportProblem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportProblem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportProblem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchProblemReports(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfProblemReportResponseDTO> {
        let url_ = this.baseUrl + "/api/ProblemReport/SearchProblemReports?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProblemReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProblemReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfProblemReportResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfProblemReportResponseDTO>;
        }));
    }

    protected processSearchProblemReports(response: HttpResponseBase): Observable<PagedResultDTOOfProblemReportResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfProblemReportResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchProblemReportLogs(problemReportId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfProblemReportLogResponseDTO> {
        let url_ = this.baseUrl + "/api/ProblemReport/SearchProblemReportLogs?";
        if (problemReportId === null)
            throw new globalThis.Error("The parameter 'problemReportId' cannot be null.");
        else if (problemReportId !== undefined)
            url_ += "problemReportId=" + encodeURIComponent("" + problemReportId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProblemReportLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProblemReportLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfProblemReportLogResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfProblemReportLogResponseDTO>;
        }));
    }

    protected processSearchProblemReportLogs(response: HttpResponseBase): Observable<PagedResultDTOOfProblemReportLogResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfProblemReportLogResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProblemReport(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ProblemReport/DeleteProblemReport?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProblemReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProblemReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProblemReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProxyAccessClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getAllParkers(skip: number | undefined, take: number | undefined, isoChangeDateTimeUtc: string | null | undefined): Observable<ProxyParkerDTO[]> {
        let url_ = this.baseUrl + "/api/ProxyAccess/GetAllParkers?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (isoChangeDateTimeUtc !== undefined && isoChangeDateTimeUtc !== null)
            url_ += "isoChangeDateTimeUtc=" + encodeURIComponent("" + isoChangeDateTimeUtc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParkers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParkers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProxyParkerDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProxyParkerDTO[]>;
        }));
    }

    protected processGetAllParkers(response: HttpResponseBase): Observable<ProxyParkerDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProxyParkerDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSyncInfo(): Observable<ProxySyncInfoDTO> {
        let url_ = this.baseUrl + "/api/ProxyAccess/GetSyncInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSyncInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSyncInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProxySyncInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProxySyncInfoDTO>;
        }));
    }

    protected processGetSyncInfo(response: HttpResponseBase): Observable<ProxySyncInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProxySyncInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSyncInfo(infoDto: ProxySyncInfoDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ProxyAccess/UpdateSyncInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(infoDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSyncInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSyncInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSyncInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateParkers(parkers: ProxyUpdateParkerDTO[]): Observable<ProxyParkerUpdateResponseDTO[]> {
        let url_ = this.baseUrl + "/api/ProxyAccess/UpdateParkers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parkers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParkers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParkers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProxyParkerUpdateResponseDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProxyParkerUpdateResponseDTO[]>;
        }));
    }

    protected processUpdateParkers(response: HttpResponseBase): Observable<ProxyParkerUpdateResponseDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProxyParkerUpdateResponseDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTags(dto: ProxyUpdateTagsDTO): Observable<ProxyUpdateTagsResponseDTO> {
        let url_ = this.baseUrl + "/api/ProxyAccess/UpdateTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProxyUpdateTagsResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProxyUpdateTagsResponseDTO>;
        }));
    }

    protected processUpdateTags(response: HttpResponseBase): Observable<ProxyUpdateTagsResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProxyUpdateTagsResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addProxyTagRegistrations(proxyAddDto: ProxyAddTagRegistrationsDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ProxyAccess/AddProxyTagRegistrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(proxyAddDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProxyTagRegistrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProxyTagRegistrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProxyTagRegistrations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addProxyNonTaggedRegistrations(dto: ProxyAddNonTaggedRegistrationsDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ProxyAccess/AddProxyNonTaggedRegistrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProxyNonTaggedRegistrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProxyNonTaggedRegistrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProxyNonTaggedRegistrations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestAccessByTag(requestDTO: ProxyRequestAccessByTagDTO): Observable<ProxyRequestAccessByTagResponseDTO> {
        let url_ = this.baseUrl + "/api/ProxyAccess/RequestAccessByTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestAccessByTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestAccessByTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProxyRequestAccessByTagResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProxyRequestAccessByTagResponseDTO>;
        }));
    }

    protected processRequestAccessByTag(response: HttpResponseBase): Observable<ProxyRequestAccessByTagResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProxyRequestAccessByTagResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestAccessByPlate(requestDTO: ProxyRequestAccessByPlateDTO): Observable<ProxyRequestAccessByPlateResponseDTO> {
        let url_ = this.baseUrl + "/api/ProxyAccess/RequestAccessByPlate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestAccessByPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestAccessByPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProxyRequestAccessByPlateResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProxyRequestAccessByPlateResponseDTO>;
        }));
    }

    protected processRequestAccessByPlate(response: HttpResponseBase): Observable<ProxyRequestAccessByPlateResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProxyRequestAccessByPlateResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerDeviceCommandExecution(dto: ProxyRegisterDeviceCommandExecutionDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ProxyAccess/RegisterDeviceCommandExecution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterDeviceCommandExecution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterDeviceCommandExecution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegisterDeviceCommandExecution(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateZoneDeviceState(deviceStateDto: ProxyUpdateZoneDeviceDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ProxyAccess/UpdateZoneDeviceState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceStateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZoneDeviceState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZoneDeviceState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateZoneDeviceState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    heartBeat(info: HeartBeatInfoDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ProxyAccess/HeartBeat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(info);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHeartBeat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHeartBeat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHeartBeat(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importTags(tagDto: ImportTagsDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ProxyAccess/ImportTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportTags(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProxyInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getClientInfo(): Observable<ClientDTO> {
        let url_ = this.baseUrl + "/api/ProxyInfo/GetClientInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO>;
        }));
    }

    protected processGetClientInfo(response: HttpResponseBase): Observable<ClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllDevices(): Observable<ProxyZoneDeviceDTO[] | null> {
        let url_ = this.baseUrl + "/api/ProxyInfo/GetAllDevices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProxyZoneDeviceDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProxyZoneDeviceDTO[] | null>;
        }));
    }

    protected processGetAllDevices(response: HttpResponseBase): Observable<ProxyZoneDeviceDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProxyZoneDeviceDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllCompanies(): Observable<ParkerCompanyDTO[] | null> {
        let url_ = this.baseUrl + "/api/ProxyInfo/GetAllCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParkerCompanyDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParkerCompanyDTO[] | null>;
        }));
    }

    protected processGetAllCompanies(response: HttpResponseBase): Observable<ParkerCompanyDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParkerCompanyDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNextDeviceCommands(maxWaitDuration: number | undefined): Observable<ProxyExecuteCommandDTO[] | null> {
        let url_ = this.baseUrl + "/api/ProxyInfo/GetNextDeviceCommands?";
        if (maxWaitDuration === null)
            throw new globalThis.Error("The parameter 'maxWaitDuration' cannot be null.");
        else if (maxWaitDuration !== undefined)
            url_ += "maxWaitDuration=" + encodeURIComponent("" + maxWaitDuration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextDeviceCommands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextDeviceCommands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProxyExecuteCommandDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProxyExecuteCommandDTO[] | null>;
        }));
    }

    protected processGetNextDeviceCommands(response: HttpResponseBase): Observable<ProxyExecuteCommandDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProxyExecuteCommandDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SavedReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchSavedReports(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined): Observable<PagedResultDTOOfSavedReportDTO | null> {
        let url_ = this.baseUrl + "/api/SavedReport/SearchSavedReports?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSavedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSavedReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfSavedReportDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfSavedReportDTO | null>;
        }));
    }

    protected processSearchSavedReports(response: HttpResponseBase): Observable<PagedResultDTOOfSavedReportDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfSavedReportDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSavedReportFile(clientId: number | undefined, savedReportId: number | undefined): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/SavedReport/GetSavedReportFile?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (savedReportId === null)
            throw new globalThis.Error("The parameter 'savedReportId' cannot be null.");
        else if (savedReportId !== undefined)
            url_ += "savedReportId=" + encodeURIComponent("" + savedReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSavedReportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSavedReportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processGetSavedReportFile(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getAllClients(): Observable<StatusClientDTO[]> {
        let url_ = this.baseUrl + "/api/Status/GetAllClients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusClientDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusClientDTO[]>;
        }));
    }

    protected processGetAllClients(response: HttpResponseBase): Observable<StatusClientDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusClientDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientAdminsSince(since: DateTime | null | undefined, skip: number | undefined, take: number | undefined): Observable<PagedResultDTOOfStatusClientAdminDTO> {
        let url_ = this.baseUrl + "/api/Status/GetClientAdminsSince?";
        if (since !== undefined && since !== null)
            url_ += "since=" + encodeURIComponent(since ? "" + since.toString() : "") + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientAdminsSince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientAdminsSince(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfStatusClientAdminDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfStatusClientAdminDTO>;
        }));
    }

    protected processGetClientAdminsSince(response: HttpResponseBase): Observable<PagedResultDTOOfStatusClientAdminDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfStatusClientAdminDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersSince(since: DateTime | null | undefined, skip: number | undefined, take: number | undefined): Observable<PagedResultDTOOfStatusUserDTO> {
        let url_ = this.baseUrl + "/api/Status/GetUsersSince?";
        if (since !== undefined && since !== null)
            url_ += "since=" + encodeURIComponent(since ? "" + since.toString() : "") + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersSince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersSince(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfStatusUserDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfStatusUserDTO>;
        }));
    }

    protected processGetUsersSince(response: HttpResponseBase): Observable<PagedResultDTOOfStatusUserDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfStatusUserDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SystemInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getSystemInformation(clientId: string | undefined, platform: MobilePlatform | undefined, currentVersion: string | undefined): Observable<SystemInformationDTO> {
        let url_ = this.baseUrl + "/api/SystemInfo/GetSystemInformation?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (platform === null)
            throw new globalThis.Error("The parameter 'platform' cannot be null.");
        else if (platform !== undefined)
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        if (currentVersion === null)
            throw new globalThis.Error("The parameter 'currentVersion' cannot be null.");
        else if (currentVersion !== undefined)
            url_ += "currentVersion=" + encodeURIComponent("" + currentVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemInformationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemInformationDTO>;
        }));
    }

    protected processGetSystemInformation(response: HttpResponseBase): Observable<SystemInformationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemInformationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    reportMobileClientProblem(zipStream: string): Observable<void> {
        let url_ = this.baseUrl + "/api/SystemInfo/ReportMobileClientProblem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zipStream);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportMobileClientProblem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportMobileClientProblem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportMobileClientProblem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TagMasterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchTagMasters(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined): Observable<PagedResultDTOOfTagMasterDTO> {
        let url_ = this.baseUrl + "/api/TagMaster/SearchTagMasters?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTagMasters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTagMasters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfTagMasterDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfTagMasterDTO>;
        }));
    }

    protected processSearchTagMasters(response: HttpResponseBase): Observable<PagedResultDTOOfTagMasterDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfTagMasterDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTagMasters(ids: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/TagMaster/DeleteTagMasters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTagMasters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTagMasters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTagMasters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TagsPerParkerReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchTagsPerParkerReportData(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, includeListElements: boolean | undefined): Observable<PagedResultDTOOfTagsPerParkerReportDTO> {
        let url_ = this.baseUrl + "/api/Reports/SearchTagsPerParkerReportData?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (includeListElements === null)
            throw new globalThis.Error("The parameter 'includeListElements' cannot be null.");
        else if (includeListElements !== undefined)
            url_ += "includeListElements=" + encodeURIComponent("" + includeListElements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTagsPerParkerReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTagsPerParkerReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfTagsPerParkerReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfTagsPerParkerReportDTO>;
        }));
    }

    protected processSearchTagsPerParkerReportData(response: HttpResponseBase): Observable<PagedResultDTOOfTagsPerParkerReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfTagsPerParkerReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportTagsPerParkerReport(clientId: number | undefined, fileType: ReportFileType | undefined, saveReport: boolean | undefined, reportParameterDto: TagsPerParkerReportParameterDTO): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/Reports/ExportTagsPerParkerReport?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (fileType === null)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (saveReport === null)
            throw new globalThis.Error("The parameter 'saveReport' cannot be null.");
        else if (saveReport !== undefined)
            url_ += "saveReport=" + encodeURIComponent("" + saveReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportParameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportTagsPerParkerReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTagsPerParkerReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processExportTagsPerParkerReport(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ThirdPartyParkingControlClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    checkLicensePlate(dto: ThirdPartyCheckLicensePlateDTO): Observable<ThirdPartyCheckLicensePlateResultDTO> {
        let url_ = this.baseUrl + "/ThirdPartyApi/ParkingControl/CheckLicensePlate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckLicensePlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckLicensePlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThirdPartyCheckLicensePlateResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThirdPartyCheckLicensePlateResultDTO>;
        }));
    }

    protected processCheckLicensePlate(response: HttpResponseBase): Observable<ThirdPartyCheckLicensePlateResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThirdPartyCheckLicensePlateResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ThirdPartyUserClientZoneAssignmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchThirdPartyUserClientZoneAssignments(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO> {
        let url_ = this.baseUrl + "/api/ThirdPartyUserClientZoneAssignment/SearchThirdPartyUserClientZoneAssignments?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchThirdPartyUserClientZoneAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchThirdPartyUserClientZoneAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO>;
        }));
    }

    protected processSearchThirdPartyUserClientZoneAssignments(response: HttpResponseBase): Observable<PagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createThirdPartyUserClientZoneAssignments(dto: CreateThirdPartyUserClientZoneAssignmentDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ThirdPartyUserClientZoneAssignment/CreateThirdPartyUserClientZoneAssignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateThirdPartyUserClientZoneAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateThirdPartyUserClientZoneAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateThirdPartyUserClientZoneAssignments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteThirdPartyUserClientZoneAssignment(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ThirdPartyUserClientZoneAssignment/DeleteThirdPartyUserClientZoneAssignment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteThirdPartyUserClientZoneAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteThirdPartyUserClientZoneAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteThirdPartyUserClientZoneAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkDeleteThirdPartyUserClientZoneAssignment(userId: string | undefined, clientId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ThirdPartyUserClientZoneAssignment/BulkDeleteThirdPartyUserClientZoneAssignment?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkDeleteThirdPartyUserClientZoneAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkDeleteThirdPartyUserClientZoneAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkDeleteThirdPartyUserClientZoneAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchThirdPartyUsers(searchText: string | undefined, skip: number | undefined, take: number | undefined): Observable<ThirdPartyUserClientZoneAssignmentUserInfoDTO[]> {
        let url_ = this.baseUrl + "/api/ThirdPartyUserClientZoneAssignment/SearchThirdPartyUsers?";
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchThirdPartyUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchThirdPartyUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThirdPartyUserClientZoneAssignmentUserInfoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThirdPartyUserClientZoneAssignmentUserInfoDTO[]>;
        }));
    }

    protected processSearchThirdPartyUsers(response: HttpResponseBase): Observable<ThirdPartyUserClientZoneAssignmentUserInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThirdPartyUserClientZoneAssignmentUserInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchZonesByClient(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO> {
        let url_ = this.baseUrl + "/api/ThirdPartyUserClientZoneAssignment/SearchZonesByClient?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchZonesByClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchZonesByClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO>;
        }));
    }

    protected processSearchZonesByClient(response: HttpResponseBase): Observable<PagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    info(): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/Info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processInfo(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerUser(model: CreateUserDTO): Observable<RegisterUserResultDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/RegisterUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterUserResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterUserResultDTO>;
        }));
    }

    protected processRegisterUser(response: HttpResponseBase): Observable<RegisterUserResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterUserResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchUsers(filters: FilterDTO[] | undefined, clientId: number | null | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfUserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/SearchUsers?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfUserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfUserInfoDTO>;
        }));
    }

    protected processSearchUsers(response: HttpResponseBase): Observable<PagedResultDTOOfUserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfUserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setUserLanguage(language: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/SetUserLanguage?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUserLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(model: UpdateUserInfoDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserNotificationSettings(dto: UpdateUserNotificationSettingsDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/UpdateUserNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processUpdateUserNotificationSettings(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addParkingRangerUser(model: CreateMobileUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/AddParkingRangerUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddParkingRangerUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddParkingRangerUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddParkingRangerUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addProxyUser(model: CreateProxyUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/AddProxyUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProxyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProxyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddProxyUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProxyUser(model: UpdateProxyUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/UpdateProxyUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProxyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProxyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processUpdateProxyUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addThirdPartyUser(model: CreateThirdPartyUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/AddThirdPartyUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddThirdPartyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddThirdPartyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddThirdPartyUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateThirdPartyUser(model: UpdateThirdPartyUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/UpdateThirdPartyUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateThirdPartyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateThirdPartyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processUpdateThirdPartyUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUser(model: CreateUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/AddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmEmail(userId: string | undefined, code: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/ConfirmEmail?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserAccount/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(model: ChangePasswordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserAccount/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setPassword(model: SetPasswordDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/SetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotPassword(model: ForgotPasswordDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUser(): Observable<UserDeletionResultDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/DeleteUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDeletionResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDeletionResultDTO>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<UserDeletionResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDeletionResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUserByAdmin(userId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/DeleteUserByAdmin?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserByAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUserByAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    request2FARegistrationCode(dto: Request2FARegistrationCodeDTO): Observable<Request2FARegistrationCodeResponseDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/Request2FARegistrationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequest2FARegistrationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequest2FARegistrationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Request2FARegistrationCodeResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Request2FARegistrationCodeResponseDTO>;
        }));
    }

    protected processRequest2FARegistrationCode(response: HttpResponseBase): Observable<Request2FARegistrationCodeResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Request2FARegistrationCodeResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verify2FARegistrationCode(dto: Verify2FARegistrationCodeDTO): Observable<Verify2FARegistrationCodeResponseDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/Verify2FARegistrationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerify2FARegistrationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerify2FARegistrationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Verify2FARegistrationCodeResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Verify2FARegistrationCodeResponseDTO>;
        }));
    }

    protected processVerify2FARegistrationCode(response: HttpResponseBase): Observable<Verify2FARegistrationCodeResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Verify2FARegistrationCodeResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reset2FARegistration(userId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/Reset2FARegistration?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReset2FARegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReset2FARegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReset2FARegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestSelfReset2FARegistration(dto: RequestSelfReset2FARegistrationDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/RequestSelfReset2FARegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestSelfReset2FARegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestSelfReset2FARegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestSelfReset2FARegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserControlPlateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getUserControlPlates(): Observable<UserControlPlateDTO[] | null> {
        let url_ = this.baseUrl + "/api/UserControlPlate/GetUserControlPlates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserControlPlates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserControlPlates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserControlPlateDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserControlPlateDTO[] | null>;
        }));
    }

    protected processGetUserControlPlates(response: HttpResponseBase): Observable<UserControlPlateDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserControlPlateDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserControlPlates(model: UpdateControlPlatesDTO): Observable<UserControlPlateDTO[] | null> {
        let url_ = this.baseUrl + "/api/UserControlPlate/UpdateUserControlPlates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserControlPlates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserControlPlates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserControlPlateDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserControlPlateDTO[] | null>;
        }));
    }

    protected processUpdateUserControlPlates(response: HttpResponseBase): Observable<UserControlPlateDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserControlPlateDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserExtractReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    searchUserExtractReportData(parameterDto: DateRangeParameterDTO, skip: number | undefined, take: number | undefined, sortByAscending: boolean | undefined): Observable<PagedResultDTOOfUserExtractReportDTO> {
        let url_ = this.baseUrl + "/api/Reports/SearchUserExtractReportData?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortByAscending === null)
            throw new globalThis.Error("The parameter 'sortByAscending' cannot be null.");
        else if (sortByAscending !== undefined)
            url_ += "sortByAscending=" + encodeURIComponent("" + sortByAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUserExtractReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUserExtractReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfUserExtractReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfUserExtractReportDTO>;
        }));
    }

    protected processSearchUserExtractReportData(response: HttpResponseBase): Observable<PagedResultDTOOfUserExtractReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfUserExtractReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportUserExtractReport(fileType: ReportFileType | undefined, saveReport: boolean | undefined, parameterDto: DateRangeParameterDTO): Observable<SavedReportFileDTO> {
        let url_ = this.baseUrl + "/api/Reports/ExportUserExtractReport?";
        if (fileType === null)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (saveReport === null)
            throw new globalThis.Error("The parameter 'saveReport' cannot be null.");
        else if (saveReport !== undefined)
            url_ += "saveReport=" + encodeURIComponent("" + saveReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportUserExtractReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportUserExtractReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedReportFileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedReportFileDTO>;
        }));
    }

    protected processExportUserExtractReport(response: HttpResponseBase): Observable<SavedReportFileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavedReportFileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    summarizeUserExtractReport(parameterDto: DateRangeParameterDTO): Observable<UserExtractReportSummaryDTO> {
        let url_ = this.baseUrl + "/api/Reports/SummarizeUserExtractReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameterDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSummarizeUserExtractReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSummarizeUserExtractReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserExtractReportSummaryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserExtractReportSummaryDTO>;
        }));
    }

    protected processSummarizeUserExtractReport(response: HttpResponseBase): Observable<UserExtractReportSummaryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserExtractReportSummaryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserParkingProcessClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    checkinUserParking(checkinDto: CheckinUserParkingDTO): Observable<CheckinUserParkingRegistrationDTO> {
        let url_ = this.baseUrl + "/api/UserParkingProcess/CheckinUserParking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkinDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckinUserParking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckinUserParking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckinUserParkingRegistrationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckinUserParkingRegistrationDTO>;
        }));
    }

    protected processCheckinUserParking(response: HttpResponseBase): Observable<CheckinUserParkingRegistrationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckinUserParkingRegistrationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkoutUserParking(checkoutDto: CheckoutUserParkingDTO): Observable<CheckoutUserParkingResultDTO> {
        let url_ = this.baseUrl + "/api/UserParkingProcess/CheckoutUserParking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkoutDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckoutUserParking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckoutUserParking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckoutUserParkingResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckoutUserParkingResultDTO>;
        }));
    }

    protected processCheckoutUserParking(response: HttpResponseBase): Observable<CheckoutUserParkingResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckoutUserParkingResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    extendUserParkingSession(dto: ExtendUserParkingDTO): Observable<ExtendUserParkingResultDTO> {
        let url_ = this.baseUrl + "/api/UserParkingProcess/ExtendUserParkingSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendUserParkingSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendUserParkingSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendUserParkingResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendUserParkingResultDTO>;
        }));
    }

    protected processExtendUserParkingSession(response: HttpResponseBase): Observable<ExtendUserParkingResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtendUserParkingResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    startParkingExtensionPaymentProcess(dto: StartParkingExtensionPaymentProcessDTO): Observable<StartParkingExtensionPaymentProcessResponseDTO> {
        let url_ = this.baseUrl + "/api/UserParkingProcess/StartParkingExtensionPaymentProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartParkingExtensionPaymentProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartParkingExtensionPaymentProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartParkingExtensionPaymentProcessResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartParkingExtensionPaymentProcessResponseDTO>;
        }));
    }

    protected processStartParkingExtensionPaymentProcess(response: HttpResponseBase): Observable<StartParkingExtensionPaymentProcessResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartParkingExtensionPaymentProcessResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZoneClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    createZone(createZoneDto: CreateZoneDTO): Observable<ZoneDTO | null> {
        let url_ = this.baseUrl + "/api/Zone/CreateZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createZoneDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDTO | null>;
        }));
    }

    protected processCreateZone(response: HttpResponseBase): Observable<ZoneDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZoneDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchZones(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfZoneDTO | null> {
        let url_ = this.baseUrl + "/api/Zone/SearchZones?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfZoneDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfZoneDTO | null>;
        }));
    }

    protected processSearchZones(response: HttpResponseBase): Observable<PagedResultDTOOfZoneDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfZoneDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateZone(updateZoneDto: UpdateZoneDTO): Observable<ZoneDTO> {
        let url_ = this.baseUrl + "/api/Zone/UpdateZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateZoneDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDTO>;
        }));
    }

    protected processUpdateZone(response: HttpResponseBase): Observable<ZoneDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getZone(id: number | undefined): Observable<ZoneDTO> {
        let url_ = this.baseUrl + "/api/Zone/GetZone?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDTO>;
        }));
    }

    protected processGetZone(response: HttpResponseBase): Observable<ZoneDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientIdent (optional) 
     * @param id (optional) 
     * @deprecated
     */
    getZoneByBarcodeNumber(clientIdent: string | undefined, id: number | undefined): Observable<ZoneDTO | null> {
        let url_ = this.baseUrl + "/api/Zone/GetZoneByBarcodeNumber?";
        if (clientIdent === null)
            throw new globalThis.Error("The parameter 'clientIdent' cannot be null.");
        else if (clientIdent !== undefined)
            url_ += "clientIdent=" + encodeURIComponent("" + clientIdent) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoneByBarcodeNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoneByBarcodeNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDTO | null>;
        }));
    }

    protected processGetZoneByBarcodeNumber(response: HttpResponseBase): Observable<ZoneDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZoneDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getZoneByNfcCode(nfcCode: string | undefined): Observable<ZoneDTO | null> {
        let url_ = this.baseUrl + "/api/Zone/GetZoneByNfcCode?";
        if (nfcCode === null)
            throw new globalThis.Error("The parameter 'nfcCode' cannot be null.");
        else if (nfcCode !== undefined)
            url_ += "nfcCode=" + encodeURIComponent("" + nfcCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoneByNfcCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoneByNfcCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDTO | null>;
        }));
    }

    protected processGetZoneByNfcCode(response: HttpResponseBase): Observable<ZoneDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZoneDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllZones(): Observable<ZoneDTO[] | null> {
        let url_ = this.baseUrl + "/api/Zone/GetAllZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDTO[] | null>;
        }));
    }

    protected processGetAllZones(response: HttpResponseBase): Observable<ZoneDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllZonesForUser(zoneInfo: GetAllZonesForUserDataDTO): Observable<ZoneForUserDTO[] | null> {
        let url_ = this.baseUrl + "/api/Zone/GetAllZonesForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zoneInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllZonesForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllZonesForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneForUserDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneForUserDTO[] | null>;
        }));
    }

    protected processGetAllZonesForUser(response: HttpResponseBase): Observable<ZoneForUserDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneForUserDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchZonesForUser(zoneInfo: SearchZonesForUserDataDTO): Observable<ZoneForUserDTO[] | null> {
        let url_ = this.baseUrl + "/api/Zone/SearchZonesForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zoneInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchZonesForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchZonesForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneForUserDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneForUserDTO[] | null>;
        }));
    }

    protected processSearchZonesForUser(response: HttpResponseBase): Observable<ZoneForUserDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneForUserDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllParkerZonesForUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Zone/GetAllParkerZonesForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParkerZonesForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParkerZonesForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllParkerZonesForUser(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getZonesWithSubscriptionsRequiringValidation(clientId: number | null | undefined, companyId: number | null | undefined): Observable<ZoneForUserDTO[]> {
        let url_ = this.baseUrl + "/api/Zone/GetZonesWithSubscriptionsRequiringValidation?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZonesWithSubscriptionsRequiringValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZonesWithSubscriptionsRequiringValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneForUserDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneForUserDTO[]>;
        }));
    }

    protected processGetZonesWithSubscriptionsRequiringValidation(response: HttpResponseBase): Observable<ZoneForUserDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneForUserDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteZone(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Zone/DeleteZone?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteZone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setCurrentParkerCount(id: number | undefined, parkerCount: number | undefined): Observable<ZoneDTO> {
        let url_ = this.baseUrl + "/api/Zone/SetCurrentParkerCount?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (parkerCount === null)
            throw new globalThis.Error("The parameter 'parkerCount' cannot be null.");
        else if (parkerCount !== undefined)
            url_ += "parkerCount=" + encodeURIComponent("" + parkerCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCurrentParkerCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCurrentParkerCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDTO>;
        }));
    }

    protected processSetCurrentParkerCount(response: HttpResponseBase): Observable<ZoneDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveZone(id: number | undefined, parentId: number | null | undefined): Observable<ZoneDTO> {
        let url_ = this.baseUrl + "/api/Zone/MoveZone?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDTO>;
        }));
    }

    protected processMoveZone(response: HttpResponseBase): Observable<ZoneDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateQrCode(qrInfos: ZoneQrCodeInfosDTO): Observable<GeneratedQrCodesDTO> {
        let url_ = this.baseUrl + "/api/Zone/GenerateQrCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(qrInfos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateQrCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQrCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneratedQrCodesDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneratedQrCodesDTO>;
        }));
    }

    protected processGenerateQrCode(response: HttpResponseBase): Observable<GeneratedQrCodesDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneratedQrCodesDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZoneDamageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    addDamage(createDamageDto: CreateZoneDamageDTO): Observable<ZoneDamageDTO> {
        let url_ = this.baseUrl + "/api/ZoneDamage/AddDamage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDamageDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDamage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDamage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDamageDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDamageDTO>;
        }));
    }

    protected processAddDamage(response: HttpResponseBase): Observable<ZoneDamageDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDamageDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDamage(id: number | undefined): Observable<ZoneDamageDTO> {
        let url_ = this.baseUrl + "/api/ZoneDamage/GetDamage?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDamage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDamage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDamageDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDamageDTO>;
        }));
    }

    protected processGetDamage(response: HttpResponseBase): Observable<ZoneDamageDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDamageDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDamages(clientId: number | undefined, skip: number | undefined, take: number | undefined, filterStates: ZoneDamageState | undefined): Observable<PagedResultDTOOfZoneDamageDTO | null> {
        let url_ = this.baseUrl + "/api/ZoneDamage/GetDamages?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterStates === null)
            throw new globalThis.Error("The parameter 'filterStates' cannot be null.");
        else if (filterStates !== undefined)
            url_ += "filterStates=" + encodeURIComponent("" + filterStates) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDamages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDamages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfZoneDamageDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfZoneDamageDTO | null>;
        }));
    }

    protected processGetDamages(response: HttpResponseBase): Observable<PagedResultDTOOfZoneDamageDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfZoneDamageDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchDamages(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfZoneDamageDTO | null> {
        let url_ = this.baseUrl + "/api/ZoneDamage/SearchDamages?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDamages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDamages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfZoneDamageDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfZoneDamageDTO | null>;
        }));
    }

    protected processSearchDamages(response: HttpResponseBase): Observable<PagedResultDTOOfZoneDamageDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfZoneDamageDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDamage(updateDamageDto: UpdateZoneDamageDTO): Observable<ZoneDamageDTO | null> {
        let url_ = this.baseUrl + "/api/ZoneDamage/UpdateDamage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDamageDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDamage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDamage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDamageDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDamageDTO | null>;
        }));
    }

    protected processUpdateDamage(response: HttpResponseBase): Observable<ZoneDamageDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZoneDamageDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDamage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ZoneDamage/DeleteDamage?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDamage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDamage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDamage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDamageImage(damageId: number | undefined, mediaId: string | undefined): Observable<string | null> {
        let url_ = this.baseUrl + "/api/ZoneDamage/GetDamageImage?";
        if (damageId === null)
            throw new globalThis.Error("The parameter 'damageId' cannot be null.");
        else if (damageId !== undefined)
            url_ += "damageId=" + encodeURIComponent("" + damageId) + "&";
        if (mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' cannot be null.");
        else if (mediaId !== undefined)
            url_ += "mediaId=" + encodeURIComponent("" + mediaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDamageImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDamageImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetDamageImage(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDamageImage(addDto: AddZoneDamageImageDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/ZoneDamage/AddDamageImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDamageImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDamageImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddDamageImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDamageImage(updateDto: UpdateZoneDamageImageDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ZoneDamage/UpdateDamageImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDamageImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDamageImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDamageImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDamageImage(deleteDto: DeleteZoneDamageImageDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ZoneDamage/DeleteDamageImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDamageImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDamageImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDamageImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZoneDeviceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getZoneDeviceInitialStructure(deviceType: ZoneDeviceType | undefined, brand: ZoneDeviceBrand | undefined): Observable<ZoneDeviceDTO> {
        let url_ = this.baseUrl + "/api/ZoneDevice/GetZoneDeviceInitialStructure?";
        if (deviceType === null)
            throw new globalThis.Error("The parameter 'deviceType' cannot be null.");
        else if (deviceType !== undefined)
            url_ += "deviceType=" + encodeURIComponent("" + deviceType) + "&";
        if (brand === null)
            throw new globalThis.Error("The parameter 'brand' cannot be null.");
        else if (brand !== undefined)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoneDeviceInitialStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoneDeviceInitialStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDeviceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDeviceDTO>;
        }));
    }

    protected processGetZoneDeviceInitialStructure(response: HttpResponseBase): Observable<ZoneDeviceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDeviceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDevice(createDto: CreateZoneDeviceDTO): Observable<ZoneDeviceDTO> {
        let url_ = this.baseUrl + "/api/ZoneDevice/CreateDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDeviceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDeviceDTO>;
        }));
    }

    protected processCreateDevice(response: HttpResponseBase): Observable<ZoneDeviceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDeviceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDevice(updateDto: UpdateZoneDeviceDTO): Observable<ZoneDeviceDTO> {
        let url_ = this.baseUrl + "/api/ZoneDevice/UpdateDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDeviceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDeviceDTO>;
        }));
    }

    protected processUpdateDevice(response: HttpResponseBase): Observable<ZoneDeviceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDeviceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveDevice(id: number | undefined, zoneId: number | undefined): Observable<ZoneDeviceDTO> {
        let url_ = this.baseUrl + "/api/ZoneDevice/MoveDevice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDeviceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDeviceDTO>;
        }));
    }

    protected processMoveDevice(response: HttpResponseBase): Observable<ZoneDeviceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDeviceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchDevices(clientId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfZoneDeviceDTO | null> {
        let url_ = this.baseUrl + "/api/ZoneDevice/SearchDevices?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfZoneDeviceDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfZoneDeviceDTO | null>;
        }));
    }

    protected processSearchDevices(response: HttpResponseBase): Observable<PagedResultDTOOfZoneDeviceDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfZoneDeviceDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDevice(id: number | undefined): Observable<ZoneDeviceDTO> {
        let url_ = this.baseUrl + "/api/ZoneDevice/GetDevice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDeviceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDeviceDTO>;
        }));
    }

    protected processGetDevice(response: HttpResponseBase): Observable<ZoneDeviceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDeviceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDevices(clientId: number | undefined, skip: number | undefined, take: number | undefined, filterBy: string | undefined, filter: string | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfZoneDeviceDTO | null> {
        let url_ = this.baseUrl + "/api/ZoneDevice/GetDevices?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterBy === null)
            throw new globalThis.Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfZoneDeviceDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfZoneDeviceDTO | null>;
        }));
    }

    protected processGetDevices(response: HttpResponseBase): Observable<PagedResultDTOOfZoneDeviceDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfZoneDeviceDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllDevices(skip: number | undefined, take: number | undefined): Observable<ZoneDeviceDTO[] | null> {
        let url_ = this.baseUrl + "/api/ZoneDevice/GetAllDevices?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDeviceDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDeviceDTO[] | null>;
        }));
    }

    protected processGetAllDevices(response: HttpResponseBase): Observable<ZoneDeviceDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneDeviceDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableDeviceSpecifications(): Observable<ZoneDeviceSpecificationDTO[] | null> {
        let url_ = this.baseUrl + "/api/ZoneDevice/GetAvailableDeviceSpecifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableDeviceSpecifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableDeviceSpecifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDeviceSpecificationDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDeviceSpecificationDTO[] | null>;
        }));
    }

    protected processGetAvailableDeviceSpecifications(response: HttpResponseBase): Observable<ZoneDeviceSpecificationDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneDeviceSpecificationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDevice(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ZoneDevice/DeleteDevice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    executeDeviceCommand(dto: ExecuteZoneDeviceCommandDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/ZoneDevice/ExecuteDeviceCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteDeviceCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteDeviceCommand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteDeviceCommand(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllCommandableDevicesForCurrentUser(): Observable<ZoneDeviceDTO[] | null> {
        let url_ = this.baseUrl + "/api/ZoneDevice/GetAllCommandableDevicesForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommandableDevicesForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommandableDevicesForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDeviceDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDeviceDTO[] | null>;
        }));
    }

    protected processGetAllCommandableDevicesForCurrentUser(response: HttpResponseBase): Observable<ZoneDeviceDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneDeviceDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCommandableDevice(id: number | undefined): Observable<ZoneDeviceDTO> {
        let url_ = this.baseUrl + "/api/ZoneDevice/GetCommandableDevice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommandableDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommandableDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDeviceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDeviceDTO>;
        }));
    }

    protected processGetCommandableDevice(response: HttpResponseBase): Observable<ZoneDeviceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneDeviceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    getDashboards(): Observable<DashboardDTO[] | null> {
        let url_ = this.baseUrl + "/api/Dashboard/GetDashboards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardDTO[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardDTO[] | null>;
        }));
    }

    protected processGetDashboards(response: HttpResponseBase): Observable<DashboardDTO[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDashboardPanels(updateDashboardPanelsDto: UpdateDashboardPanelsDTO): Observable<DashboardDTO | null> {
        let url_ = this.baseUrl + "/api/Dashboard/UpdateDashboardPanels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDashboardPanelsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDashboardPanels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDashboardPanels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardDTO | null>;
        }));
    }

    protected processUpdateDashboardPanels(response: HttpResponseBase): Observable<DashboardDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DashboardDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDashboard(createDashboardDto: CreateDashboardDTO): Observable<DashboardDTO> {
        let url_ = this.baseUrl + "/api/Dashboard/AddDashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDashboardDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardDTO>;
        }));
    }

    protected processAddDashboard(response: HttpResponseBase): Observable<DashboardDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDashboard(updateDashboardDto: UpdateDashboardDTO): Observable<DashboardDTO | null> {
        let url_ = this.baseUrl + "/api/Dashboard/UpdateDashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDashboardDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardDTO | null>;
        }));
    }

    protected processUpdateDashboard(response: HttpResponseBase): Observable<DashboardDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DashboardDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDashboard(dashboardId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Dashboard/DeleteDashboard?";
        if (dashboardId === null)
            throw new globalThis.Error("The parameter 'dashboardId' cannot be null.");
        else if (dashboardId !== undefined)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDashboard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DetectionHikVisionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:44395";
    }

    deepInView(aNPR_xml: FileParameter[] | null | undefined, licensePlatePicture_jpg: FileParameter[] | null | undefined, detectionPicture_jpg: FileParameter[] | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/Detection/HikVision/DeepInView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (aNPR_xml !== null && aNPR_xml !== undefined)
            aNPR_xml.forEach(item_ => content_.append("ANPR.xml", item_.data, item_.fileName ? item_.fileName : "ANPR.xml") );
        if (licensePlatePicture_jpg !== null && licensePlatePicture_jpg !== undefined)
            licensePlatePicture_jpg.forEach(item_ => content_.append("licensePlatePicture.jpg", item_.data, item_.fileName ? item_.fileName : "licensePlatePicture.jpg") );
        if (detectionPicture_jpg !== null && detectionPicture_jpg !== undefined)
            detectionPicture_jpg.forEach(item_ => content_.append("detectionPicture.jpg", item_.data, item_.fileName ? item_.fileName : "detectionPicture.jpg") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeepInView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeepInView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeepInView(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserTokenDTO implements IUserTokenDTO {
    access_token?: string | undefined;
    token_type?: string | undefined;
    username?: string | undefined;
    clientId?: string | undefined;
    refresh_token?: string | undefined;
    refreshTokenExpiresIn!: number;
    expires_in!: number;
    expires?: string | undefined;
    twoFactorAuthCodeRequired!: boolean;

    constructor(data?: IUserTokenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.token_type = _data["token_type"];
            this.username = _data["username"];
            this.clientId = _data["clientId"];
            this.refresh_token = _data["refresh_token"];
            this.refreshTokenExpiresIn = _data["refreshTokenExpiresIn"];
            this.expires_in = _data["expires_in"];
            this.expires = _data["expires"];
            this.twoFactorAuthCodeRequired = _data["twoFactorAuthCodeRequired"];
        }
    }

    static fromJS(data: any): UserTokenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserTokenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["token_type"] = this.token_type;
        data["username"] = this.username;
        data["clientId"] = this.clientId;
        data["refresh_token"] = this.refresh_token;
        data["refreshTokenExpiresIn"] = this.refreshTokenExpiresIn;
        data["expires_in"] = this.expires_in;
        data["expires"] = this.expires;
        data["twoFactorAuthCodeRequired"] = this.twoFactorAuthCodeRequired;
        return data;
    }
}

export interface IUserTokenDTO {
    access_token?: string | undefined;
    token_type?: string | undefined;
    username?: string | undefined;
    clientId?: string | undefined;
    refresh_token?: string | undefined;
    refreshTokenExpiresIn: number;
    expires_in: number;
    expires?: string | undefined;
    twoFactorAuthCodeRequired: boolean;
}

export class UserLoginDTO implements IUserLoginDTO {
    userName?: string | undefined;
    password?: string | undefined;
    grant_Type!: string;
    client_Id?: string | undefined;
    client_Secret?: string | undefined;
    refresh_Token?: string | undefined;
    twoFactorAuthenticationToken?: string | undefined;

    constructor(data?: IUserLoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.grant_Type = _data["grant_Type"];
            this.client_Id = _data["client_Id"];
            this.client_Secret = _data["client_Secret"];
            this.refresh_Token = _data["refresh_Token"];
            this.twoFactorAuthenticationToken = _data["twoFactorAuthenticationToken"];
        }
    }

    static fromJS(data: any): UserLoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["grant_Type"] = this.grant_Type;
        data["client_Id"] = this.client_Id;
        data["client_Secret"] = this.client_Secret;
        data["refresh_Token"] = this.refresh_Token;
        data["twoFactorAuthenticationToken"] = this.twoFactorAuthenticationToken;
        return data;
    }
}

export interface IUserLoginDTO {
    userName?: string | undefined;
    password?: string | undefined;
    grant_Type: string;
    client_Id?: string | undefined;
    client_Secret?: string | undefined;
    refresh_Token?: string | undefined;
    twoFactorAuthenticationToken?: string | undefined;
}

export class PagedResultDTOOfAutomaticParkingReportDTO implements IPagedResultDTOOfAutomaticParkingReportDTO {
    items?: AutomaticParkingReportDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfAutomaticParkingReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AutomaticParkingReportDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfAutomaticParkingReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfAutomaticParkingReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfAutomaticParkingReportDTO {
    items?: AutomaticParkingReportDTO[] | undefined;
    totalNumberOfItems: number;
}

export class AutomaticParkingReportDTO implements IAutomaticParkingReportDTO {
    id!: number;
    client?: ClientDTO | undefined;
    registeredZone?: ZoneLimitedDTO | undefined;
    knownTagId?: number | undefined;
    knownTag?: ParkerTagWithParkerInfoDTO | undefined;
    firstEntryDateTime!: DateTime;
    lastEntryDateTime?: DateTime | undefined;

    constructor(data?: IAutomaticParkingReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.client = _data["client"] ? ClientDTO.fromJS(_data["client"]) : undefined as any;
            this.registeredZone = _data["registeredZone"] ? ZoneLimitedDTO.fromJS(_data["registeredZone"]) : undefined as any;
            this.knownTagId = _data["knownTagId"];
            this.knownTag = _data["knownTag"] ? ParkerTagWithParkerInfoDTO.fromJS(_data["knownTag"]) : undefined as any;
            this.firstEntryDateTime = _data["firstEntryDateTime"] ? DateTime.fromISO(_data["firstEntryDateTime"].toString()) : undefined as any;
            this.lastEntryDateTime = _data["lastEntryDateTime"] ? DateTime.fromISO(_data["lastEntryDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AutomaticParkingReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AutomaticParkingReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["registeredZone"] = this.registeredZone ? this.registeredZone.toJSON() : undefined as any;
        data["knownTagId"] = this.knownTagId;
        data["knownTag"] = this.knownTag ? this.knownTag.toJSON() : undefined as any;
        data["firstEntryDateTime"] = this.firstEntryDateTime ? this.firstEntryDateTime.toString() : undefined as any;
        data["lastEntryDateTime"] = this.lastEntryDateTime ? this.lastEntryDateTime.toString() : undefined as any;
        return data;
    }
}

export interface IAutomaticParkingReportDTO {
    id: number;
    client?: ClientDTO | undefined;
    registeredZone?: ZoneLimitedDTO | undefined;
    knownTagId?: number | undefined;
    knownTag?: ParkerTagWithParkerInfoDTO | undefined;
    firstEntryDateTime: DateTime;
    lastEntryDateTime?: DateTime | undefined;
}

export class ClientDTO implements IClientDTO {
    id!: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    dataRetentionPeriodInDays!: number;
    clientIdent?: string | undefined;
    isActive!: boolean;
    qrCodeIdentificationEnabled!: boolean;
    automaticParkingSchedulesEnabled!: boolean;
    automaticParkingScheduleToleranceInMinutes!: number;
    connectionMode!: ConnectionMode;
    auditLogEnabled!: boolean;
    enableLPRPictureStorage!: boolean;
    enableLPRPictureStorageOnOffense!: boolean;
    custom1Name?: string | undefined;
    custom2Name?: string | undefined;
    custom3Name?: string | undefined;
    custom4Name?: string | undefined;
    custom5Name?: string | undefined;
    custom6Name?: string | undefined;
    custom7Name?: string | undefined;
    custom8Name?: string | undefined;
    custom9Name?: string | undefined;

    constructor(data?: IClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.zip = _data["zip"];
            this.dataRetentionPeriodInDays = _data["dataRetentionPeriodInDays"];
            this.clientIdent = _data["clientIdent"];
            this.isActive = _data["isActive"];
            this.qrCodeIdentificationEnabled = _data["qrCodeIdentificationEnabled"];
            this.automaticParkingSchedulesEnabled = _data["automaticParkingSchedulesEnabled"];
            this.automaticParkingScheduleToleranceInMinutes = _data["automaticParkingScheduleToleranceInMinutes"];
            this.connectionMode = _data["connectionMode"];
            this.auditLogEnabled = _data["auditLogEnabled"];
            this.enableLPRPictureStorage = _data["enableLPRPictureStorage"];
            this.enableLPRPictureStorageOnOffense = _data["enableLPRPictureStorageOnOffense"];
            this.custom1Name = _data["custom1Name"];
            this.custom2Name = _data["custom2Name"];
            this.custom3Name = _data["custom3Name"];
            this.custom4Name = _data["custom4Name"];
            this.custom5Name = _data["custom5Name"];
            this.custom6Name = _data["custom6Name"];
            this.custom7Name = _data["custom7Name"];
            this.custom8Name = _data["custom8Name"];
            this.custom9Name = _data["custom9Name"];
        }
    }

    static fromJS(data: any): ClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["zip"] = this.zip;
        data["dataRetentionPeriodInDays"] = this.dataRetentionPeriodInDays;
        data["clientIdent"] = this.clientIdent;
        data["isActive"] = this.isActive;
        data["qrCodeIdentificationEnabled"] = this.qrCodeIdentificationEnabled;
        data["automaticParkingSchedulesEnabled"] = this.automaticParkingSchedulesEnabled;
        data["automaticParkingScheduleToleranceInMinutes"] = this.automaticParkingScheduleToleranceInMinutes;
        data["connectionMode"] = this.connectionMode;
        data["auditLogEnabled"] = this.auditLogEnabled;
        data["enableLPRPictureStorage"] = this.enableLPRPictureStorage;
        data["enableLPRPictureStorageOnOffense"] = this.enableLPRPictureStorageOnOffense;
        data["custom1Name"] = this.custom1Name;
        data["custom2Name"] = this.custom2Name;
        data["custom3Name"] = this.custom3Name;
        data["custom4Name"] = this.custom4Name;
        data["custom5Name"] = this.custom5Name;
        data["custom6Name"] = this.custom6Name;
        data["custom7Name"] = this.custom7Name;
        data["custom8Name"] = this.custom8Name;
        data["custom9Name"] = this.custom9Name;
        return data;
    }
}

export interface IClientDTO {
    id: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    dataRetentionPeriodInDays: number;
    clientIdent?: string | undefined;
    isActive: boolean;
    qrCodeIdentificationEnabled: boolean;
    automaticParkingSchedulesEnabled: boolean;
    automaticParkingScheduleToleranceInMinutes: number;
    connectionMode: ConnectionMode;
    auditLogEnabled: boolean;
    enableLPRPictureStorage: boolean;
    enableLPRPictureStorageOnOffense: boolean;
    custom1Name?: string | undefined;
    custom2Name?: string | undefined;
    custom3Name?: string | undefined;
    custom4Name?: string | undefined;
    custom5Name?: string | undefined;
    custom6Name?: string | undefined;
    custom7Name?: string | undefined;
    custom8Name?: string | undefined;
    custom9Name?: string | undefined;
}

export enum ConnectionMode {
    RequestConnection = 0,
    DirectConnection = 1,
}

export class ZoneLimitedDTO implements IZoneLimitedDTO {
    id!: number;
    name?: string | undefined;
    zoneGPSArea?: string | undefined;
    parkingSpaceNumberDefinition?: string | undefined;
    sessionControlType!: ParkingSessionControlType;
    maxPassageTime!: number;

    constructor(data?: IZoneLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.zoneGPSArea = _data["zoneGPSArea"];
            this.parkingSpaceNumberDefinition = _data["parkingSpaceNumberDefinition"];
            this.sessionControlType = _data["sessionControlType"];
            this.maxPassageTime = _data["maxPassageTime"];
        }
    }

    static fromJS(data: any): ZoneLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["zoneGPSArea"] = this.zoneGPSArea;
        data["parkingSpaceNumberDefinition"] = this.parkingSpaceNumberDefinition;
        data["sessionControlType"] = this.sessionControlType;
        data["maxPassageTime"] = this.maxPassageTime;
        return data;
    }
}

export interface IZoneLimitedDTO {
    id: number;
    name?: string | undefined;
    zoneGPSArea?: string | undefined;
    parkingSpaceNumberDefinition?: string | undefined;
    sessionControlType: ParkingSessionControlType;
    maxPassageTime: number;
}

export enum ParkingSessionControlType {
    CheckInCheckOut = 0,
    HardwareControlled = 1,
}

export class ParkerTagDTO implements IParkerTagDTO {
    id!: number;
    clientId!: number;
    parkerId!: number;
    usage!: ParkerTagUsage;
    identificationCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    countryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    operationalControlPlate?: string | undefined;
    normalizedControlPlate?: string | undefined;
    hashedControlPlate?: string | undefined;
    description?: string | undefined;
    barcode?: string | undefined;
    active!: boolean;
    defect!: boolean;
    enableAutomaticPlateRecognitionParking!: boolean;
    modifiedOn!: DateTime;
    modifiedBy?: string | undefined;

    constructor(data?: IParkerTagDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.parkerId = _data["parkerId"];
            this.usage = _data["usage"];
            this.identificationCode = _data["identificationCode"];
            this.controlPlateType = _data["controlPlateType"];
            this.countryCode = _data["countryCode"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.operationalControlPlate = _data["operationalControlPlate"];
            this.normalizedControlPlate = _data["normalizedControlPlate"];
            this.hashedControlPlate = _data["hashedControlPlate"];
            this.description = _data["description"];
            this.barcode = _data["barcode"];
            this.active = _data["active"];
            this.defect = _data["defect"];
            this.enableAutomaticPlateRecognitionParking = _data["enableAutomaticPlateRecognitionParking"];
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): ParkerTagDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerTagDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["parkerId"] = this.parkerId;
        data["usage"] = this.usage;
        data["identificationCode"] = this.identificationCode;
        data["controlPlateType"] = this.controlPlateType;
        data["countryCode"] = this.countryCode;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["operationalControlPlate"] = this.operationalControlPlate;
        data["normalizedControlPlate"] = this.normalizedControlPlate;
        data["hashedControlPlate"] = this.hashedControlPlate;
        data["description"] = this.description;
        data["barcode"] = this.barcode;
        data["active"] = this.active;
        data["defect"] = this.defect;
        data["enableAutomaticPlateRecognitionParking"] = this.enableAutomaticPlateRecognitionParking;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IParkerTagDTO {
    id: number;
    clientId: number;
    parkerId: number;
    usage: ParkerTagUsage;
    identificationCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    countryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    operationalControlPlate?: string | undefined;
    normalizedControlPlate?: string | undefined;
    hashedControlPlate?: string | undefined;
    description?: string | undefined;
    barcode?: string | undefined;
    active: boolean;
    defect: boolean;
    enableAutomaticPlateRecognitionParking: boolean;
    modifiedOn: DateTime;
    modifiedBy?: string | undefined;
}

export class ParkerTagWithParkerInfoDTO extends ParkerTagDTO implements IParkerTagWithParkerInfoDTO {
    parker?: ParkerInfoDTO | undefined;

    constructor(data?: IParkerTagWithParkerInfoDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parker = _data["parker"] ? ParkerInfoDTO.fromJS(_data["parker"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ParkerTagWithParkerInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerTagWithParkerInfoDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parker"] = this.parker ? this.parker.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IParkerTagWithParkerInfoDTO extends IParkerTagDTO {
    parker?: ParkerInfoDTO | undefined;
}

export class ParkerInfoDTO implements IParkerInfoDTO {
    id!: number;
    clientId!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    identification?: string | undefined;
    group!: ParkerGroup;
    title?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    company?: ParkerCompanyDTO | undefined;
    custom1?: string | undefined;
    custom2?: string | undefined;
    custom3?: string | undefined;
    custom4?: string | undefined;
    custom5?: string | undefined;
    custom6?: string | undefined;
    custom7?: string | undefined;
    custom8?: string | undefined;
    custom9?: string | undefined;

    constructor(data?: IParkerInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.identification = _data["identification"];
            this.group = _data["group"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.company = _data["company"] ? ParkerCompanyDTO.fromJS(_data["company"]) : undefined as any;
            this.custom1 = _data["custom1"];
            this.custom2 = _data["custom2"];
            this.custom3 = _data["custom3"];
            this.custom4 = _data["custom4"];
            this.custom5 = _data["custom5"];
            this.custom6 = _data["custom6"];
            this.custom7 = _data["custom7"];
            this.custom8 = _data["custom8"];
            this.custom9 = _data["custom9"];
        }
    }

    static fromJS(data: any): ParkerInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["identification"] = this.identification;
        data["group"] = this.group;
        data["title"] = this.title;
        data["email"] = this.email;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["company"] = this.company ? this.company.toJSON() : undefined as any;
        data["custom1"] = this.custom1;
        data["custom2"] = this.custom2;
        data["custom3"] = this.custom3;
        data["custom4"] = this.custom4;
        data["custom5"] = this.custom5;
        data["custom6"] = this.custom6;
        data["custom7"] = this.custom7;
        data["custom8"] = this.custom8;
        data["custom9"] = this.custom9;
        return data;
    }
}

export interface IParkerInfoDTO {
    id: number;
    clientId: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    identification?: string | undefined;
    group: ParkerGroup;
    title?: string | undefined;
    email?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    company?: ParkerCompanyDTO | undefined;
    custom1?: string | undefined;
    custom2?: string | undefined;
    custom3?: string | undefined;
    custom4?: string | undefined;
    custom5?: string | undefined;
    custom6?: string | undefined;
    custom7?: string | undefined;
    custom8?: string | undefined;
    custom9?: string | undefined;
}

export enum ParkerGroup {
    Undefined = 0,
    Guest = 1,
    Employee = 2,
}

export class ParkerCompanyDTO implements IParkerCompanyDTO {
    id!: number;
    clientId!: number;
    active!: boolean;
    name?: string | undefined;

    constructor(data?: IParkerCompanyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.active = _data["active"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ParkerCompanyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerCompanyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["active"] = this.active;
        data["name"] = this.name;
        return data;
    }
}

export interface IParkerCompanyDTO {
    id: number;
    clientId: number;
    active: boolean;
    name?: string | undefined;
}

export enum ParkerTagUsage {
    CommonTag = 0,
    ParkerIdentity = 1,
}

export enum ControlPlateType {
    Car = 0,
    Motorcycle = 1,
    Truck = 2,
    Tractor = 3,
}

export class AutomaticParkingReportParameterDTO implements IAutomaticParkingReportParameterDTO {
    dateRange!: DateRangeParameterDTO;

    constructor(data?: IAutomaticParkingReportParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeParameterDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRange = _data["dateRange"] ? DateRangeParameterDTO.fromJS(_data["dateRange"]) : new DateRangeParameterDTO();
        }
    }

    static fromJS(data: any): AutomaticParkingReportParameterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AutomaticParkingReportParameterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        return data;
    }
}

export interface IAutomaticParkingReportParameterDTO {
    dateRange: DateRangeParameterDTO;
}

export class DateRangeParameterDTO implements IDateRangeParameterDTO {
    startDate!: string;
    endDate!: string;

    constructor(data?: IDateRangeParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): DateRangeParameterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeParameterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IDateRangeParameterDTO {
    startDate: string;
    endDate: string;
}

export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export class SavedReportFileDTO implements ISavedReportFileDTO {
    reportName?: string | undefined;
    fileType!: ReportFileType;
    contentBase64?: string | undefined;

    constructor(data?: ISavedReportFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportName = _data["reportName"];
            this.fileType = _data["fileType"];
            this.contentBase64 = _data["contentBase64"];
        }
    }

    static fromJS(data: any): SavedReportFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SavedReportFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportName"] = this.reportName;
        data["fileType"] = this.fileType;
        data["contentBase64"] = this.contentBase64;
        return data;
    }
}

export interface ISavedReportFileDTO {
    reportName?: string | undefined;
    fileType: ReportFileType;
    contentBase64?: string | undefined;
}

export enum ReportFileType {
    CSV = 0,
    PDF = 1,
}

export class PagedResultDTOOfAutomaticParkingScheduleDTO implements IPagedResultDTOOfAutomaticParkingScheduleDTO {
    items?: AutomaticParkingScheduleDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfAutomaticParkingScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AutomaticParkingScheduleDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfAutomaticParkingScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfAutomaticParkingScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfAutomaticParkingScheduleDTO {
    items?: AutomaticParkingScheduleDTO[] | undefined;
    totalNumberOfItems: number;
}

export class AutomaticParkingScheduleDTO implements IAutomaticParkingScheduleDTO {
    id!: number;
    name?: string | undefined;
    client?: ClientLimitedDTO | undefined;
    parkerId!: number;
    zone?: ZoneLimitedDTO | undefined;
    parkingSpaceNumber?: string | undefined;
    subscriptionAssignment?: ParkerSubscriptionAssignmentDTO | undefined;
    tag?: ParkerTagDTO | undefined;
    parkingStartTime!: Duration;
    parkingDurationInMinutes!: number;
    onWeekDays!: WeekDayFlags;
    isActive!: boolean;

    constructor(data?: IAutomaticParkingScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.client = _data["client"] ? ClientLimitedDTO.fromJS(_data["client"]) : undefined as any;
            this.parkerId = _data["parkerId"];
            this.zone = _data["zone"] ? ZoneLimitedDTO.fromJS(_data["zone"]) : undefined as any;
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.subscriptionAssignment = _data["subscriptionAssignment"] ? ParkerSubscriptionAssignmentDTO.fromJS(_data["subscriptionAssignment"]) : undefined as any;
            this.tag = _data["tag"] ? ParkerTagDTO.fromJS(_data["tag"]) : undefined as any;
            this.parkingStartTime = _data["parkingStartTime"] ? Duration.fromISO(_data["parkingStartTime"].toString()) : undefined as any;
            this.parkingDurationInMinutes = _data["parkingDurationInMinutes"];
            this.onWeekDays = _data["onWeekDays"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AutomaticParkingScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AutomaticParkingScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["parkerId"] = this.parkerId;
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["subscriptionAssignment"] = this.subscriptionAssignment ? this.subscriptionAssignment.toJSON() : undefined as any;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined as any;
        data["parkingStartTime"] = this.parkingStartTime ? this.parkingStartTime.toString() : undefined as any;
        data["parkingDurationInMinutes"] = this.parkingDurationInMinutes;
        data["onWeekDays"] = this.onWeekDays;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAutomaticParkingScheduleDTO {
    id: number;
    name?: string | undefined;
    client?: ClientLimitedDTO | undefined;
    parkerId: number;
    zone?: ZoneLimitedDTO | undefined;
    parkingSpaceNumber?: string | undefined;
    subscriptionAssignment?: ParkerSubscriptionAssignmentDTO | undefined;
    tag?: ParkerTagDTO | undefined;
    parkingStartTime: Duration;
    parkingDurationInMinutes: number;
    onWeekDays: WeekDayFlags;
    isActive: boolean;
}

export class ClientLimitedDTO implements IClientLimitedDTO {
    id!: number;
    name?: string | undefined;
    isActive!: boolean;
    automaticParkingSchedulesEnabled!: boolean;
    qrCodeIdentificationEnabled!: boolean;
    automaticParkingScheduleToleranceInMinutes!: number;

    constructor(data?: IClientLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.automaticParkingSchedulesEnabled = _data["automaticParkingSchedulesEnabled"];
            this.qrCodeIdentificationEnabled = _data["qrCodeIdentificationEnabled"];
            this.automaticParkingScheduleToleranceInMinutes = _data["automaticParkingScheduleToleranceInMinutes"];
        }
    }

    static fromJS(data: any): ClientLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["automaticParkingSchedulesEnabled"] = this.automaticParkingSchedulesEnabled;
        data["qrCodeIdentificationEnabled"] = this.qrCodeIdentificationEnabled;
        data["automaticParkingScheduleToleranceInMinutes"] = this.automaticParkingScheduleToleranceInMinutes;
        return data;
    }
}

export interface IClientLimitedDTO {
    id: number;
    name?: string | undefined;
    isActive: boolean;
    automaticParkingSchedulesEnabled: boolean;
    qrCodeIdentificationEnabled: boolean;
    automaticParkingScheduleToleranceInMinutes: number;
}

export class ParkerSubscriptionAssignmentDTO implements IParkerSubscriptionAssignmentDTO {
    id!: number;
    active!: boolean;
    subscription?: ParkingSubscriptionLimitedWithTariffsDTO | undefined;
    validFrom!: DateTime;
    validTo?: DateTime | undefined;
    isFavorite!: boolean;
    isForeignParkingAssignment!: boolean;
    modifiedOn!: DateTime;
    modifiedBy?: string | undefined;

    constructor(data?: IParkerSubscriptionAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.subscription = _data["subscription"] ? ParkingSubscriptionLimitedWithTariffsDTO.fromJS(_data["subscription"]) : undefined as any;
            this.validFrom = _data["validFrom"] ? DateTime.fromISO(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : undefined as any;
            this.isFavorite = _data["isFavorite"];
            this.isForeignParkingAssignment = _data["isForeignParkingAssignment"];
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): ParkerSubscriptionAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerSubscriptionAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined as any;
        data["validFrom"] = this.validFrom ? this.validFrom.toString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toString() : undefined as any;
        data["isFavorite"] = this.isFavorite;
        data["isForeignParkingAssignment"] = this.isForeignParkingAssignment;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IParkerSubscriptionAssignmentDTO {
    id: number;
    active: boolean;
    subscription?: ParkingSubscriptionLimitedWithTariffsDTO | undefined;
    validFrom: DateTime;
    validTo?: DateTime | undefined;
    isFavorite: boolean;
    isForeignParkingAssignment: boolean;
    modifiedOn: DateTime;
    modifiedBy?: string | undefined;
}

export class ParkingSubscriptionLimitedDTO implements IParkingSubscriptionLimitedDTO {
    id!: number;
    clientId!: number;
    clientName?: string | undefined;
    active!: boolean;
    assignable!: boolean;
    name?: string | undefined;
    type!: ParkingSubscriptionType;
    description?: string | undefined;
    fixPricePerMonth?: number | undefined;
    basePricePerDay?: number | undefined;
    currency!: Currency;
    maxParkingDurationInMin?: number | undefined;
    denyForeignParkingSubscriptionFallback!: boolean;
    sessionIsExtendable!: boolean;
    usage!: ParkingSubscriptionUsage;
    paidBy!: ParkingSubscriptionPaidBy;
    orderWeight!: number;
    companyId?: number | undefined;
    company?: ParkerCompanyLimitedDTO | undefined;
    validationFallbackSubscriptionId?: number | undefined;

    constructor(data?: IParkingSubscriptionLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.active = _data["active"];
            this.assignable = _data["assignable"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.fixPricePerMonth = _data["fixPricePerMonth"];
            this.basePricePerDay = _data["basePricePerDay"];
            this.currency = _data["currency"];
            this.maxParkingDurationInMin = _data["maxParkingDurationInMin"];
            this.denyForeignParkingSubscriptionFallback = _data["denyForeignParkingSubscriptionFallback"];
            this.sessionIsExtendable = _data["sessionIsExtendable"];
            this.usage = _data["usage"];
            this.paidBy = _data["paidBy"];
            this.orderWeight = _data["orderWeight"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? ParkerCompanyLimitedDTO.fromJS(_data["company"]) : undefined as any;
            this.validationFallbackSubscriptionId = _data["validationFallbackSubscriptionId"];
        }
    }

    static fromJS(data: any): ParkingSubscriptionLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingSubscriptionLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["active"] = this.active;
        data["assignable"] = this.assignable;
        data["name"] = this.name;
        data["type"] = this.type;
        data["description"] = this.description;
        data["fixPricePerMonth"] = this.fixPricePerMonth;
        data["basePricePerDay"] = this.basePricePerDay;
        data["currency"] = this.currency;
        data["maxParkingDurationInMin"] = this.maxParkingDurationInMin;
        data["denyForeignParkingSubscriptionFallback"] = this.denyForeignParkingSubscriptionFallback;
        data["sessionIsExtendable"] = this.sessionIsExtendable;
        data["usage"] = this.usage;
        data["paidBy"] = this.paidBy;
        data["orderWeight"] = this.orderWeight;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : undefined as any;
        data["validationFallbackSubscriptionId"] = this.validationFallbackSubscriptionId;
        return data;
    }
}

export interface IParkingSubscriptionLimitedDTO {
    id: number;
    clientId: number;
    clientName?: string | undefined;
    active: boolean;
    assignable: boolean;
    name?: string | undefined;
    type: ParkingSubscriptionType;
    description?: string | undefined;
    fixPricePerMonth?: number | undefined;
    basePricePerDay?: number | undefined;
    currency: Currency;
    maxParkingDurationInMin?: number | undefined;
    denyForeignParkingSubscriptionFallback: boolean;
    sessionIsExtendable: boolean;
    usage: ParkingSubscriptionUsage;
    paidBy: ParkingSubscriptionPaidBy;
    orderWeight: number;
    companyId?: number | undefined;
    company?: ParkerCompanyLimitedDTO | undefined;
    validationFallbackSubscriptionId?: number | undefined;
}

export class ParkingSubscriptionLimitedWithTariffsDTO extends ParkingSubscriptionLimitedDTO implements IParkingSubscriptionLimitedWithTariffsDTO {
    tariffs?: ParkingTariffDTO[] | undefined;

    constructor(data?: IParkingSubscriptionLimitedWithTariffsDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tariffs"])) {
                this.tariffs = [] as any;
                for (let item of _data["tariffs"])
                    this.tariffs!.push(ParkingTariffDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ParkingSubscriptionLimitedWithTariffsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingSubscriptionLimitedWithTariffsDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tariffs)) {
            data["tariffs"] = [];
            for (let item of this.tariffs)
                data["tariffs"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IParkingSubscriptionLimitedWithTariffsDTO extends IParkingSubscriptionLimitedDTO {
    tariffs?: ParkingTariffDTO[] | undefined;
}

export class ParkingTariffDTO implements IParkingTariffDTO {
    id!: number;
    clientId!: number;
    active!: boolean;
    deleted!: boolean;
    onWeekDays?: WeekDayFlags | undefined;
    description?: string | undefined;
    startTime?: Duration | undefined;
    durationInMinutes?: number | undefined;
    maxParkingDurationInMin?: number | undefined;
    name?: string | undefined;
    tariffCurrency!: Currency;
    priceType!: TariffPriceType;
    tieredPrices?: ParkingTariffTieredPriceDTO[] | undefined;
    placeOfResidence!: PlaceOfResidence;
    fixedPrice?: number | undefined;
    pricePerHour?: number | undefined;
    maximumPrice?: number | undefined;
    linearPriceMinStepInMinutes!: number;
    subscriptionId?: number | undefined;
    hasActiveSubscription!: boolean;
    assignedZones?: AssignedZoneDTO[] | undefined;
    isTwentyFourSevenTariff!: boolean;
    isDeviceControlTariff!: boolean;
    modifiedOn!: DateTime;
    modifiedBy?: string | undefined;
    blacklistedLicensePlates?: BlacklistLicensePlateDTO[] | undefined;

    constructor(data?: IParkingTariffDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.active = _data["active"];
            this.deleted = _data["deleted"];
            this.onWeekDays = _data["onWeekDays"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? Duration.fromISO(_data["startTime"].toString()) : undefined as any;
            this.durationInMinutes = _data["durationInMinutes"];
            this.maxParkingDurationInMin = _data["maxParkingDurationInMin"];
            this.name = _data["name"];
            this.tariffCurrency = _data["tariffCurrency"];
            this.priceType = _data["priceType"];
            if (Array.isArray(_data["tieredPrices"])) {
                this.tieredPrices = [] as any;
                for (let item of _data["tieredPrices"])
                    this.tieredPrices!.push(ParkingTariffTieredPriceDTO.fromJS(item));
            }
            this.placeOfResidence = _data["placeOfResidence"];
            this.fixedPrice = _data["fixedPrice"];
            this.pricePerHour = _data["pricePerHour"];
            this.maximumPrice = _data["maximumPrice"];
            this.linearPriceMinStepInMinutes = _data["linearPriceMinStepInMinutes"];
            this.subscriptionId = _data["subscriptionId"];
            this.hasActiveSubscription = _data["hasActiveSubscription"];
            if (Array.isArray(_data["assignedZones"])) {
                this.assignedZones = [] as any;
                for (let item of _data["assignedZones"])
                    this.assignedZones!.push(AssignedZoneDTO.fromJS(item));
            }
            this.isTwentyFourSevenTariff = _data["isTwentyFourSevenTariff"];
            this.isDeviceControlTariff = _data["isDeviceControlTariff"];
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["blacklistedLicensePlates"])) {
                this.blacklistedLicensePlates = [] as any;
                for (let item of _data["blacklistedLicensePlates"])
                    this.blacklistedLicensePlates!.push(BlacklistLicensePlateDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParkingTariffDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingTariffDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["active"] = this.active;
        data["deleted"] = this.deleted;
        data["onWeekDays"] = this.onWeekDays;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["durationInMinutes"] = this.durationInMinutes;
        data["maxParkingDurationInMin"] = this.maxParkingDurationInMin;
        data["name"] = this.name;
        data["tariffCurrency"] = this.tariffCurrency;
        data["priceType"] = this.priceType;
        if (Array.isArray(this.tieredPrices)) {
            data["tieredPrices"] = [];
            for (let item of this.tieredPrices)
                data["tieredPrices"].push(item ? item.toJSON() : undefined as any);
        }
        data["placeOfResidence"] = this.placeOfResidence;
        data["fixedPrice"] = this.fixedPrice;
        data["pricePerHour"] = this.pricePerHour;
        data["maximumPrice"] = this.maximumPrice;
        data["linearPriceMinStepInMinutes"] = this.linearPriceMinStepInMinutes;
        data["subscriptionId"] = this.subscriptionId;
        data["hasActiveSubscription"] = this.hasActiveSubscription;
        if (Array.isArray(this.assignedZones)) {
            data["assignedZones"] = [];
            for (let item of this.assignedZones)
                data["assignedZones"].push(item ? item.toJSON() : undefined as any);
        }
        data["isTwentyFourSevenTariff"] = this.isTwentyFourSevenTariff;
        data["isDeviceControlTariff"] = this.isDeviceControlTariff;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.blacklistedLicensePlates)) {
            data["blacklistedLicensePlates"] = [];
            for (let item of this.blacklistedLicensePlates)
                data["blacklistedLicensePlates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParkingTariffDTO {
    id: number;
    clientId: number;
    active: boolean;
    deleted: boolean;
    onWeekDays?: WeekDayFlags | undefined;
    description?: string | undefined;
    startTime?: Duration | undefined;
    durationInMinutes?: number | undefined;
    maxParkingDurationInMin?: number | undefined;
    name?: string | undefined;
    tariffCurrency: Currency;
    priceType: TariffPriceType;
    tieredPrices?: ParkingTariffTieredPriceDTO[] | undefined;
    placeOfResidence: PlaceOfResidence;
    fixedPrice?: number | undefined;
    pricePerHour?: number | undefined;
    maximumPrice?: number | undefined;
    linearPriceMinStepInMinutes: number;
    subscriptionId?: number | undefined;
    hasActiveSubscription: boolean;
    assignedZones?: AssignedZoneDTO[] | undefined;
    isTwentyFourSevenTariff: boolean;
    isDeviceControlTariff: boolean;
    modifiedOn: DateTime;
    modifiedBy?: string | undefined;
    blacklistedLicensePlates?: BlacklistLicensePlateDTO[] | undefined;
}

export enum WeekDayFlags {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 4,
    Thursday = 8,
    Friday = 16,
    Saturday = 32,
    Sunday = 64,
}

export enum Currency {
    CHF = 0,
    EUR = 1,
}

export enum TariffPriceType {
    LinearPrice = 0,
    FixedPrice = 1,
    TieredPrice = 2,
}

export class ParkingTariffTieredPriceDTO implements IParkingTariffTieredPriceDTO {
    id!: number;
    evaluationRelayIndex!: number;
    amountOfMinutes!: number;
    pricePerHour!: number;
    minStepInMinutes!: number;

    constructor(data?: IParkingTariffTieredPriceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.evaluationRelayIndex = _data["evaluationRelayIndex"];
            this.amountOfMinutes = _data["amountOfMinutes"];
            this.pricePerHour = _data["pricePerHour"];
            this.minStepInMinutes = _data["minStepInMinutes"];
        }
    }

    static fromJS(data: any): ParkingTariffTieredPriceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingTariffTieredPriceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["evaluationRelayIndex"] = this.evaluationRelayIndex;
        data["amountOfMinutes"] = this.amountOfMinutes;
        data["pricePerHour"] = this.pricePerHour;
        data["minStepInMinutes"] = this.minStepInMinutes;
        return data;
    }
}

export interface IParkingTariffTieredPriceDTO {
    id: number;
    evaluationRelayIndex: number;
    amountOfMinutes: number;
    pricePerHour: number;
    minStepInMinutes: number;
}

export enum PlaceOfResidence {
    Unspecified = 0,
    LocalCommunity = 1,
    External = 2,
}

export class AssignedZoneDTO implements IAssignedZoneDTO {
    id!: number;
    name?: string | undefined;
    deleted!: boolean;

    constructor(data?: IAssignedZoneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): AssignedZoneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedZoneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface IAssignedZoneDTO {
    id: number;
    name?: string | undefined;
    deleted: boolean;
}

export class BlacklistLicensePlateDTO implements IBlacklistLicensePlateDTO {
    id!: number;
    controlPlateNumber?: string | undefined;
    countryCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;

    constructor(data?: IBlacklistLicensePlateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.countryCode = _data["countryCode"];
            this.controlPlateType = _data["controlPlateType"];
        }
    }

    static fromJS(data: any): BlacklistLicensePlateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BlacklistLicensePlateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["countryCode"] = this.countryCode;
        data["controlPlateType"] = this.controlPlateType;
        return data;
    }
}

export interface IBlacklistLicensePlateDTO {
    id: number;
    controlPlateNumber?: string | undefined;
    countryCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
}

export enum ParkingSubscriptionType {
    StandardSubscription = 0,
    ForeignParkerSubscription = 1,
}

export enum ParkingSubscriptionUsage {
    ParkerOrForeignParker = 0,
    Visitor = 1,
    VisitorAndParkerAsVisitor = 2,
}

export enum ParkingSubscriptionPaidBy {
    ParkingPerson = 0,
    ParkingCard = 1,
}

export class ParkerCompanyLimitedDTO implements IParkerCompanyLimitedDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IParkerCompanyLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ParkerCompanyLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerCompanyLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IParkerCompanyLimitedDTO {
    id: number;
    name?: string | undefined;
}

export class FilterDTO implements IFilterDTO {
    isComplex!: boolean;
    condition?: FilterCondition | undefined;
    field?: string | undefined;
    operator?: FilterOperator | undefined;
    value?: string | undefined;
    predicates?: FilterDTO[] | undefined;

    constructor(data?: IFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplex = _data["isComplex"];
            this.condition = _data["condition"];
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            if (Array.isArray(_data["predicates"])) {
                this.predicates = [] as any;
                for (let item of _data["predicates"])
                    this.predicates!.push(FilterDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isComplex"] = this.isComplex;
        data["condition"] = this.condition;
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["value"] = this.value;
        if (Array.isArray(this.predicates)) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterDTO {
    isComplex: boolean;
    condition?: FilterCondition | undefined;
    field?: string | undefined;
    operator?: FilterOperator | undefined;
    value?: string | undefined;
    predicates?: FilterDTO[] | undefined;
}

export enum FilterCondition {
    And = 0,
    Or = 1,
}

export enum FilterOperator {
    StartsWith = 0,
    EndsWith = 1,
    Contains = 2,
    Equal = 3,
    NotEqual = 4,
    GreaterThan = 5,
    GreaterThanOrEqual = 6,
    LessThan = 7,
    LessThanOrEqual = 8,
    IsNull = 9,
    IsNotNull = 10,
    Any = 11,
    None = 12,
    Empty = 13,
    NotEmpty = 14,
    DoesNotStartWith = 15,
    DoesNotEndWith = 16,
    DoesNotContain = 17,
}

export class CreateAutomaticParkingScheduleDTO implements ICreateAutomaticParkingScheduleDTO {
    name?: string | undefined;
    clientId!: number;
    zoneId!: number;
    parkingSpaceNumber?: string | undefined;
    subscriptionAssignmentId!: number;
    tagId!: number;
    parkingStartTime!: Duration;
    parkingDurationInMinutes!: number;
    onWeekDays!: WeekDayFlags;

    constructor(data?: ICreateAutomaticParkingScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            this.zoneId = _data["zoneId"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.subscriptionAssignmentId = _data["subscriptionAssignmentId"];
            this.tagId = _data["tagId"];
            this.parkingStartTime = _data["parkingStartTime"] ? Duration.fromISO(_data["parkingStartTime"].toString()) : undefined as any;
            this.parkingDurationInMinutes = _data["parkingDurationInMinutes"];
            this.onWeekDays = _data["onWeekDays"];
        }
    }

    static fromJS(data: any): CreateAutomaticParkingScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAutomaticParkingScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        data["zoneId"] = this.zoneId;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["subscriptionAssignmentId"] = this.subscriptionAssignmentId;
        data["tagId"] = this.tagId;
        data["parkingStartTime"] = this.parkingStartTime ? this.parkingStartTime.toString() : undefined as any;
        data["parkingDurationInMinutes"] = this.parkingDurationInMinutes;
        data["onWeekDays"] = this.onWeekDays;
        return data;
    }
}

export interface ICreateAutomaticParkingScheduleDTO {
    name?: string | undefined;
    clientId: number;
    zoneId: number;
    parkingSpaceNumber?: string | undefined;
    subscriptionAssignmentId: number;
    tagId: number;
    parkingStartTime: Duration;
    parkingDurationInMinutes: number;
    onWeekDays: WeekDayFlags;
}

export class UpdateAutomaticParkingScheduleDTO implements IUpdateAutomaticParkingScheduleDTO {
    id!: number;
    name?: string | undefined;
    zoneId?: number | undefined;
    parkingSpaceNumber?: string | undefined;
    subscriptionAssignmentId?: number | undefined;
    tagId?: number | undefined;
    parkingStartTime?: Duration | undefined;
    parkingDurationInMinutes?: number | undefined;
    onWeekDays?: WeekDayFlags | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdateAutomaticParkingScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.zoneId = _data["zoneId"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.subscriptionAssignmentId = _data["subscriptionAssignmentId"];
            this.tagId = _data["tagId"];
            this.parkingStartTime = _data["parkingStartTime"] ? Duration.fromISO(_data["parkingStartTime"].toString()) : undefined as any;
            this.parkingDurationInMinutes = _data["parkingDurationInMinutes"];
            this.onWeekDays = _data["onWeekDays"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateAutomaticParkingScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAutomaticParkingScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["zoneId"] = this.zoneId;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["subscriptionAssignmentId"] = this.subscriptionAssignmentId;
        data["tagId"] = this.tagId;
        data["parkingStartTime"] = this.parkingStartTime ? this.parkingStartTime.toString() : undefined as any;
        data["parkingDurationInMinutes"] = this.parkingDurationInMinutes;
        data["onWeekDays"] = this.onWeekDays;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateAutomaticParkingScheduleDTO {
    id: number;
    name?: string | undefined;
    zoneId?: number | undefined;
    parkingSpaceNumber?: string | undefined;
    subscriptionAssignmentId?: number | undefined;
    tagId?: number | undefined;
    parkingStartTime?: Duration | undefined;
    parkingDurationInMinutes?: number | undefined;
    onWeekDays?: WeekDayFlags | undefined;
    isActive?: boolean | undefined;
}

export class ParkingProcessZoneInfoDTO implements IParkingProcessZoneInfoDTO {
    id!: number;
    name?: string | undefined;
    clientId!: number;
    clientName?: string | undefined;
    foreignParkersAllowed!: boolean;
    parkingSpaceNumberDefinition?: string | undefined;
    defaultForeignParkingSubscriptionId?: number | undefined;
    useBlacklistArea!: boolean;
    fastCheckinSubscriptionId?: number | undefined;
    foreignParkingSubscriptionInfos!: ForeignParkingSubscriptionInfoDTO[];
    subscriptionAssignments!: ParkingProcessSubscriptionAssignmentInfoDTO[];
    parent?: ParkingProcessLimitedZoneWithParentInfoDTO | undefined;
    sessionControlType!: ParkingSessionControlType;

    constructor(data?: IParkingProcessZoneInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.foreignParkingSubscriptionInfos = [];
            this.subscriptionAssignments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.foreignParkersAllowed = _data["foreignParkersAllowed"];
            this.parkingSpaceNumberDefinition = _data["parkingSpaceNumberDefinition"];
            this.defaultForeignParkingSubscriptionId = _data["defaultForeignParkingSubscriptionId"];
            this.useBlacklistArea = _data["useBlacklistArea"];
            this.fastCheckinSubscriptionId = _data["fastCheckinSubscriptionId"];
            if (Array.isArray(_data["foreignParkingSubscriptionInfos"])) {
                this.foreignParkingSubscriptionInfos = [] as any;
                for (let item of _data["foreignParkingSubscriptionInfos"])
                    this.foreignParkingSubscriptionInfos!.push(ForeignParkingSubscriptionInfoDTO.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionAssignments"])) {
                this.subscriptionAssignments = [] as any;
                for (let item of _data["subscriptionAssignments"])
                    this.subscriptionAssignments!.push(ParkingProcessSubscriptionAssignmentInfoDTO.fromJS(item));
            }
            this.parent = _data["parent"] ? ParkingProcessLimitedZoneWithParentInfoDTO.fromJS(_data["parent"]) : undefined as any;
            this.sessionControlType = _data["sessionControlType"];
        }
    }

    static fromJS(data: any): ParkingProcessZoneInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingProcessZoneInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["foreignParkersAllowed"] = this.foreignParkersAllowed;
        data["parkingSpaceNumberDefinition"] = this.parkingSpaceNumberDefinition;
        data["defaultForeignParkingSubscriptionId"] = this.defaultForeignParkingSubscriptionId;
        data["useBlacklistArea"] = this.useBlacklistArea;
        data["fastCheckinSubscriptionId"] = this.fastCheckinSubscriptionId;
        if (Array.isArray(this.foreignParkingSubscriptionInfos)) {
            data["foreignParkingSubscriptionInfos"] = [];
            for (let item of this.foreignParkingSubscriptionInfos)
                data["foreignParkingSubscriptionInfos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subscriptionAssignments)) {
            data["subscriptionAssignments"] = [];
            for (let item of this.subscriptionAssignments)
                data["subscriptionAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["sessionControlType"] = this.sessionControlType;
        return data;
    }
}

export interface IParkingProcessZoneInfoDTO {
    id: number;
    name?: string | undefined;
    clientId: number;
    clientName?: string | undefined;
    foreignParkersAllowed: boolean;
    parkingSpaceNumberDefinition?: string | undefined;
    defaultForeignParkingSubscriptionId?: number | undefined;
    useBlacklistArea: boolean;
    fastCheckinSubscriptionId?: number | undefined;
    foreignParkingSubscriptionInfos: ForeignParkingSubscriptionInfoDTO[];
    subscriptionAssignments: ParkingProcessSubscriptionAssignmentInfoDTO[];
    parent?: ParkingProcessLimitedZoneWithParentInfoDTO | undefined;
    sessionControlType: ParkingSessionControlType;
}

export class ForeignParkingSubscriptionInfoDTO implements IForeignParkingSubscriptionInfoDTO {
    subscription?: ParkingProcessSubscriptionInfoDTO | undefined;
    templateInfo?: ParkingSubscriptionAssignmentTemplateInfoDTO | undefined;

    constructor(data?: IForeignParkingSubscriptionInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscription = _data["subscription"] ? ParkingProcessSubscriptionInfoDTO.fromJS(_data["subscription"]) : undefined as any;
            this.templateInfo = _data["templateInfo"] ? ParkingSubscriptionAssignmentTemplateInfoDTO.fromJS(_data["templateInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): ForeignParkingSubscriptionInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ForeignParkingSubscriptionInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined as any;
        data["templateInfo"] = this.templateInfo ? this.templateInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IForeignParkingSubscriptionInfoDTO {
    subscription?: ParkingProcessSubscriptionInfoDTO | undefined;
    templateInfo?: ParkingSubscriptionAssignmentTemplateInfoDTO | undefined;
}

export class ParkingProcessSubscriptionInfoDTO implements IParkingProcessSubscriptionInfoDTO {
    id!: number;
    name?: string | undefined;
    description?: string | undefined;
    type!: ParkingSubscriptionType;
    usage!: ParkingSubscriptionUsage;
    needsVisitorValidation!: boolean;
    validationFallbackSubscriptionName?: string | undefined;
    currency!: Currency;
    maxParkingDurationInMin?: number | undefined;
    parkingQuotaHours?: number | undefined;
    denyForeignParkingSubscriptionFallback!: boolean;
    parkingCardConfirmationTimeInMinutes!: number;
    tariffs?: ParkingProcessTariffInfoDTO[] | undefined;
    companyId?: number | undefined;
    company?: ParkerCompanyLimitedDTO | undefined;
    orderWeight!: number;
    multipleCarsPerUserTreatAs!: MultipleCarsPerUserTreatAs;
    activeSessionsCount!: number;
    paidBy!: ParkingSubscriptionPaidBy;

    constructor(data?: IParkingProcessSubscriptionInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.usage = _data["usage"];
            this.needsVisitorValidation = _data["needsVisitorValidation"];
            this.validationFallbackSubscriptionName = _data["validationFallbackSubscriptionName"];
            this.currency = _data["currency"];
            this.maxParkingDurationInMin = _data["maxParkingDurationInMin"];
            this.parkingQuotaHours = _data["parkingQuotaHours"];
            this.denyForeignParkingSubscriptionFallback = _data["denyForeignParkingSubscriptionFallback"];
            this.parkingCardConfirmationTimeInMinutes = _data["parkingCardConfirmationTimeInMinutes"];
            if (Array.isArray(_data["tariffs"])) {
                this.tariffs = [] as any;
                for (let item of _data["tariffs"])
                    this.tariffs!.push(ParkingProcessTariffInfoDTO.fromJS(item));
            }
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? ParkerCompanyLimitedDTO.fromJS(_data["company"]) : undefined as any;
            this.orderWeight = _data["orderWeight"];
            this.multipleCarsPerUserTreatAs = _data["multipleCarsPerUserTreatAs"];
            this.activeSessionsCount = _data["activeSessionsCount"];
            this.paidBy = _data["paidBy"];
        }
    }

    static fromJS(data: any): ParkingProcessSubscriptionInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingProcessSubscriptionInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["usage"] = this.usage;
        data["needsVisitorValidation"] = this.needsVisitorValidation;
        data["validationFallbackSubscriptionName"] = this.validationFallbackSubscriptionName;
        data["currency"] = this.currency;
        data["maxParkingDurationInMin"] = this.maxParkingDurationInMin;
        data["parkingQuotaHours"] = this.parkingQuotaHours;
        data["denyForeignParkingSubscriptionFallback"] = this.denyForeignParkingSubscriptionFallback;
        data["parkingCardConfirmationTimeInMinutes"] = this.parkingCardConfirmationTimeInMinutes;
        if (Array.isArray(this.tariffs)) {
            data["tariffs"] = [];
            for (let item of this.tariffs)
                data["tariffs"].push(item ? item.toJSON() : undefined as any);
        }
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : undefined as any;
        data["orderWeight"] = this.orderWeight;
        data["multipleCarsPerUserTreatAs"] = this.multipleCarsPerUserTreatAs;
        data["activeSessionsCount"] = this.activeSessionsCount;
        data["paidBy"] = this.paidBy;
        return data;
    }
}

export interface IParkingProcessSubscriptionInfoDTO {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    type: ParkingSubscriptionType;
    usage: ParkingSubscriptionUsage;
    needsVisitorValidation: boolean;
    validationFallbackSubscriptionName?: string | undefined;
    currency: Currency;
    maxParkingDurationInMin?: number | undefined;
    parkingQuotaHours?: number | undefined;
    denyForeignParkingSubscriptionFallback: boolean;
    parkingCardConfirmationTimeInMinutes: number;
    tariffs?: ParkingProcessTariffInfoDTO[] | undefined;
    companyId?: number | undefined;
    company?: ParkerCompanyLimitedDTO | undefined;
    orderWeight: number;
    multipleCarsPerUserTreatAs: MultipleCarsPerUserTreatAs;
    activeSessionsCount: number;
    paidBy: ParkingSubscriptionPaidBy;
}

export class ParkingProcessTariffInfoDTO implements IParkingProcessTariffInfoDTO {
    id!: number;
    name?: string | undefined;
    onWeekDays?: WeekDayFlags | undefined;
    startTime?: Duration | undefined;
    durationInMinutes?: number | undefined;
    maxParkingDurationInMin?: number | undefined;
    isTwentyFourSevenTariff!: boolean;
    pricePerHour?: number | undefined;
    fixedPrice?: number | undefined;
    tariffCurrency!: Currency;

    constructor(data?: IParkingProcessTariffInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.onWeekDays = _data["onWeekDays"];
            this.startTime = _data["startTime"] ? Duration.fromISO(_data["startTime"].toString()) : undefined as any;
            this.durationInMinutes = _data["durationInMinutes"];
            this.maxParkingDurationInMin = _data["maxParkingDurationInMin"];
            this.isTwentyFourSevenTariff = _data["isTwentyFourSevenTariff"];
            this.pricePerHour = _data["pricePerHour"];
            this.fixedPrice = _data["fixedPrice"];
            this.tariffCurrency = _data["tariffCurrency"];
        }
    }

    static fromJS(data: any): ParkingProcessTariffInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingProcessTariffInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["onWeekDays"] = this.onWeekDays;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["durationInMinutes"] = this.durationInMinutes;
        data["maxParkingDurationInMin"] = this.maxParkingDurationInMin;
        data["isTwentyFourSevenTariff"] = this.isTwentyFourSevenTariff;
        data["pricePerHour"] = this.pricePerHour;
        data["fixedPrice"] = this.fixedPrice;
        data["tariffCurrency"] = this.tariffCurrency;
        return data;
    }
}

export interface IParkingProcessTariffInfoDTO {
    id: number;
    name?: string | undefined;
    onWeekDays?: WeekDayFlags | undefined;
    startTime?: Duration | undefined;
    durationInMinutes?: number | undefined;
    maxParkingDurationInMin?: number | undefined;
    isTwentyFourSevenTariff: boolean;
    pricePerHour?: number | undefined;
    fixedPrice?: number | undefined;
    tariffCurrency: Currency;
}

export enum MultipleCarsPerUserTreatAs {
    Forbidden = 0,
    OneCar = 1,
    MultipleCars = 2,
}

export class ParkingSubscriptionAssignmentTemplateInfoDTO implements IParkingSubscriptionAssignmentTemplateInfoDTO {
    assignmentDurationInMinutes!: number;
    templateValidFrom?: DateTime | undefined;
    templateValidTo?: DateTime | undefined;

    constructor(data?: IParkingSubscriptionAssignmentTemplateInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentDurationInMinutes = _data["assignmentDurationInMinutes"];
            this.templateValidFrom = _data["templateValidFrom"] ? DateTime.fromISO(_data["templateValidFrom"].toString()) : undefined as any;
            this.templateValidTo = _data["templateValidTo"] ? DateTime.fromISO(_data["templateValidTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ParkingSubscriptionAssignmentTemplateInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingSubscriptionAssignmentTemplateInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentDurationInMinutes"] = this.assignmentDurationInMinutes;
        data["templateValidFrom"] = this.templateValidFrom ? this.templateValidFrom.toString() : undefined as any;
        data["templateValidTo"] = this.templateValidTo ? this.templateValidTo.toString() : undefined as any;
        return data;
    }
}

export interface IParkingSubscriptionAssignmentTemplateInfoDTO {
    assignmentDurationInMinutes: number;
    templateValidFrom?: DateTime | undefined;
    templateValidTo?: DateTime | undefined;
}

export class ParkingProcessSubscriptionAssignmentInfoDTO implements IParkingProcessSubscriptionAssignmentInfoDTO {
    id!: number;
    parkerId!: number;
    validTo?: DateTime | undefined;
    subscription?: ParkingProcessSubscriptionInfoDTO | undefined;
    isFavorite!: boolean;

    constructor(data?: IParkingProcessSubscriptionAssignmentInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parkerId = _data["parkerId"];
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : undefined as any;
            this.subscription = _data["subscription"] ? ParkingProcessSubscriptionInfoDTO.fromJS(_data["subscription"]) : undefined as any;
            this.isFavorite = _data["isFavorite"];
        }
    }

    static fromJS(data: any): ParkingProcessSubscriptionAssignmentInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingProcessSubscriptionAssignmentInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parkerId"] = this.parkerId;
        data["validTo"] = this.validTo ? this.validTo.toString() : undefined as any;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined as any;
        data["isFavorite"] = this.isFavorite;
        return data;
    }
}

export interface IParkingProcessSubscriptionAssignmentInfoDTO {
    id: number;
    parkerId: number;
    validTo?: DateTime | undefined;
    subscription?: ParkingProcessSubscriptionInfoDTO | undefined;
    isFavorite: boolean;
}

export class ParkingProcessLimitedZoneWithParentInfoDTO implements IParkingProcessLimitedZoneWithParentInfoDTO {
    id!: number;
    name?: string | undefined;
    foreignParkingSubscription?: ParkingProcessSubscriptionInfoDTO | undefined;
    foreignParkersAllowed!: boolean;
    parent?: ParkingProcessLimitedZoneWithParentInfoDTO | undefined;

    constructor(data?: IParkingProcessLimitedZoneWithParentInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.foreignParkingSubscription = _data["foreignParkingSubscription"] ? ParkingProcessSubscriptionInfoDTO.fromJS(_data["foreignParkingSubscription"]) : undefined as any;
            this.foreignParkersAllowed = _data["foreignParkersAllowed"];
            this.parent = _data["parent"] ? ParkingProcessLimitedZoneWithParentInfoDTO.fromJS(_data["parent"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParkingProcessLimitedZoneWithParentInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingProcessLimitedZoneWithParentInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["foreignParkingSubscription"] = this.foreignParkingSubscription ? this.foreignParkingSubscription.toJSON() : undefined as any;
        data["foreignParkersAllowed"] = this.foreignParkersAllowed;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        return data;
    }
}

export interface IParkingProcessLimitedZoneWithParentInfoDTO {
    id: number;
    name?: string | undefined;
    foreignParkingSubscription?: ParkingProcessSubscriptionInfoDTO | undefined;
    foreignParkersAllowed: boolean;
    parent?: ParkingProcessLimitedZoneWithParentInfoDTO | undefined;
}

export class AuditLogDTO implements IAuditLogDTO {
    id!: number;
    clientId?: number | undefined;
    userName!: string;
    timestamp!: DateTime;
    entryType!: string;
    actionType!: AuditActionType;
    keyValues!: string[];
    affectedFields!: AuditLogFieldDTO[];

    constructor(data?: IAuditLogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.keyValues = [];
            this.affectedFields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.userName = _data["userName"];
            this.timestamp = _data["timestamp"] ? DateTime.fromISO(_data["timestamp"].toString()) : undefined as any;
            this.entryType = _data["entryType"];
            this.actionType = _data["actionType"];
            if (Array.isArray(_data["keyValues"])) {
                this.keyValues = [] as any;
                for (let item of _data["keyValues"])
                    this.keyValues!.push(item);
            }
            if (Array.isArray(_data["affectedFields"])) {
                this.affectedFields = [] as any;
                for (let item of _data["affectedFields"])
                    this.affectedFields!.push(AuditLogFieldDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditLogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["userName"] = this.userName;
        data["timestamp"] = this.timestamp ? this.timestamp.toString() : undefined as any;
        data["entryType"] = this.entryType;
        data["actionType"] = this.actionType;
        if (Array.isArray(this.keyValues)) {
            data["keyValues"] = [];
            for (let item of this.keyValues)
                data["keyValues"].push(item);
        }
        if (Array.isArray(this.affectedFields)) {
            data["affectedFields"] = [];
            for (let item of this.affectedFields)
                data["affectedFields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAuditLogDTO {
    id: number;
    clientId?: number | undefined;
    userName: string;
    timestamp: DateTime;
    entryType: string;
    actionType: AuditActionType;
    keyValues: string[];
    affectedFields: AuditLogFieldDTO[];
}

export enum AuditActionType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
    UnDeleted = 3,
    ParkerListRead = 10,
    ParkerDetails = 11,
    ReportTagsPerParker = 20,
    ReportParkerRegistrations = 21,
    ReportFalseRecordings = 22,
    ReportParkerExtract = 23,
    ReportParkerTurnover = 24,
}

export class AuditLogFieldDTO implements IAuditLogFieldDTO {
    fieldName!: string;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IAuditLogFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): AuditLogFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IAuditLogFieldDTO {
    fieldName: string;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class PagedResultDTOOfClientDTO implements IPagedResultDTOOfClientDTO {
    items?: ClientDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfClientDTO {
    items?: ClientDTO[] | undefined;
    totalNumberOfItems: number;
}

export class PagedResultDTOOfParkerDTO implements IPagedResultDTOOfParkerDTO {
    items?: ParkerDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkerDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkerDTO {
    items?: ParkerDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ParkerDTO implements IParkerDTO {
    id!: number;
    clientId!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    identification?: string | undefined;
    group!: ParkerGroup;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    privateAddress?: string | undefined;
    privateZIP?: string | undefined;
    privateCity?: string | undefined;
    privateCountry?: string | undefined;
    email?: string | undefined;
    company?: ParkerCompanyDTO | undefined;
    costCenter?: string | undefined;
    title?: string | undefined;
    entryDate!: DateTime;
    exitDate?: DateTime | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    billing!: boolean;
    active!: boolean;
    workplace?: string | undefined;
    employmentPercentage!: number;
    billingCurrency!: Currency;
    linkedUserUserName?: string | undefined;
    userLinkCodeValidUntil?: DateTime | undefined;
    creationType!: ParkerCreationType;
    tags?: ParkerTagDTO[] | undefined;
    parkerSubscriptionAssignments?: ParkerSubscriptionAssignmentDTO[] | undefined;
    modifiedOn!: DateTime;
    modifiedBy?: string | undefined;
    custom1?: string | undefined;
    custom2?: string | undefined;
    custom3?: string | undefined;
    custom4?: string | undefined;
    custom5?: string | undefined;
    custom6?: string | undefined;
    custom7?: string | undefined;
    custom8?: string | undefined;
    custom9?: string | undefined;
    comment?: string | undefined;
    activeParkingPermitGuid?: string | undefined;
    parkingPermitValidUntil?: DateTime | undefined;
    parkingPermitValidityPeriod?: number | undefined;

    constructor(data?: IParkerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.identification = _data["identification"];
            this.group = _data["group"];
            this.address = _data["address"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.privateAddress = _data["privateAddress"];
            this.privateZIP = _data["privateZIP"];
            this.privateCity = _data["privateCity"];
            this.privateCountry = _data["privateCountry"];
            this.email = _data["email"];
            this.company = _data["company"] ? ParkerCompanyDTO.fromJS(_data["company"]) : undefined as any;
            this.costCenter = _data["costCenter"];
            this.title = _data["title"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : undefined as any;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : undefined as any;
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.billing = _data["billing"];
            this.active = _data["active"];
            this.workplace = _data["workplace"];
            this.employmentPercentage = _data["employmentPercentage"];
            this.billingCurrency = _data["billingCurrency"];
            this.linkedUserUserName = _data["linkedUserUserName"];
            this.userLinkCodeValidUntil = _data["userLinkCodeValidUntil"] ? DateTime.fromISO(_data["userLinkCodeValidUntil"].toString()) : undefined as any;
            this.creationType = _data["creationType"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ParkerTagDTO.fromJS(item));
            }
            if (Array.isArray(_data["parkerSubscriptionAssignments"])) {
                this.parkerSubscriptionAssignments = [] as any;
                for (let item of _data["parkerSubscriptionAssignments"])
                    this.parkerSubscriptionAssignments!.push(ParkerSubscriptionAssignmentDTO.fromJS(item));
            }
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.custom1 = _data["custom1"];
            this.custom2 = _data["custom2"];
            this.custom3 = _data["custom3"];
            this.custom4 = _data["custom4"];
            this.custom5 = _data["custom5"];
            this.custom6 = _data["custom6"];
            this.custom7 = _data["custom7"];
            this.custom8 = _data["custom8"];
            this.custom9 = _data["custom9"];
            this.comment = _data["comment"];
            this.activeParkingPermitGuid = _data["activeParkingPermitGuid"];
            this.parkingPermitValidUntil = _data["parkingPermitValidUntil"] ? DateTime.fromISO(_data["parkingPermitValidUntil"].toString()) : undefined as any;
            this.parkingPermitValidityPeriod = _data["parkingPermitValidityPeriod"];
        }
    }

    static fromJS(data: any): ParkerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["identification"] = this.identification;
        data["group"] = this.group;
        data["address"] = this.address;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["privateAddress"] = this.privateAddress;
        data["privateZIP"] = this.privateZIP;
        data["privateCity"] = this.privateCity;
        data["privateCountry"] = this.privateCountry;
        data["email"] = this.email;
        data["company"] = this.company ? this.company.toJSON() : undefined as any;
        data["costCenter"] = this.costCenter;
        data["title"] = this.title;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : undefined as any;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : undefined as any;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["billing"] = this.billing;
        data["active"] = this.active;
        data["workplace"] = this.workplace;
        data["employmentPercentage"] = this.employmentPercentage;
        data["billingCurrency"] = this.billingCurrency;
        data["linkedUserUserName"] = this.linkedUserUserName;
        data["userLinkCodeValidUntil"] = this.userLinkCodeValidUntil ? this.userLinkCodeValidUntil.toString() : undefined as any;
        data["creationType"] = this.creationType;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parkerSubscriptionAssignments)) {
            data["parkerSubscriptionAssignments"] = [];
            for (let item of this.parkerSubscriptionAssignments)
                data["parkerSubscriptionAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["custom1"] = this.custom1;
        data["custom2"] = this.custom2;
        data["custom3"] = this.custom3;
        data["custom4"] = this.custom4;
        data["custom5"] = this.custom5;
        data["custom6"] = this.custom6;
        data["custom7"] = this.custom7;
        data["custom8"] = this.custom8;
        data["custom9"] = this.custom9;
        data["comment"] = this.comment;
        data["activeParkingPermitGuid"] = this.activeParkingPermitGuid;
        data["parkingPermitValidUntil"] = this.parkingPermitValidUntil ? this.parkingPermitValidUntil.toString() : undefined as any;
        data["parkingPermitValidityPeriod"] = this.parkingPermitValidityPeriod;
        return data;
    }
}

export interface IParkerDTO {
    id: number;
    clientId: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    identification?: string | undefined;
    group: ParkerGroup;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    privateAddress?: string | undefined;
    privateZIP?: string | undefined;
    privateCity?: string | undefined;
    privateCountry?: string | undefined;
    email?: string | undefined;
    company?: ParkerCompanyDTO | undefined;
    costCenter?: string | undefined;
    title?: string | undefined;
    entryDate: DateTime;
    exitDate?: DateTime | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    billing: boolean;
    active: boolean;
    workplace?: string | undefined;
    employmentPercentage: number;
    billingCurrency: Currency;
    linkedUserUserName?: string | undefined;
    userLinkCodeValidUntil?: DateTime | undefined;
    creationType: ParkerCreationType;
    tags?: ParkerTagDTO[] | undefined;
    parkerSubscriptionAssignments?: ParkerSubscriptionAssignmentDTO[] | undefined;
    modifiedOn: DateTime;
    modifiedBy?: string | undefined;
    custom1?: string | undefined;
    custom2?: string | undefined;
    custom3?: string | undefined;
    custom4?: string | undefined;
    custom5?: string | undefined;
    custom6?: string | undefined;
    custom7?: string | undefined;
    custom8?: string | undefined;
    custom9?: string | undefined;
    comment?: string | undefined;
    activeParkingPermitGuid?: string | undefined;
    parkingPermitValidUntil?: DateTime | undefined;
    parkingPermitValidityPeriod?: number | undefined;
}

export enum ParkerCreationType {
    ManuallyCreated = 0,
    CreatedByProxy = 1,
    AutomaticallyCreatedByUser = 2,
}

export class ParkerExtractFullReportDataDTO implements IParkerExtractFullReportDataDTO {
    parkingSessions!: ParkerExtractReportDTO[];
    summary!: ParkerExtractReportSummaryDTO;

    constructor(data?: IParkerExtractFullReportDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.parkingSessions = [];
            this.summary = new ParkerExtractReportSummaryDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parkingSessions"])) {
                this.parkingSessions = [] as any;
                for (let item of _data["parkingSessions"])
                    this.parkingSessions!.push(ParkerExtractReportDTO.fromJS(item));
            }
            this.summary = _data["summary"] ? ParkerExtractReportSummaryDTO.fromJS(_data["summary"]) : new ParkerExtractReportSummaryDTO();
        }
    }

    static fromJS(data: any): ParkerExtractFullReportDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerExtractFullReportDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parkingSessions)) {
            data["parkingSessions"] = [];
            for (let item of this.parkingSessions)
                data["parkingSessions"].push(item ? item.toJSON() : undefined as any);
        }
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        return data;
    }
}

export interface IParkerExtractFullReportDataDTO {
    parkingSessions: ParkerExtractReportDTO[];
    summary: ParkerExtractReportSummaryDTO;
}

export class ParkerExtractReportDTO implements IParkerExtractReportDTO {
    parker?: ParkerInfoDTO | undefined;
    entryDate!: DateTime;
    exitDate!: DateTime;
    durationInMinutes!: number;
    knownTag?: ParkerTagDTO | undefined;
    zone?: ZoneDTO | undefined;
    subscriptionName?: string | undefined;
    isFallbackSubscriptionApplied!: boolean;
    paidBy!: ParkingSubscriptionPaidBy;
    amount!: number;
    currency!: Currency;
    calculationRoadmap?: string | undefined;
    sessionOpeningEventType!: SessionEventType;
    sessionClosingEventType!: SessionEventType;
    isVisitorParking!: boolean;
    controlPlateNumber?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    detailedPriceInformation?: ParkingPriceDetailsDTO | undefined;

    constructor(data?: IParkerExtractReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parker = _data["parker"] ? ParkerInfoDTO.fromJS(_data["parker"]) : undefined as any;
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : undefined as any;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : undefined as any;
            this.durationInMinutes = _data["durationInMinutes"];
            this.knownTag = _data["knownTag"] ? ParkerTagDTO.fromJS(_data["knownTag"]) : undefined as any;
            this.zone = _data["zone"] ? ZoneDTO.fromJS(_data["zone"]) : undefined as any;
            this.subscriptionName = _data["subscriptionName"];
            this.isFallbackSubscriptionApplied = _data["isFallbackSubscriptionApplied"];
            this.paidBy = _data["paidBy"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.calculationRoadmap = _data["calculationRoadmap"];
            this.sessionOpeningEventType = _data["sessionOpeningEventType"];
            this.sessionClosingEventType = _data["sessionClosingEventType"];
            this.isVisitorParking = _data["isVisitorParking"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.controlPlateType = _data["controlPlateType"];
            this.detailedPriceInformation = _data["detailedPriceInformation"] ? ParkingPriceDetailsDTO.fromJS(_data["detailedPriceInformation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParkerExtractReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerExtractReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parker"] = this.parker ? this.parker.toJSON() : undefined as any;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : undefined as any;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : undefined as any;
        data["durationInMinutes"] = this.durationInMinutes;
        data["knownTag"] = this.knownTag ? this.knownTag.toJSON() : undefined as any;
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        data["subscriptionName"] = this.subscriptionName;
        data["isFallbackSubscriptionApplied"] = this.isFallbackSubscriptionApplied;
        data["paidBy"] = this.paidBy;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["calculationRoadmap"] = this.calculationRoadmap;
        data["sessionOpeningEventType"] = this.sessionOpeningEventType;
        data["sessionClosingEventType"] = this.sessionClosingEventType;
        data["isVisitorParking"] = this.isVisitorParking;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["controlPlateType"] = this.controlPlateType;
        data["detailedPriceInformation"] = this.detailedPriceInformation ? this.detailedPriceInformation.toJSON() : undefined as any;
        return data;
    }
}

export interface IParkerExtractReportDTO {
    parker?: ParkerInfoDTO | undefined;
    entryDate: DateTime;
    exitDate: DateTime;
    durationInMinutes: number;
    knownTag?: ParkerTagDTO | undefined;
    zone?: ZoneDTO | undefined;
    subscriptionName?: string | undefined;
    isFallbackSubscriptionApplied: boolean;
    paidBy: ParkingSubscriptionPaidBy;
    amount: number;
    currency: Currency;
    calculationRoadmap?: string | undefined;
    sessionOpeningEventType: SessionEventType;
    sessionClosingEventType: SessionEventType;
    isVisitorParking: boolean;
    controlPlateNumber?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    detailedPriceInformation?: ParkingPriceDetailsDTO | undefined;
}

export class ZoneDTO implements IZoneDTO {
    id!: number;
    name?: string | undefined;
    clientId!: number;
    parentId?: number | undefined;
    isGroupingElement!: boolean;
    separateNFCCode!: boolean;
    nfcCode?: string | undefined;
    enableGPSDetection!: boolean;
    zoneGPSArea?: string | undefined;
    foreignParkersAllowed!: boolean;
    foreignParkingSubscription?: ParkingSubscriptionDTO | undefined;
    fastCheckinSubscription?: ParkingSubscriptionDTO | undefined;
    maxPassageTime!: number;
    parkingSpaceNumberDefinition?: string | undefined;
    parkingSpaceCapacity?: number | undefined;
    currentParkerCount!: number;
    deleted!: boolean;
    assignedTariffs?: number[] | undefined;
    hasDevicesAssigned!: boolean;
    hasChildZones!: boolean;
    useBlacklistArea!: boolean;
    blacklistGPSArea?: string | undefined;
    sessionControlType!: ParkingSessionControlType;

    constructor(data?: IZoneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            this.parentId = _data["parentId"];
            this.isGroupingElement = _data["isGroupingElement"];
            this.separateNFCCode = _data["separateNFCCode"];
            this.nfcCode = _data["nfcCode"];
            this.enableGPSDetection = _data["enableGPSDetection"];
            this.zoneGPSArea = _data["zoneGPSArea"];
            this.foreignParkersAllowed = _data["foreignParkersAllowed"];
            this.foreignParkingSubscription = _data["foreignParkingSubscription"] ? ParkingSubscriptionDTO.fromJS(_data["foreignParkingSubscription"]) : undefined as any;
            this.fastCheckinSubscription = _data["fastCheckinSubscription"] ? ParkingSubscriptionDTO.fromJS(_data["fastCheckinSubscription"]) : undefined as any;
            this.maxPassageTime = _data["maxPassageTime"];
            this.parkingSpaceNumberDefinition = _data["parkingSpaceNumberDefinition"];
            this.parkingSpaceCapacity = _data["parkingSpaceCapacity"];
            this.currentParkerCount = _data["currentParkerCount"];
            this.deleted = _data["deleted"];
            if (Array.isArray(_data["assignedTariffs"])) {
                this.assignedTariffs = [] as any;
                for (let item of _data["assignedTariffs"])
                    this.assignedTariffs!.push(item);
            }
            this.hasDevicesAssigned = _data["hasDevicesAssigned"];
            this.hasChildZones = _data["hasChildZones"];
            this.useBlacklistArea = _data["useBlacklistArea"];
            this.blacklistGPSArea = _data["blacklistGPSArea"];
            this.sessionControlType = _data["sessionControlType"];
        }
    }

    static fromJS(data: any): ZoneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        data["parentId"] = this.parentId;
        data["isGroupingElement"] = this.isGroupingElement;
        data["separateNFCCode"] = this.separateNFCCode;
        data["nfcCode"] = this.nfcCode;
        data["enableGPSDetection"] = this.enableGPSDetection;
        data["zoneGPSArea"] = this.zoneGPSArea;
        data["foreignParkersAllowed"] = this.foreignParkersAllowed;
        data["foreignParkingSubscription"] = this.foreignParkingSubscription ? this.foreignParkingSubscription.toJSON() : undefined as any;
        data["fastCheckinSubscription"] = this.fastCheckinSubscription ? this.fastCheckinSubscription.toJSON() : undefined as any;
        data["maxPassageTime"] = this.maxPassageTime;
        data["parkingSpaceNumberDefinition"] = this.parkingSpaceNumberDefinition;
        data["parkingSpaceCapacity"] = this.parkingSpaceCapacity;
        data["currentParkerCount"] = this.currentParkerCount;
        data["deleted"] = this.deleted;
        if (Array.isArray(this.assignedTariffs)) {
            data["assignedTariffs"] = [];
            for (let item of this.assignedTariffs)
                data["assignedTariffs"].push(item);
        }
        data["hasDevicesAssigned"] = this.hasDevicesAssigned;
        data["hasChildZones"] = this.hasChildZones;
        data["useBlacklistArea"] = this.useBlacklistArea;
        data["blacklistGPSArea"] = this.blacklistGPSArea;
        data["sessionControlType"] = this.sessionControlType;
        return data;
    }
}

export interface IZoneDTO {
    id: number;
    name?: string | undefined;
    clientId: number;
    parentId?: number | undefined;
    isGroupingElement: boolean;
    separateNFCCode: boolean;
    nfcCode?: string | undefined;
    enableGPSDetection: boolean;
    zoneGPSArea?: string | undefined;
    foreignParkersAllowed: boolean;
    foreignParkingSubscription?: ParkingSubscriptionDTO | undefined;
    fastCheckinSubscription?: ParkingSubscriptionDTO | undefined;
    maxPassageTime: number;
    parkingSpaceNumberDefinition?: string | undefined;
    parkingSpaceCapacity?: number | undefined;
    currentParkerCount: number;
    deleted: boolean;
    assignedTariffs?: number[] | undefined;
    hasDevicesAssigned: boolean;
    hasChildZones: boolean;
    useBlacklistArea: boolean;
    blacklistGPSArea?: string | undefined;
    sessionControlType: ParkingSessionControlType;
}

export class ParkingSubscriptionDTO implements IParkingSubscriptionDTO {
    id!: number;
    clientId!: number;
    active!: boolean;
    assignable!: boolean;
    name?: string | undefined;
    type!: ParkingSubscriptionType;
    description?: string | undefined;
    multipleCarsPerUserTreatAs!: MultipleCarsPerUserTreatAs;
    chargeCap?: number | undefined;
    chargeCapPerMonth!: boolean;
    chargeInRelationToEmploymentPercentage!: boolean;
    fixPricePerMonth?: number | undefined;
    basePricePerDay?: number | undefined;
    currency!: Currency;
    denyForeignParkingSubscriptionFallback!: boolean;
    sessionIsExtendable!: boolean;
    maxParkingDurationInMin?: number | undefined;
    structuralEntries?: ConfigBasedStructuralEntryDTO[] | undefined;
    roundSessionFeeToXCents!: number;
    usage!: ParkingSubscriptionUsage;
    paidBy!: ParkingSubscriptionPaidBy;
    parkingCardConfirmationTimeInMinutes!: number;
    modifiedOn!: DateTime;
    modifiedBy?: string | undefined;
    tariffs?: ParkingTariffLimitedDTO[] | undefined;
    parkingQuotaHours?: number | undefined;
    parkingQuotaDuration!: ParkingQuotaDuration;
    companyId?: number | undefined;
    orderWeight!: number;
    validationFallbackSubscriptionId?: number | undefined;

    constructor(data?: IParkingSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.active = _data["active"];
            this.assignable = _data["assignable"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.multipleCarsPerUserTreatAs = _data["multipleCarsPerUserTreatAs"];
            this.chargeCap = _data["chargeCap"];
            this.chargeCapPerMonth = _data["chargeCapPerMonth"];
            this.chargeInRelationToEmploymentPercentage = _data["chargeInRelationToEmploymentPercentage"];
            this.fixPricePerMonth = _data["fixPricePerMonth"];
            this.basePricePerDay = _data["basePricePerDay"];
            this.currency = _data["currency"];
            this.denyForeignParkingSubscriptionFallback = _data["denyForeignParkingSubscriptionFallback"];
            this.sessionIsExtendable = _data["sessionIsExtendable"];
            this.maxParkingDurationInMin = _data["maxParkingDurationInMin"];
            if (Array.isArray(_data["structuralEntries"])) {
                this.structuralEntries = [] as any;
                for (let item of _data["structuralEntries"])
                    this.structuralEntries!.push(ConfigBasedStructuralEntryDTO.fromJS(item));
            }
            this.roundSessionFeeToXCents = _data["roundSessionFeeToXCents"];
            this.usage = _data["usage"];
            this.paidBy = _data["paidBy"];
            this.parkingCardConfirmationTimeInMinutes = _data["parkingCardConfirmationTimeInMinutes"];
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["tariffs"])) {
                this.tariffs = [] as any;
                for (let item of _data["tariffs"])
                    this.tariffs!.push(ParkingTariffLimitedDTO.fromJS(item));
            }
            this.parkingQuotaHours = _data["parkingQuotaHours"];
            this.parkingQuotaDuration = _data["parkingQuotaDuration"];
            this.companyId = _data["companyId"];
            this.orderWeight = _data["orderWeight"];
            this.validationFallbackSubscriptionId = _data["validationFallbackSubscriptionId"];
        }
    }

    static fromJS(data: any): ParkingSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["active"] = this.active;
        data["assignable"] = this.assignable;
        data["name"] = this.name;
        data["type"] = this.type;
        data["description"] = this.description;
        data["multipleCarsPerUserTreatAs"] = this.multipleCarsPerUserTreatAs;
        data["chargeCap"] = this.chargeCap;
        data["chargeCapPerMonth"] = this.chargeCapPerMonth;
        data["chargeInRelationToEmploymentPercentage"] = this.chargeInRelationToEmploymentPercentage;
        data["fixPricePerMonth"] = this.fixPricePerMonth;
        data["basePricePerDay"] = this.basePricePerDay;
        data["currency"] = this.currency;
        data["denyForeignParkingSubscriptionFallback"] = this.denyForeignParkingSubscriptionFallback;
        data["sessionIsExtendable"] = this.sessionIsExtendable;
        data["maxParkingDurationInMin"] = this.maxParkingDurationInMin;
        if (Array.isArray(this.structuralEntries)) {
            data["structuralEntries"] = [];
            for (let item of this.structuralEntries)
                data["structuralEntries"].push(item ? item.toJSON() : undefined as any);
        }
        data["roundSessionFeeToXCents"] = this.roundSessionFeeToXCents;
        data["usage"] = this.usage;
        data["paidBy"] = this.paidBy;
        data["parkingCardConfirmationTimeInMinutes"] = this.parkingCardConfirmationTimeInMinutes;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.tariffs)) {
            data["tariffs"] = [];
            for (let item of this.tariffs)
                data["tariffs"].push(item ? item.toJSON() : undefined as any);
        }
        data["parkingQuotaHours"] = this.parkingQuotaHours;
        data["parkingQuotaDuration"] = this.parkingQuotaDuration;
        data["companyId"] = this.companyId;
        data["orderWeight"] = this.orderWeight;
        data["validationFallbackSubscriptionId"] = this.validationFallbackSubscriptionId;
        return data;
    }
}

export interface IParkingSubscriptionDTO {
    id: number;
    clientId: number;
    active: boolean;
    assignable: boolean;
    name?: string | undefined;
    type: ParkingSubscriptionType;
    description?: string | undefined;
    multipleCarsPerUserTreatAs: MultipleCarsPerUserTreatAs;
    chargeCap?: number | undefined;
    chargeCapPerMonth: boolean;
    chargeInRelationToEmploymentPercentage: boolean;
    fixPricePerMonth?: number | undefined;
    basePricePerDay?: number | undefined;
    currency: Currency;
    denyForeignParkingSubscriptionFallback: boolean;
    sessionIsExtendable: boolean;
    maxParkingDurationInMin?: number | undefined;
    structuralEntries?: ConfigBasedStructuralEntryDTO[] | undefined;
    roundSessionFeeToXCents: number;
    usage: ParkingSubscriptionUsage;
    paidBy: ParkingSubscriptionPaidBy;
    parkingCardConfirmationTimeInMinutes: number;
    modifiedOn: DateTime;
    modifiedBy?: string | undefined;
    tariffs?: ParkingTariffLimitedDTO[] | undefined;
    parkingQuotaHours?: number | undefined;
    parkingQuotaDuration: ParkingQuotaDuration;
    companyId?: number | undefined;
    orderWeight: number;
    validationFallbackSubscriptionId?: number | undefined;
}

export class ConfigBasedStructuralEntryDTO implements IConfigBasedStructuralEntryDTO {
    id!: number;
    clientId!: number;
    name!: string;
    parentId?: number | undefined;
    hasChildEntries!: boolean;
    hasSubscriptions!: boolean;
    isSubscriptionSet!: boolean;

    constructor(data?: IConfigBasedStructuralEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.hasChildEntries = _data["hasChildEntries"];
            this.hasSubscriptions = _data["hasSubscriptions"];
            this.isSubscriptionSet = _data["isSubscriptionSet"];
        }
    }

    static fromJS(data: any): ConfigBasedStructuralEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigBasedStructuralEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["hasChildEntries"] = this.hasChildEntries;
        data["hasSubscriptions"] = this.hasSubscriptions;
        data["isSubscriptionSet"] = this.isSubscriptionSet;
        return data;
    }
}

export interface IConfigBasedStructuralEntryDTO {
    id: number;
    clientId: number;
    name: string;
    parentId?: number | undefined;
    hasChildEntries: boolean;
    hasSubscriptions: boolean;
    isSubscriptionSet: boolean;
}

export class ParkingTariffLimitedDTO implements IParkingTariffLimitedDTO {
    id!: number;
    clientId!: number;
    active!: boolean;
    deleted!: boolean;
    name?: string | undefined;
    description?: string | undefined;
    subscriptionId?: number | undefined;
    isDeviceControlTariff!: boolean;

    constructor(data?: IParkingTariffLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.active = _data["active"];
            this.deleted = _data["deleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.subscriptionId = _data["subscriptionId"];
            this.isDeviceControlTariff = _data["isDeviceControlTariff"];
        }
    }

    static fromJS(data: any): ParkingTariffLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingTariffLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["active"] = this.active;
        data["deleted"] = this.deleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["subscriptionId"] = this.subscriptionId;
        data["isDeviceControlTariff"] = this.isDeviceControlTariff;
        return data;
    }
}

export interface IParkingTariffLimitedDTO {
    id: number;
    clientId: number;
    active: boolean;
    deleted: boolean;
    name?: string | undefined;
    description?: string | undefined;
    subscriptionId?: number | undefined;
    isDeviceControlTariff: boolean;
}

export enum ParkingQuotaDuration {
    Week = 0,
    Month = 1,
}

export enum SessionEventType {
    ParkingRanger = 0,
    Manually = 1,
    Automatic = 2,
    AutomaticParkingSchedule = 3,
    Device = 4,
    Unknown = 5,
    AdminIntervention = 6,
}

export class ParkingPriceDetailsDTO implements IParkingPriceDetailsDTO {
    totalPriceWithVAT!: number;
    totalPriceWithoutVAT!: number;
    parkingPrice!: number;
    parkingPriceIncludedVAT!: number;
    parkingTransactionFeesConstant!: number;
    parkingTransactionFeesVariable!: number;
    feesPaidByParkingSpaceOwner!: boolean;
    vat!: number;
    currency!: Currency;

    constructor(data?: IParkingPriceDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPriceWithVAT = _data["totalPriceWithVAT"];
            this.totalPriceWithoutVAT = _data["totalPriceWithoutVAT"];
            this.parkingPrice = _data["parkingPrice"];
            this.parkingPriceIncludedVAT = _data["parkingPriceIncludedVAT"];
            this.parkingTransactionFeesConstant = _data["parkingTransactionFeesConstant"];
            this.parkingTransactionFeesVariable = _data["parkingTransactionFeesVariable"];
            this.feesPaidByParkingSpaceOwner = _data["feesPaidByParkingSpaceOwner"];
            this.vat = _data["vat"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): ParkingPriceDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingPriceDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPriceWithVAT"] = this.totalPriceWithVAT;
        data["totalPriceWithoutVAT"] = this.totalPriceWithoutVAT;
        data["parkingPrice"] = this.parkingPrice;
        data["parkingPriceIncludedVAT"] = this.parkingPriceIncludedVAT;
        data["parkingTransactionFeesConstant"] = this.parkingTransactionFeesConstant;
        data["parkingTransactionFeesVariable"] = this.parkingTransactionFeesVariable;
        data["feesPaidByParkingSpaceOwner"] = this.feesPaidByParkingSpaceOwner;
        data["vat"] = this.vat;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IParkingPriceDetailsDTO {
    totalPriceWithVAT: number;
    totalPriceWithoutVAT: number;
    parkingPrice: number;
    parkingPriceIncludedVAT: number;
    parkingTransactionFeesConstant: number;
    parkingTransactionFeesVariable: number;
    feesPaidByParkingSpaceOwner: boolean;
    vat: number;
    currency: Currency;
}

export class ParkerExtractReportSummaryDTO implements IParkerExtractReportSummaryDTO {
    chargedAmount!: number;
    totalNumberOfParkings!: number;
    calculationSummary?: string | undefined;
    currency!: Currency;
    subscriptionSummary?: ParkerExtractReportSubscriptionSummaryDTO[] | undefined;

    constructor(data?: IParkerExtractReportSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargedAmount = _data["chargedAmount"];
            this.totalNumberOfParkings = _data["totalNumberOfParkings"];
            this.calculationSummary = _data["calculationSummary"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["subscriptionSummary"])) {
                this.subscriptionSummary = [] as any;
                for (let item of _data["subscriptionSummary"])
                    this.subscriptionSummary!.push(ParkerExtractReportSubscriptionSummaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParkerExtractReportSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerExtractReportSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargedAmount"] = this.chargedAmount;
        data["totalNumberOfParkings"] = this.totalNumberOfParkings;
        data["calculationSummary"] = this.calculationSummary;
        data["currency"] = this.currency;
        if (Array.isArray(this.subscriptionSummary)) {
            data["subscriptionSummary"] = [];
            for (let item of this.subscriptionSummary)
                data["subscriptionSummary"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParkerExtractReportSummaryDTO {
    chargedAmount: number;
    totalNumberOfParkings: number;
    calculationSummary?: string | undefined;
    currency: Currency;
    subscriptionSummary?: ParkerExtractReportSubscriptionSummaryDTO[] | undefined;
}

export class ParkerExtractReportSubscriptionSummaryDTO implements IParkerExtractReportSubscriptionSummaryDTO {
    subscriptionId!: number;
    subscriptionName?: string | undefined;
    chargedAmount!: number;
    currency!: Currency;
    appliedStartDate!: DateTime;
    appliedEndDate!: DateTime;
    monthlyFixedPrice?: number | undefined;
    fixedFee?: number | undefined;
    feeFromParkingSessions?: number | undefined;
    cap?: number | undefined;
    totalParkingWithCap?: number | undefined;
    currencyConversionFactor?: number | undefined;
    convertedCurrency!: Currency;
    convertedChargedAmount!: number;

    constructor(data?: IParkerExtractReportSubscriptionSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionName = _data["subscriptionName"];
            this.chargedAmount = _data["chargedAmount"];
            this.currency = _data["currency"];
            this.appliedStartDate = _data["appliedStartDate"] ? DateTime.fromISO(_data["appliedStartDate"].toString()) : undefined as any;
            this.appliedEndDate = _data["appliedEndDate"] ? DateTime.fromISO(_data["appliedEndDate"].toString()) : undefined as any;
            this.monthlyFixedPrice = _data["monthlyFixedPrice"];
            this.fixedFee = _data["fixedFee"];
            this.feeFromParkingSessions = _data["feeFromParkingSessions"];
            this.cap = _data["cap"];
            this.totalParkingWithCap = _data["totalParkingWithCap"];
            this.currencyConversionFactor = _data["currencyConversionFactor"];
            this.convertedCurrency = _data["convertedCurrency"];
            this.convertedChargedAmount = _data["convertedChargedAmount"];
        }
    }

    static fromJS(data: any): ParkerExtractReportSubscriptionSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerExtractReportSubscriptionSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionName"] = this.subscriptionName;
        data["chargedAmount"] = this.chargedAmount;
        data["currency"] = this.currency;
        data["appliedStartDate"] = this.appliedStartDate ? this.appliedStartDate.toString() : undefined as any;
        data["appliedEndDate"] = this.appliedEndDate ? this.appliedEndDate.toString() : undefined as any;
        data["monthlyFixedPrice"] = this.monthlyFixedPrice;
        data["fixedFee"] = this.fixedFee;
        data["feeFromParkingSessions"] = this.feeFromParkingSessions;
        data["cap"] = this.cap;
        data["totalParkingWithCap"] = this.totalParkingWithCap;
        data["currencyConversionFactor"] = this.currencyConversionFactor;
        data["convertedCurrency"] = this.convertedCurrency;
        data["convertedChargedAmount"] = this.convertedChargedAmount;
        return data;
    }
}

export interface IParkerExtractReportSubscriptionSummaryDTO {
    subscriptionId: number;
    subscriptionName?: string | undefined;
    chargedAmount: number;
    currency: Currency;
    appliedStartDate: DateTime;
    appliedEndDate: DateTime;
    monthlyFixedPrice?: number | undefined;
    fixedFee?: number | undefined;
    feeFromParkingSessions?: number | undefined;
    cap?: number | undefined;
    totalParkingWithCap?: number | undefined;
    currencyConversionFactor?: number | undefined;
    convertedCurrency: Currency;
    convertedChargedAmount: number;
}

export class CreateClientDTO implements ICreateClientDTO {
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name!: string;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    dataRetentionPeriodInDays!: number;
    clientIdent!: string;
    automaticParkingSchedulesEnabled!: boolean;
    automaticParkingScheduleToleranceInMinutes!: number;
    qrCodeIdentificationEnabled!: boolean;
    auditLogEnabled!: boolean;
    custom1Name?: string | undefined;
    custom2Name?: string | undefined;
    custom3Name?: string | undefined;
    custom4Name?: string | undefined;
    custom5Name?: string | undefined;
    custom6Name?: string | undefined;
    custom7Name?: string | undefined;
    custom8Name?: string | undefined;
    custom9Name?: string | undefined;

    constructor(data?: ICreateClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.zip = _data["zip"];
            this.dataRetentionPeriodInDays = _data["dataRetentionPeriodInDays"];
            this.clientIdent = _data["clientIdent"];
            this.automaticParkingSchedulesEnabled = _data["automaticParkingSchedulesEnabled"];
            this.automaticParkingScheduleToleranceInMinutes = _data["automaticParkingScheduleToleranceInMinutes"];
            this.qrCodeIdentificationEnabled = _data["qrCodeIdentificationEnabled"];
            this.auditLogEnabled = _data["auditLogEnabled"];
            this.custom1Name = _data["custom1Name"];
            this.custom2Name = _data["custom2Name"];
            this.custom3Name = _data["custom3Name"];
            this.custom4Name = _data["custom4Name"];
            this.custom5Name = _data["custom5Name"];
            this.custom6Name = _data["custom6Name"];
            this.custom7Name = _data["custom7Name"];
            this.custom8Name = _data["custom8Name"];
            this.custom9Name = _data["custom9Name"];
        }
    }

    static fromJS(data: any): CreateClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["zip"] = this.zip;
        data["dataRetentionPeriodInDays"] = this.dataRetentionPeriodInDays;
        data["clientIdent"] = this.clientIdent;
        data["automaticParkingSchedulesEnabled"] = this.automaticParkingSchedulesEnabled;
        data["automaticParkingScheduleToleranceInMinutes"] = this.automaticParkingScheduleToleranceInMinutes;
        data["qrCodeIdentificationEnabled"] = this.qrCodeIdentificationEnabled;
        data["auditLogEnabled"] = this.auditLogEnabled;
        data["custom1Name"] = this.custom1Name;
        data["custom2Name"] = this.custom2Name;
        data["custom3Name"] = this.custom3Name;
        data["custom4Name"] = this.custom4Name;
        data["custom5Name"] = this.custom5Name;
        data["custom6Name"] = this.custom6Name;
        data["custom7Name"] = this.custom7Name;
        data["custom8Name"] = this.custom8Name;
        data["custom9Name"] = this.custom9Name;
        return data;
    }
}

export interface ICreateClientDTO {
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name: string;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    dataRetentionPeriodInDays: number;
    clientIdent: string;
    automaticParkingSchedulesEnabled: boolean;
    automaticParkingScheduleToleranceInMinutes: number;
    qrCodeIdentificationEnabled: boolean;
    auditLogEnabled: boolean;
    custom1Name?: string | undefined;
    custom2Name?: string | undefined;
    custom3Name?: string | undefined;
    custom4Name?: string | undefined;
    custom5Name?: string | undefined;
    custom6Name?: string | undefined;
    custom7Name?: string | undefined;
    custom8Name?: string | undefined;
    custom9Name?: string | undefined;
}

export class UpdateClientDTO implements IUpdateClientDTO {
    id!: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    dataRetentionPeriodInDays?: number | undefined;
    clientIdent!: string;
    isActive?: boolean | undefined;
    automaticParkingSchedulesEnabled!: boolean;
    automaticParkingScheduleToleranceInMinutes!: number;
    qrCodeIdentificationEnabled!: boolean;
    connectionMode!: ConnectionMode;
    auditLogEnabled!: boolean;
    enableLPRPictureStorage!: boolean;
    enableLPRPictureStorageOnOffense!: boolean;
    custom1Name?: string | undefined;
    custom2Name?: string | undefined;
    custom3Name?: string | undefined;
    custom4Name?: string | undefined;
    custom5Name?: string | undefined;
    custom6Name?: string | undefined;
    custom7Name?: string | undefined;
    custom8Name?: string | undefined;
    custom9Name?: string | undefined;

    constructor(data?: IUpdateClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.zip = _data["zip"];
            this.dataRetentionPeriodInDays = _data["dataRetentionPeriodInDays"];
            this.clientIdent = _data["clientIdent"];
            this.isActive = _data["isActive"];
            this.automaticParkingSchedulesEnabled = _data["automaticParkingSchedulesEnabled"];
            this.automaticParkingScheduleToleranceInMinutes = _data["automaticParkingScheduleToleranceInMinutes"];
            this.qrCodeIdentificationEnabled = _data["qrCodeIdentificationEnabled"];
            this.connectionMode = _data["connectionMode"];
            this.auditLogEnabled = _data["auditLogEnabled"];
            this.enableLPRPictureStorage = _data["enableLPRPictureStorage"];
            this.enableLPRPictureStorageOnOffense = _data["enableLPRPictureStorageOnOffense"];
            this.custom1Name = _data["custom1Name"];
            this.custom2Name = _data["custom2Name"];
            this.custom3Name = _data["custom3Name"];
            this.custom4Name = _data["custom4Name"];
            this.custom5Name = _data["custom5Name"];
            this.custom6Name = _data["custom6Name"];
            this.custom7Name = _data["custom7Name"];
            this.custom8Name = _data["custom8Name"];
            this.custom9Name = _data["custom9Name"];
        }
    }

    static fromJS(data: any): UpdateClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["zip"] = this.zip;
        data["dataRetentionPeriodInDays"] = this.dataRetentionPeriodInDays;
        data["clientIdent"] = this.clientIdent;
        data["isActive"] = this.isActive;
        data["automaticParkingSchedulesEnabled"] = this.automaticParkingSchedulesEnabled;
        data["automaticParkingScheduleToleranceInMinutes"] = this.automaticParkingScheduleToleranceInMinutes;
        data["qrCodeIdentificationEnabled"] = this.qrCodeIdentificationEnabled;
        data["connectionMode"] = this.connectionMode;
        data["auditLogEnabled"] = this.auditLogEnabled;
        data["enableLPRPictureStorage"] = this.enableLPRPictureStorage;
        data["enableLPRPictureStorageOnOffense"] = this.enableLPRPictureStorageOnOffense;
        data["custom1Name"] = this.custom1Name;
        data["custom2Name"] = this.custom2Name;
        data["custom3Name"] = this.custom3Name;
        data["custom4Name"] = this.custom4Name;
        data["custom5Name"] = this.custom5Name;
        data["custom6Name"] = this.custom6Name;
        data["custom7Name"] = this.custom7Name;
        data["custom8Name"] = this.custom8Name;
        data["custom9Name"] = this.custom9Name;
        return data;
    }
}

export interface IUpdateClientDTO {
    id: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    dataRetentionPeriodInDays?: number | undefined;
    clientIdent: string;
    isActive?: boolean | undefined;
    automaticParkingSchedulesEnabled: boolean;
    automaticParkingScheduleToleranceInMinutes: number;
    qrCodeIdentificationEnabled: boolean;
    connectionMode: ConnectionMode;
    auditLogEnabled: boolean;
    enableLPRPictureStorage: boolean;
    enableLPRPictureStorageOnOffense: boolean;
    custom1Name?: string | undefined;
    custom2Name?: string | undefined;
    custom3Name?: string | undefined;
    custom4Name?: string | undefined;
    custom5Name?: string | undefined;
    custom6Name?: string | undefined;
    custom7Name?: string | undefined;
    custom8Name?: string | undefined;
    custom9Name?: string | undefined;
}

export class CreateConfigBasedStructuralEntryDTO implements ICreateConfigBasedStructuralEntryDTO {
    clientId!: number;
    name!: string;
    parentId?: number | undefined;
    isSubscriptionSet!: boolean;

    constructor(data?: ICreateConfigBasedStructuralEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.isSubscriptionSet = _data["isSubscriptionSet"];
        }
    }

    static fromJS(data: any): CreateConfigBasedStructuralEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConfigBasedStructuralEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["isSubscriptionSet"] = this.isSubscriptionSet;
        return data;
    }
}

export interface ICreateConfigBasedStructuralEntryDTO {
    clientId: number;
    name: string;
    parentId?: number | undefined;
    isSubscriptionSet: boolean;
}

export class UpdateConfigBasedStructuralEntryDTO implements IUpdateConfigBasedStructuralEntryDTO {
    id!: number;
    name?: string | undefined;
    parentId?: number | undefined;
    isSubscriptionSet?: boolean | undefined;

    constructor(data?: IUpdateConfigBasedStructuralEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.isSubscriptionSet = _data["isSubscriptionSet"];
        }
    }

    static fromJS(data: any): UpdateConfigBasedStructuralEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigBasedStructuralEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["isSubscriptionSet"] = this.isSubscriptionSet;
        return data;
    }
}

export interface IUpdateConfigBasedStructuralEntryDTO {
    id: number;
    name?: string | undefined;
    parentId?: number | undefined;
    isSubscriptionSet?: boolean | undefined;
}

export class PagedResultDTOOfConfigBasedStructuralEntryDTO implements IPagedResultDTOOfConfigBasedStructuralEntryDTO {
    items?: ConfigBasedStructuralEntryDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfConfigBasedStructuralEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConfigBasedStructuralEntryDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfConfigBasedStructuralEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfConfigBasedStructuralEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfConfigBasedStructuralEntryDTO {
    items?: ConfigBasedStructuralEntryDTO[] | undefined;
    totalNumberOfItems: number;
}

export class RegisterDeviceInfoDTO implements IRegisterDeviceInfoDTO {
    deviceIdentifier!: string;
    devicePlatform!: MobilePlatform;
    fcmToken?: string | undefined;
    userId?: string | undefined;
    appVersion?: string | undefined;
    deviceVersion?: string | undefined;
    deviceModel?: string | undefined;
    deviceName?: string | undefined;
    deviceInfoSerialization?: string | undefined;

    constructor(data?: IRegisterDeviceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceIdentifier = _data["deviceIdentifier"];
            this.devicePlatform = _data["devicePlatform"];
            this.fcmToken = _data["fcmToken"];
            this.userId = _data["userId"];
            this.appVersion = _data["appVersion"];
            this.deviceVersion = _data["deviceVersion"];
            this.deviceModel = _data["deviceModel"];
            this.deviceName = _data["deviceName"];
            this.deviceInfoSerialization = _data["deviceInfoSerialization"];
        }
    }

    static fromJS(data: any): RegisterDeviceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["devicePlatform"] = this.devicePlatform;
        data["fcmToken"] = this.fcmToken;
        data["userId"] = this.userId;
        data["appVersion"] = this.appVersion;
        data["deviceVersion"] = this.deviceVersion;
        data["deviceModel"] = this.deviceModel;
        data["deviceName"] = this.deviceName;
        data["deviceInfoSerialization"] = this.deviceInfoSerialization;
        return data;
    }
}

export interface IRegisterDeviceInfoDTO {
    deviceIdentifier: string;
    devicePlatform: MobilePlatform;
    fcmToken?: string | undefined;
    userId?: string | undefined;
    appVersion?: string | undefined;
    deviceVersion?: string | undefined;
    deviceModel?: string | undefined;
    deviceName?: string | undefined;
    deviceInfoSerialization?: string | undefined;
}

export enum MobilePlatform {
    Android = 0,
    IOS = 1,
}

export class PagedResultDTOOfDeviceStatusReportDTO implements IPagedResultDTOOfDeviceStatusReportDTO {
    items?: DeviceStatusReportDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfDeviceStatusReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DeviceStatusReportDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfDeviceStatusReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfDeviceStatusReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfDeviceStatusReportDTO {
    items?: DeviceStatusReportDTO[] | undefined;
    totalNumberOfItems: number;
}

export class DeviceStatusReportDTO implements IDeviceStatusReportDTO {
    device?: ZoneDeviceDTO | undefined;

    constructor(data?: IDeviceStatusReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device = _data["device"] ? ZoneDeviceDTO.fromJS(_data["device"]) : undefined as any;
        }
    }

    static fromJS(data: any): DeviceStatusReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatusReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device"] = this.device ? this.device.toJSON() : undefined as any;
        return data;
    }
}

export interface IDeviceStatusReportDTO {
    device?: ZoneDeviceDTO | undefined;
}

export class ZoneDeviceDTO implements IZoneDeviceDTO {
    id!: number;
    clientId!: number;
    name?: string | undefined;
    zone?: ZoneDTO | undefined;
    description?: string | undefined;
    enabled!: boolean;
    groupControllerDeviceId?: number | undefined;
    coordinates?: string | undefined;
    lastSignal?: DateTime | undefined;
    deviceType!: ZoneDeviceType;
    brand!: ZoneDeviceBrand;
    direction?: ZoneDeviceDirection | undefined;
    state!: ZoneDeviceState;
    currentDevicePosition?: string | undefined;
    proxyUserId?: string | undefined;
    supportedDevicePositions?: ZoneDevicePositionDTO[] | undefined;
    parameters?: ZoneDeviceParameterDTO[] | undefined;

    constructor(data?: IZoneDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.zone = _data["zone"] ? ZoneDTO.fromJS(_data["zone"]) : undefined as any;
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.groupControllerDeviceId = _data["groupControllerDeviceId"];
            this.coordinates = _data["coordinates"];
            this.lastSignal = _data["lastSignal"] ? DateTime.fromISO(_data["lastSignal"].toString()) : undefined as any;
            this.deviceType = _data["deviceType"];
            this.brand = _data["brand"];
            this.direction = _data["direction"];
            this.state = _data["state"];
            this.currentDevicePosition = _data["currentDevicePosition"];
            this.proxyUserId = _data["proxyUserId"];
            if (Array.isArray(_data["supportedDevicePositions"])) {
                this.supportedDevicePositions = [] as any;
                for (let item of _data["supportedDevicePositions"])
                    this.supportedDevicePositions!.push(ZoneDevicePositionDTO.fromJS(item));
            }
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ZoneDeviceParameterDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZoneDeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["groupControllerDeviceId"] = this.groupControllerDeviceId;
        data["coordinates"] = this.coordinates;
        data["lastSignal"] = this.lastSignal ? this.lastSignal.toString() : undefined as any;
        data["deviceType"] = this.deviceType;
        data["brand"] = this.brand;
        data["direction"] = this.direction;
        data["state"] = this.state;
        data["currentDevicePosition"] = this.currentDevicePosition;
        data["proxyUserId"] = this.proxyUserId;
        if (Array.isArray(this.supportedDevicePositions)) {
            data["supportedDevicePositions"] = [];
            for (let item of this.supportedDevicePositions)
                data["supportedDevicePositions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IZoneDeviceDTO {
    id: number;
    clientId: number;
    name?: string | undefined;
    zone?: ZoneDTO | undefined;
    description?: string | undefined;
    enabled: boolean;
    groupControllerDeviceId?: number | undefined;
    coordinates?: string | undefined;
    lastSignal?: DateTime | undefined;
    deviceType: ZoneDeviceType;
    brand: ZoneDeviceBrand;
    direction?: ZoneDeviceDirection | undefined;
    state: ZoneDeviceState;
    currentDevicePosition?: string | undefined;
    proxyUserId?: string | undefined;
    supportedDevicePositions?: ZoneDevicePositionDTO[] | undefined;
    parameters?: ZoneDeviceParameterDTO[] | undefined;
}

export enum ZoneDeviceType {
    UHFReader = 0,
    DeviceGroupController = 1,
    AutomaticBollard = 2,
    GarageDoor = 3,
    LPRCameraDeepinView = 4,
    AvThingProxyBasedBarrierControlGPIO = 5,
    AvThingProxyBasedBarrierControlRemoteIO = 6,
    SwarcoParkingspace = 7,
}

export enum ZoneDeviceBrand {
    Unknown = 0,
    Sick = 1,
    Cori = 2,
    Aventit = 3,
    TestCloud = 4,
    TestProxy = 5,
    HikVision = 6,
    Swarco = 7,
}

export enum ZoneDeviceDirection {
    Entrance = 0,
    Exit = 1,
    Undefined = 2,
}

export enum ZoneDeviceState {
    Unknown = 0,
    Present = 1,
    NotPresent = 2,
    Defect = 3,
}

export class ZoneDevicePositionDTO implements IZoneDevicePositionDTO {
    position?: string | undefined;
    supportedCommands?: ZoneDeviceCommandDTO[] | undefined;

    constructor(data?: IZoneDevicePositionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            if (Array.isArray(_data["supportedCommands"])) {
                this.supportedCommands = [] as any;
                for (let item of _data["supportedCommands"])
                    this.supportedCommands!.push(ZoneDeviceCommandDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZoneDevicePositionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDevicePositionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        if (Array.isArray(this.supportedCommands)) {
            data["supportedCommands"] = [];
            for (let item of this.supportedCommands)
                data["supportedCommands"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IZoneDevicePositionDTO {
    position?: string | undefined;
    supportedCommands?: ZoneDeviceCommandDTO[] | undefined;
}

export class ZoneDeviceCommandDTO implements IZoneDeviceCommandDTO {
    command?: string | undefined;
    commandName?: string | undefined;
    commandDescription?: string | undefined;
    executionContext?: ZoneDeviceCommandExecutionContextDTO | undefined;
    isBillable!: boolean;
    accessLevel!: ZoneDeviceCommandAccessLevel;

    constructor(data?: IZoneDeviceCommandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.command = _data["command"];
            this.commandName = _data["commandName"];
            this.commandDescription = _data["commandDescription"];
            this.executionContext = _data["executionContext"] ? ZoneDeviceCommandExecutionContextDTO.fromJS(_data["executionContext"]) : undefined as any;
            this.isBillable = _data["isBillable"];
            this.accessLevel = _data["accessLevel"];
        }
    }

    static fromJS(data: any): ZoneDeviceCommandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceCommandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["command"] = this.command;
        data["commandName"] = this.commandName;
        data["commandDescription"] = this.commandDescription;
        data["executionContext"] = this.executionContext ? this.executionContext.toJSON() : undefined as any;
        data["isBillable"] = this.isBillable;
        data["accessLevel"] = this.accessLevel;
        return data;
    }
}

export interface IZoneDeviceCommandDTO {
    command?: string | undefined;
    commandName?: string | undefined;
    commandDescription?: string | undefined;
    executionContext?: ZoneDeviceCommandExecutionContextDTO | undefined;
    isBillable: boolean;
    accessLevel: ZoneDeviceCommandAccessLevel;
}

export class ZoneDeviceCommandExecutionContextDTO implements IZoneDeviceCommandExecutionContextDTO {
    executedUserId?: string | undefined;
    executionTimeUtc?: DateTime | undefined;
    contextData?: string | undefined;

    constructor(data?: IZoneDeviceCommandExecutionContextDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.executedUserId = _data["executedUserId"];
            this.executionTimeUtc = _data["executionTimeUtc"] ? DateTime.fromISO(_data["executionTimeUtc"].toString()) : undefined as any;
            this.contextData = _data["contextData"];
        }
    }

    static fromJS(data: any): ZoneDeviceCommandExecutionContextDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceCommandExecutionContextDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executedUserId"] = this.executedUserId;
        data["executionTimeUtc"] = this.executionTimeUtc ? this.executionTimeUtc.toString() : undefined as any;
        data["contextData"] = this.contextData;
        return data;
    }
}

export interface IZoneDeviceCommandExecutionContextDTO {
    executedUserId?: string | undefined;
    executionTimeUtc?: DateTime | undefined;
    contextData?: string | undefined;
}

export enum ZoneDeviceCommandAccessLevel {
    Admin = 0,
    Parker = 1,
}

export abstract class ZoneDeviceParameterDTO implements IZoneDeviceParameterDTO {
    type!: ZoneDeviceParameterType;

    protected _discriminator: string;

    constructor(data?: IZoneDeviceParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "ZoneDeviceParameterDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ZoneDeviceParameterDTO {
        data = typeof data === 'object' ? data : {};
        if (data["typeselector"] === "ZoneDeviceParameterStringDTO") {
            let result = new ZoneDeviceParameterStringDTO();
            result.init(data);
            return result;
        }
        if (data["typeselector"] === "ZoneDeviceParameterIntDTO") {
            let result = new ZoneDeviceParameterIntDTO();
            result.init(data);
            return result;
        }
        if (data["typeselector"] === "ZoneDeviceParameterBoolDTO") {
            let result = new ZoneDeviceParameterBoolDTO();
            result.init(data);
            return result;
        }
        if (data["typeselector"] === "ZoneDeviceParameterFloatDTO") {
            let result = new ZoneDeviceParameterFloatDTO();
            result.init(data);
            return result;
        }
        if (data["typeselector"] === "ZoneDeviceParameterIPDTO") {
            let result = new ZoneDeviceParameterIPDTO();
            result.init(data);
            return result;
        }
        if (data["typeselector"] === "ZoneDeviceParameterSelectDTO") {
            let result = new ZoneDeviceParameterSelectDTO();
            result.init(data);
            return result;
        }
        if (data["typeselector"] === "ZoneDeviceParameterPhoneDTO") {
            let result = new ZoneDeviceParameterPhoneDTO();
            result.init(data);
            return result;
        }
        if (data["typeselector"] === "ZoneDeviceParameterMacDTO") {
            let result = new ZoneDeviceParameterMacDTO();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ZoneDeviceParameterDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeselector"] = this._discriminator;
        data["type"] = this.type;
        return data;
    }
}

export interface IZoneDeviceParameterDTO {
    type: ZoneDeviceParameterType;
}

export enum ZoneDeviceParameterType {
    String = 0,
    Int = 1,
    Bool = 2,
    Float = 3,
    IP = 4,
    Select = 5,
    Phone = 6,
    MacAddress = 7,
}

export class ZoneDeviceParameterStringDTO extends ZoneDeviceParameterDTO implements IZoneDeviceParameterStringDTO {
    value?: string | undefined;
    configuration?: ZoneDeviceParameterStringConfigDTO | undefined;

    constructor(data?: IZoneDeviceParameterStringDTO) {
        super(data);
        this._discriminator = "ZoneDeviceParameterStringDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
            this.configuration = _data["configuration"] ? ZoneDeviceParameterStringConfigDTO.fromJS(_data["configuration"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterStringDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterStringDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterStringDTO extends IZoneDeviceParameterDTO {
    value?: string | undefined;
    configuration?: ZoneDeviceParameterStringConfigDTO | undefined;
}

export abstract class ZoneDeviceParameterConfigDTO implements IZoneDeviceParameterConfigDTO {
    ident!: string;
    displayName!: string;
    group!: ZoneDeviceParameterConfigGroupDTO;

    constructor(data?: IZoneDeviceParameterConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.group = new ZoneDeviceParameterConfigGroupDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ident = _data["ident"];
            this.displayName = _data["displayName"];
            this.group = _data["group"] ? ZoneDeviceParameterConfigGroupDTO.fromJS(_data["group"]) : new ZoneDeviceParameterConfigGroupDTO();
        }
    }

    static fromJS(data: any): ZoneDeviceParameterConfigDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ZoneDeviceParameterConfigDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ident"] = this.ident;
        data["displayName"] = this.displayName;
        data["group"] = this.group ? this.group.toJSON() : undefined as any;
        return data;
    }
}

export interface IZoneDeviceParameterConfigDTO {
    ident: string;
    displayName: string;
    group: ZoneDeviceParameterConfigGroupDTO;
}

export class ZoneDeviceParameterStringConfigDTO extends ZoneDeviceParameterConfigDTO implements IZoneDeviceParameterStringConfigDTO {
    minLength!: number;
    maxLength!: number;
    required!: boolean;
    defaultValue?: string | undefined;

    constructor(data?: IZoneDeviceParameterStringConfigDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
            this.required = _data["required"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterStringConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterStringConfigDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        data["required"] = this.required;
        data["defaultValue"] = this.defaultValue;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterStringConfigDTO extends IZoneDeviceParameterConfigDTO {
    minLength: number;
    maxLength: number;
    required: boolean;
    defaultValue?: string | undefined;
}

export class ZoneDeviceParameterConfigGroupDTO implements IZoneDeviceParameterConfigGroupDTO {
    groupName!: string;
    groupPosition!: number;

    constructor(data?: IZoneDeviceParameterConfigGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.groupPosition = _data["groupPosition"];
        }
    }

    static fromJS(data: any): ZoneDeviceParameterConfigGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterConfigGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["groupPosition"] = this.groupPosition;
        return data;
    }
}

export interface IZoneDeviceParameterConfigGroupDTO {
    groupName: string;
    groupPosition: number;
}

export class ZoneDeviceParameterIntDTO extends ZoneDeviceParameterDTO implements IZoneDeviceParameterIntDTO {
    value!: number;
    configuration?: ZoneDeviceParameterIntConfigDTO | undefined;

    constructor(data?: IZoneDeviceParameterIntDTO) {
        super(data);
        this._discriminator = "ZoneDeviceParameterIntDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
            this.configuration = _data["configuration"] ? ZoneDeviceParameterIntConfigDTO.fromJS(_data["configuration"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterIntDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterIntDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterIntDTO extends IZoneDeviceParameterDTO {
    value: number;
    configuration?: ZoneDeviceParameterIntConfigDTO | undefined;
}

export class ZoneDeviceParameterIntConfigDTO extends ZoneDeviceParameterConfigDTO implements IZoneDeviceParameterIntConfigDTO {
    minValue!: number;
    maxValue!: number;
    required!: boolean;
    defaultValue!: number;

    constructor(data?: IZoneDeviceParameterIntConfigDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.required = _data["required"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterIntConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterIntConfigDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["required"] = this.required;
        data["defaultValue"] = this.defaultValue;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterIntConfigDTO extends IZoneDeviceParameterConfigDTO {
    minValue: number;
    maxValue: number;
    required: boolean;
    defaultValue: number;
}

export class ZoneDeviceParameterBoolDTO extends ZoneDeviceParameterDTO implements IZoneDeviceParameterBoolDTO {
    value!: boolean;
    configuration?: ZoneDeviceParameterBoolConfigDTO | undefined;

    constructor(data?: IZoneDeviceParameterBoolDTO) {
        super(data);
        this._discriminator = "ZoneDeviceParameterBoolDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
            this.configuration = _data["configuration"] ? ZoneDeviceParameterBoolConfigDTO.fromJS(_data["configuration"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterBoolDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterBoolDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterBoolDTO extends IZoneDeviceParameterDTO {
    value: boolean;
    configuration?: ZoneDeviceParameterBoolConfigDTO | undefined;
}

export class ZoneDeviceParameterBoolConfigDTO extends ZoneDeviceParameterConfigDTO implements IZoneDeviceParameterBoolConfigDTO {
    defaultValue!: boolean;

    constructor(data?: IZoneDeviceParameterBoolConfigDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultValue = _data["defaultValue"];
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterBoolConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterBoolConfigDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultValue"] = this.defaultValue;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterBoolConfigDTO extends IZoneDeviceParameterConfigDTO {
    defaultValue: boolean;
}

export class ZoneDeviceParameterFloatDTO extends ZoneDeviceParameterDTO implements IZoneDeviceParameterFloatDTO {
    value!: number;
    configuration?: ZoneDeviceParameterFloatConfigDTO | undefined;

    constructor(data?: IZoneDeviceParameterFloatDTO) {
        super(data);
        this._discriminator = "ZoneDeviceParameterFloatDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
            this.configuration = _data["configuration"] ? ZoneDeviceParameterFloatConfigDTO.fromJS(_data["configuration"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterFloatDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterFloatDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterFloatDTO extends IZoneDeviceParameterDTO {
    value: number;
    configuration?: ZoneDeviceParameterFloatConfigDTO | undefined;
}

export class ZoneDeviceParameterFloatConfigDTO extends ZoneDeviceParameterConfigDTO implements IZoneDeviceParameterFloatConfigDTO {
    minValue!: number;
    maxValue!: number;
    required!: boolean;
    noOfDecimals!: number;
    defaultValue!: number;

    constructor(data?: IZoneDeviceParameterFloatConfigDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.required = _data["required"];
            this.noOfDecimals = _data["noOfDecimals"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterFloatConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterFloatConfigDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["required"] = this.required;
        data["noOfDecimals"] = this.noOfDecimals;
        data["defaultValue"] = this.defaultValue;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterFloatConfigDTO extends IZoneDeviceParameterConfigDTO {
    minValue: number;
    maxValue: number;
    required: boolean;
    noOfDecimals: number;
    defaultValue: number;
}

export class ZoneDeviceParameterIPDTO extends ZoneDeviceParameterDTO implements IZoneDeviceParameterIPDTO {
    value?: string | undefined;
    configuration?: ZoneDeviceParameterIPConfigDTO | undefined;

    constructor(data?: IZoneDeviceParameterIPDTO) {
        super(data);
        this._discriminator = "ZoneDeviceParameterIPDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
            this.configuration = _data["configuration"] ? ZoneDeviceParameterIPConfigDTO.fromJS(_data["configuration"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterIPDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterIPDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterIPDTO extends IZoneDeviceParameterDTO {
    value?: string | undefined;
    configuration?: ZoneDeviceParameterIPConfigDTO | undefined;
}

export class ZoneDeviceParameterIPConfigDTO extends ZoneDeviceParameterConfigDTO implements IZoneDeviceParameterIPConfigDTO {
    allowIPV6!: boolean;
    required!: boolean;
    defaultValue?: string | undefined;

    constructor(data?: IZoneDeviceParameterIPConfigDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allowIPV6 = _data["allowIPV6"];
            this.required = _data["required"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterIPConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterIPConfigDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowIPV6"] = this.allowIPV6;
        data["required"] = this.required;
        data["defaultValue"] = this.defaultValue;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterIPConfigDTO extends IZoneDeviceParameterConfigDTO {
    allowIPV6: boolean;
    required: boolean;
    defaultValue?: string | undefined;
}

export class ZoneDeviceParameterSelectDTO extends ZoneDeviceParameterDTO implements IZoneDeviceParameterSelectDTO {
    selection?: string | undefined;
    configuration?: ZoneDeviceParameterSelectConfigDTO | undefined;

    constructor(data?: IZoneDeviceParameterSelectDTO) {
        super(data);
        this._discriminator = "ZoneDeviceParameterSelectDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.selection = _data["selection"];
            this.configuration = _data["configuration"] ? ZoneDeviceParameterSelectConfigDTO.fromJS(_data["configuration"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterSelectDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selection"] = this.selection;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterSelectDTO extends IZoneDeviceParameterDTO {
    selection?: string | undefined;
    configuration?: ZoneDeviceParameterSelectConfigDTO | undefined;
}

export class ZoneDeviceParameterSelectConfigDTO extends ZoneDeviceParameterConfigDTO implements IZoneDeviceParameterSelectConfigDTO {
    selectionPossibilities?: string[] | undefined;
    defaultValue?: string | undefined;
    required!: boolean;

    constructor(data?: IZoneDeviceParameterSelectConfigDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["selectionPossibilities"])) {
                this.selectionPossibilities = [] as any;
                for (let item of _data["selectionPossibilities"])
                    this.selectionPossibilities!.push(item);
            }
            this.defaultValue = _data["defaultValue"];
            this.required = _data["required"];
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterSelectConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterSelectConfigDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectionPossibilities)) {
            data["selectionPossibilities"] = [];
            for (let item of this.selectionPossibilities)
                data["selectionPossibilities"].push(item);
        }
        data["defaultValue"] = this.defaultValue;
        data["required"] = this.required;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterSelectConfigDTO extends IZoneDeviceParameterConfigDTO {
    selectionPossibilities?: string[] | undefined;
    defaultValue?: string | undefined;
    required: boolean;
}

export class ZoneDeviceParameterPhoneDTO extends ZoneDeviceParameterDTO implements IZoneDeviceParameterPhoneDTO {
    phone?: string | undefined;
    configuration?: ZoneDeviceParameterPhoneConfigDTO | undefined;

    constructor(data?: IZoneDeviceParameterPhoneDTO) {
        super(data);
        this._discriminator = "ZoneDeviceParameterPhoneDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phone = _data["phone"];
            this.configuration = _data["configuration"] ? ZoneDeviceParameterPhoneConfigDTO.fromJS(_data["configuration"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterPhoneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterPhoneDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterPhoneDTO extends IZoneDeviceParameterDTO {
    phone?: string | undefined;
    configuration?: ZoneDeviceParameterPhoneConfigDTO | undefined;
}

export class ZoneDeviceParameterPhoneConfigDTO extends ZoneDeviceParameterConfigDTO implements IZoneDeviceParameterPhoneConfigDTO {
    defaultValue?: string | undefined;
    required!: boolean;

    constructor(data?: IZoneDeviceParameterPhoneConfigDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultValue = _data["defaultValue"];
            this.required = _data["required"];
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterPhoneConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterPhoneConfigDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultValue"] = this.defaultValue;
        data["required"] = this.required;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterPhoneConfigDTO extends IZoneDeviceParameterConfigDTO {
    defaultValue?: string | undefined;
    required: boolean;
}

export class ZoneDeviceParameterMacDTO extends ZoneDeviceParameterDTO implements IZoneDeviceParameterMacDTO {
    value?: string | undefined;
    macAddress?: PhysicalAddress | undefined;
    configuration?: ZoneDeviceParameterMacConfigDTO | undefined;

    constructor(data?: IZoneDeviceParameterMacDTO) {
        super(data);
        this._discriminator = "ZoneDeviceParameterMacDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
            this.macAddress = _data["macAddress"] ? PhysicalAddress.fromJS(_data["macAddress"]) : undefined as any;
            this.configuration = _data["configuration"] ? ZoneDeviceParameterMacConfigDTO.fromJS(_data["configuration"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterMacDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterMacDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["macAddress"] = this.macAddress ? this.macAddress.toJSON() : undefined as any;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterMacDTO extends IZoneDeviceParameterDTO {
    value?: string | undefined;
    macAddress?: PhysicalAddress | undefined;
    configuration?: ZoneDeviceParameterMacConfigDTO | undefined;
}

export class PhysicalAddress implements IPhysicalAddress {

    constructor(data?: IPhysicalAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PhysicalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IPhysicalAddress {
}

export class ZoneDeviceParameterMacConfigDTO extends ZoneDeviceParameterConfigDTO implements IZoneDeviceParameterMacConfigDTO {
    required!: boolean;
    defaultValue?: string | undefined;

    constructor(data?: IZoneDeviceParameterMacConfigDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.required = _data["required"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static override fromJS(data: any): ZoneDeviceParameterMacConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceParameterMacConfigDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["required"] = this.required;
        data["defaultValue"] = this.defaultValue;
        super.toJSON(data);
        return data;
    }
}

export interface IZoneDeviceParameterMacConfigDTO extends IZoneDeviceParameterConfigDTO {
    required: boolean;
    defaultValue?: string | undefined;
}

export class DeviceStatusReportParameterDTO implements IDeviceStatusReportParameterDTO {
    zoneId?: number | undefined;

    constructor(data?: IDeviceStatusReportParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
        }
    }

    static fromJS(data: any): DeviceStatusReportParameterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatusReportParameterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        return data;
    }
}

export interface IDeviceStatusReportParameterDTO {
    zoneId?: number | undefined;
}

export class PagedResultDTOOfExportJobLimitedDTO implements IPagedResultDTOOfExportJobLimitedDTO {
    items?: ExportJobLimitedDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfExportJobLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExportJobLimitedDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfExportJobLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfExportJobLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfExportJobLimitedDTO {
    items?: ExportJobLimitedDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ExportJobLimitedDTO implements IExportJobLimitedDTO {
    id!: number;
    type!: ExportJobType;
    fileType!: ReportFileType;
    clientId!: number;
    clientName?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    templateMediaId?: string | undefined;
    status!: ExportJobStatus;
    outputFile?: string | undefined;

    constructor(data?: IExportJobLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.fileType = _data["fileType"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.templateMediaId = _data["templateMediaId"];
            this.status = _data["status"];
            this.outputFile = _data["outputFile"];
        }
    }

    static fromJS(data: any): ExportJobLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportJobLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["fileType"] = this.fileType;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["templateMediaId"] = this.templateMediaId;
        data["status"] = this.status;
        data["outputFile"] = this.outputFile;
        return data;
    }
}

export interface IExportJobLimitedDTO {
    id: number;
    type: ExportJobType;
    fileType: ReportFileType;
    clientId: number;
    clientName?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    templateMediaId?: string | undefined;
    status: ExportJobStatus;
    outputFile?: string | undefined;
}

export enum ExportJobType {
    ParkerExtract = 1,
    ParkerExtractSAP = 2,
}

export enum ExportJobStatus {
    NotStarted = 0,
    InProgress = 1,
    Completed = 2,
    Error = 3,
}

export class ExportJobDTO implements IExportJobDTO {
    id!: number;
    type!: ExportJobType;
    fileType!: ReportFileType;
    clientId!: number;
    clientName?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    templateMediaId?: string | undefined;
    status!: ExportJobStatus;
    outputFile?: string | undefined;
    configurationSerialized?: string | undefined;
    createdOn?: DateTime | undefined;
    executedOn?: DateTime | undefined;
    initiatedByUser?: LimitedUserInfoDTO | undefined;
    purgeDataOn?: DateTime | undefined;

    constructor(data?: IExportJobDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.fileType = _data["fileType"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.templateMediaId = _data["templateMediaId"];
            this.status = _data["status"];
            this.outputFile = _data["outputFile"];
            this.configurationSerialized = _data["configurationSerialized"];
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
            this.executedOn = _data["executedOn"] ? DateTime.fromISO(_data["executedOn"].toString()) : undefined as any;
            this.initiatedByUser = _data["initiatedByUser"] ? LimitedUserInfoDTO.fromJS(_data["initiatedByUser"]) : undefined as any;
            this.purgeDataOn = _data["purgeDataOn"] ? DateTime.fromISO(_data["purgeDataOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ExportJobDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportJobDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["fileType"] = this.fileType;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["templateMediaId"] = this.templateMediaId;
        data["status"] = this.status;
        data["outputFile"] = this.outputFile;
        data["configurationSerialized"] = this.configurationSerialized;
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["executedOn"] = this.executedOn ? this.executedOn.toString() : undefined as any;
        data["initiatedByUser"] = this.initiatedByUser ? this.initiatedByUser.toJSON() : undefined as any;
        data["purgeDataOn"] = this.purgeDataOn ? this.purgeDataOn.toString() : undefined as any;
        return data;
    }
}

export interface IExportJobDTO {
    id: number;
    type: ExportJobType;
    fileType: ReportFileType;
    clientId: number;
    clientName?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    templateMediaId?: string | undefined;
    status: ExportJobStatus;
    outputFile?: string | undefined;
    configurationSerialized?: string | undefined;
    createdOn?: DateTime | undefined;
    executedOn?: DateTime | undefined;
    initiatedByUser?: LimitedUserInfoDTO | undefined;
    purgeDataOn?: DateTime | undefined;
}

export class LimitedUserInfoDTO implements ILimitedUserInfoDTO {
    userId?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    companyName?: string | undefined;
    clientId!: number;
    clientIdent?: string | undefined;
    roles?: Role[] | undefined;

    constructor(data?: ILimitedUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.companyName = _data["companyName"];
            this.clientId = _data["clientId"];
            this.clientIdent = _data["clientIdent"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): LimitedUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["companyName"] = this.companyName;
        data["clientId"] = this.clientId;
        data["clientIdent"] = this.clientIdent;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ILimitedUserInfoDTO {
    userId?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    companyName?: string | undefined;
    clientId: number;
    clientIdent?: string | undefined;
    roles?: Role[] | undefined;
}

export enum Role {
    None = 0,
    Admin = 1,
    ClientAdmin = 2,
    ClientUser = 3,
    User = 4,
    ParkingRanger = 5,
    Proxy = 6,
    ThirdPartyParkingControl = 7,
    BIClientUser = 8,
    BIAdmin = 9,
    CompanyAdmin = 10,
    Thing = 11,
    Status = 12,
}

export class CreateExportJobDTO implements ICreateExportJobDTO {
    type!: ExportJobType;
    fileType!: ReportFileType;
    clientId!: number;
    companyId?: number | undefined;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    templateBase64?: string | undefined;

    constructor(data?: ICreateExportJobDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.fileType = _data["fileType"];
            this.clientId = _data["clientId"];
            this.companyId = _data["companyId"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.templateBase64 = _data["templateBase64"];
        }
    }

    static fromJS(data: any): CreateExportJobDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExportJobDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["fileType"] = this.fileType;
        data["clientId"] = this.clientId;
        data["companyId"] = this.companyId;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["templateBase64"] = this.templateBase64;
        return data;
    }
}

export interface ICreateExportJobDTO {
    type: ExportJobType;
    fileType: ReportFileType;
    clientId: number;
    companyId?: number | undefined;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    templateBase64?: string | undefined;
}

export class MergeFieldInfoDTO implements IMergeFieldInfoDTO {
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    groupName?: string | undefined;
    type!: MergeFieldType;

    constructor(data?: IMergeFieldInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.groupName = _data["groupName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): MergeFieldInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MergeFieldInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["groupName"] = this.groupName;
        data["type"] = this.type;
        return data;
    }
}

export interface IMergeFieldInfoDTO {
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    groupName?: string | undefined;
    type: MergeFieldType;
}

export enum MergeFieldType {
    Field = 0,
    Group = 1,
    Table = 2,
}

export class ExportJobExecutionLogDTO implements IExportJobExecutionLogDTO {
    logMessage?: string | undefined;
    executedOn?: DateTime | undefined;

    constructor(data?: IExportJobExecutionLogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logMessage = _data["logMessage"];
            this.executedOn = _data["executedOn"] ? DateTime.fromISO(_data["executedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ExportJobExecutionLogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportJobExecutionLogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logMessage"] = this.logMessage;
        data["executedOn"] = this.executedOn ? this.executedOn.toString() : undefined as any;
        return data;
    }
}

export interface IExportJobExecutionLogDTO {
    logMessage?: string | undefined;
    executedOn?: DateTime | undefined;
}

export class PagedResultDTOOfFalseRecordingsReportDTO implements IPagedResultDTOOfFalseRecordingsReportDTO {
    items?: FalseRecordingsReportDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfFalseRecordingsReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FalseRecordingsReportDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfFalseRecordingsReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfFalseRecordingsReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfFalseRecordingsReportDTO {
    items?: FalseRecordingsReportDTO[] | undefined;
    totalNumberOfItems: number;
}

export class FalseRecordingsReportDTO implements IFalseRecordingsReportDTO {
    date!: DateTime;
    parkerRegistrationType!: ParkerRegistrationType;
    parker?: ParkerInfoDTO | undefined;
    knownTag?: ParkerTagDTO | undefined;
    registeredZone?: ZoneDTO | undefined;
    agent?: LimitedUserInfoDTO | undefined;
    parkingSessionId!: number;

    constructor(data?: IFalseRecordingsReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.parkerRegistrationType = _data["parkerRegistrationType"];
            this.parker = _data["parker"] ? ParkerInfoDTO.fromJS(_data["parker"]) : undefined as any;
            this.knownTag = _data["knownTag"] ? ParkerTagDTO.fromJS(_data["knownTag"]) : undefined as any;
            this.registeredZone = _data["registeredZone"] ? ZoneDTO.fromJS(_data["registeredZone"]) : undefined as any;
            this.agent = _data["agent"] ? LimitedUserInfoDTO.fromJS(_data["agent"]) : undefined as any;
            this.parkingSessionId = _data["parkingSessionId"];
        }
    }

    static fromJS(data: any): FalseRecordingsReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FalseRecordingsReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["parkerRegistrationType"] = this.parkerRegistrationType;
        data["parker"] = this.parker ? this.parker.toJSON() : undefined as any;
        data["knownTag"] = this.knownTag ? this.knownTag.toJSON() : undefined as any;
        data["registeredZone"] = this.registeredZone ? this.registeredZone.toJSON() : undefined as any;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["parkingSessionId"] = this.parkingSessionId;
        return data;
    }
}

export interface IFalseRecordingsReportDTO {
    date: DateTime;
    parkerRegistrationType: ParkerRegistrationType;
    parker?: ParkerInfoDTO | undefined;
    knownTag?: ParkerTagDTO | undefined;
    registeredZone?: ZoneDTO | undefined;
    agent?: LimitedUserInfoDTO | undefined;
    parkingSessionId: number;
}

export enum ParkerRegistrationType {
    Unknown = 0,
    ParkingRangerEntry = 1,
    Entry = 2,
    Exit = 3,
    AutoClose = 4,
    AutoScheduleEntry = 5,
    AutoScheduleClose = 6,
    DeviceCommandExecution = 7,
    CloseByAdmin = 8,
    StartTimeByAdmin = 9,
    ParkingCard = 10,
}

export class FalseRecordingsReportParameterDTO implements IFalseRecordingsReportParameterDTO {
    dateRange!: DateRangeParameterDTO;
    zoneId?: number | undefined;
    agentId?: string | undefined;

    constructor(data?: IFalseRecordingsReportParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeParameterDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRange = _data["dateRange"] ? DateRangeParameterDTO.fromJS(_data["dateRange"]) : new DateRangeParameterDTO();
            this.zoneId = _data["zoneId"];
            this.agentId = _data["agentId"];
        }
    }

    static fromJS(data: any): FalseRecordingsReportParameterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FalseRecordingsReportParameterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        data["zoneId"] = this.zoneId;
        data["agentId"] = this.agentId;
        return data;
    }
}

export interface IFalseRecordingsReportParameterDTO {
    dateRange: DateRangeParameterDTO;
    zoneId?: number | undefined;
    agentId?: string | undefined;
}

export class ParkingQuotaInfoDTO implements IParkingQuotaInfoDTO {
    remainingParkingQuotaInMinutes?: number | undefined;
    totalParkingQuotaInHours?: number | undefined;
    parkingQuotaDuration!: ParkingQuotaDuration;

    constructor(data?: IParkingQuotaInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remainingParkingQuotaInMinutes = _data["remainingParkingQuotaInMinutes"];
            this.totalParkingQuotaInHours = _data["totalParkingQuotaInHours"];
            this.parkingQuotaDuration = _data["parkingQuotaDuration"];
        }
    }

    static fromJS(data: any): ParkingQuotaInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingQuotaInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remainingParkingQuotaInMinutes"] = this.remainingParkingQuotaInMinutes;
        data["totalParkingQuotaInHours"] = this.totalParkingQuotaInHours;
        data["parkingQuotaDuration"] = this.parkingQuotaDuration;
        return data;
    }
}

export interface IParkingQuotaInfoDTO {
    remainingParkingQuotaInMinutes?: number | undefined;
    totalParkingQuotaInHours?: number | undefined;
    parkingQuotaDuration: ParkingQuotaDuration;
}

export class CalculateParkingPriceResultDTO implements ICalculateParkingPriceResultDTO {
    parkingPriceDetails!: ParkingPriceDetailsDTO;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    needsForeignParkingPaymentProcess!: boolean;
    offense!: ParkerRegistrationOffense;

    constructor(data?: ICalculateParkingPriceResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.parkingPriceDetails = new ParkingPriceDetailsDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : new ParkingPriceDetailsDTO();
            this.fallbackParkingPriceDetails = _data["fallbackParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["fallbackParkingPriceDetails"]) : undefined as any;
            this.needsForeignParkingPaymentProcess = _data["needsForeignParkingPaymentProcess"];
            this.offense = _data["offense"];
        }
    }

    static fromJS(data: any): CalculateParkingPriceResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateParkingPriceResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        data["fallbackParkingPriceDetails"] = this.fallbackParkingPriceDetails ? this.fallbackParkingPriceDetails.toJSON() : undefined as any;
        data["needsForeignParkingPaymentProcess"] = this.needsForeignParkingPaymentProcess;
        data["offense"] = this.offense;
        return data;
    }
}

export interface ICalculateParkingPriceResultDTO {
    parkingPriceDetails: ParkingPriceDetailsDTO;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    needsForeignParkingPaymentProcess: boolean;
    offense: ParkerRegistrationOffense;
}

export enum ParkerRegistrationOffense {
    NoOffense = 0,
    ZoneNotAllowed = 1,
    ParkingTimeTooLong = 2,
    ParkerUnknown = 3,
    ParkerInactive = 4,
    ParkerAlreadyLeftZone = 5,
    NoEntryReading = 6,
    NoEntryAndExitReading = 7,
    OffenseOverdue = 8,
    MultipleCarsNotAllowed = 9,
    SessionNotExtendable = 10,
    InsufficientFunds = 11,
    GhostRead = 12,
    Blacklisted = 13,
    ParkingCardConfirmationTimeExceeded = 14,
    NoExitReading = 15,
    QuotaExceeded = 16,
    PaymentNotAuthorized = 17,
    PaymentMethodExpired = 18,
    InvalidPaymentMethod = 19,
    DeviceLostRegistrationControlling = 20,
    InsufficientPayment = 21,
    SessionAlreadyClosed = 22,
}

export class CalculateForeignParkingPriceFastCheckinDTO implements ICalculateForeignParkingPriceFastCheckinDTO {
    controlPlateNumber!: string;
    zoneId!: number;
    selectedSubscriptionId!: number;
    intendedParkingDurationMinutes!: number;

    constructor(data?: ICalculateForeignParkingPriceFastCheckinDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.zoneId = _data["zoneId"];
            this.selectedSubscriptionId = _data["selectedSubscriptionId"];
            this.intendedParkingDurationMinutes = _data["intendedParkingDurationMinutes"];
        }
    }

    static fromJS(data: any): CalculateForeignParkingPriceFastCheckinDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateForeignParkingPriceFastCheckinDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["zoneId"] = this.zoneId;
        data["selectedSubscriptionId"] = this.selectedSubscriptionId;
        data["intendedParkingDurationMinutes"] = this.intendedParkingDurationMinutes;
        return data;
    }
}

export interface ICalculateForeignParkingPriceFastCheckinDTO {
    controlPlateNumber: string;
    zoneId: number;
    selectedSubscriptionId: number;
    intendedParkingDurationMinutes: number;
}

export class StartForeignParkingPaymentProcessResponseDTO implements IStartForeignParkingPaymentProcessResponseDTO {
    success!: boolean;
    errorDescription?: string | undefined;
    offense?: ParkerRegistrationOffense | undefined;
    paymentId?: number | undefined;
    redirectionUrl?: string | undefined;
    successUrl?: string | undefined;
    failedUrl?: string | undefined;

    constructor(data?: IStartForeignParkingPaymentProcessResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorDescription = _data["errorDescription"];
            this.offense = _data["offense"];
            this.paymentId = _data["paymentId"];
            this.redirectionUrl = _data["redirectionUrl"];
            this.successUrl = _data["successUrl"];
            this.failedUrl = _data["failedUrl"];
        }
    }

    static fromJS(data: any): StartForeignParkingPaymentProcessResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StartForeignParkingPaymentProcessResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorDescription"] = this.errorDescription;
        data["offense"] = this.offense;
        data["paymentId"] = this.paymentId;
        data["redirectionUrl"] = this.redirectionUrl;
        data["successUrl"] = this.successUrl;
        data["failedUrl"] = this.failedUrl;
        return data;
    }
}

export interface IStartForeignParkingPaymentProcessResponseDTO {
    success: boolean;
    errorDescription?: string | undefined;
    offense?: ParkerRegistrationOffense | undefined;
    paymentId?: number | undefined;
    redirectionUrl?: string | undefined;
    successUrl?: string | undefined;
    failedUrl?: string | undefined;
}

export class StartForeignParkingPaymentProcessFastCheckinResponseDTO extends StartForeignParkingPaymentProcessResponseDTO implements IStartForeignParkingPaymentProcessFastCheckinResponseDTO {
    altPaymentIdent?: string | undefined;

    constructor(data?: IStartForeignParkingPaymentProcessFastCheckinResponseDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.altPaymentIdent = _data["altPaymentIdent"];
        }
    }

    static override fromJS(data: any): StartForeignParkingPaymentProcessFastCheckinResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StartForeignParkingPaymentProcessFastCheckinResponseDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["altPaymentIdent"] = this.altPaymentIdent;
        super.toJSON(data);
        return data;
    }
}

export interface IStartForeignParkingPaymentProcessFastCheckinResponseDTO extends IStartForeignParkingPaymentProcessResponseDTO {
    altPaymentIdent?: string | undefined;
}

export class StartForeignParkingPaymentProcessFastCheckinDTO implements IStartForeignParkingPaymentProcessFastCheckinDTO {
    maxIntendedParkingDurationMinutes!: number;
    selectedSubscriptionId?: number | undefined;
    controlPlateType?: ControlPlateType | undefined;
    controlPlateCountryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    parkingSpaceNumber?: string | undefined;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    zoneId!: number;
    email?: string | undefined;

    constructor(data?: IStartForeignParkingPaymentProcessFastCheckinDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxIntendedParkingDurationMinutes = _data["maxIntendedParkingDurationMinutes"];
            this.selectedSubscriptionId = _data["selectedSubscriptionId"];
            this.controlPlateType = _data["controlPlateType"];
            this.controlPlateCountryCode = _data["controlPlateCountryCode"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : undefined as any;
            this.fallbackParkingPriceDetails = _data["fallbackParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["fallbackParkingPriceDetails"]) : undefined as any;
            this.zoneId = _data["zoneId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): StartForeignParkingPaymentProcessFastCheckinDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StartForeignParkingPaymentProcessFastCheckinDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxIntendedParkingDurationMinutes"] = this.maxIntendedParkingDurationMinutes;
        data["selectedSubscriptionId"] = this.selectedSubscriptionId;
        data["controlPlateType"] = this.controlPlateType;
        data["controlPlateCountryCode"] = this.controlPlateCountryCode;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        data["fallbackParkingPriceDetails"] = this.fallbackParkingPriceDetails ? this.fallbackParkingPriceDetails.toJSON() : undefined as any;
        data["zoneId"] = this.zoneId;
        data["email"] = this.email;
        return data;
    }
}

export interface IStartForeignParkingPaymentProcessFastCheckinDTO {
    maxIntendedParkingDurationMinutes: number;
    selectedSubscriptionId?: number | undefined;
    controlPlateType?: ControlPlateType | undefined;
    controlPlateCountryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    parkingSpaceNumber?: string | undefined;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    zoneId: number;
    email?: string | undefined;
}

export class CheckinUserForeignParkingFastCheckInResultDTO implements ICheckinUserForeignParkingFastCheckInResultDTO {
    altSessionId?: string | undefined;
    state!: ParkingRegistrationState;
    offense!: ParkerRegistrationOffense;

    constructor(data?: ICheckinUserForeignParkingFastCheckInResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.altSessionId = _data["altSessionId"];
            this.state = _data["state"];
            this.offense = _data["offense"];
        }
    }

    static fromJS(data: any): CheckinUserForeignParkingFastCheckInResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinUserForeignParkingFastCheckInResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["altSessionId"] = this.altSessionId;
        data["state"] = this.state;
        data["offense"] = this.offense;
        return data;
    }
}

export interface ICheckinUserForeignParkingFastCheckInResultDTO {
    altSessionId?: string | undefined;
    state: ParkingRegistrationState;
    offense: ParkerRegistrationOffense;
}

export enum ParkingRegistrationState {
    Success = 0,
    ParkingSessionAlreadyActive = 1,
    ParkingRangerAlreadyChecked = 2,
    Offense = 3,
}

export class CheckinUserForeignParkingFastCheckinNoPaymentDTO implements ICheckinUserForeignParkingFastCheckinNoPaymentDTO {
    maxIntendedParkingDurationMinutes!: number;
    selectedSubscriptionId!: number;
    controlPlateType?: ControlPlateType | undefined;
    controlPlateCountryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    parkingSpaceNumber?: string | undefined;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    zoneId!: number;
    email?: string | undefined;

    constructor(data?: ICheckinUserForeignParkingFastCheckinNoPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxIntendedParkingDurationMinutes = _data["maxIntendedParkingDurationMinutes"];
            this.selectedSubscriptionId = _data["selectedSubscriptionId"];
            this.controlPlateType = _data["controlPlateType"];
            this.controlPlateCountryCode = _data["controlPlateCountryCode"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : undefined as any;
            this.fallbackParkingPriceDetails = _data["fallbackParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["fallbackParkingPriceDetails"]) : undefined as any;
            this.zoneId = _data["zoneId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CheckinUserForeignParkingFastCheckinNoPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinUserForeignParkingFastCheckinNoPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxIntendedParkingDurationMinutes"] = this.maxIntendedParkingDurationMinutes;
        data["selectedSubscriptionId"] = this.selectedSubscriptionId;
        data["controlPlateType"] = this.controlPlateType;
        data["controlPlateCountryCode"] = this.controlPlateCountryCode;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        data["fallbackParkingPriceDetails"] = this.fallbackParkingPriceDetails ? this.fallbackParkingPriceDetails.toJSON() : undefined as any;
        data["zoneId"] = this.zoneId;
        data["email"] = this.email;
        return data;
    }
}

export interface ICheckinUserForeignParkingFastCheckinNoPaymentDTO {
    maxIntendedParkingDurationMinutes: number;
    selectedSubscriptionId: number;
    controlPlateType?: ControlPlateType | undefined;
    controlPlateCountryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    parkingSpaceNumber?: string | undefined;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    zoneId: number;
    email?: string | undefined;
}

export class FastCheckinParkingSessionInfoDTO implements IFastCheckinParkingSessionInfoDTO {
    sessionId!: number;
    isClosed!: boolean;
    startDateTime!: DateTime;
    endDateTime?: DateTime | undefined;
    state!: ParkingRegistrationState;
    offense!: ParkerRegistrationOffense;
    zone?: ZoneLimitedDTO | undefined;
    maxIntendedParkingDurationMinutes?: number | undefined;
    parkingSpaceNumber?: string | undefined;
    controlPlateNumber?: string | undefined;
    controlPlateCountryCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    visitorSessionIdToValidate?: number | undefined;
    visitorSessionToValidateUntil?: DateTime | undefined;
    validationFallbackSubscriptionName?: string | undefined;
    isSessionExtendable?: boolean | undefined;
    validatedByParkingCard!: boolean;
    totalWithVat!: number;
    currency!: Currency;
    calculatedParkingPriceDetails?: string | undefined;
    sessionClosingEventType?: SessionEventType | undefined;
    parkingSubscriptionInfo?: ParkingProcessSubscriptionInfoDTO | undefined;

    constructor(data?: IFastCheckinParkingSessionInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.isClosed = _data["isClosed"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.offense = _data["offense"];
            this.zone = _data["zone"] ? ZoneLimitedDTO.fromJS(_data["zone"]) : undefined as any;
            this.maxIntendedParkingDurationMinutes = _data["maxIntendedParkingDurationMinutes"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.controlPlateCountryCode = _data["controlPlateCountryCode"];
            this.controlPlateType = _data["controlPlateType"];
            this.visitorSessionIdToValidate = _data["visitorSessionIdToValidate"];
            this.visitorSessionToValidateUntil = _data["visitorSessionToValidateUntil"] ? DateTime.fromISO(_data["visitorSessionToValidateUntil"].toString()) : undefined as any;
            this.validationFallbackSubscriptionName = _data["validationFallbackSubscriptionName"];
            this.isSessionExtendable = _data["isSessionExtendable"];
            this.validatedByParkingCard = _data["validatedByParkingCard"];
            this.totalWithVat = _data["totalWithVat"];
            this.currency = _data["currency"];
            this.calculatedParkingPriceDetails = _data["calculatedParkingPriceDetails"];
            this.sessionClosingEventType = _data["sessionClosingEventType"];
            this.parkingSubscriptionInfo = _data["parkingSubscriptionInfo"] ? ParkingProcessSubscriptionInfoDTO.fromJS(_data["parkingSubscriptionInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): FastCheckinParkingSessionInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FastCheckinParkingSessionInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["isClosed"] = this.isClosed;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["state"] = this.state;
        data["offense"] = this.offense;
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        data["maxIntendedParkingDurationMinutes"] = this.maxIntendedParkingDurationMinutes;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["controlPlateCountryCode"] = this.controlPlateCountryCode;
        data["controlPlateType"] = this.controlPlateType;
        data["visitorSessionIdToValidate"] = this.visitorSessionIdToValidate;
        data["visitorSessionToValidateUntil"] = this.visitorSessionToValidateUntil ? this.visitorSessionToValidateUntil.toString() : undefined as any;
        data["validationFallbackSubscriptionName"] = this.validationFallbackSubscriptionName;
        data["isSessionExtendable"] = this.isSessionExtendable;
        data["validatedByParkingCard"] = this.validatedByParkingCard;
        data["totalWithVat"] = this.totalWithVat;
        data["currency"] = this.currency;
        data["calculatedParkingPriceDetails"] = this.calculatedParkingPriceDetails;
        data["sessionClosingEventType"] = this.sessionClosingEventType;
        data["parkingSubscriptionInfo"] = this.parkingSubscriptionInfo ? this.parkingSubscriptionInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IFastCheckinParkingSessionInfoDTO {
    sessionId: number;
    isClosed: boolean;
    startDateTime: DateTime;
    endDateTime?: DateTime | undefined;
    state: ParkingRegistrationState;
    offense: ParkerRegistrationOffense;
    zone?: ZoneLimitedDTO | undefined;
    maxIntendedParkingDurationMinutes?: number | undefined;
    parkingSpaceNumber?: string | undefined;
    controlPlateNumber?: string | undefined;
    controlPlateCountryCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    visitorSessionIdToValidate?: number | undefined;
    visitorSessionToValidateUntil?: DateTime | undefined;
    validationFallbackSubscriptionName?: string | undefined;
    isSessionExtendable?: boolean | undefined;
    validatedByParkingCard: boolean;
    totalWithVat: number;
    currency: Currency;
    calculatedParkingPriceDetails?: string | undefined;
    sessionClosingEventType?: SessionEventType | undefined;
    parkingSubscriptionInfo?: ParkingProcessSubscriptionInfoDTO | undefined;
}

export class FastCheckinSessionDTO implements IFastCheckinSessionDTO {
    sessionIdent?: string | undefined;

    constructor(data?: IFastCheckinSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionIdent = _data["sessionIdent"];
        }
    }

    static fromJS(data: any): FastCheckinSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FastCheckinSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionIdent"] = this.sessionIdent;
        return data;
    }
}

export interface IFastCheckinSessionDTO {
    sessionIdent?: string | undefined;
}

export class ValidateFastCheckinSessionDTO implements IValidateFastCheckinSessionDTO {
    sessionIdent!: string;
    parkingCardIdent!: string;

    constructor(data?: IValidateFastCheckinSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionIdent = _data["sessionIdent"];
            this.parkingCardIdent = _data["parkingCardIdent"];
        }
    }

    static fromJS(data: any): ValidateFastCheckinSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateFastCheckinSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionIdent"] = this.sessionIdent;
        data["parkingCardIdent"] = this.parkingCardIdent;
        return data;
    }
}

export interface IValidateFastCheckinSessionDTO {
    sessionIdent: string;
    parkingCardIdent: string;
}

export class CalculateParkingExtensionPriceResultDTO implements ICalculateParkingExtensionPriceResultDTO {
    totalPrice!: number;
    currency!: Currency;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackPriceDetails?: ParkingPriceDetailsDTO | undefined;
    needsForeignParkingPaymentProcess!: boolean;
    offense!: ParkerRegistrationOffense;

    constructor(data?: ICalculateParkingExtensionPriceResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPrice = _data["totalPrice"];
            this.currency = _data["currency"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : undefined as any;
            this.fallbackPriceDetails = _data["fallbackPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["fallbackPriceDetails"]) : undefined as any;
            this.needsForeignParkingPaymentProcess = _data["needsForeignParkingPaymentProcess"];
            this.offense = _data["offense"];
        }
    }

    static fromJS(data: any): CalculateParkingExtensionPriceResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateParkingExtensionPriceResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPrice"] = this.totalPrice;
        data["currency"] = this.currency;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        data["fallbackPriceDetails"] = this.fallbackPriceDetails ? this.fallbackPriceDetails.toJSON() : undefined as any;
        data["needsForeignParkingPaymentProcess"] = this.needsForeignParkingPaymentProcess;
        data["offense"] = this.offense;
        return data;
    }
}

export interface ICalculateParkingExtensionPriceResultDTO {
    totalPrice: number;
    currency: Currency;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackPriceDetails?: ParkingPriceDetailsDTO | undefined;
    needsForeignParkingPaymentProcess: boolean;
    offense: ParkerRegistrationOffense;
}

export class CalculateExtendFastCheckinParkingDTO implements ICalculateExtendFastCheckinParkingDTO {
    sessionIdent!: string;
    extensionInMinutes!: number;

    constructor(data?: ICalculateExtendFastCheckinParkingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionIdent = _data["sessionIdent"];
            this.extensionInMinutes = _data["extensionInMinutes"];
        }
    }

    static fromJS(data: any): CalculateExtendFastCheckinParkingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateExtendFastCheckinParkingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionIdent"] = this.sessionIdent;
        data["extensionInMinutes"] = this.extensionInMinutes;
        return data;
    }
}

export interface ICalculateExtendFastCheckinParkingDTO {
    sessionIdent: string;
    extensionInMinutes: number;
}

export class StartParkingExtensionPaymentProcessResponseDTO implements IStartParkingExtensionPaymentProcessResponseDTO {
    success!: boolean;
    errorDescription?: string | undefined;
    offense?: ParkerRegistrationOffense | undefined;
    paymentId?: number | undefined;
    redirectionUrl?: string | undefined;
    successUrl?: string | undefined;
    failedUrl?: string | undefined;

    constructor(data?: IStartParkingExtensionPaymentProcessResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorDescription = _data["errorDescription"];
            this.offense = _data["offense"];
            this.paymentId = _data["paymentId"];
            this.redirectionUrl = _data["redirectionUrl"];
            this.successUrl = _data["successUrl"];
            this.failedUrl = _data["failedUrl"];
        }
    }

    static fromJS(data: any): StartParkingExtensionPaymentProcessResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StartParkingExtensionPaymentProcessResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorDescription"] = this.errorDescription;
        data["offense"] = this.offense;
        data["paymentId"] = this.paymentId;
        data["redirectionUrl"] = this.redirectionUrl;
        data["successUrl"] = this.successUrl;
        data["failedUrl"] = this.failedUrl;
        return data;
    }
}

export interface IStartParkingExtensionPaymentProcessResponseDTO {
    success: boolean;
    errorDescription?: string | undefined;
    offense?: ParkerRegistrationOffense | undefined;
    paymentId?: number | undefined;
    redirectionUrl?: string | undefined;
    successUrl?: string | undefined;
    failedUrl?: string | undefined;
}

export class StartFastCheckinParkingExtensionPaymentProcessResponseDTO extends StartParkingExtensionPaymentProcessResponseDTO implements IStartFastCheckinParkingExtensionPaymentProcessResponseDTO {
    altPaymentIdent?: string | undefined;

    constructor(data?: IStartFastCheckinParkingExtensionPaymentProcessResponseDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.altPaymentIdent = _data["altPaymentIdent"];
        }
    }

    static override fromJS(data: any): StartFastCheckinParkingExtensionPaymentProcessResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StartFastCheckinParkingExtensionPaymentProcessResponseDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["altPaymentIdent"] = this.altPaymentIdent;
        super.toJSON(data);
        return data;
    }
}

export interface IStartFastCheckinParkingExtensionPaymentProcessResponseDTO extends IStartParkingExtensionPaymentProcessResponseDTO {
    altPaymentIdent?: string | undefined;
}

export class StartFastCheckinParkingExtensionPaymentProcessDTO implements IStartFastCheckinParkingExtensionPaymentProcessDTO {
    sessionIdent!: string;
    extensionInMinutes!: number;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;

    constructor(data?: IStartFastCheckinParkingExtensionPaymentProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionIdent = _data["sessionIdent"];
            this.extensionInMinutes = _data["extensionInMinutes"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : undefined as any;
            this.fallbackParkingPriceDetails = _data["fallbackParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["fallbackParkingPriceDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): StartFastCheckinParkingExtensionPaymentProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StartFastCheckinParkingExtensionPaymentProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionIdent"] = this.sessionIdent;
        data["extensionInMinutes"] = this.extensionInMinutes;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        data["fallbackParkingPriceDetails"] = this.fallbackParkingPriceDetails ? this.fallbackParkingPriceDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IStartFastCheckinParkingExtensionPaymentProcessDTO {
    sessionIdent: string;
    extensionInMinutes: number;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
}

export class ExtendUserParkingResultDTO implements IExtendUserParkingResultDTO {
    offense!: ParkerRegistrationOffense;
    calculatedParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;

    constructor(data?: IExtendUserParkingResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offense = _data["offense"];
            this.calculatedParkingPriceDetails = _data["calculatedParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["calculatedParkingPriceDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExtendUserParkingResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendUserParkingResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offense"] = this.offense;
        data["calculatedParkingPriceDetails"] = this.calculatedParkingPriceDetails ? this.calculatedParkingPriceDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IExtendUserParkingResultDTO {
    offense: ParkerRegistrationOffense;
    calculatedParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
}

export class ExtendFastCheckinParkingDTO implements IExtendFastCheckinParkingDTO {
    sessionIdent!: string;
    extensionInMinutes!: number;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    altPaymentIdent?: string | undefined;

    constructor(data?: IExtendFastCheckinParkingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionIdent = _data["sessionIdent"];
            this.extensionInMinutes = _data["extensionInMinutes"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : undefined as any;
            this.fallbackParkingPriceDetails = _data["fallbackParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["fallbackParkingPriceDetails"]) : undefined as any;
            this.altPaymentIdent = _data["altPaymentIdent"];
        }
    }

    static fromJS(data: any): ExtendFastCheckinParkingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendFastCheckinParkingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionIdent"] = this.sessionIdent;
        data["extensionInMinutes"] = this.extensionInMinutes;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        data["fallbackParkingPriceDetails"] = this.fallbackParkingPriceDetails ? this.fallbackParkingPriceDetails.toJSON() : undefined as any;
        data["altPaymentIdent"] = this.altPaymentIdent;
        return data;
    }
}

export interface IExtendFastCheckinParkingDTO {
    sessionIdent: string;
    extensionInMinutes: number;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    altPaymentIdent?: string | undefined;
}

export class FinanceClientPriceModelDTO implements IFinanceClientPriceModelDTO {
    id!: number;
    navisionCustomerNumber?: string | undefined;
    navisionProjectNumber?: string | undefined;
    validTo?: string | undefined;
    feesPaidByParkingSpaceOwner!: boolean;
    vatInPercent!: number;
    parkingPriceIncludedVATInPercent!: number;
    basePricePerMonth!: number;
    paymentProviderTransactionConstantPrice!: number;
    paymentProviderTransactionVariablePriceInPercent!: number;
    transactionMinimumPrice!: number;
    transactionConstantPrice!: number;
    transactionVariablePriceInPercent!: number;
    creditCardPaymentProviderTransactionConstantPrice?: number | undefined;
    creditCardPaymentProviderTransactionVariablePriceInPercent?: number | undefined;
    creditCardTransactionConstantPrice?: number | undefined;
    creditCardTransactionVariablePriceInPercent?: number | undefined;
    twintPaymentProviderTransactionConstantPrice?: number | undefined;
    twintPaymentProviderTransactionVariablePriceInPercent?: number | undefined;
    twintTransactionConstantPrice?: number | undefined;
    twintTransactionVariablePriceInPercent?: number | undefined;
    payPalPaymentProviderTransactionConstantPrice?: number | undefined;
    payPalPaymentProviderTransactionVariablePriceInPercent?: number | undefined;
    payPalTransactionConstantPrice?: number | undefined;
    payPalTransactionVariablePriceInPercent?: number | undefined;
    noOfIncludedAdmins!: number;
    pricePerAdditionalAdmin!: number;
    noOfIncludedWebUser!: number;
    pricePerAdditionalWebUser!: number;
    noOfIncludedParkingRanger!: number;
    pricePerAdditionalParkingRanger!: number;
    noOfIncludedDevices!: number;
    pricePerAdditionalDevice!: number;
    noOfIncludedProxies!: number;
    pricePerAdditionalProxy!: number;
    autoParkingActive!: boolean;
    pricePerAutoParkingParkerPerMonth!: number;
    thirdPartyInterfaceActive!: boolean;
    pricePerThirdPartyInterface!: number;
    noOfIncludedParkingSpaces!: number;
    noOfIncludedParkers!: number;
    imageStoragePricePerMB!: number;
    parkingSpacePriceModelName?: string | undefined;
    parkerPriceModelName?: string | undefined;

    constructor(data?: IFinanceClientPriceModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.navisionCustomerNumber = _data["navisionCustomerNumber"];
            this.navisionProjectNumber = _data["navisionProjectNumber"];
            this.validTo = _data["validTo"];
            this.feesPaidByParkingSpaceOwner = _data["feesPaidByParkingSpaceOwner"];
            this.vatInPercent = _data["vatInPercent"];
            this.parkingPriceIncludedVATInPercent = _data["parkingPriceIncludedVATInPercent"];
            this.basePricePerMonth = _data["basePricePerMonth"];
            this.paymentProviderTransactionConstantPrice = _data["paymentProviderTransactionConstantPrice"];
            this.paymentProviderTransactionVariablePriceInPercent = _data["paymentProviderTransactionVariablePriceInPercent"];
            this.transactionMinimumPrice = _data["transactionMinimumPrice"];
            this.transactionConstantPrice = _data["transactionConstantPrice"];
            this.transactionVariablePriceInPercent = _data["transactionVariablePriceInPercent"];
            this.creditCardPaymentProviderTransactionConstantPrice = _data["creditCardPaymentProviderTransactionConstantPrice"];
            this.creditCardPaymentProviderTransactionVariablePriceInPercent = _data["creditCardPaymentProviderTransactionVariablePriceInPercent"];
            this.creditCardTransactionConstantPrice = _data["creditCardTransactionConstantPrice"];
            this.creditCardTransactionVariablePriceInPercent = _data["creditCardTransactionVariablePriceInPercent"];
            this.twintPaymentProviderTransactionConstantPrice = _data["twintPaymentProviderTransactionConstantPrice"];
            this.twintPaymentProviderTransactionVariablePriceInPercent = _data["twintPaymentProviderTransactionVariablePriceInPercent"];
            this.twintTransactionConstantPrice = _data["twintTransactionConstantPrice"];
            this.twintTransactionVariablePriceInPercent = _data["twintTransactionVariablePriceInPercent"];
            this.payPalPaymentProviderTransactionConstantPrice = _data["payPalPaymentProviderTransactionConstantPrice"];
            this.payPalPaymentProviderTransactionVariablePriceInPercent = _data["payPalPaymentProviderTransactionVariablePriceInPercent"];
            this.payPalTransactionConstantPrice = _data["payPalTransactionConstantPrice"];
            this.payPalTransactionVariablePriceInPercent = _data["payPalTransactionVariablePriceInPercent"];
            this.noOfIncludedAdmins = _data["noOfIncludedAdmins"];
            this.pricePerAdditionalAdmin = _data["pricePerAdditionalAdmin"];
            this.noOfIncludedWebUser = _data["noOfIncludedWebUser"];
            this.pricePerAdditionalWebUser = _data["pricePerAdditionalWebUser"];
            this.noOfIncludedParkingRanger = _data["noOfIncludedParkingRanger"];
            this.pricePerAdditionalParkingRanger = _data["pricePerAdditionalParkingRanger"];
            this.noOfIncludedDevices = _data["noOfIncludedDevices"];
            this.pricePerAdditionalDevice = _data["pricePerAdditionalDevice"];
            this.noOfIncludedProxies = _data["noOfIncludedProxies"];
            this.pricePerAdditionalProxy = _data["pricePerAdditionalProxy"];
            this.autoParkingActive = _data["autoParkingActive"];
            this.pricePerAutoParkingParkerPerMonth = _data["pricePerAutoParkingParkerPerMonth"];
            this.thirdPartyInterfaceActive = _data["thirdPartyInterfaceActive"];
            this.pricePerThirdPartyInterface = _data["pricePerThirdPartyInterface"];
            this.noOfIncludedParkingSpaces = _data["noOfIncludedParkingSpaces"];
            this.noOfIncludedParkers = _data["noOfIncludedParkers"];
            this.imageStoragePricePerMB = _data["imageStoragePricePerMB"];
            this.parkingSpacePriceModelName = _data["parkingSpacePriceModelName"];
            this.parkerPriceModelName = _data["parkerPriceModelName"];
        }
    }

    static fromJS(data: any): FinanceClientPriceModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceClientPriceModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["navisionCustomerNumber"] = this.navisionCustomerNumber;
        data["navisionProjectNumber"] = this.navisionProjectNumber;
        data["validTo"] = this.validTo;
        data["feesPaidByParkingSpaceOwner"] = this.feesPaidByParkingSpaceOwner;
        data["vatInPercent"] = this.vatInPercent;
        data["parkingPriceIncludedVATInPercent"] = this.parkingPriceIncludedVATInPercent;
        data["basePricePerMonth"] = this.basePricePerMonth;
        data["paymentProviderTransactionConstantPrice"] = this.paymentProviderTransactionConstantPrice;
        data["paymentProviderTransactionVariablePriceInPercent"] = this.paymentProviderTransactionVariablePriceInPercent;
        data["transactionMinimumPrice"] = this.transactionMinimumPrice;
        data["transactionConstantPrice"] = this.transactionConstantPrice;
        data["transactionVariablePriceInPercent"] = this.transactionVariablePriceInPercent;
        data["creditCardPaymentProviderTransactionConstantPrice"] = this.creditCardPaymentProviderTransactionConstantPrice;
        data["creditCardPaymentProviderTransactionVariablePriceInPercent"] = this.creditCardPaymentProviderTransactionVariablePriceInPercent;
        data["creditCardTransactionConstantPrice"] = this.creditCardTransactionConstantPrice;
        data["creditCardTransactionVariablePriceInPercent"] = this.creditCardTransactionVariablePriceInPercent;
        data["twintPaymentProviderTransactionConstantPrice"] = this.twintPaymentProviderTransactionConstantPrice;
        data["twintPaymentProviderTransactionVariablePriceInPercent"] = this.twintPaymentProviderTransactionVariablePriceInPercent;
        data["twintTransactionConstantPrice"] = this.twintTransactionConstantPrice;
        data["twintTransactionVariablePriceInPercent"] = this.twintTransactionVariablePriceInPercent;
        data["payPalPaymentProviderTransactionConstantPrice"] = this.payPalPaymentProviderTransactionConstantPrice;
        data["payPalPaymentProviderTransactionVariablePriceInPercent"] = this.payPalPaymentProviderTransactionVariablePriceInPercent;
        data["payPalTransactionConstantPrice"] = this.payPalTransactionConstantPrice;
        data["payPalTransactionVariablePriceInPercent"] = this.payPalTransactionVariablePriceInPercent;
        data["noOfIncludedAdmins"] = this.noOfIncludedAdmins;
        data["pricePerAdditionalAdmin"] = this.pricePerAdditionalAdmin;
        data["noOfIncludedWebUser"] = this.noOfIncludedWebUser;
        data["pricePerAdditionalWebUser"] = this.pricePerAdditionalWebUser;
        data["noOfIncludedParkingRanger"] = this.noOfIncludedParkingRanger;
        data["pricePerAdditionalParkingRanger"] = this.pricePerAdditionalParkingRanger;
        data["noOfIncludedDevices"] = this.noOfIncludedDevices;
        data["pricePerAdditionalDevice"] = this.pricePerAdditionalDevice;
        data["noOfIncludedProxies"] = this.noOfIncludedProxies;
        data["pricePerAdditionalProxy"] = this.pricePerAdditionalProxy;
        data["autoParkingActive"] = this.autoParkingActive;
        data["pricePerAutoParkingParkerPerMonth"] = this.pricePerAutoParkingParkerPerMonth;
        data["thirdPartyInterfaceActive"] = this.thirdPartyInterfaceActive;
        data["pricePerThirdPartyInterface"] = this.pricePerThirdPartyInterface;
        data["noOfIncludedParkingSpaces"] = this.noOfIncludedParkingSpaces;
        data["noOfIncludedParkers"] = this.noOfIncludedParkers;
        data["imageStoragePricePerMB"] = this.imageStoragePricePerMB;
        data["parkingSpacePriceModelName"] = this.parkingSpacePriceModelName;
        data["parkerPriceModelName"] = this.parkerPriceModelName;
        return data;
    }
}

export interface IFinanceClientPriceModelDTO {
    id: number;
    navisionCustomerNumber?: string | undefined;
    navisionProjectNumber?: string | undefined;
    validTo?: string | undefined;
    feesPaidByParkingSpaceOwner: boolean;
    vatInPercent: number;
    parkingPriceIncludedVATInPercent: number;
    basePricePerMonth: number;
    paymentProviderTransactionConstantPrice: number;
    paymentProviderTransactionVariablePriceInPercent: number;
    transactionMinimumPrice: number;
    transactionConstantPrice: number;
    transactionVariablePriceInPercent: number;
    creditCardPaymentProviderTransactionConstantPrice?: number | undefined;
    creditCardPaymentProviderTransactionVariablePriceInPercent?: number | undefined;
    creditCardTransactionConstantPrice?: number | undefined;
    creditCardTransactionVariablePriceInPercent?: number | undefined;
    twintPaymentProviderTransactionConstantPrice?: number | undefined;
    twintPaymentProviderTransactionVariablePriceInPercent?: number | undefined;
    twintTransactionConstantPrice?: number | undefined;
    twintTransactionVariablePriceInPercent?: number | undefined;
    payPalPaymentProviderTransactionConstantPrice?: number | undefined;
    payPalPaymentProviderTransactionVariablePriceInPercent?: number | undefined;
    payPalTransactionConstantPrice?: number | undefined;
    payPalTransactionVariablePriceInPercent?: number | undefined;
    noOfIncludedAdmins: number;
    pricePerAdditionalAdmin: number;
    noOfIncludedWebUser: number;
    pricePerAdditionalWebUser: number;
    noOfIncludedParkingRanger: number;
    pricePerAdditionalParkingRanger: number;
    noOfIncludedDevices: number;
    pricePerAdditionalDevice: number;
    noOfIncludedProxies: number;
    pricePerAdditionalProxy: number;
    autoParkingActive: boolean;
    pricePerAutoParkingParkerPerMonth: number;
    thirdPartyInterfaceActive: boolean;
    pricePerThirdPartyInterface: number;
    noOfIncludedParkingSpaces: number;
    noOfIncludedParkers: number;
    imageStoragePricePerMB: number;
    parkingSpacePriceModelName?: string | undefined;
    parkerPriceModelName?: string | undefined;
}

export class FinancePriceModelDataDTO implements IFinancePriceModelDataDTO {
    parkingSpacePriceModels!: FinanceParkingSpacePriceModelDTO[];
    parkerPriceModels!: FinanceParkerPriceModelDTO[];

    constructor(data?: IFinancePriceModelDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.parkingSpacePriceModels = [];
            this.parkerPriceModels = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parkingSpacePriceModels"])) {
                this.parkingSpacePriceModels = [] as any;
                for (let item of _data["parkingSpacePriceModels"])
                    this.parkingSpacePriceModels!.push(FinanceParkingSpacePriceModelDTO.fromJS(item));
            }
            if (Array.isArray(_data["parkerPriceModels"])) {
                this.parkerPriceModels = [] as any;
                for (let item of _data["parkerPriceModels"])
                    this.parkerPriceModels!.push(FinanceParkerPriceModelDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinancePriceModelDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FinancePriceModelDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parkingSpacePriceModels)) {
            data["parkingSpacePriceModels"] = [];
            for (let item of this.parkingSpacePriceModels)
                data["parkingSpacePriceModels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parkerPriceModels)) {
            data["parkerPriceModels"] = [];
            for (let item of this.parkerPriceModels)
                data["parkerPriceModels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFinancePriceModelDataDTO {
    parkingSpacePriceModels: FinanceParkingSpacePriceModelDTO[];
    parkerPriceModels: FinanceParkerPriceModelDTO[];
}

export class FinanceParkingSpacePriceModelDTO implements IFinanceParkingSpacePriceModelDTO {
    modelName?: string | undefined;

    constructor(data?: IFinanceParkingSpacePriceModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelName = _data["modelName"];
        }
    }

    static fromJS(data: any): FinanceParkingSpacePriceModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceParkingSpacePriceModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName;
        return data;
    }
}

export interface IFinanceParkingSpacePriceModelDTO {
    modelName?: string | undefined;
}

export class FinanceParkerPriceModelDTO implements IFinanceParkerPriceModelDTO {
    modelName?: string | undefined;

    constructor(data?: IFinanceParkerPriceModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelName = _data["modelName"];
        }
    }

    static fromJS(data: any): FinanceParkerPriceModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceParkerPriceModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName;
        return data;
    }
}

export interface IFinanceParkerPriceModelDTO {
    modelName?: string | undefined;
}

export class FinancialClientInfoDTO implements IFinancialClientInfoDTO {
    clientId!: number;
    clientName?: string | undefined;
    navisionCustomerNumber?: string | undefined;
    navisionProjectNumber?: string | undefined;

    constructor(data?: IFinancialClientInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.navisionCustomerNumber = _data["navisionCustomerNumber"];
            this.navisionProjectNumber = _data["navisionProjectNumber"];
        }
    }

    static fromJS(data: any): FinancialClientInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialClientInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["navisionCustomerNumber"] = this.navisionCustomerNumber;
        data["navisionProjectNumber"] = this.navisionProjectNumber;
        return data;
    }
}

export interface IFinancialClientInfoDTO {
    clientId: number;
    clientName?: string | undefined;
    navisionCustomerNumber?: string | undefined;
    navisionProjectNumber?: string | undefined;
}

export class ClientFinancialPriceReportDTO implements IClientFinancialPriceReportDTO {
    financialClientInfo?: FinancialClientInfoDTO | undefined;
    reportStartDate?: DateTime | undefined;
    reportEndDate?: DateTime | undefined;
    basePricePerMonth!: number;
    feesPaidByParkingSpaceOwner!: boolean;
    noOfClientAdmins!: number;
    noOfIncludedClientAdmins!: number;
    noOfAdditionalClientAdmins!: number;
    pricePerAdditionalClientAdmin!: number;
    priceForAdditionalClientAdmins!: number;
    noOfClientUsers!: number;
    noOfIncludedClientUsers!: number;
    noOfAdditionalClientUsers!: number;
    pricePerAdditionalClientUser!: number;
    priceForAdditionalClientUsers!: number;
    noOfParkingRangers!: number;
    noOfIncludedParkingRangers!: number;
    noOfAdditionalParkingRangers!: number;
    pricePerAdditionalParkingRanger!: number;
    priceForAdditionalParkingRangers!: number;
    noOfProxies!: number;
    noOfIncludedProxies!: number;
    noOfAdditionalProxies!: number;
    pricePerAdditionalProxy!: number;
    priceForAdditionalProxies!: number;
    noOfDevices!: number;
    noOfIncludedDevices!: number;
    noOfAdditionalDevices!: number;
    pricePerAdditionalDevice!: number;
    priceForAdditionalDevices!: number;
    noOfParkingSpaces!: number;
    noOfIncludedParkingSpaces!: number;
    noOfAdditionalParkingSpaces!: number;
    noOfAdditionalParkingSpacesCat1!: number;
    priceForAdditionalParkingSpacesCat1?: number | undefined;
    noOfAdditionalParkingSpacesCat2!: number;
    priceForAdditionalParkingSpacesCat2?: number | undefined;
    noOfAdditionalParkingSpacesCat3!: number;
    priceForAdditionalParkingSpacesCat3?: number | undefined;
    noOfAdditionalParkingSpacesCat4!: number;
    priceForAdditionalParkingSpacesCat4?: number | undefined;
    priceForAdditionalParkingSpaces!: number;
    noOfParkers!: number;
    noOfIncludedParkers!: number;
    noOfAdditionalParkers!: number;
    noOfAdditionalParkersCat1!: number;
    priceForAdditionalParkersCat1?: number | undefined;
    noOfAdditionalParkersCat2!: number;
    priceForAdditionalParkersCat2?: number | undefined;
    noOfAdditionalParkersCat3!: number;
    priceForAdditionalParkersCat3?: number | undefined;
    noOfAdditionalParkersCat4!: number;
    priceForAdditionalParkersCat4?: number | undefined;
    priceForAdditionalParkers!: number;
    priceForThirdPartyInterface!: number;
    lprImageSavingEnabled!: boolean;
    noOfImageMBs!: number;
    imageStoragePricePerMB!: number;
    priceForImageStorage!: number;
    totalCosts!: number;

    constructor(data?: IClientFinancialPriceReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialClientInfo = _data["financialClientInfo"] ? FinancialClientInfoDTO.fromJS(_data["financialClientInfo"]) : undefined as any;
            this.reportStartDate = _data["reportStartDate"] ? DateTime.fromISO(_data["reportStartDate"].toString()) : undefined as any;
            this.reportEndDate = _data["reportEndDate"] ? DateTime.fromISO(_data["reportEndDate"].toString()) : undefined as any;
            this.basePricePerMonth = _data["basePricePerMonth"];
            this.feesPaidByParkingSpaceOwner = _data["feesPaidByParkingSpaceOwner"];
            this.noOfClientAdmins = _data["noOfClientAdmins"];
            this.noOfIncludedClientAdmins = _data["noOfIncludedClientAdmins"];
            this.noOfAdditionalClientAdmins = _data["noOfAdditionalClientAdmins"];
            this.pricePerAdditionalClientAdmin = _data["pricePerAdditionalClientAdmin"];
            this.priceForAdditionalClientAdmins = _data["priceForAdditionalClientAdmins"];
            this.noOfClientUsers = _data["noOfClientUsers"];
            this.noOfIncludedClientUsers = _data["noOfIncludedClientUsers"];
            this.noOfAdditionalClientUsers = _data["noOfAdditionalClientUsers"];
            this.pricePerAdditionalClientUser = _data["pricePerAdditionalClientUser"];
            this.priceForAdditionalClientUsers = _data["priceForAdditionalClientUsers"];
            this.noOfParkingRangers = _data["noOfParkingRangers"];
            this.noOfIncludedParkingRangers = _data["noOfIncludedParkingRangers"];
            this.noOfAdditionalParkingRangers = _data["noOfAdditionalParkingRangers"];
            this.pricePerAdditionalParkingRanger = _data["pricePerAdditionalParkingRanger"];
            this.priceForAdditionalParkingRangers = _data["priceForAdditionalParkingRangers"];
            this.noOfProxies = _data["noOfProxies"];
            this.noOfIncludedProxies = _data["noOfIncludedProxies"];
            this.noOfAdditionalProxies = _data["noOfAdditionalProxies"];
            this.pricePerAdditionalProxy = _data["pricePerAdditionalProxy"];
            this.priceForAdditionalProxies = _data["priceForAdditionalProxies"];
            this.noOfDevices = _data["noOfDevices"];
            this.noOfIncludedDevices = _data["noOfIncludedDevices"];
            this.noOfAdditionalDevices = _data["noOfAdditionalDevices"];
            this.pricePerAdditionalDevice = _data["pricePerAdditionalDevice"];
            this.priceForAdditionalDevices = _data["priceForAdditionalDevices"];
            this.noOfParkingSpaces = _data["noOfParkingSpaces"];
            this.noOfIncludedParkingSpaces = _data["noOfIncludedParkingSpaces"];
            this.noOfAdditionalParkingSpaces = _data["noOfAdditionalParkingSpaces"];
            this.noOfAdditionalParkingSpacesCat1 = _data["noOfAdditionalParkingSpacesCat1"];
            this.priceForAdditionalParkingSpacesCat1 = _data["priceForAdditionalParkingSpacesCat1"];
            this.noOfAdditionalParkingSpacesCat2 = _data["noOfAdditionalParkingSpacesCat2"];
            this.priceForAdditionalParkingSpacesCat2 = _data["priceForAdditionalParkingSpacesCat2"];
            this.noOfAdditionalParkingSpacesCat3 = _data["noOfAdditionalParkingSpacesCat3"];
            this.priceForAdditionalParkingSpacesCat3 = _data["priceForAdditionalParkingSpacesCat3"];
            this.noOfAdditionalParkingSpacesCat4 = _data["noOfAdditionalParkingSpacesCat4"];
            this.priceForAdditionalParkingSpacesCat4 = _data["priceForAdditionalParkingSpacesCat4"];
            this.priceForAdditionalParkingSpaces = _data["priceForAdditionalParkingSpaces"];
            this.noOfParkers = _data["noOfParkers"];
            this.noOfIncludedParkers = _data["noOfIncludedParkers"];
            this.noOfAdditionalParkers = _data["noOfAdditionalParkers"];
            this.noOfAdditionalParkersCat1 = _data["noOfAdditionalParkersCat1"];
            this.priceForAdditionalParkersCat1 = _data["priceForAdditionalParkersCat1"];
            this.noOfAdditionalParkersCat2 = _data["noOfAdditionalParkersCat2"];
            this.priceForAdditionalParkersCat2 = _data["priceForAdditionalParkersCat2"];
            this.noOfAdditionalParkersCat3 = _data["noOfAdditionalParkersCat3"];
            this.priceForAdditionalParkersCat3 = _data["priceForAdditionalParkersCat3"];
            this.noOfAdditionalParkersCat4 = _data["noOfAdditionalParkersCat4"];
            this.priceForAdditionalParkersCat4 = _data["priceForAdditionalParkersCat4"];
            this.priceForAdditionalParkers = _data["priceForAdditionalParkers"];
            this.priceForThirdPartyInterface = _data["priceForThirdPartyInterface"];
            this.lprImageSavingEnabled = _data["lprImageSavingEnabled"];
            this.noOfImageMBs = _data["noOfImageMBs"];
            this.imageStoragePricePerMB = _data["imageStoragePricePerMB"];
            this.priceForImageStorage = _data["priceForImageStorage"];
            this.totalCosts = _data["totalCosts"];
        }
    }

    static fromJS(data: any): ClientFinancialPriceReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientFinancialPriceReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialClientInfo"] = this.financialClientInfo ? this.financialClientInfo.toJSON() : undefined as any;
        data["reportStartDate"] = this.reportStartDate ? this.reportStartDate.toString() : undefined as any;
        data["reportEndDate"] = this.reportEndDate ? this.reportEndDate.toString() : undefined as any;
        data["basePricePerMonth"] = this.basePricePerMonth;
        data["feesPaidByParkingSpaceOwner"] = this.feesPaidByParkingSpaceOwner;
        data["noOfClientAdmins"] = this.noOfClientAdmins;
        data["noOfIncludedClientAdmins"] = this.noOfIncludedClientAdmins;
        data["noOfAdditionalClientAdmins"] = this.noOfAdditionalClientAdmins;
        data["pricePerAdditionalClientAdmin"] = this.pricePerAdditionalClientAdmin;
        data["priceForAdditionalClientAdmins"] = this.priceForAdditionalClientAdmins;
        data["noOfClientUsers"] = this.noOfClientUsers;
        data["noOfIncludedClientUsers"] = this.noOfIncludedClientUsers;
        data["noOfAdditionalClientUsers"] = this.noOfAdditionalClientUsers;
        data["pricePerAdditionalClientUser"] = this.pricePerAdditionalClientUser;
        data["priceForAdditionalClientUsers"] = this.priceForAdditionalClientUsers;
        data["noOfParkingRangers"] = this.noOfParkingRangers;
        data["noOfIncludedParkingRangers"] = this.noOfIncludedParkingRangers;
        data["noOfAdditionalParkingRangers"] = this.noOfAdditionalParkingRangers;
        data["pricePerAdditionalParkingRanger"] = this.pricePerAdditionalParkingRanger;
        data["priceForAdditionalParkingRangers"] = this.priceForAdditionalParkingRangers;
        data["noOfProxies"] = this.noOfProxies;
        data["noOfIncludedProxies"] = this.noOfIncludedProxies;
        data["noOfAdditionalProxies"] = this.noOfAdditionalProxies;
        data["pricePerAdditionalProxy"] = this.pricePerAdditionalProxy;
        data["priceForAdditionalProxies"] = this.priceForAdditionalProxies;
        data["noOfDevices"] = this.noOfDevices;
        data["noOfIncludedDevices"] = this.noOfIncludedDevices;
        data["noOfAdditionalDevices"] = this.noOfAdditionalDevices;
        data["pricePerAdditionalDevice"] = this.pricePerAdditionalDevice;
        data["priceForAdditionalDevices"] = this.priceForAdditionalDevices;
        data["noOfParkingSpaces"] = this.noOfParkingSpaces;
        data["noOfIncludedParkingSpaces"] = this.noOfIncludedParkingSpaces;
        data["noOfAdditionalParkingSpaces"] = this.noOfAdditionalParkingSpaces;
        data["noOfAdditionalParkingSpacesCat1"] = this.noOfAdditionalParkingSpacesCat1;
        data["priceForAdditionalParkingSpacesCat1"] = this.priceForAdditionalParkingSpacesCat1;
        data["noOfAdditionalParkingSpacesCat2"] = this.noOfAdditionalParkingSpacesCat2;
        data["priceForAdditionalParkingSpacesCat2"] = this.priceForAdditionalParkingSpacesCat2;
        data["noOfAdditionalParkingSpacesCat3"] = this.noOfAdditionalParkingSpacesCat3;
        data["priceForAdditionalParkingSpacesCat3"] = this.priceForAdditionalParkingSpacesCat3;
        data["noOfAdditionalParkingSpacesCat4"] = this.noOfAdditionalParkingSpacesCat4;
        data["priceForAdditionalParkingSpacesCat4"] = this.priceForAdditionalParkingSpacesCat4;
        data["priceForAdditionalParkingSpaces"] = this.priceForAdditionalParkingSpaces;
        data["noOfParkers"] = this.noOfParkers;
        data["noOfIncludedParkers"] = this.noOfIncludedParkers;
        data["noOfAdditionalParkers"] = this.noOfAdditionalParkers;
        data["noOfAdditionalParkersCat1"] = this.noOfAdditionalParkersCat1;
        data["priceForAdditionalParkersCat1"] = this.priceForAdditionalParkersCat1;
        data["noOfAdditionalParkersCat2"] = this.noOfAdditionalParkersCat2;
        data["priceForAdditionalParkersCat2"] = this.priceForAdditionalParkersCat2;
        data["noOfAdditionalParkersCat3"] = this.noOfAdditionalParkersCat3;
        data["priceForAdditionalParkersCat3"] = this.priceForAdditionalParkersCat3;
        data["noOfAdditionalParkersCat4"] = this.noOfAdditionalParkersCat4;
        data["priceForAdditionalParkersCat4"] = this.priceForAdditionalParkersCat4;
        data["priceForAdditionalParkers"] = this.priceForAdditionalParkers;
        data["priceForThirdPartyInterface"] = this.priceForThirdPartyInterface;
        data["lprImageSavingEnabled"] = this.lprImageSavingEnabled;
        data["noOfImageMBs"] = this.noOfImageMBs;
        data["imageStoragePricePerMB"] = this.imageStoragePricePerMB;
        data["priceForImageStorage"] = this.priceForImageStorage;
        data["totalCosts"] = this.totalCosts;
        return data;
    }
}

export interface IClientFinancialPriceReportDTO {
    financialClientInfo?: FinancialClientInfoDTO | undefined;
    reportStartDate?: DateTime | undefined;
    reportEndDate?: DateTime | undefined;
    basePricePerMonth: number;
    feesPaidByParkingSpaceOwner: boolean;
    noOfClientAdmins: number;
    noOfIncludedClientAdmins: number;
    noOfAdditionalClientAdmins: number;
    pricePerAdditionalClientAdmin: number;
    priceForAdditionalClientAdmins: number;
    noOfClientUsers: number;
    noOfIncludedClientUsers: number;
    noOfAdditionalClientUsers: number;
    pricePerAdditionalClientUser: number;
    priceForAdditionalClientUsers: number;
    noOfParkingRangers: number;
    noOfIncludedParkingRangers: number;
    noOfAdditionalParkingRangers: number;
    pricePerAdditionalParkingRanger: number;
    priceForAdditionalParkingRangers: number;
    noOfProxies: number;
    noOfIncludedProxies: number;
    noOfAdditionalProxies: number;
    pricePerAdditionalProxy: number;
    priceForAdditionalProxies: number;
    noOfDevices: number;
    noOfIncludedDevices: number;
    noOfAdditionalDevices: number;
    pricePerAdditionalDevice: number;
    priceForAdditionalDevices: number;
    noOfParkingSpaces: number;
    noOfIncludedParkingSpaces: number;
    noOfAdditionalParkingSpaces: number;
    noOfAdditionalParkingSpacesCat1: number;
    priceForAdditionalParkingSpacesCat1?: number | undefined;
    noOfAdditionalParkingSpacesCat2: number;
    priceForAdditionalParkingSpacesCat2?: number | undefined;
    noOfAdditionalParkingSpacesCat3: number;
    priceForAdditionalParkingSpacesCat3?: number | undefined;
    noOfAdditionalParkingSpacesCat4: number;
    priceForAdditionalParkingSpacesCat4?: number | undefined;
    priceForAdditionalParkingSpaces: number;
    noOfParkers: number;
    noOfIncludedParkers: number;
    noOfAdditionalParkers: number;
    noOfAdditionalParkersCat1: number;
    priceForAdditionalParkersCat1?: number | undefined;
    noOfAdditionalParkersCat2: number;
    priceForAdditionalParkersCat2?: number | undefined;
    noOfAdditionalParkersCat3: number;
    priceForAdditionalParkersCat3?: number | undefined;
    noOfAdditionalParkersCat4: number;
    priceForAdditionalParkersCat4?: number | undefined;
    priceForAdditionalParkers: number;
    priceForThirdPartyInterface: number;
    lprImageSavingEnabled: boolean;
    noOfImageMBs: number;
    imageStoragePricePerMB: number;
    priceForImageStorage: number;
    totalCosts: number;
}

export class FinancialParkingSessionDTO implements IFinancialParkingSessionDTO {
    parkingSessionId!: number;
    clientId!: number;
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    durationInMinutes!: number;
    companyId?: number | undefined;
    companyName?: string | undefined;
    zoneId?: number | undefined;
    zoneName?: string | undefined;
    payedByParkingSpaceOwner!: boolean;
    paymentProviderUuid?: string | undefined;
    grossAmount!: number;
    totalVat!: number;
    netAmount!: number;
    grossParking!: number;
    parkingVat!: number;
    netParking!: number;
    grossService!: number;
    serviceVat!: number;
    netService!: number;

    constructor(data?: IFinancialParkingSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parkingSessionId = _data["parkingSessionId"];
            this.clientId = _data["clientId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.durationInMinutes = _data["durationInMinutes"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.zoneId = _data["zoneId"];
            this.zoneName = _data["zoneName"];
            this.payedByParkingSpaceOwner = _data["payedByParkingSpaceOwner"];
            this.paymentProviderUuid = _data["paymentProviderUuid"];
            this.grossAmount = _data["grossAmount"];
            this.totalVat = _data["totalVat"];
            this.netAmount = _data["netAmount"];
            this.grossParking = _data["grossParking"];
            this.parkingVat = _data["parkingVat"];
            this.netParking = _data["netParking"];
            this.grossService = _data["grossService"];
            this.serviceVat = _data["serviceVat"];
            this.netService = _data["netService"];
        }
    }

    static fromJS(data: any): FinancialParkingSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialParkingSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parkingSessionId"] = this.parkingSessionId;
        data["clientId"] = this.clientId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["durationInMinutes"] = this.durationInMinutes;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["zoneId"] = this.zoneId;
        data["zoneName"] = this.zoneName;
        data["payedByParkingSpaceOwner"] = this.payedByParkingSpaceOwner;
        data["paymentProviderUuid"] = this.paymentProviderUuid;
        data["grossAmount"] = this.grossAmount;
        data["totalVat"] = this.totalVat;
        data["netAmount"] = this.netAmount;
        data["grossParking"] = this.grossParking;
        data["parkingVat"] = this.parkingVat;
        data["netParking"] = this.netParking;
        data["grossService"] = this.grossService;
        data["serviceVat"] = this.serviceVat;
        data["netService"] = this.netService;
        return data;
    }
}

export interface IFinancialParkingSessionDTO {
    parkingSessionId: number;
    clientId: number;
    startDateTime: DateTime;
    endDateTime: DateTime;
    durationInMinutes: number;
    companyId?: number | undefined;
    companyName?: string | undefined;
    zoneId?: number | undefined;
    zoneName?: string | undefined;
    payedByParkingSpaceOwner: boolean;
    paymentProviderUuid?: string | undefined;
    grossAmount: number;
    totalVat: number;
    netAmount: number;
    grossParking: number;
    parkingVat: number;
    netParking: number;
    grossService: number;
    serviceVat: number;
    netService: number;
}

export class PagedResultDTOOfFleetListEntryDTO implements IPagedResultDTOOfFleetListEntryDTO {
    items?: FleetListEntryDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfFleetListEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FleetListEntryDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfFleetListEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfFleetListEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfFleetListEntryDTO {
    items?: FleetListEntryDTO[] | undefined;
    totalNumberOfItems: number;
}

export class FleetListEntryDTO implements IFleetListEntryDTO {
    id!: number;
    clientId!: number;
    client?: ClientLimitedDTO | undefined;
    companyId?: number | undefined;
    company?: ParkerCompanyDTO | undefined;
    countryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    controlPlateType!: ControlPlateType;
    description?: string | undefined;
    type!: FleetListEntryType;
    tagIdent?: string | undefined;

    constructor(data?: IFleetListEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ClientLimitedDTO.fromJS(_data["client"]) : undefined as any;
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? ParkerCompanyDTO.fromJS(_data["company"]) : undefined as any;
            this.countryCode = _data["countryCode"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.controlPlateType = _data["controlPlateType"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.tagIdent = _data["tagIdent"];
        }
    }

    static fromJS(data: any): FleetListEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FleetListEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : undefined as any;
        data["countryCode"] = this.countryCode;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["controlPlateType"] = this.controlPlateType;
        data["description"] = this.description;
        data["type"] = this.type;
        data["tagIdent"] = this.tagIdent;
        return data;
    }
}

export interface IFleetListEntryDTO {
    id: number;
    clientId: number;
    client?: ClientLimitedDTO | undefined;
    companyId?: number | undefined;
    company?: ParkerCompanyDTO | undefined;
    countryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    controlPlateType: ControlPlateType;
    description?: string | undefined;
    type: FleetListEntryType;
    tagIdent?: string | undefined;
}

export enum FleetListEntryType {
    Undefined = 0,
    FleetVehicle = 1,
    EmployeeVehicle = 2,
    GuestVehicle = 3,
}

export class StartForeignParkingPaymentProcessDTO implements IStartForeignParkingPaymentProcessDTO {
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    maxIntendedParkingDurationMinutes!: number;
    subscriptionId!: number;
    controlPlateType!: ControlPlateType;
    controlPlateCountryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    parkingSpaceNumber?: string | undefined;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    zoneId!: number;

    constructor(data?: IStartForeignParkingPaymentProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentAliasId = _data["paymentAliasId"];
            this.directPayPaymentType = _data["directPayPaymentType"];
            this.maxIntendedParkingDurationMinutes = _data["maxIntendedParkingDurationMinutes"];
            this.subscriptionId = _data["subscriptionId"];
            this.controlPlateType = _data["controlPlateType"];
            this.controlPlateCountryCode = _data["controlPlateCountryCode"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : undefined as any;
            this.fallbackParkingPriceDetails = _data["fallbackParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["fallbackParkingPriceDetails"]) : undefined as any;
            this.zoneId = _data["zoneId"];
        }
    }

    static fromJS(data: any): StartForeignParkingPaymentProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StartForeignParkingPaymentProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentAliasId"] = this.paymentAliasId;
        data["directPayPaymentType"] = this.directPayPaymentType;
        data["maxIntendedParkingDurationMinutes"] = this.maxIntendedParkingDurationMinutes;
        data["subscriptionId"] = this.subscriptionId;
        data["controlPlateType"] = this.controlPlateType;
        data["controlPlateCountryCode"] = this.controlPlateCountryCode;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        data["fallbackParkingPriceDetails"] = this.fallbackParkingPriceDetails ? this.fallbackParkingPriceDetails.toJSON() : undefined as any;
        data["zoneId"] = this.zoneId;
        return data;
    }
}

export interface IStartForeignParkingPaymentProcessDTO {
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    maxIntendedParkingDurationMinutes: number;
    subscriptionId: number;
    controlPlateType: ControlPlateType;
    controlPlateCountryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    parkingSpaceNumber?: string | undefined;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    zoneId: number;
}

export enum PaymentType {
    Card = 0,
    Paypal = 1,
    Twint = 2,
    Unknown = 3,
}

export class CheckForeignParkingPaymentResponseDTO implements ICheckForeignParkingPaymentResponseDTO {
    paymentId!: number;
    success!: boolean;
    errorDescription?: string | undefined;
    offense?: ParkerRegistrationOffense | undefined;

    constructor(data?: ICheckForeignParkingPaymentResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.success = _data["success"];
            this.errorDescription = _data["errorDescription"];
            this.offense = _data["offense"];
        }
    }

    static fromJS(data: any): CheckForeignParkingPaymentResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckForeignParkingPaymentResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["success"] = this.success;
        data["errorDescription"] = this.errorDescription;
        data["offense"] = this.offense;
        return data;
    }
}

export interface ICheckForeignParkingPaymentResponseDTO {
    paymentId: number;
    success: boolean;
    errorDescription?: string | undefined;
    offense?: ParkerRegistrationOffense | undefined;
}

export class CheckForeignParkingPaymentDTO implements ICheckForeignParkingPaymentDTO {
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    paymentId!: number;

    constructor(data?: ICheckForeignParkingPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentAliasId = _data["paymentAliasId"];
            this.directPayPaymentType = _data["directPayPaymentType"];
            this.paymentId = _data["paymentId"];
        }
    }

    static fromJS(data: any): CheckForeignParkingPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckForeignParkingPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentAliasId"] = this.paymentAliasId;
        data["directPayPaymentType"] = this.directPayPaymentType;
        data["paymentId"] = this.paymentId;
        return data;
    }
}

export interface ICheckForeignParkingPaymentDTO {
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    paymentId: number;
}

export class CancelForeignParkingPaymentResponseDTO implements ICancelForeignParkingPaymentResponseDTO {
    paymentId!: number;
    success!: boolean;
    errorDescription?: string | undefined;
    offense?: ParkerRegistrationOffense | undefined;

    constructor(data?: ICancelForeignParkingPaymentResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.success = _data["success"];
            this.errorDescription = _data["errorDescription"];
            this.offense = _data["offense"];
        }
    }

    static fromJS(data: any): CancelForeignParkingPaymentResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CancelForeignParkingPaymentResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["success"] = this.success;
        data["errorDescription"] = this.errorDescription;
        data["offense"] = this.offense;
        return data;
    }
}

export interface ICancelForeignParkingPaymentResponseDTO {
    paymentId: number;
    success: boolean;
    errorDescription?: string | undefined;
    offense?: ParkerRegistrationOffense | undefined;
}

export class CancelForeignParkingPaymentDTO implements ICancelForeignParkingPaymentDTO {
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    paymentId!: number;

    constructor(data?: ICancelForeignParkingPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentAliasId = _data["paymentAliasId"];
            this.directPayPaymentType = _data["directPayPaymentType"];
            this.paymentId = _data["paymentId"];
        }
    }

    static fromJS(data: any): CancelForeignParkingPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CancelForeignParkingPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentAliasId"] = this.paymentAliasId;
        data["directPayPaymentType"] = this.directPayPaymentType;
        data["paymentId"] = this.paymentId;
        return data;
    }
}

export interface ICancelForeignParkingPaymentDTO {
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    paymentId: number;
}

export class CheckinUserParkingRegistrationDTO implements ICheckinUserParkingRegistrationDTO {
    sessionId!: number;
    registrationDateTime!: DateTime;
    state!: ParkingRegistrationState;
    offense!: ParkerRegistrationOffense;
    clientId?: number | undefined;
    clientName?: string | undefined;
    companyId?: number | undefined;
    subscriptionAssignment?: ParkerSubscriptionAssignmentDTO | undefined;
    zoneId?: number | undefined;
    zone?: ParkingProcessLimitedZoneWithParentInfoDTO | undefined;
    maxIntendedParkingDurationMinutes?: number | undefined;
    parkingSpaceNumber?: string | undefined;
    controlPlateNumber?: string | undefined;
    controlPlateCountryCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    reservedAmount?: number | undefined;
    currency?: Currency | undefined;
    paymentAliasId?: number | undefined;
    paymentMethod?: string | undefined;
    calculatedParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    automaticScheduleEndTime?: DateTime | undefined;
    sessionOpeningEventType!: SessionEventType;
    visitorSessionIdToValidate?: number | undefined;
    visitorSessionToValidateUntil?: DateTime | undefined;
    validationFallbackSubscriptionName?: string | undefined;
    isSessionExtendable?: boolean | undefined;
    validatedByParkingCard!: boolean;

    constructor(data?: ICheckinUserParkingRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.registrationDateTime = _data["registrationDateTime"] ? DateTime.fromISO(_data["registrationDateTime"].toString()) : undefined as any;
            this.state = _data["state"];
            this.offense = _data["offense"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.companyId = _data["companyId"];
            this.subscriptionAssignment = _data["subscriptionAssignment"] ? ParkerSubscriptionAssignmentDTO.fromJS(_data["subscriptionAssignment"]) : undefined as any;
            this.zoneId = _data["zoneId"];
            this.zone = _data["zone"] ? ParkingProcessLimitedZoneWithParentInfoDTO.fromJS(_data["zone"]) : undefined as any;
            this.maxIntendedParkingDurationMinutes = _data["maxIntendedParkingDurationMinutes"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.controlPlateCountryCode = _data["controlPlateCountryCode"];
            this.controlPlateType = _data["controlPlateType"];
            this.reservedAmount = _data["reservedAmount"];
            this.currency = _data["currency"];
            this.paymentAliasId = _data["paymentAliasId"];
            this.paymentMethod = _data["paymentMethod"];
            this.calculatedParkingPriceDetails = _data["calculatedParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["calculatedParkingPriceDetails"]) : undefined as any;
            this.automaticScheduleEndTime = _data["automaticScheduleEndTime"] ? DateTime.fromISO(_data["automaticScheduleEndTime"].toString()) : undefined as any;
            this.sessionOpeningEventType = _data["sessionOpeningEventType"];
            this.visitorSessionIdToValidate = _data["visitorSessionIdToValidate"];
            this.visitorSessionToValidateUntil = _data["visitorSessionToValidateUntil"] ? DateTime.fromISO(_data["visitorSessionToValidateUntil"].toString()) : undefined as any;
            this.validationFallbackSubscriptionName = _data["validationFallbackSubscriptionName"];
            this.isSessionExtendable = _data["isSessionExtendable"];
            this.validatedByParkingCard = _data["validatedByParkingCard"];
        }
    }

    static fromJS(data: any): CheckinUserParkingRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinUserParkingRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["registrationDateTime"] = this.registrationDateTime ? this.registrationDateTime.toString() : undefined as any;
        data["state"] = this.state;
        data["offense"] = this.offense;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["companyId"] = this.companyId;
        data["subscriptionAssignment"] = this.subscriptionAssignment ? this.subscriptionAssignment.toJSON() : undefined as any;
        data["zoneId"] = this.zoneId;
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        data["maxIntendedParkingDurationMinutes"] = this.maxIntendedParkingDurationMinutes;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["controlPlateCountryCode"] = this.controlPlateCountryCode;
        data["controlPlateType"] = this.controlPlateType;
        data["reservedAmount"] = this.reservedAmount;
        data["currency"] = this.currency;
        data["paymentAliasId"] = this.paymentAliasId;
        data["paymentMethod"] = this.paymentMethod;
        data["calculatedParkingPriceDetails"] = this.calculatedParkingPriceDetails ? this.calculatedParkingPriceDetails.toJSON() : undefined as any;
        data["automaticScheduleEndTime"] = this.automaticScheduleEndTime ? this.automaticScheduleEndTime.toString() : undefined as any;
        data["sessionOpeningEventType"] = this.sessionOpeningEventType;
        data["visitorSessionIdToValidate"] = this.visitorSessionIdToValidate;
        data["visitorSessionToValidateUntil"] = this.visitorSessionToValidateUntil ? this.visitorSessionToValidateUntil.toString() : undefined as any;
        data["validationFallbackSubscriptionName"] = this.validationFallbackSubscriptionName;
        data["isSessionExtendable"] = this.isSessionExtendable;
        data["validatedByParkingCard"] = this.validatedByParkingCard;
        return data;
    }
}

export interface ICheckinUserParkingRegistrationDTO {
    sessionId: number;
    registrationDateTime: DateTime;
    state: ParkingRegistrationState;
    offense: ParkerRegistrationOffense;
    clientId?: number | undefined;
    clientName?: string | undefined;
    companyId?: number | undefined;
    subscriptionAssignment?: ParkerSubscriptionAssignmentDTO | undefined;
    zoneId?: number | undefined;
    zone?: ParkingProcessLimitedZoneWithParentInfoDTO | undefined;
    maxIntendedParkingDurationMinutes?: number | undefined;
    parkingSpaceNumber?: string | undefined;
    controlPlateNumber?: string | undefined;
    controlPlateCountryCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    reservedAmount?: number | undefined;
    currency?: Currency | undefined;
    paymentAliasId?: number | undefined;
    paymentMethod?: string | undefined;
    calculatedParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    automaticScheduleEndTime?: DateTime | undefined;
    sessionOpeningEventType: SessionEventType;
    visitorSessionIdToValidate?: number | undefined;
    visitorSessionToValidateUntil?: DateTime | undefined;
    validationFallbackSubscriptionName?: string | undefined;
    isSessionExtendable?: boolean | undefined;
    validatedByParkingCard: boolean;
}

export abstract class CheckinUserParkingBaseDTO implements ICheckinUserParkingBaseDTO {
    zoneId!: number;
    controlPlateType!: ControlPlateType;
    controlPlateCountryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    parkingSpaceNumber?: string | undefined;

    constructor(data?: ICheckinUserParkingBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.controlPlateType = _data["controlPlateType"];
            this.controlPlateCountryCode = _data["controlPlateCountryCode"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
        }
    }

    static fromJS(data: any): CheckinUserParkingBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CheckinUserParkingBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["controlPlateType"] = this.controlPlateType;
        data["controlPlateCountryCode"] = this.controlPlateCountryCode;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        return data;
    }
}

export interface ICheckinUserParkingBaseDTO {
    zoneId: number;
    controlPlateType: ControlPlateType;
    controlPlateCountryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    parkingSpaceNumber?: string | undefined;
}

export class CheckinUserForeignParkingDTO extends CheckinUserParkingBaseDTO implements ICheckinUserForeignParkingDTO {
    maxIntendedParkingDurationMinutes!: number;
    selectedSubscriptionId!: number;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    paymentId?: number | undefined;

    constructor(data?: ICheckinUserForeignParkingDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.maxIntendedParkingDurationMinutes = _data["maxIntendedParkingDurationMinutes"];
            this.selectedSubscriptionId = _data["selectedSubscriptionId"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : undefined as any;
            this.fallbackParkingPriceDetails = _data["fallbackParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["fallbackParkingPriceDetails"]) : undefined as any;
            this.paymentId = _data["paymentId"];
        }
    }

    static override fromJS(data: any): CheckinUserForeignParkingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinUserForeignParkingDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxIntendedParkingDurationMinutes"] = this.maxIntendedParkingDurationMinutes;
        data["selectedSubscriptionId"] = this.selectedSubscriptionId;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        data["fallbackParkingPriceDetails"] = this.fallbackParkingPriceDetails ? this.fallbackParkingPriceDetails.toJSON() : undefined as any;
        data["paymentId"] = this.paymentId;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckinUserForeignParkingDTO extends ICheckinUserParkingBaseDTO {
    maxIntendedParkingDurationMinutes: number;
    selectedSubscriptionId: number;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    paymentId?: number | undefined;
}

export class PaymentFailedDTO implements IPaymentFailedDTO {
    altPaymentIdent!: string;

    constructor(data?: IPaymentFailedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.altPaymentIdent = _data["altPaymentIdent"];
        }
    }

    static fromJS(data: any): PaymentFailedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentFailedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["altPaymentIdent"] = this.altPaymentIdent;
        return data;
    }
}

export interface IPaymentFailedDTO {
    altPaymentIdent: string;
}

export class CreateParkerCompanyDTO implements ICreateParkerCompanyDTO {
    clientId!: number;
    name!: string;

    constructor(data?: ICreateParkerCompanyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateParkerCompanyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkerCompanyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateParkerCompanyDTO {
    clientId: number;
    name: string;
}

export class PagedResultDTOOfParkerCompanyDTO implements IPagedResultDTOOfParkerCompanyDTO {
    items?: ParkerCompanyDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkerCompanyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkerCompanyDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkerCompanyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkerCompanyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkerCompanyDTO {
    items?: ParkerCompanyDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UpdateParkerCompanyDTO implements IUpdateParkerCompanyDTO {
    id!: number;
    active!: boolean;
    name?: string | undefined;

    constructor(data?: IUpdateParkerCompanyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateParkerCompanyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParkerCompanyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateParkerCompanyDTO {
    id: number;
    active: boolean;
    name?: string | undefined;
}

export class CreateParkerDTO implements ICreateParkerDTO {
    clientId!: number;
    firstName!: string;
    lastName!: string;
    identification?: string | undefined;
    group!: ParkerGroup;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    email?: string | undefined;
    privateAddress?: string | undefined;
    privateZIP?: string | undefined;
    privateCity?: string | undefined;
    privateCountry?: string | undefined;
    companyId?: number | undefined;
    costCenter?: string | undefined;
    title?: string | undefined;
    entryDate!: DateTime;
    exitDate?: DateTime | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    billing!: boolean;
    active!: boolean;
    workplace?: string | undefined;
    employmentPercentage!: number;
    billingCurrency!: Currency;
    tags?: CreateParkerTagDTO[] | undefined;
    parkerSubscriptionAssignments?: UpdateParkerSubscriptionAssignmentDTO[] | undefined;
    custom1?: string | undefined;
    custom2?: string | undefined;
    custom3?: string | undefined;
    custom4?: string | undefined;
    custom5?: string | undefined;
    custom6?: string | undefined;
    custom7?: string | undefined;
    custom8?: string | undefined;
    custom9?: string | undefined;
    comment?: string | undefined;

    constructor(data?: ICreateParkerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.identification = _data["identification"];
            this.group = _data["group"];
            this.address = _data["address"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.email = _data["email"];
            this.privateAddress = _data["privateAddress"];
            this.privateZIP = _data["privateZIP"];
            this.privateCity = _data["privateCity"];
            this.privateCountry = _data["privateCountry"];
            this.companyId = _data["companyId"];
            this.costCenter = _data["costCenter"];
            this.title = _data["title"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : undefined as any;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : undefined as any;
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.billing = _data["billing"];
            this.active = _data["active"];
            this.workplace = _data["workplace"];
            this.employmentPercentage = _data["employmentPercentage"];
            this.billingCurrency = _data["billingCurrency"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(CreateParkerTagDTO.fromJS(item));
            }
            if (Array.isArray(_data["parkerSubscriptionAssignments"])) {
                this.parkerSubscriptionAssignments = [] as any;
                for (let item of _data["parkerSubscriptionAssignments"])
                    this.parkerSubscriptionAssignments!.push(UpdateParkerSubscriptionAssignmentDTO.fromJS(item));
            }
            this.custom1 = _data["custom1"];
            this.custom2 = _data["custom2"];
            this.custom3 = _data["custom3"];
            this.custom4 = _data["custom4"];
            this.custom5 = _data["custom5"];
            this.custom6 = _data["custom6"];
            this.custom7 = _data["custom7"];
            this.custom8 = _data["custom8"];
            this.custom9 = _data["custom9"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateParkerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["identification"] = this.identification;
        data["group"] = this.group;
        data["address"] = this.address;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["email"] = this.email;
        data["privateAddress"] = this.privateAddress;
        data["privateZIP"] = this.privateZIP;
        data["privateCity"] = this.privateCity;
        data["privateCountry"] = this.privateCountry;
        data["companyId"] = this.companyId;
        data["costCenter"] = this.costCenter;
        data["title"] = this.title;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : undefined as any;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : undefined as any;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["billing"] = this.billing;
        data["active"] = this.active;
        data["workplace"] = this.workplace;
        data["employmentPercentage"] = this.employmentPercentage;
        data["billingCurrency"] = this.billingCurrency;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parkerSubscriptionAssignments)) {
            data["parkerSubscriptionAssignments"] = [];
            for (let item of this.parkerSubscriptionAssignments)
                data["parkerSubscriptionAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        data["custom1"] = this.custom1;
        data["custom2"] = this.custom2;
        data["custom3"] = this.custom3;
        data["custom4"] = this.custom4;
        data["custom5"] = this.custom5;
        data["custom6"] = this.custom6;
        data["custom7"] = this.custom7;
        data["custom8"] = this.custom8;
        data["custom9"] = this.custom9;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICreateParkerDTO {
    clientId: number;
    firstName: string;
    lastName: string;
    identification?: string | undefined;
    group: ParkerGroup;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    email?: string | undefined;
    privateAddress?: string | undefined;
    privateZIP?: string | undefined;
    privateCity?: string | undefined;
    privateCountry?: string | undefined;
    companyId?: number | undefined;
    costCenter?: string | undefined;
    title?: string | undefined;
    entryDate: DateTime;
    exitDate?: DateTime | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    billing: boolean;
    active: boolean;
    workplace?: string | undefined;
    employmentPercentage: number;
    billingCurrency: Currency;
    tags?: CreateParkerTagDTO[] | undefined;
    parkerSubscriptionAssignments?: UpdateParkerSubscriptionAssignmentDTO[] | undefined;
    custom1?: string | undefined;
    custom2?: string | undefined;
    custom3?: string | undefined;
    custom4?: string | undefined;
    custom5?: string | undefined;
    custom6?: string | undefined;
    custom7?: string | undefined;
    custom8?: string | undefined;
    custom9?: string | undefined;
    comment?: string | undefined;
}

export class CreateParkerTagDTO implements ICreateParkerTagDTO {
    clientId!: number;
    parkerId!: number;
    identificationCode?: string | undefined;
    controlPlateType!: ControlPlateType;
    countryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    description?: string | undefined;
    barcode?: string | undefined;
    active!: boolean;
    defect!: boolean;

    constructor(data?: ICreateParkerTagDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.parkerId = _data["parkerId"];
            this.identificationCode = _data["identificationCode"];
            this.controlPlateType = _data["controlPlateType"];
            this.countryCode = _data["countryCode"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.description = _data["description"];
            this.barcode = _data["barcode"];
            this.active = _data["active"];
            this.defect = _data["defect"];
        }
    }

    static fromJS(data: any): CreateParkerTagDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkerTagDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["parkerId"] = this.parkerId;
        data["identificationCode"] = this.identificationCode;
        data["controlPlateType"] = this.controlPlateType;
        data["countryCode"] = this.countryCode;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["description"] = this.description;
        data["barcode"] = this.barcode;
        data["active"] = this.active;
        data["defect"] = this.defect;
        return data;
    }
}

export interface ICreateParkerTagDTO {
    clientId: number;
    parkerId: number;
    identificationCode?: string | undefined;
    controlPlateType: ControlPlateType;
    countryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    description?: string | undefined;
    barcode?: string | undefined;
    active: boolean;
    defect: boolean;
}

export class UpdateParkerSubscriptionAssignmentDTO implements IUpdateParkerSubscriptionAssignmentDTO {
    id!: number;
    active!: boolean;
    subscriptionId!: number;
    validFrom!: DateTime;
    validTo?: DateTime | undefined;
    isFavorite!: boolean;

    constructor(data?: IUpdateParkerSubscriptionAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.subscriptionId = _data["subscriptionId"];
            this.validFrom = _data["validFrom"] ? DateTime.fromISO(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : undefined as any;
            this.isFavorite = _data["isFavorite"];
        }
    }

    static fromJS(data: any): UpdateParkerSubscriptionAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParkerSubscriptionAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["subscriptionId"] = this.subscriptionId;
        data["validFrom"] = this.validFrom ? this.validFrom.toString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toString() : undefined as any;
        data["isFavorite"] = this.isFavorite;
        return data;
    }
}

export interface IUpdateParkerSubscriptionAssignmentDTO {
    id: number;
    active: boolean;
    subscriptionId: number;
    validFrom: DateTime;
    validTo?: DateTime | undefined;
    isFavorite: boolean;
}

export class ParkerLimitedDTO implements IParkerLimitedDTO {
    id!: number;
    clientId!: number;
    identification?: string | undefined;
    tagIds?: number[] | undefined;
    active!: boolean;

    constructor(data?: IParkerLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.identification = _data["identification"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ParkerLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["identification"] = this.identification;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["active"] = this.active;
        return data;
    }
}

export interface IParkerLimitedDTO {
    id: number;
    clientId: number;
    identification?: string | undefined;
    tagIds?: number[] | undefined;
    active: boolean;
}

export class UpdateParkerDTO implements IUpdateParkerDTO {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    identification?: string | undefined;
    group!: ParkerGroup;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    privateAddress?: string | undefined;
    privateZIP?: string | undefined;
    privateCity?: string | undefined;
    privateCountry?: string | undefined;
    email?: string | undefined;
    companyId?: number | undefined;
    costCenter?: string | undefined;
    title?: string | undefined;
    entryDate?: DateTime | undefined;
    exitDate?: DateTime | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    billing?: boolean | undefined;
    active?: boolean | undefined;
    workplace?: string | undefined;
    employmentPercentage?: number | undefined;
    billingCurrency!: Currency;
    tags?: UpdateParkerTagDTO[] | undefined;
    parkerSubscriptionAssignments?: UpdateParkerSubscriptionAssignmentDTO[] | undefined;
    custom1?: string | undefined;
    custom2?: string | undefined;
    custom3?: string | undefined;
    custom4?: string | undefined;
    custom5?: string | undefined;
    custom6?: string | undefined;
    custom7?: string | undefined;
    custom8?: string | undefined;
    custom9?: string | undefined;
    comment?: string | undefined;
    activeParkingPermitGuid?: string | undefined;
    parkingPermitValidityPeriod?: number | undefined;

    constructor(data?: IUpdateParkerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.identification = _data["identification"];
            this.group = _data["group"];
            this.address = _data["address"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.privateAddress = _data["privateAddress"];
            this.privateZIP = _data["privateZIP"];
            this.privateCity = _data["privateCity"];
            this.privateCountry = _data["privateCountry"];
            this.email = _data["email"];
            this.companyId = _data["companyId"];
            this.costCenter = _data["costCenter"];
            this.title = _data["title"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : undefined as any;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : undefined as any;
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.billing = _data["billing"];
            this.active = _data["active"];
            this.workplace = _data["workplace"];
            this.employmentPercentage = _data["employmentPercentage"];
            this.billingCurrency = _data["billingCurrency"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(UpdateParkerTagDTO.fromJS(item));
            }
            if (Array.isArray(_data["parkerSubscriptionAssignments"])) {
                this.parkerSubscriptionAssignments = [] as any;
                for (let item of _data["parkerSubscriptionAssignments"])
                    this.parkerSubscriptionAssignments!.push(UpdateParkerSubscriptionAssignmentDTO.fromJS(item));
            }
            this.custom1 = _data["custom1"];
            this.custom2 = _data["custom2"];
            this.custom3 = _data["custom3"];
            this.custom4 = _data["custom4"];
            this.custom5 = _data["custom5"];
            this.custom6 = _data["custom6"];
            this.custom7 = _data["custom7"];
            this.custom8 = _data["custom8"];
            this.custom9 = _data["custom9"];
            this.comment = _data["comment"];
            this.activeParkingPermitGuid = _data["activeParkingPermitGuid"];
            this.parkingPermitValidityPeriod = _data["parkingPermitValidityPeriod"];
        }
    }

    static fromJS(data: any): UpdateParkerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParkerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["identification"] = this.identification;
        data["group"] = this.group;
        data["address"] = this.address;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["privateAddress"] = this.privateAddress;
        data["privateZIP"] = this.privateZIP;
        data["privateCity"] = this.privateCity;
        data["privateCountry"] = this.privateCountry;
        data["email"] = this.email;
        data["companyId"] = this.companyId;
        data["costCenter"] = this.costCenter;
        data["title"] = this.title;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : undefined as any;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : undefined as any;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["billing"] = this.billing;
        data["active"] = this.active;
        data["workplace"] = this.workplace;
        data["employmentPercentage"] = this.employmentPercentage;
        data["billingCurrency"] = this.billingCurrency;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parkerSubscriptionAssignments)) {
            data["parkerSubscriptionAssignments"] = [];
            for (let item of this.parkerSubscriptionAssignments)
                data["parkerSubscriptionAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        data["custom1"] = this.custom1;
        data["custom2"] = this.custom2;
        data["custom3"] = this.custom3;
        data["custom4"] = this.custom4;
        data["custom5"] = this.custom5;
        data["custom6"] = this.custom6;
        data["custom7"] = this.custom7;
        data["custom8"] = this.custom8;
        data["custom9"] = this.custom9;
        data["comment"] = this.comment;
        data["activeParkingPermitGuid"] = this.activeParkingPermitGuid;
        data["parkingPermitValidityPeriod"] = this.parkingPermitValidityPeriod;
        return data;
    }
}

export interface IUpdateParkerDTO {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    identification?: string | undefined;
    group: ParkerGroup;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    privateAddress?: string | undefined;
    privateZIP?: string | undefined;
    privateCity?: string | undefined;
    privateCountry?: string | undefined;
    email?: string | undefined;
    companyId?: number | undefined;
    costCenter?: string | undefined;
    title?: string | undefined;
    entryDate?: DateTime | undefined;
    exitDate?: DateTime | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    billing?: boolean | undefined;
    active?: boolean | undefined;
    workplace?: string | undefined;
    employmentPercentage?: number | undefined;
    billingCurrency: Currency;
    tags?: UpdateParkerTagDTO[] | undefined;
    parkerSubscriptionAssignments?: UpdateParkerSubscriptionAssignmentDTO[] | undefined;
    custom1?: string | undefined;
    custom2?: string | undefined;
    custom3?: string | undefined;
    custom4?: string | undefined;
    custom5?: string | undefined;
    custom6?: string | undefined;
    custom7?: string | undefined;
    custom8?: string | undefined;
    custom9?: string | undefined;
    comment?: string | undefined;
    activeParkingPermitGuid?: string | undefined;
    parkingPermitValidityPeriod?: number | undefined;
}

export class UpdateParkerTagDTO implements IUpdateParkerTagDTO {
    id!: number;
    identificationCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    countryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    description?: string | undefined;
    barcode?: string | undefined;
    active?: boolean | undefined;
    defect?: boolean | undefined;
    enableAutomaticPlateRecognitionParking?: boolean | undefined;

    constructor(data?: IUpdateParkerTagDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identificationCode = _data["identificationCode"];
            this.controlPlateType = _data["controlPlateType"];
            this.countryCode = _data["countryCode"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.description = _data["description"];
            this.barcode = _data["barcode"];
            this.active = _data["active"];
            this.defect = _data["defect"];
            this.enableAutomaticPlateRecognitionParking = _data["enableAutomaticPlateRecognitionParking"];
        }
    }

    static fromJS(data: any): UpdateParkerTagDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParkerTagDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identificationCode"] = this.identificationCode;
        data["controlPlateType"] = this.controlPlateType;
        data["countryCode"] = this.countryCode;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["description"] = this.description;
        data["barcode"] = this.barcode;
        data["active"] = this.active;
        data["defect"] = this.defect;
        data["enableAutomaticPlateRecognitionParking"] = this.enableAutomaticPlateRecognitionParking;
        return data;
    }
}

export interface IUpdateParkerTagDTO {
    id: number;
    identificationCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    countryCode?: string | undefined;
    controlPlateNumber?: string | undefined;
    description?: string | undefined;
    barcode?: string | undefined;
    active?: boolean | undefined;
    defect?: boolean | undefined;
    enableAutomaticPlateRecognitionParking?: boolean | undefined;
}

export class SetParkerStatusDTO implements ISetParkerStatusDTO {
    id!: number;
    active!: boolean;

    constructor(data?: ISetParkerStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): SetParkerStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetParkerStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        return data;
    }
}

export interface ISetParkerStatusDTO {
    id: number;
    active: boolean;
}

export class LinkParkerToUserResultDTO implements ILinkParkerToUserResultDTO {
    success!: boolean;
    error?: LinkParkerToUserResultError | undefined;
    errorDescription?: string | undefined;
    parker?: ParkerDTO | undefined;

    constructor(data?: ILinkParkerToUserResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.errorDescription = _data["errorDescription"];
            this.parker = _data["parker"] ? ParkerDTO.fromJS(_data["parker"]) : undefined as any;
        }
    }

    static fromJS(data: any): LinkParkerToUserResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LinkParkerToUserResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["errorDescription"] = this.errorDescription;
        data["parker"] = this.parker ? this.parker.toJSON() : undefined as any;
        return data;
    }
}

export interface ILinkParkerToUserResultDTO {
    success: boolean;
    error?: LinkParkerToUserResultError | undefined;
    errorDescription?: string | undefined;
    parker?: ParkerDTO | undefined;
}

export enum LinkParkerToUserResultError {
    InvalidCode = 0,
    ParkerNotActive = 1,
    MultipleParkersOnSameClient = 2,
}

export class LinkParkerToUserDTO implements ILinkParkerToUserDTO {
    userLinkCode?: string | undefined;

    constructor(data?: ILinkParkerToUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userLinkCode = _data["userLinkCode"];
        }
    }

    static fromJS(data: any): LinkParkerToUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LinkParkerToUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userLinkCode"] = this.userLinkCode;
        return data;
    }
}

export interface ILinkParkerToUserDTO {
    userLinkCode?: string | undefined;
}

export class SetFavoriteSubscriptionAssignmentsDTO implements ISetFavoriteSubscriptionAssignmentsDTO {
    favoriteSubscriptionAssignmentIds?: number[] | undefined;

    constructor(data?: ISetFavoriteSubscriptionAssignmentsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["favoriteSubscriptionAssignmentIds"])) {
                this.favoriteSubscriptionAssignmentIds = [] as any;
                for (let item of _data["favoriteSubscriptionAssignmentIds"])
                    this.favoriteSubscriptionAssignmentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SetFavoriteSubscriptionAssignmentsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetFavoriteSubscriptionAssignmentsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.favoriteSubscriptionAssignmentIds)) {
            data["favoriteSubscriptionAssignmentIds"] = [];
            for (let item of this.favoriteSubscriptionAssignmentIds)
                data["favoriteSubscriptionAssignmentIds"].push(item);
        }
        return data;
    }
}

export interface ISetFavoriteSubscriptionAssignmentsDTO {
    favoriteSubscriptionAssignmentIds?: number[] | undefined;
}

export class PagedResultDTOOfParkerExtractReportDTO implements IPagedResultDTOOfParkerExtractReportDTO {
    items?: ParkerExtractReportDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkerExtractReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkerExtractReportDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkerExtractReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkerExtractReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkerExtractReportDTO {
    items?: ParkerExtractReportDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ParkerExtractReportParameterDTO implements IParkerExtractReportParameterDTO {
    parkerId!: number;
    month!: string;

    constructor(data?: IParkerExtractReportParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parkerId = _data["parkerId"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): ParkerExtractReportParameterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerExtractReportParameterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parkerId"] = this.parkerId;
        data["month"] = this.month;
        return data;
    }
}

export interface IParkerExtractReportParameterDTO {
    parkerId: number;
    month: string;
}

export class ParkerRegistrationBaseDTO implements IParkerRegistrationBaseDTO {
    id!: number;
    clientId!: number;
    registrationDateTime!: DateTime;
    type!: ParkerRegistrationType;
    registeredByUserAgentId?: string | undefined;
    registeredByUserAgent?: LimitedUserInfoDTO | undefined;
    registeredByZoneDeviceId?: number | undefined;
    registeredByZoneDeviceName?: string | undefined;
    registeredZoneId!: number;
    registeredZoneName?: string | undefined;
    knownTagId?: number | undefined;
    penaltyReason?: string | undefined;
    unknownParkerTagControlPlateType?: ControlPlateType | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    offense!: ParkerRegistrationOffense;
    offenseLog?: string | undefined;
    sessionOffenses?: ParkingEntryOffenseInfoDTO[] | undefined;
    sessionStartDateTime!: DateTime;
    expectedSessionEndDateTime?: DateTime | undefined;
    pendingAutomaticSessionStartDateTime?: DateTime | undefined;
    sessionOpeningEventType!: SessionEventType;
    sessionClosingEventType?: SessionEventType | undefined;
    selectedSubscription?: ParkingSubscriptionLimitedDTO | undefined;
    penaltyIssued!: boolean;
    penaltyState?: PenaltyState | undefined;
    penaltyNumber?: string | undefined;
    penaltyParkingNumber?: string | undefined;
    parkingSessionId!: number;
    mediaFiles?: string[] | undefined;

    constructor(data?: IParkerRegistrationBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.registrationDateTime = _data["registrationDateTime"] ? DateTime.fromISO(_data["registrationDateTime"].toString()) : undefined as any;
            this.type = _data["type"];
            this.registeredByUserAgentId = _data["registeredByUserAgentId"];
            this.registeredByUserAgent = _data["registeredByUserAgent"] ? LimitedUserInfoDTO.fromJS(_data["registeredByUserAgent"]) : undefined as any;
            this.registeredByZoneDeviceId = _data["registeredByZoneDeviceId"];
            this.registeredByZoneDeviceName = _data["registeredByZoneDeviceName"];
            this.registeredZoneId = _data["registeredZoneId"];
            this.registeredZoneName = _data["registeredZoneName"];
            this.knownTagId = _data["knownTagId"];
            this.penaltyReason = _data["penaltyReason"];
            this.unknownParkerTagControlPlateType = _data["unknownParkerTagControlPlateType"];
            this.unknownParkerTagCountryCode = _data["unknownParkerTagCountryCode"];
            this.unknownParkerTagControlPlateNumber = _data["unknownParkerTagControlPlateNumber"];
            this.offense = _data["offense"];
            this.offenseLog = _data["offenseLog"];
            if (Array.isArray(_data["sessionOffenses"])) {
                this.sessionOffenses = [] as any;
                for (let item of _data["sessionOffenses"])
                    this.sessionOffenses!.push(ParkingEntryOffenseInfoDTO.fromJS(item));
            }
            this.sessionStartDateTime = _data["sessionStartDateTime"] ? DateTime.fromISO(_data["sessionStartDateTime"].toString()) : undefined as any;
            this.expectedSessionEndDateTime = _data["expectedSessionEndDateTime"] ? DateTime.fromISO(_data["expectedSessionEndDateTime"].toString()) : undefined as any;
            this.pendingAutomaticSessionStartDateTime = _data["pendingAutomaticSessionStartDateTime"] ? DateTime.fromISO(_data["pendingAutomaticSessionStartDateTime"].toString()) : undefined as any;
            this.sessionOpeningEventType = _data["sessionOpeningEventType"];
            this.sessionClosingEventType = _data["sessionClosingEventType"];
            this.selectedSubscription = _data["selectedSubscription"] ? ParkingSubscriptionLimitedDTO.fromJS(_data["selectedSubscription"]) : undefined as any;
            this.penaltyIssued = _data["penaltyIssued"];
            this.penaltyState = _data["penaltyState"];
            this.penaltyNumber = _data["penaltyNumber"];
            this.penaltyParkingNumber = _data["penaltyParkingNumber"];
            this.parkingSessionId = _data["parkingSessionId"];
            if (Array.isArray(_data["mediaFiles"])) {
                this.mediaFiles = [] as any;
                for (let item of _data["mediaFiles"])
                    this.mediaFiles!.push(item);
            }
        }
    }

    static fromJS(data: any): ParkerRegistrationBaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerRegistrationBaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["registrationDateTime"] = this.registrationDateTime ? this.registrationDateTime.toString() : undefined as any;
        data["type"] = this.type;
        data["registeredByUserAgentId"] = this.registeredByUserAgentId;
        data["registeredByUserAgent"] = this.registeredByUserAgent ? this.registeredByUserAgent.toJSON() : undefined as any;
        data["registeredByZoneDeviceId"] = this.registeredByZoneDeviceId;
        data["registeredByZoneDeviceName"] = this.registeredByZoneDeviceName;
        data["registeredZoneId"] = this.registeredZoneId;
        data["registeredZoneName"] = this.registeredZoneName;
        data["knownTagId"] = this.knownTagId;
        data["penaltyReason"] = this.penaltyReason;
        data["unknownParkerTagControlPlateType"] = this.unknownParkerTagControlPlateType;
        data["unknownParkerTagCountryCode"] = this.unknownParkerTagCountryCode;
        data["unknownParkerTagControlPlateNumber"] = this.unknownParkerTagControlPlateNumber;
        data["offense"] = this.offense;
        data["offenseLog"] = this.offenseLog;
        if (Array.isArray(this.sessionOffenses)) {
            data["sessionOffenses"] = [];
            for (let item of this.sessionOffenses)
                data["sessionOffenses"].push(item ? item.toJSON() : undefined as any);
        }
        data["sessionStartDateTime"] = this.sessionStartDateTime ? this.sessionStartDateTime.toString() : undefined as any;
        data["expectedSessionEndDateTime"] = this.expectedSessionEndDateTime ? this.expectedSessionEndDateTime.toString() : undefined as any;
        data["pendingAutomaticSessionStartDateTime"] = this.pendingAutomaticSessionStartDateTime ? this.pendingAutomaticSessionStartDateTime.toString() : undefined as any;
        data["sessionOpeningEventType"] = this.sessionOpeningEventType;
        data["sessionClosingEventType"] = this.sessionClosingEventType;
        data["selectedSubscription"] = this.selectedSubscription ? this.selectedSubscription.toJSON() : undefined as any;
        data["penaltyIssued"] = this.penaltyIssued;
        data["penaltyState"] = this.penaltyState;
        data["penaltyNumber"] = this.penaltyNumber;
        data["penaltyParkingNumber"] = this.penaltyParkingNumber;
        data["parkingSessionId"] = this.parkingSessionId;
        if (Array.isArray(this.mediaFiles)) {
            data["mediaFiles"] = [];
            for (let item of this.mediaFiles)
                data["mediaFiles"].push(item);
        }
        return data;
    }
}

export interface IParkerRegistrationBaseDTO {
    id: number;
    clientId: number;
    registrationDateTime: DateTime;
    type: ParkerRegistrationType;
    registeredByUserAgentId?: string | undefined;
    registeredByUserAgent?: LimitedUserInfoDTO | undefined;
    registeredByZoneDeviceId?: number | undefined;
    registeredByZoneDeviceName?: string | undefined;
    registeredZoneId: number;
    registeredZoneName?: string | undefined;
    knownTagId?: number | undefined;
    penaltyReason?: string | undefined;
    unknownParkerTagControlPlateType?: ControlPlateType | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    offense: ParkerRegistrationOffense;
    offenseLog?: string | undefined;
    sessionOffenses?: ParkingEntryOffenseInfoDTO[] | undefined;
    sessionStartDateTime: DateTime;
    expectedSessionEndDateTime?: DateTime | undefined;
    pendingAutomaticSessionStartDateTime?: DateTime | undefined;
    sessionOpeningEventType: SessionEventType;
    sessionClosingEventType?: SessionEventType | undefined;
    selectedSubscription?: ParkingSubscriptionLimitedDTO | undefined;
    penaltyIssued: boolean;
    penaltyState?: PenaltyState | undefined;
    penaltyNumber?: string | undefined;
    penaltyParkingNumber?: string | undefined;
    parkingSessionId: number;
    mediaFiles?: string[] | undefined;
}

export class ParkerRegistrationWithParkerInfoDTO extends ParkerRegistrationBaseDTO implements IParkerRegistrationWithParkerInfoDTO {
    knownTag?: ParkerTagWithParkerInfoDTO | undefined;

    constructor(data?: IParkerRegistrationWithParkerInfoDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.knownTag = _data["knownTag"] ? ParkerTagWithParkerInfoDTO.fromJS(_data["knownTag"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ParkerRegistrationWithParkerInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerRegistrationWithParkerInfoDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knownTag"] = this.knownTag ? this.knownTag.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IParkerRegistrationWithParkerInfoDTO extends IParkerRegistrationBaseDTO {
    knownTag?: ParkerTagWithParkerInfoDTO | undefined;
}

export class ParkingEntryOffenseInfoDTO implements IParkingEntryOffenseInfoDTO {
    registrationId!: number;
    dateTime!: DateTime;
    registeredByUserAgentId?: string | undefined;
    registeredByUserAgentName?: string | undefined;
    offense!: ParkerRegistrationOffense;
    penaltyIssued!: boolean;
    penaltyNumber?: string | undefined;
    penaltyParkingNumber?: string | undefined;
    mediaFiles?: string[] | undefined;

    constructor(data?: IParkingEntryOffenseInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"];
            this.dateTime = _data["dateTime"] ? DateTime.fromISO(_data["dateTime"].toString()) : undefined as any;
            this.registeredByUserAgentId = _data["registeredByUserAgentId"];
            this.registeredByUserAgentName = _data["registeredByUserAgentName"];
            this.offense = _data["offense"];
            this.penaltyIssued = _data["penaltyIssued"];
            this.penaltyNumber = _data["penaltyNumber"];
            this.penaltyParkingNumber = _data["penaltyParkingNumber"];
            if (Array.isArray(_data["mediaFiles"])) {
                this.mediaFiles = [] as any;
                for (let item of _data["mediaFiles"])
                    this.mediaFiles!.push(item);
            }
        }
    }

    static fromJS(data: any): ParkingEntryOffenseInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingEntryOffenseInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["dateTime"] = this.dateTime ? this.dateTime.toString() : undefined as any;
        data["registeredByUserAgentId"] = this.registeredByUserAgentId;
        data["registeredByUserAgentName"] = this.registeredByUserAgentName;
        data["offense"] = this.offense;
        data["penaltyIssued"] = this.penaltyIssued;
        data["penaltyNumber"] = this.penaltyNumber;
        data["penaltyParkingNumber"] = this.penaltyParkingNumber;
        if (Array.isArray(this.mediaFiles)) {
            data["mediaFiles"] = [];
            for (let item of this.mediaFiles)
                data["mediaFiles"].push(item);
        }
        return data;
    }
}

export interface IParkingEntryOffenseInfoDTO {
    registrationId: number;
    dateTime: DateTime;
    registeredByUserAgentId?: string | undefined;
    registeredByUserAgentName?: string | undefined;
    offense: ParkerRegistrationOffense;
    penaltyIssued: boolean;
    penaltyNumber?: string | undefined;
    penaltyParkingNumber?: string | undefined;
    mediaFiles?: string[] | undefined;
}

export enum PenaltyState {
    Issued = 0,
    Cancelled = 1,
}

export class PagedResultDTOOfParkerRegistrationWithParkerInfoDTO implements IPagedResultDTOOfParkerRegistrationWithParkerInfoDTO {
    items?: ParkerRegistrationWithParkerInfoDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkerRegistrationWithParkerInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkerRegistrationWithParkerInfoDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkerRegistrationWithParkerInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkerRegistrationWithParkerInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkerRegistrationWithParkerInfoDTO {
    items?: ParkerRegistrationWithParkerInfoDTO[] | undefined;
    totalNumberOfItems: number;
}

export class AddNonTaggedRegistrationDTO implements IAddNonTaggedRegistrationDTO {
    clientId!: number;
    deviceId!: number;
    timeStamp!: DateTime;
    parkingPlateNumber?: string | undefined;
    hashedPlateNumber?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    parkingPlateCountryCode?: string | undefined;
    recognitionPictureBase64?: string | undefined;
    recognitionPlateBase64?: string | undefined;
    parkingSpaceNumber?: string | undefined;

    constructor(data?: IAddNonTaggedRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.deviceId = _data["deviceId"];
            this.timeStamp = _data["timeStamp"] ? DateTime.fromISO(_data["timeStamp"].toString()) : undefined as any;
            this.parkingPlateNumber = _data["parkingPlateNumber"];
            this.hashedPlateNumber = _data["hashedPlateNumber"];
            this.controlPlateType = _data["controlPlateType"];
            this.parkingPlateCountryCode = _data["parkingPlateCountryCode"];
            this.recognitionPictureBase64 = _data["recognitionPictureBase64"];
            this.recognitionPlateBase64 = _data["recognitionPlateBase64"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
        }
    }

    static fromJS(data: any): AddNonTaggedRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddNonTaggedRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["deviceId"] = this.deviceId;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toString() : undefined as any;
        data["parkingPlateNumber"] = this.parkingPlateNumber;
        data["hashedPlateNumber"] = this.hashedPlateNumber;
        data["controlPlateType"] = this.controlPlateType;
        data["parkingPlateCountryCode"] = this.parkingPlateCountryCode;
        data["recognitionPictureBase64"] = this.recognitionPictureBase64;
        data["recognitionPlateBase64"] = this.recognitionPlateBase64;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        return data;
    }
}

export interface IAddNonTaggedRegistrationDTO {
    clientId: number;
    deviceId: number;
    timeStamp: DateTime;
    parkingPlateNumber?: string | undefined;
    hashedPlateNumber?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    parkingPlateCountryCode?: string | undefined;
    recognitionPictureBase64?: string | undefined;
    recognitionPlateBase64?: string | undefined;
    parkingSpaceNumber?: string | undefined;
}

export class CalculateParkingPriceDTO implements ICalculateParkingPriceDTO {
    zoneId!: number;
    intendedParkingDurationMinutes!: number;
    subscriptionAssignmentId!: number;

    constructor(data?: ICalculateParkingPriceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.intendedParkingDurationMinutes = _data["intendedParkingDurationMinutes"];
            this.subscriptionAssignmentId = _data["subscriptionAssignmentId"];
        }
    }

    static fromJS(data: any): CalculateParkingPriceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateParkingPriceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["intendedParkingDurationMinutes"] = this.intendedParkingDurationMinutes;
        data["subscriptionAssignmentId"] = this.subscriptionAssignmentId;
        return data;
    }
}

export interface ICalculateParkingPriceDTO {
    zoneId: number;
    intendedParkingDurationMinutes: number;
    subscriptionAssignmentId: number;
}

export class CalculateForeignParkingPriceDTO implements ICalculateForeignParkingPriceDTO {
    zoneId!: number;
    intendedParkingDurationMinutes!: number;
    subscriptionId!: number;
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;

    constructor(data?: ICalculateForeignParkingPriceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.intendedParkingDurationMinutes = _data["intendedParkingDurationMinutes"];
            this.subscriptionId = _data["subscriptionId"];
            this.paymentAliasId = _data["paymentAliasId"];
            this.directPayPaymentType = _data["directPayPaymentType"];
        }
    }

    static fromJS(data: any): CalculateForeignParkingPriceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateForeignParkingPriceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["intendedParkingDurationMinutes"] = this.intendedParkingDurationMinutes;
        data["subscriptionId"] = this.subscriptionId;
        data["paymentAliasId"] = this.paymentAliasId;
        data["directPayPaymentType"] = this.directPayPaymentType;
        return data;
    }
}

export interface ICalculateForeignParkingPriceDTO {
    zoneId: number;
    intendedParkingDurationMinutes: number;
    subscriptionId: number;
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
}

export class CalculateVisitorParkingCardPriceResultDTO implements ICalculateVisitorParkingCardPriceResultDTO {
    offense!: ParkerRegistrationOffense;
    parkingPriceDetails!: ParkingPriceDetailsDTO;

    constructor(data?: ICalculateVisitorParkingCardPriceResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.parkingPriceDetails = new ParkingPriceDetailsDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offense = _data["offense"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : new ParkingPriceDetailsDTO();
        }
    }

    static fromJS(data: any): CalculateVisitorParkingCardPriceResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateVisitorParkingCardPriceResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offense"] = this.offense;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface ICalculateVisitorParkingCardPriceResultDTO {
    offense: ParkerRegistrationOffense;
    parkingPriceDetails: ParkingPriceDetailsDTO;
}

export class CalculateVisitorParkingCardPriceDTO implements ICalculateVisitorParkingCardPriceDTO {
    visitorSessionId!: number;

    constructor(data?: ICalculateVisitorParkingCardPriceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitorSessionId = _data["visitorSessionId"];
        }
    }

    static fromJS(data: any): CalculateVisitorParkingCardPriceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateVisitorParkingCardPriceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitorSessionId"] = this.visitorSessionId;
        return data;
    }
}

export interface ICalculateVisitorParkingCardPriceDTO {
    visitorSessionId: number;
}

export class ParkingCardDTO implements IParkingCardDTO {
    id!: number;
    parkerAlias?: string | undefined;
    visitorAlias?: string | undefined;
    issuingParkerId!: number;
    issuingParkerName?: string | undefined;
    validFromDateTime?: DateTime | undefined;
    validToDateTime?: DateTime | undefined;
    forMultipleUse!: boolean;
    controlPlateNumber?: string | undefined;
    issuedToUserId?: string | undefined;
    issuedToUserName?: string | undefined;
    isActive!: boolean;
    lastUsedOn?: DateTime | undefined;
    clientId!: number;
    clientName?: string | undefined;

    constructor(data?: IParkingCardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parkerAlias = _data["parkerAlias"];
            this.visitorAlias = _data["visitorAlias"];
            this.issuingParkerId = _data["issuingParkerId"];
            this.issuingParkerName = _data["issuingParkerName"];
            this.validFromDateTime = _data["validFromDateTime"] ? DateTime.fromISO(_data["validFromDateTime"].toString()) : undefined as any;
            this.validToDateTime = _data["validToDateTime"] ? DateTime.fromISO(_data["validToDateTime"].toString()) : undefined as any;
            this.forMultipleUse = _data["forMultipleUse"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.issuedToUserId = _data["issuedToUserId"];
            this.issuedToUserName = _data["issuedToUserName"];
            this.isActive = _data["isActive"];
            this.lastUsedOn = _data["lastUsedOn"] ? DateTime.fromISO(_data["lastUsedOn"].toString()) : undefined as any;
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
        }
    }

    static fromJS(data: any): ParkingCardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingCardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parkerAlias"] = this.parkerAlias;
        data["visitorAlias"] = this.visitorAlias;
        data["issuingParkerId"] = this.issuingParkerId;
        data["issuingParkerName"] = this.issuingParkerName;
        data["validFromDateTime"] = this.validFromDateTime ? this.validFromDateTime.toString() : undefined as any;
        data["validToDateTime"] = this.validToDateTime ? this.validToDateTime.toString() : undefined as any;
        data["forMultipleUse"] = this.forMultipleUse;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["issuedToUserId"] = this.issuedToUserId;
        data["issuedToUserName"] = this.issuedToUserName;
        data["isActive"] = this.isActive;
        data["lastUsedOn"] = this.lastUsedOn ? this.lastUsedOn.toString() : undefined as any;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        return data;
    }
}

export interface IParkingCardDTO {
    id: number;
    parkerAlias?: string | undefined;
    visitorAlias?: string | undefined;
    issuingParkerId: number;
    issuingParkerName?: string | undefined;
    validFromDateTime?: DateTime | undefined;
    validToDateTime?: DateTime | undefined;
    forMultipleUse: boolean;
    controlPlateNumber?: string | undefined;
    issuedToUserId?: string | undefined;
    issuedToUserName?: string | undefined;
    isActive: boolean;
    lastUsedOn?: DateTime | undefined;
    clientId: number;
    clientName?: string | undefined;
}

export class AssignParkingCardToVisitorDTO implements IAssignParkingCardToVisitorDTO {
    visitorSessionId!: number;

    constructor(data?: IAssignParkingCardToVisitorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitorSessionId = _data["visitorSessionId"];
        }
    }

    static fromJS(data: any): AssignParkingCardToVisitorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignParkingCardToVisitorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitorSessionId"] = this.visitorSessionId;
        return data;
    }
}

export interface IAssignParkingCardToVisitorDTO {
    visitorSessionId: number;
}

export class CheckinUserParkingDTO extends CheckinUserParkingBaseDTO implements ICheckinUserParkingDTO {
    paymentRequestId?: number | undefined;
    maxIntendedParkingDurationMinutes?: number | undefined;
    selectedSubscriptionAssignmentId!: number;

    constructor(data?: ICheckinUserParkingDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentRequestId = _data["paymentRequestId"];
            this.maxIntendedParkingDurationMinutes = _data["maxIntendedParkingDurationMinutes"];
            this.selectedSubscriptionAssignmentId = _data["selectedSubscriptionAssignmentId"];
        }
    }

    static override fromJS(data: any): CheckinUserParkingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinUserParkingDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentRequestId"] = this.paymentRequestId;
        data["maxIntendedParkingDurationMinutes"] = this.maxIntendedParkingDurationMinutes;
        data["selectedSubscriptionAssignmentId"] = this.selectedSubscriptionAssignmentId;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckinUserParkingDTO extends ICheckinUserParkingBaseDTO {
    paymentRequestId?: number | undefined;
    maxIntendedParkingDurationMinutes?: number | undefined;
    selectedSubscriptionAssignmentId: number;
}

export class CheckoutUserParkingResultDTO implements ICheckoutUserParkingResultDTO {
    zoneId?: number | undefined;
    state!: ParkingRegistrationState;
    offense!: ParkerRegistrationOffense;
    effectiveParkingDurationInMinutes!: number;
    payableParkingDurationInMinutes!: number;
    parkingPriceDetails!: ParkingPriceDetailsDTO;

    constructor(data?: ICheckoutUserParkingResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.parkingPriceDetails = new ParkingPriceDetailsDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.state = _data["state"];
            this.offense = _data["offense"];
            this.effectiveParkingDurationInMinutes = _data["effectiveParkingDurationInMinutes"];
            this.payableParkingDurationInMinutes = _data["payableParkingDurationInMinutes"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : new ParkingPriceDetailsDTO();
        }
    }

    static fromJS(data: any): CheckoutUserParkingResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutUserParkingResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["state"] = this.state;
        data["offense"] = this.offense;
        data["effectiveParkingDurationInMinutes"] = this.effectiveParkingDurationInMinutes;
        data["payableParkingDurationInMinutes"] = this.payableParkingDurationInMinutes;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface ICheckoutUserParkingResultDTO {
    zoneId?: number | undefined;
    state: ParkingRegistrationState;
    offense: ParkerRegistrationOffense;
    effectiveParkingDurationInMinutes: number;
    payableParkingDurationInMinutes: number;
    parkingPriceDetails: ParkingPriceDetailsDTO;
}

export class CheckoutUserParkingDTO implements ICheckoutUserParkingDTO {
    sessionId!: number;

    constructor(data?: ICheckoutUserParkingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): CheckoutUserParkingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutUserParkingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface ICheckoutUserParkingDTO {
    sessionId: number;
}

export class CalculateExtendUserParkingDTO implements ICalculateExtendUserParkingDTO {
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    sessionId!: number;
    extensionInMinutes!: number;

    constructor(data?: ICalculateExtendUserParkingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentAliasId = _data["paymentAliasId"];
            this.directPayPaymentType = _data["directPayPaymentType"];
            this.sessionId = _data["sessionId"];
            this.extensionInMinutes = _data["extensionInMinutes"];
        }
    }

    static fromJS(data: any): CalculateExtendUserParkingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateExtendUserParkingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentAliasId"] = this.paymentAliasId;
        data["directPayPaymentType"] = this.directPayPaymentType;
        data["sessionId"] = this.sessionId;
        data["extensionInMinutes"] = this.extensionInMinutes;
        return data;
    }
}

export interface ICalculateExtendUserParkingDTO {
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    sessionId: number;
    extensionInMinutes: number;
}

export class StartParkingExtensionPaymentProcessDTO implements IStartParkingExtensionPaymentProcessDTO {
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    extensionInMinutes!: number;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    sessionId!: number;

    constructor(data?: IStartParkingExtensionPaymentProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentAliasId = _data["paymentAliasId"];
            this.directPayPaymentType = _data["directPayPaymentType"];
            this.extensionInMinutes = _data["extensionInMinutes"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : undefined as any;
            this.fallbackParkingPriceDetails = _data["fallbackParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["fallbackParkingPriceDetails"]) : undefined as any;
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): StartParkingExtensionPaymentProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StartParkingExtensionPaymentProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentAliasId"] = this.paymentAliasId;
        data["directPayPaymentType"] = this.directPayPaymentType;
        data["extensionInMinutes"] = this.extensionInMinutes;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        data["fallbackParkingPriceDetails"] = this.fallbackParkingPriceDetails ? this.fallbackParkingPriceDetails.toJSON() : undefined as any;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IStartParkingExtensionPaymentProcessDTO {
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    extensionInMinutes: number;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    sessionId: number;
}

export class ExtendUserParkingDTO implements IExtendUserParkingDTO {
    sessionId!: number;
    extensionInMinutes!: number;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    paymentId?: number | undefined;

    constructor(data?: IExtendUserParkingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.extensionInMinutes = _data["extensionInMinutes"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : undefined as any;
            this.fallbackParkingPriceDetails = _data["fallbackParkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["fallbackParkingPriceDetails"]) : undefined as any;
            this.paymentId = _data["paymentId"];
        }
    }

    static fromJS(data: any): ExtendUserParkingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendUserParkingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["extensionInMinutes"] = this.extensionInMinutes;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        data["fallbackParkingPriceDetails"] = this.fallbackParkingPriceDetails ? this.fallbackParkingPriceDetails.toJSON() : undefined as any;
        data["paymentId"] = this.paymentId;
        return data;
    }
}

export interface IExtendUserParkingDTO {
    sessionId: number;
    extensionInMinutes: number;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    fallbackParkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
    paymentId?: number | undefined;
}

export class ParkingPermitDTO implements IParkingPermitDTO {
    permitGuid?: string | undefined;
    validUntil?: DateTime | undefined;

    constructor(data?: IParkingPermitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permitGuid = _data["permitGuid"];
            this.validUntil = _data["validUntil"] ? DateTime.fromISO(_data["validUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ParkingPermitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingPermitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permitGuid"] = this.permitGuid;
        data["validUntil"] = this.validUntil ? this.validUntil.toString() : undefined as any;
        return data;
    }
}

export interface IParkingPermitDTO {
    permitGuid?: string | undefined;
    validUntil?: DateTime | undefined;
}

export class ValidateVisitorSessionByParkingPermitResultDTO implements IValidateVisitorSessionByParkingPermitResultDTO {
    parkingCard?: ParkingCardDTO | undefined;
    responseCode!: VisitorSessionValidationResponseCode;

    constructor(data?: IValidateVisitorSessionByParkingPermitResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parkingCard = _data["parkingCard"] ? ParkingCardDTO.fromJS(_data["parkingCard"]) : undefined as any;
            this.responseCode = _data["responseCode"];
        }
    }

    static fromJS(data: any): ValidateVisitorSessionByParkingPermitResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateVisitorSessionByParkingPermitResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parkingCard"] = this.parkingCard ? this.parkingCard.toJSON() : undefined as any;
        data["responseCode"] = this.responseCode;
        return data;
    }
}

export interface IValidateVisitorSessionByParkingPermitResultDTO {
    parkingCard?: ParkingCardDTO | undefined;
    responseCode: VisitorSessionValidationResponseCode;
}

export enum VisitorSessionValidationResponseCode {
    Success = 0,
    UnexpectedError = 1,
    ParkingPermitExpired = 2,
    WrongClient = 3,
    WrongCompany = 4,
    AlreadyValidated = 5,
    UnknownVisitorSession = 6,
    WrongUser = 7,
    InvalidPermit = 8,
    SessionAlreadyClosed = 9,
    SessionInOffense = 10,
    SessionDoesNotNeedValidation = 11,
}

export class ValidateVisitorSessionByParkingPermitDTO implements IValidateVisitorSessionByParkingPermitDTO {
    scannedPermitGuid?: string | undefined;
    visitorSessionId?: number | undefined;

    constructor(data?: IValidateVisitorSessionByParkingPermitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scannedPermitGuid = _data["scannedPermitGuid"];
            this.visitorSessionId = _data["visitorSessionId"];
        }
    }

    static fromJS(data: any): ValidateVisitorSessionByParkingPermitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateVisitorSessionByParkingPermitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scannedPermitGuid"] = this.scannedPermitGuid;
        data["visitorSessionId"] = this.visitorSessionId;
        return data;
    }
}

export interface IValidateVisitorSessionByParkingPermitDTO {
    scannedPermitGuid?: string | undefined;
    visitorSessionId?: number | undefined;
}

export class PagedResultDTOOfParkerRegistrationReportDTO implements IPagedResultDTOOfParkerRegistrationReportDTO {
    items?: ParkerRegistrationReportDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkerRegistrationReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkerRegistrationReportDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkerRegistrationReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkerRegistrationReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkerRegistrationReportDTO {
    items?: ParkerRegistrationReportDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ParkerRegistrationReportDTO implements IParkerRegistrationReportDTO {
    registrationDateTime!: DateTime;
    parkerRegistrationType!: ParkerRegistrationType;
    parker?: ParkerInfoDTO | undefined;
    knownTag?: ParkerTagDTO | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    unknownParkerTagOperationalControlPlateNumber?: string | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    registeredZone?: ZoneDTO | undefined;
    agent?: LimitedUserInfoDTO | undefined;
    parkingSessionId!: number;

    constructor(data?: IParkerRegistrationReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationDateTime = _data["registrationDateTime"] ? DateTime.fromISO(_data["registrationDateTime"].toString()) : undefined as any;
            this.parkerRegistrationType = _data["parkerRegistrationType"];
            this.parker = _data["parker"] ? ParkerInfoDTO.fromJS(_data["parker"]) : undefined as any;
            this.knownTag = _data["knownTag"] ? ParkerTagDTO.fromJS(_data["knownTag"]) : undefined as any;
            this.unknownParkerTagControlPlateNumber = _data["unknownParkerTagControlPlateNumber"];
            this.unknownParkerTagOperationalControlPlateNumber = _data["unknownParkerTagOperationalControlPlateNumber"];
            this.unknownParkerTagCountryCode = _data["unknownParkerTagCountryCode"];
            this.registeredZone = _data["registeredZone"] ? ZoneDTO.fromJS(_data["registeredZone"]) : undefined as any;
            this.agent = _data["agent"] ? LimitedUserInfoDTO.fromJS(_data["agent"]) : undefined as any;
            this.parkingSessionId = _data["parkingSessionId"];
        }
    }

    static fromJS(data: any): ParkerRegistrationReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerRegistrationReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationDateTime"] = this.registrationDateTime ? this.registrationDateTime.toString() : undefined as any;
        data["parkerRegistrationType"] = this.parkerRegistrationType;
        data["parker"] = this.parker ? this.parker.toJSON() : undefined as any;
        data["knownTag"] = this.knownTag ? this.knownTag.toJSON() : undefined as any;
        data["unknownParkerTagControlPlateNumber"] = this.unknownParkerTagControlPlateNumber;
        data["unknownParkerTagOperationalControlPlateNumber"] = this.unknownParkerTagOperationalControlPlateNumber;
        data["unknownParkerTagCountryCode"] = this.unknownParkerTagCountryCode;
        data["registeredZone"] = this.registeredZone ? this.registeredZone.toJSON() : undefined as any;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["parkingSessionId"] = this.parkingSessionId;
        return data;
    }
}

export interface IParkerRegistrationReportDTO {
    registrationDateTime: DateTime;
    parkerRegistrationType: ParkerRegistrationType;
    parker?: ParkerInfoDTO | undefined;
    knownTag?: ParkerTagDTO | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    unknownParkerTagOperationalControlPlateNumber?: string | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    registeredZone?: ZoneDTO | undefined;
    agent?: LimitedUserInfoDTO | undefined;
    parkingSessionId: number;
}

export class ParkerRegistrationsReportParameterDTO implements IParkerRegistrationsReportParameterDTO {
    dateRange!: DateRangeParameterDTO;
    parkerRegistrationType?: ParkerRegistrationType | undefined;

    constructor(data?: IParkerRegistrationsReportParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeParameterDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRange = _data["dateRange"] ? DateRangeParameterDTO.fromJS(_data["dateRange"]) : new DateRangeParameterDTO();
            this.parkerRegistrationType = _data["parkerRegistrationType"];
        }
    }

    static fromJS(data: any): ParkerRegistrationsReportParameterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerRegistrationsReportParameterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        data["parkerRegistrationType"] = this.parkerRegistrationType;
        return data;
    }
}

export interface IParkerRegistrationsReportParameterDTO {
    dateRange: DateRangeParameterDTO;
    parkerRegistrationType?: ParkerRegistrationType | undefined;
}

export class PagedResultDTOOfParkerTagDTO implements IPagedResultDTOOfParkerTagDTO {
    items?: ParkerTagDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkerTagDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkerTagDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkerTagDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkerTagDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkerTagDTO {
    items?: ParkerTagDTO[] | undefined;
    totalNumberOfItems: number;
}

export class PagedResultDTOOfParkerTurnoverReportDTO implements IPagedResultDTOOfParkerTurnoverReportDTO {
    items?: ParkerTurnoverReportDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkerTurnoverReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkerTurnoverReportDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkerTurnoverReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkerTurnoverReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkerTurnoverReportDTO {
    items?: ParkerTurnoverReportDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ParkerTurnoverReportDTO implements IParkerTurnoverReportDTO {
    parker?: ParkerInfoDTO | undefined;
    entryDate!: DateTime;
    exitDate!: DateTime;
    durationInMinutes!: number;
    knownTag?: ParkerTagDTO | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    zone?: ZoneDTO | undefined;
    amount!: number;
    currency!: Currency;
    calculationRoadmap?: string | undefined;
    isVisitorParking!: boolean;

    constructor(data?: IParkerTurnoverReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parker = _data["parker"] ? ParkerInfoDTO.fromJS(_data["parker"]) : undefined as any;
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : undefined as any;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : undefined as any;
            this.durationInMinutes = _data["durationInMinutes"];
            this.knownTag = _data["knownTag"] ? ParkerTagDTO.fromJS(_data["knownTag"]) : undefined as any;
            this.unknownParkerTagCountryCode = _data["unknownParkerTagCountryCode"];
            this.unknownParkerTagControlPlateNumber = _data["unknownParkerTagControlPlateNumber"];
            this.zone = _data["zone"] ? ZoneDTO.fromJS(_data["zone"]) : undefined as any;
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.calculationRoadmap = _data["calculationRoadmap"];
            this.isVisitorParking = _data["isVisitorParking"];
        }
    }

    static fromJS(data: any): ParkerTurnoverReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerTurnoverReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parker"] = this.parker ? this.parker.toJSON() : undefined as any;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : undefined as any;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : undefined as any;
        data["durationInMinutes"] = this.durationInMinutes;
        data["knownTag"] = this.knownTag ? this.knownTag.toJSON() : undefined as any;
        data["unknownParkerTagCountryCode"] = this.unknownParkerTagCountryCode;
        data["unknownParkerTagControlPlateNumber"] = this.unknownParkerTagControlPlateNumber;
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["calculationRoadmap"] = this.calculationRoadmap;
        data["isVisitorParking"] = this.isVisitorParking;
        return data;
    }
}

export interface IParkerTurnoverReportDTO {
    parker?: ParkerInfoDTO | undefined;
    entryDate: DateTime;
    exitDate: DateTime;
    durationInMinutes: number;
    knownTag?: ParkerTagDTO | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    zone?: ZoneDTO | undefined;
    amount: number;
    currency: Currency;
    calculationRoadmap?: string | undefined;
    isVisitorParking: boolean;
}

export class ParkerTurnoverReportParameterDTO implements IParkerTurnoverReportParameterDTO {
    dateRange!: DateRangeParameterDTO;
    zoneId?: number | undefined;
    parkerIds?: number[] | undefined;

    constructor(data?: IParkerTurnoverReportParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeParameterDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRange = _data["dateRange"] ? DateRangeParameterDTO.fromJS(_data["dateRange"]) : new DateRangeParameterDTO();
            this.zoneId = _data["zoneId"];
            if (Array.isArray(_data["parkerIds"])) {
                this.parkerIds = [] as any;
                for (let item of _data["parkerIds"])
                    this.parkerIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ParkerTurnoverReportParameterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerTurnoverReportParameterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        data["zoneId"] = this.zoneId;
        if (Array.isArray(this.parkerIds)) {
            data["parkerIds"] = [];
            for (let item of this.parkerIds)
                data["parkerIds"].push(item);
        }
        return data;
    }
}

export interface IParkerTurnoverReportParameterDTO {
    dateRange: DateRangeParameterDTO;
    zoneId?: number | undefined;
    parkerIds?: number[] | undefined;
}

export class ParkerTurnoverReportSummaryDTO implements IParkerTurnoverReportSummaryDTO {
    totalAmounts!: AmountWithCurrencyDTO[];
    totalNumberOfParkings!: number;

    constructor(data?: IParkerTurnoverReportSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.totalAmounts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totalAmounts"])) {
                this.totalAmounts = [] as any;
                for (let item of _data["totalAmounts"])
                    this.totalAmounts!.push(AmountWithCurrencyDTO.fromJS(item));
            }
            this.totalNumberOfParkings = _data["totalNumberOfParkings"];
        }
    }

    static fromJS(data: any): ParkerTurnoverReportSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerTurnoverReportSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totalAmounts)) {
            data["totalAmounts"] = [];
            for (let item of this.totalAmounts)
                data["totalAmounts"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfParkings"] = this.totalNumberOfParkings;
        return data;
    }
}

export interface IParkerTurnoverReportSummaryDTO {
    totalAmounts: AmountWithCurrencyDTO[];
    totalNumberOfParkings: number;
}

export class AmountWithCurrencyDTO implements IAmountWithCurrencyDTO {
    totalPrice!: number;
    currency!: Currency;
    priceDetails!: ParkingPriceDetailsDTO;

    constructor(data?: IAmountWithCurrencyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.priceDetails = new ParkingPriceDetailsDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPrice = _data["totalPrice"];
            this.currency = _data["currency"];
            this.priceDetails = _data["priceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["priceDetails"]) : new ParkingPriceDetailsDTO();
        }
    }

    static fromJS(data: any): AmountWithCurrencyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AmountWithCurrencyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPrice"] = this.totalPrice;
        data["currency"] = this.currency;
        data["priceDetails"] = this.priceDetails ? this.priceDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IAmountWithCurrencyDTO {
    totalPrice: number;
    currency: Currency;
    priceDetails: ParkingPriceDetailsDTO;
}

export class CreateParkingCardDTO implements ICreateParkingCardDTO {
    issuingParkerId!: number;
    validFromDateTime?: DateTime | undefined;
    validToDateTime?: DateTime | undefined;
    forMultipleUse!: boolean;
    controlPlateNumber?: string | undefined;
    issuedToUserId?: string | undefined;

    constructor(data?: ICreateParkingCardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuingParkerId = _data["issuingParkerId"];
            this.validFromDateTime = _data["validFromDateTime"] ? DateTime.fromISO(_data["validFromDateTime"].toString()) : undefined as any;
            this.validToDateTime = _data["validToDateTime"] ? DateTime.fromISO(_data["validToDateTime"].toString()) : undefined as any;
            this.forMultipleUse = _data["forMultipleUse"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.issuedToUserId = _data["issuedToUserId"];
        }
    }

    static fromJS(data: any): CreateParkingCardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkingCardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuingParkerId"] = this.issuingParkerId;
        data["validFromDateTime"] = this.validFromDateTime ? this.validFromDateTime.toString() : undefined as any;
        data["validToDateTime"] = this.validToDateTime ? this.validToDateTime.toString() : undefined as any;
        data["forMultipleUse"] = this.forMultipleUse;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["issuedToUserId"] = this.issuedToUserId;
        return data;
    }
}

export interface ICreateParkingCardDTO {
    issuingParkerId: number;
    validFromDateTime?: DateTime | undefined;
    validToDateTime?: DateTime | undefined;
    forMultipleUse: boolean;
    controlPlateNumber?: string | undefined;
    issuedToUserId?: string | undefined;
}

export class PagedResultDTOOfParkingCardDTO implements IPagedResultDTOOfParkingCardDTO {
    items?: ParkingCardDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkingCardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkingCardDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkingCardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkingCardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkingCardDTO {
    items?: ParkingCardDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UpdateParkingCardDTO implements IUpdateParkingCardDTO {
    parkingCardId!: number;
    parkingCardName!: string;

    constructor(data?: IUpdateParkingCardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parkingCardId = _data["parkingCardId"];
            this.parkingCardName = _data["parkingCardName"];
        }
    }

    static fromJS(data: any): UpdateParkingCardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParkingCardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parkingCardId"] = this.parkingCardId;
        data["parkingCardName"] = this.parkingCardName;
        return data;
    }
}

export interface IUpdateParkingCardDTO {
    parkingCardId: number;
    parkingCardName: string;
}

export class ParkingProcessInfoDTO implements IParkingProcessInfoDTO {
    activeCheckinInfo?: CheckinUserParkingRegistrationDTO | undefined;

    constructor(data?: IParkingProcessInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeCheckinInfo = _data["activeCheckinInfo"] ? CheckinUserParkingRegistrationDTO.fromJS(_data["activeCheckinInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParkingProcessInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingProcessInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeCheckinInfo"] = this.activeCheckinInfo ? this.activeCheckinInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IParkingProcessInfoDTO {
    activeCheckinInfo?: CheckinUserParkingRegistrationDTO | undefined;
}

export class ParkingEntryDTO implements IParkingEntryDTO {
    registrationDateTime!: DateTime;
    registeredZoneId!: number;
    knownTagId?: number | undefined;
    unknownParkerTagControlPlateType?: ControlPlateType | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    parkingDuration!: number;
    hasOffense!: boolean;
    sessionStartDateTime!: DateTime;
    expectedSessionEndDateTime?: DateTime | undefined;
    pendingAutomaticSessionStartDateTime?: DateTime | undefined;
    sessionOpeningEventType!: SessionEventType;
    sessionClosingEventType?: SessionEventType | undefined;
    selectedSubscription?: ParkingSubscriptionLimitedDTO | undefined;
    offenses?: ParkingEntryOffenseInfoDTO[] | undefined;

    constructor(data?: IParkingEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationDateTime = _data["registrationDateTime"] ? DateTime.fromISO(_data["registrationDateTime"].toString()) : undefined as any;
            this.registeredZoneId = _data["registeredZoneId"];
            this.knownTagId = _data["knownTagId"];
            this.unknownParkerTagControlPlateType = _data["unknownParkerTagControlPlateType"];
            this.unknownParkerTagCountryCode = _data["unknownParkerTagCountryCode"];
            this.unknownParkerTagControlPlateNumber = _data["unknownParkerTagControlPlateNumber"];
            this.parkingDuration = _data["parkingDuration"];
            this.hasOffense = _data["hasOffense"];
            this.sessionStartDateTime = _data["sessionStartDateTime"] ? DateTime.fromISO(_data["sessionStartDateTime"].toString()) : undefined as any;
            this.expectedSessionEndDateTime = _data["expectedSessionEndDateTime"] ? DateTime.fromISO(_data["expectedSessionEndDateTime"].toString()) : undefined as any;
            this.pendingAutomaticSessionStartDateTime = _data["pendingAutomaticSessionStartDateTime"] ? DateTime.fromISO(_data["pendingAutomaticSessionStartDateTime"].toString()) : undefined as any;
            this.sessionOpeningEventType = _data["sessionOpeningEventType"];
            this.sessionClosingEventType = _data["sessionClosingEventType"];
            this.selectedSubscription = _data["selectedSubscription"] ? ParkingSubscriptionLimitedDTO.fromJS(_data["selectedSubscription"]) : undefined as any;
            if (Array.isArray(_data["offenses"])) {
                this.offenses = [] as any;
                for (let item of _data["offenses"])
                    this.offenses!.push(ParkingEntryOffenseInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParkingEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationDateTime"] = this.registrationDateTime ? this.registrationDateTime.toString() : undefined as any;
        data["registeredZoneId"] = this.registeredZoneId;
        data["knownTagId"] = this.knownTagId;
        data["unknownParkerTagControlPlateType"] = this.unknownParkerTagControlPlateType;
        data["unknownParkerTagCountryCode"] = this.unknownParkerTagCountryCode;
        data["unknownParkerTagControlPlateNumber"] = this.unknownParkerTagControlPlateNumber;
        data["parkingDuration"] = this.parkingDuration;
        data["hasOffense"] = this.hasOffense;
        data["sessionStartDateTime"] = this.sessionStartDateTime ? this.sessionStartDateTime.toString() : undefined as any;
        data["expectedSessionEndDateTime"] = this.expectedSessionEndDateTime ? this.expectedSessionEndDateTime.toString() : undefined as any;
        data["pendingAutomaticSessionStartDateTime"] = this.pendingAutomaticSessionStartDateTime ? this.pendingAutomaticSessionStartDateTime.toString() : undefined as any;
        data["sessionOpeningEventType"] = this.sessionOpeningEventType;
        data["sessionClosingEventType"] = this.sessionClosingEventType;
        data["selectedSubscription"] = this.selectedSubscription ? this.selectedSubscription.toJSON() : undefined as any;
        if (Array.isArray(this.offenses)) {
            data["offenses"] = [];
            for (let item of this.offenses)
                data["offenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParkingEntryDTO {
    registrationDateTime: DateTime;
    registeredZoneId: number;
    knownTagId?: number | undefined;
    unknownParkerTagControlPlateType?: ControlPlateType | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    parkingDuration: number;
    hasOffense: boolean;
    sessionStartDateTime: DateTime;
    expectedSessionEndDateTime?: DateTime | undefined;
    pendingAutomaticSessionStartDateTime?: DateTime | undefined;
    sessionOpeningEventType: SessionEventType;
    sessionClosingEventType?: SessionEventType | undefined;
    selectedSubscription?: ParkingSubscriptionLimitedDTO | undefined;
    offenses?: ParkingEntryOffenseInfoDTO[] | undefined;
}

export class FastCheckinPaymentSessionInfoDTO implements IFastCheckinPaymentSessionInfoDTO {
    paymentIdent?: string | undefined;
    sessionIdent?: string | undefined;
    fastCheckinType?: FastCheckinType | undefined;

    constructor(data?: IFastCheckinPaymentSessionInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentIdent = _data["paymentIdent"];
            this.sessionIdent = _data["sessionIdent"];
            this.fastCheckinType = _data["fastCheckinType"];
        }
    }

    static fromJS(data: any): FastCheckinPaymentSessionInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FastCheckinPaymentSessionInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentIdent"] = this.paymentIdent;
        data["sessionIdent"] = this.sessionIdent;
        data["fastCheckinType"] = this.fastCheckinType;
        return data;
    }
}

export interface IFastCheckinPaymentSessionInfoDTO {
    paymentIdent?: string | undefined;
    sessionIdent?: string | undefined;
    fastCheckinType?: FastCheckinType | undefined;
}

export enum FastCheckinType {
    PayTillNow = 0,
    FastCheckIn = 1,
}

export class FastCheckinPaymentDTO implements IFastCheckinPaymentDTO {
    paymentIdent?: string | undefined;

    constructor(data?: IFastCheckinPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentIdent = _data["paymentIdent"];
        }
    }

    static fromJS(data: any): FastCheckinPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FastCheckinPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentIdent"] = this.paymentIdent;
        return data;
    }
}

export interface IFastCheckinPaymentDTO {
    paymentIdent?: string | undefined;
}

export class PrintableParkingPermitDTO implements IPrintableParkingPermitDTO {
    filename?: string | undefined;
    base64FileContent?: string | undefined;

    constructor(data?: IPrintableParkingPermitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.base64FileContent = _data["base64FileContent"];
        }
    }

    static fromJS(data: any): PrintableParkingPermitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PrintableParkingPermitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["base64FileContent"] = this.base64FileContent;
        return data;
    }
}

export interface IPrintableParkingPermitDTO {
    filename?: string | undefined;
    base64FileContent?: string | undefined;
}

export class ParkingRangerCheckPreviewResultDTO implements IParkingRangerCheckPreviewResultDTO {
    sessions!: ParkingRangerCheckPreviewSessionDTO[];
    isLicensePlateInFleetList!: boolean;

    constructor(data?: IParkingRangerCheckPreviewResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.sessions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(ParkingRangerCheckPreviewSessionDTO.fromJS(item));
            }
            this.isLicensePlateInFleetList = _data["isLicensePlateInFleetList"];
        }
    }

    static fromJS(data: any): ParkingRangerCheckPreviewResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingRangerCheckPreviewResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item ? item.toJSON() : undefined as any);
        }
        data["isLicensePlateInFleetList"] = this.isLicensePlateInFleetList;
        return data;
    }
}

export interface IParkingRangerCheckPreviewResultDTO {
    sessions: ParkingRangerCheckPreviewSessionDTO[];
    isLicensePlateInFleetList: boolean;
}

export class ParkingRangerCheckPreviewSessionDTO implements IParkingRangerCheckPreviewSessionDTO {
    zoneId!: number;
    startDateTime!: DateTime;
    endDateTime?: DateTime | undefined;
    hasOffense!: boolean;

    constructor(data?: IParkingRangerCheckPreviewSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.hasOffense = _data["hasOffense"];
        }
    }

    static fromJS(data: any): ParkingRangerCheckPreviewSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingRangerCheckPreviewSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["hasOffense"] = this.hasOffense;
        return data;
    }
}

export interface IParkingRangerCheckPreviewSessionDTO {
    zoneId: number;
    startDateTime: DateTime;
    endDateTime?: DateTime | undefined;
    hasOffense: boolean;
}

export class RegisterParkingRangerCheckResultDTO implements IRegisterParkingRangerCheckResultDTO {
    sessions!: ParkingRangerParkingSessionDTO[];

    constructor(data?: IRegisterParkingRangerCheckResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.sessions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(ParkingRangerParkingSessionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegisterParkingRangerCheckResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterParkingRangerCheckResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegisterParkingRangerCheckResultDTO {
    sessions: ParkingRangerParkingSessionDTO[];
}

export class ParkingSessionDTO implements IParkingSessionDTO {
    id!: number;
    client?: ClientDTO | undefined;
    isClosed!: boolean;
    isManuallyAdded!: boolean;
    registeredZoneId!: number;
    registeredZone?: ZoneLimitedDTO | undefined;
    knownTagId?: number | undefined;
    knownTag?: ParkerTagWithParkerInfoDTO | undefined;
    parkingSpaceNumber?: string | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    penaltyIssued!: boolean;
    offenses?: ParkerRegistrationOffense[] | undefined;
    maxIntendedParkingDurationMinutes?: number | undefined;
    firstEntryDateTime!: DateTime;
    lastEntryDateTime!: DateTime;
    calculatedParkingFee!: number;
    totalParkingFee!: number;
    paidParkingFee!: number;
    detailedPriceInformation?: ParkingPriceDetailsDTO | undefined;
    currency!: Currency;
    calculationRoadmap?: string | undefined;
    parkingDuration!: number;
    parkerRegistrations?: ParkerRegistrationDTO[] | undefined;
    subscription?: ParkingSubscriptionLimitedDTO | undefined;

    constructor(data?: IParkingSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.client = _data["client"] ? ClientDTO.fromJS(_data["client"]) : undefined as any;
            this.isClosed = _data["isClosed"];
            this.isManuallyAdded = _data["isManuallyAdded"];
            this.registeredZoneId = _data["registeredZoneId"];
            this.registeredZone = _data["registeredZone"] ? ZoneLimitedDTO.fromJS(_data["registeredZone"]) : undefined as any;
            this.knownTagId = _data["knownTagId"];
            this.knownTag = _data["knownTag"] ? ParkerTagWithParkerInfoDTO.fromJS(_data["knownTag"]) : undefined as any;
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.unknownParkerTagCountryCode = _data["unknownParkerTagCountryCode"];
            this.unknownParkerTagControlPlateNumber = _data["unknownParkerTagControlPlateNumber"];
            this.penaltyIssued = _data["penaltyIssued"];
            if (Array.isArray(_data["offenses"])) {
                this.offenses = [] as any;
                for (let item of _data["offenses"])
                    this.offenses!.push(item);
            }
            this.maxIntendedParkingDurationMinutes = _data["maxIntendedParkingDurationMinutes"];
            this.firstEntryDateTime = _data["firstEntryDateTime"] ? DateTime.fromISO(_data["firstEntryDateTime"].toString()) : undefined as any;
            this.lastEntryDateTime = _data["lastEntryDateTime"] ? DateTime.fromISO(_data["lastEntryDateTime"].toString()) : undefined as any;
            this.calculatedParkingFee = _data["calculatedParkingFee"];
            this.totalParkingFee = _data["totalParkingFee"];
            this.paidParkingFee = _data["paidParkingFee"];
            this.detailedPriceInformation = _data["detailedPriceInformation"] ? ParkingPriceDetailsDTO.fromJS(_data["detailedPriceInformation"]) : undefined as any;
            this.currency = _data["currency"];
            this.calculationRoadmap = _data["calculationRoadmap"];
            this.parkingDuration = _data["parkingDuration"];
            if (Array.isArray(_data["parkerRegistrations"])) {
                this.parkerRegistrations = [] as any;
                for (let item of _data["parkerRegistrations"])
                    this.parkerRegistrations!.push(ParkerRegistrationDTO.fromJS(item));
            }
            this.subscription = _data["subscription"] ? ParkingSubscriptionLimitedDTO.fromJS(_data["subscription"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParkingSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["isClosed"] = this.isClosed;
        data["isManuallyAdded"] = this.isManuallyAdded;
        data["registeredZoneId"] = this.registeredZoneId;
        data["registeredZone"] = this.registeredZone ? this.registeredZone.toJSON() : undefined as any;
        data["knownTagId"] = this.knownTagId;
        data["knownTag"] = this.knownTag ? this.knownTag.toJSON() : undefined as any;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["unknownParkerTagCountryCode"] = this.unknownParkerTagCountryCode;
        data["unknownParkerTagControlPlateNumber"] = this.unknownParkerTagControlPlateNumber;
        data["penaltyIssued"] = this.penaltyIssued;
        if (Array.isArray(this.offenses)) {
            data["offenses"] = [];
            for (let item of this.offenses)
                data["offenses"].push(item);
        }
        data["maxIntendedParkingDurationMinutes"] = this.maxIntendedParkingDurationMinutes;
        data["firstEntryDateTime"] = this.firstEntryDateTime ? this.firstEntryDateTime.toString() : undefined as any;
        data["lastEntryDateTime"] = this.lastEntryDateTime ? this.lastEntryDateTime.toString() : undefined as any;
        data["calculatedParkingFee"] = this.calculatedParkingFee;
        data["totalParkingFee"] = this.totalParkingFee;
        data["paidParkingFee"] = this.paidParkingFee;
        data["detailedPriceInformation"] = this.detailedPriceInformation ? this.detailedPriceInformation.toJSON() : undefined as any;
        data["currency"] = this.currency;
        data["calculationRoadmap"] = this.calculationRoadmap;
        data["parkingDuration"] = this.parkingDuration;
        if (Array.isArray(this.parkerRegistrations)) {
            data["parkerRegistrations"] = [];
            for (let item of this.parkerRegistrations)
                data["parkerRegistrations"].push(item ? item.toJSON() : undefined as any);
        }
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined as any;
        return data;
    }
}

export interface IParkingSessionDTO {
    id: number;
    client?: ClientDTO | undefined;
    isClosed: boolean;
    isManuallyAdded: boolean;
    registeredZoneId: number;
    registeredZone?: ZoneLimitedDTO | undefined;
    knownTagId?: number | undefined;
    knownTag?: ParkerTagWithParkerInfoDTO | undefined;
    parkingSpaceNumber?: string | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    penaltyIssued: boolean;
    offenses?: ParkerRegistrationOffense[] | undefined;
    maxIntendedParkingDurationMinutes?: number | undefined;
    firstEntryDateTime: DateTime;
    lastEntryDateTime: DateTime;
    calculatedParkingFee: number;
    totalParkingFee: number;
    paidParkingFee: number;
    detailedPriceInformation?: ParkingPriceDetailsDTO | undefined;
    currency: Currency;
    calculationRoadmap?: string | undefined;
    parkingDuration: number;
    parkerRegistrations?: ParkerRegistrationDTO[] | undefined;
    subscription?: ParkingSubscriptionLimitedDTO | undefined;
}

export class ParkingRangerParkingSessionDTO extends ParkingSessionDTO implements IParkingRangerParkingSessionDTO {

    constructor(data?: IParkingRangerParkingSessionDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ParkingRangerParkingSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingRangerParkingSessionDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IParkingRangerParkingSessionDTO extends IParkingSessionDTO {
}

export class ParkerRegistrationDTO extends ParkerRegistrationBaseDTO implements IParkerRegistrationDTO {
    knownTag?: ParkerTagDTO | undefined;

    constructor(data?: IParkerRegistrationDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.knownTag = _data["knownTag"] ? ParkerTagDTO.fromJS(_data["knownTag"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ParkerRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkerRegistrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knownTag"] = this.knownTag ? this.knownTag.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IParkerRegistrationDTO extends IParkerRegistrationBaseDTO {
    knownTag?: ParkerTagDTO | undefined;
}

export class RegisterParkingRangerCheckDTO implements IRegisterParkingRangerCheckDTO {
    zoneId!: number;
    parkingRangerSessionId?: number | undefined;
    controlPlateNumber!: string;
    controlPlateCountryCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    parkingSpaceNumber?: string | undefined;

    constructor(data?: IRegisterParkingRangerCheckDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.parkingRangerSessionId = _data["parkingRangerSessionId"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.controlPlateCountryCode = _data["controlPlateCountryCode"];
            this.controlPlateType = _data["controlPlateType"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
        }
    }

    static fromJS(data: any): RegisterParkingRangerCheckDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterParkingRangerCheckDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["parkingRangerSessionId"] = this.parkingRangerSessionId;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["controlPlateCountryCode"] = this.controlPlateCountryCode;
        data["controlPlateType"] = this.controlPlateType;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        return data;
    }
}

export interface IRegisterParkingRangerCheckDTO {
    zoneId: number;
    parkingRangerSessionId?: number | undefined;
    controlPlateNumber: string;
    controlPlateCountryCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    parkingSpaceNumber?: string | undefined;
}

export class UpdateParkerRegistrationDTO implements IUpdateParkerRegistrationDTO {
    id!: number;
    penaltyNumber?: string | undefined;
    penaltyReason?: string | undefined;

    constructor(data?: IUpdateParkerRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.penaltyNumber = _data["penaltyNumber"];
            this.penaltyReason = _data["penaltyReason"];
        }
    }

    static fromJS(data: any): UpdateParkerRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParkerRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["penaltyNumber"] = this.penaltyNumber;
        data["penaltyReason"] = this.penaltyReason;
        return data;
    }
}

export interface IUpdateParkerRegistrationDTO {
    id: number;
    penaltyNumber?: string | undefined;
    penaltyReason?: string | undefined;
}

export class AddRegistrationImageDTO implements IAddRegistrationImageDTO {
    registrationId!: number;
    imageBase64?: string | undefined;

    constructor(data?: IAddRegistrationImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"];
            this.imageBase64 = _data["imageBase64"];
        }
    }

    static fromJS(data: any): AddRegistrationImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddRegistrationImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["imageBase64"] = this.imageBase64;
        return data;
    }
}

export interface IAddRegistrationImageDTO {
    registrationId: number;
    imageBase64?: string | undefined;
}

export class UpdateRegistrationImage implements IUpdateRegistrationImage {
    registrationId!: number;
    mediaId?: string | undefined;
    imageBase64?: string | undefined;

    constructor(data?: IUpdateRegistrationImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"];
            this.mediaId = _data["mediaId"];
            this.imageBase64 = _data["imageBase64"];
        }
    }

    static fromJS(data: any): UpdateRegistrationImage {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegistrationImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["mediaId"] = this.mediaId;
        data["imageBase64"] = this.imageBase64;
        return data;
    }
}

export interface IUpdateRegistrationImage {
    registrationId: number;
    mediaId?: string | undefined;
    imageBase64?: string | undefined;
}

export class DeleteRegistrationImageDTO implements IDeleteRegistrationImageDTO {
    registrationId!: number;
    mediaId?: string | undefined;

    constructor(data?: IDeleteRegistrationImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"];
            this.mediaId = _data["mediaId"];
        }
    }

    static fromJS(data: any): DeleteRegistrationImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegistrationImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["mediaId"] = this.mediaId;
        return data;
    }
}

export interface IDeleteRegistrationImageDTO {
    registrationId: number;
    mediaId?: string | undefined;
}

export class PagedResultDTOOfParkingRangerClientZoneAssignmentDTO implements IPagedResultDTOOfParkingRangerClientZoneAssignmentDTO {
    items?: ParkingRangerClientZoneAssignmentDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkingRangerClientZoneAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkingRangerClientZoneAssignmentDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkingRangerClientZoneAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkingRangerClientZoneAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkingRangerClientZoneAssignmentDTO {
    items?: ParkingRangerClientZoneAssignmentDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ParkingRangerClientZoneAssignmentDTO implements IParkingRangerClientZoneAssignmentDTO {
    id!: number;
    userId!: string;
    user?: ParkingRangerClientZoneAssignmentUserInfoDTO | undefined;
    zoneId?: number | undefined;
    zone?: ParkingRangerClientZoneAssignmentZoneInfoDTO | undefined;
    clientId!: number;
    client?: ParkingRangerClientZoneAssignmentClientInfoDTO | undefined;
    isRegistrationCreationEnabled!: boolean;
    isSessionCreationEnabled!: boolean;
    isCurrentPositionEnabled!: boolean;
    isPositionTrackingEnabled!: boolean;
    newSessionCreationAfterHours!: number;
    previewConsideredHours!: number;

    constructor(data?: IParkingRangerClientZoneAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? ParkingRangerClientZoneAssignmentUserInfoDTO.fromJS(_data["user"]) : undefined as any;
            this.zoneId = _data["zoneId"];
            this.zone = _data["zone"] ? ParkingRangerClientZoneAssignmentZoneInfoDTO.fromJS(_data["zone"]) : undefined as any;
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ParkingRangerClientZoneAssignmentClientInfoDTO.fromJS(_data["client"]) : undefined as any;
            this.isRegistrationCreationEnabled = _data["isRegistrationCreationEnabled"];
            this.isSessionCreationEnabled = _data["isSessionCreationEnabled"];
            this.isCurrentPositionEnabled = _data["isCurrentPositionEnabled"];
            this.isPositionTrackingEnabled = _data["isPositionTrackingEnabled"];
            this.newSessionCreationAfterHours = _data["newSessionCreationAfterHours"];
            this.previewConsideredHours = _data["previewConsideredHours"];
        }
    }

    static fromJS(data: any): ParkingRangerClientZoneAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingRangerClientZoneAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["zoneId"] = this.zoneId;
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["isRegistrationCreationEnabled"] = this.isRegistrationCreationEnabled;
        data["isSessionCreationEnabled"] = this.isSessionCreationEnabled;
        data["isCurrentPositionEnabled"] = this.isCurrentPositionEnabled;
        data["isPositionTrackingEnabled"] = this.isPositionTrackingEnabled;
        data["newSessionCreationAfterHours"] = this.newSessionCreationAfterHours;
        data["previewConsideredHours"] = this.previewConsideredHours;
        return data;
    }
}

export interface IParkingRangerClientZoneAssignmentDTO {
    id: number;
    userId: string;
    user?: ParkingRangerClientZoneAssignmentUserInfoDTO | undefined;
    zoneId?: number | undefined;
    zone?: ParkingRangerClientZoneAssignmentZoneInfoDTO | undefined;
    clientId: number;
    client?: ParkingRangerClientZoneAssignmentClientInfoDTO | undefined;
    isRegistrationCreationEnabled: boolean;
    isSessionCreationEnabled: boolean;
    isCurrentPositionEnabled: boolean;
    isPositionTrackingEnabled: boolean;
    newSessionCreationAfterHours: number;
    previewConsideredHours: number;
}

export class ParkingRangerClientZoneAssignmentUserInfoDTO implements IParkingRangerClientZoneAssignmentUserInfoDTO {
    id!: string;
    userName?: string | undefined;

    constructor(data?: IParkingRangerClientZoneAssignmentUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ParkingRangerClientZoneAssignmentUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingRangerClientZoneAssignmentUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IParkingRangerClientZoneAssignmentUserInfoDTO {
    id: string;
    userName?: string | undefined;
}

export class ParkingRangerClientZoneAssignmentZoneInfoDTO implements IParkingRangerClientZoneAssignmentZoneInfoDTO {
    id!: number;
    name?: string | undefined;
    parentId?: number | undefined;
    parentName?: string | undefined;
    grandParentName?: string | undefined;
    grandGrandParentName?: string | undefined;
    clientId!: number;
    client?: ParkingRangerClientZoneAssignmentClientInfoDTO | undefined;

    constructor(data?: IParkingRangerClientZoneAssignmentZoneInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.parentName = _data["parentName"];
            this.grandParentName = _data["grandParentName"];
            this.grandGrandParentName = _data["grandGrandParentName"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ParkingRangerClientZoneAssignmentClientInfoDTO.fromJS(_data["client"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParkingRangerClientZoneAssignmentZoneInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingRangerClientZoneAssignmentZoneInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["grandParentName"] = this.grandParentName;
        data["grandGrandParentName"] = this.grandGrandParentName;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        return data;
    }
}

export interface IParkingRangerClientZoneAssignmentZoneInfoDTO {
    id: number;
    name?: string | undefined;
    parentId?: number | undefined;
    parentName?: string | undefined;
    grandParentName?: string | undefined;
    grandGrandParentName?: string | undefined;
    clientId: number;
    client?: ParkingRangerClientZoneAssignmentClientInfoDTO | undefined;
}

export class ParkingRangerClientZoneAssignmentClientInfoDTO implements IParkingRangerClientZoneAssignmentClientInfoDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IParkingRangerClientZoneAssignmentClientInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ParkingRangerClientZoneAssignmentClientInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingRangerClientZoneAssignmentClientInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IParkingRangerClientZoneAssignmentClientInfoDTO {
    id: number;
    name?: string | undefined;
}

export class CreateParkingRangerClientZoneAssignmentDTO implements ICreateParkingRangerClientZoneAssignmentDTO {
    userId!: string;
    zoneId?: number | undefined;
    clientId!: number;
    isRegistrationCreationEnabled!: boolean;
    isSessionCreationEnabled!: boolean;
    isCurrentPositionEnabled!: boolean;
    isPositionTrackingEnabled!: boolean;
    newSessionCreationAfterHours!: number;
    previewConsideredHours!: number;

    constructor(data?: ICreateParkingRangerClientZoneAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.zoneId = _data["zoneId"];
            this.clientId = _data["clientId"];
            this.isRegistrationCreationEnabled = _data["isRegistrationCreationEnabled"];
            this.isSessionCreationEnabled = _data["isSessionCreationEnabled"];
            this.isCurrentPositionEnabled = _data["isCurrentPositionEnabled"];
            this.isPositionTrackingEnabled = _data["isPositionTrackingEnabled"];
            this.newSessionCreationAfterHours = _data["newSessionCreationAfterHours"];
            this.previewConsideredHours = _data["previewConsideredHours"];
        }
    }

    static fromJS(data: any): CreateParkingRangerClientZoneAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkingRangerClientZoneAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["zoneId"] = this.zoneId;
        data["clientId"] = this.clientId;
        data["isRegistrationCreationEnabled"] = this.isRegistrationCreationEnabled;
        data["isSessionCreationEnabled"] = this.isSessionCreationEnabled;
        data["isCurrentPositionEnabled"] = this.isCurrentPositionEnabled;
        data["isPositionTrackingEnabled"] = this.isPositionTrackingEnabled;
        data["newSessionCreationAfterHours"] = this.newSessionCreationAfterHours;
        data["previewConsideredHours"] = this.previewConsideredHours;
        return data;
    }
}

export interface ICreateParkingRangerClientZoneAssignmentDTO {
    userId: string;
    zoneId?: number | undefined;
    clientId: number;
    isRegistrationCreationEnabled: boolean;
    isSessionCreationEnabled: boolean;
    isCurrentPositionEnabled: boolean;
    isPositionTrackingEnabled: boolean;
    newSessionCreationAfterHours: number;
    previewConsideredHours: number;
}

export class EditParkingRangerClientZoneAssignmentDTO implements IEditParkingRangerClientZoneAssignmentDTO {
    id!: number;
    isRegistrationCreationEnabled!: boolean;
    isSessionCreationEnabled!: boolean;
    isCurrentPositionEnabled!: boolean;
    isPositionTrackingEnabled!: boolean;
    newSessionCreationAfterHours!: number;
    previewConsideredHours!: number;

    constructor(data?: IEditParkingRangerClientZoneAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isRegistrationCreationEnabled = _data["isRegistrationCreationEnabled"];
            this.isSessionCreationEnabled = _data["isSessionCreationEnabled"];
            this.isCurrentPositionEnabled = _data["isCurrentPositionEnabled"];
            this.isPositionTrackingEnabled = _data["isPositionTrackingEnabled"];
            this.newSessionCreationAfterHours = _data["newSessionCreationAfterHours"];
            this.previewConsideredHours = _data["previewConsideredHours"];
        }
    }

    static fromJS(data: any): EditParkingRangerClientZoneAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditParkingRangerClientZoneAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isRegistrationCreationEnabled"] = this.isRegistrationCreationEnabled;
        data["isSessionCreationEnabled"] = this.isSessionCreationEnabled;
        data["isCurrentPositionEnabled"] = this.isCurrentPositionEnabled;
        data["isPositionTrackingEnabled"] = this.isPositionTrackingEnabled;
        data["newSessionCreationAfterHours"] = this.newSessionCreationAfterHours;
        data["previewConsideredHours"] = this.previewConsideredHours;
        return data;
    }
}

export interface IEditParkingRangerClientZoneAssignmentDTO {
    id: number;
    isRegistrationCreationEnabled: boolean;
    isSessionCreationEnabled: boolean;
    isCurrentPositionEnabled: boolean;
    isPositionTrackingEnabled: boolean;
    newSessionCreationAfterHours: number;
    previewConsideredHours: number;
}

export class PagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO implements IPagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO {
    items?: ParkingRangerClientZoneAssignmentZoneInfoDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkingRangerClientZoneAssignmentZoneInfoDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkingRangerClientZoneAssignmentZoneInfoDTO {
    items?: ParkingRangerClientZoneAssignmentZoneInfoDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ParkingRangerZoneInfoDTO extends ParkingRangerClientZoneAssignmentZoneInfoDTO implements IParkingRangerZoneInfoDTO {
    isRegistrationCreationEnabled!: boolean;
    isSessionCreationEnabled!: boolean;
    isCurrentPositionEnabled!: boolean;
    isPositionTrackingEnabled!: boolean;
    zoneGPSArea?: string | undefined;

    constructor(data?: IParkingRangerZoneInfoDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isRegistrationCreationEnabled = _data["isRegistrationCreationEnabled"];
            this.isSessionCreationEnabled = _data["isSessionCreationEnabled"];
            this.isCurrentPositionEnabled = _data["isCurrentPositionEnabled"];
            this.isPositionTrackingEnabled = _data["isPositionTrackingEnabled"];
            this.zoneGPSArea = _data["zoneGPSArea"];
        }
    }

    static override fromJS(data: any): ParkingRangerZoneInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingRangerZoneInfoDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRegistrationCreationEnabled"] = this.isRegistrationCreationEnabled;
        data["isSessionCreationEnabled"] = this.isSessionCreationEnabled;
        data["isCurrentPositionEnabled"] = this.isCurrentPositionEnabled;
        data["isPositionTrackingEnabled"] = this.isPositionTrackingEnabled;
        data["zoneGPSArea"] = this.zoneGPSArea;
        super.toJSON(data);
        return data;
    }
}

export interface IParkingRangerZoneInfoDTO extends IParkingRangerClientZoneAssignmentZoneInfoDTO {
    isRegistrationCreationEnabled: boolean;
    isSessionCreationEnabled: boolean;
    isCurrentPositionEnabled: boolean;
    isPositionTrackingEnabled: boolean;
    zoneGPSArea?: string | undefined;
}

export class ParkingRangerSessionDTO implements IParkingRangerSessionDTO {
    id!: number;
    clientId!: number;
    zoneId!: number;
    userId?: string | undefined;
    user?: LimitedUserInfoDTO | undefined;
    sessionStartTime!: DateTime;
    sessionEndTime?: DateTime | undefined;
    positions?: ParkingRangerSessionPositionDTO[] | undefined;
    registrations?: ParkerRegistrationDTO[] | undefined;

    constructor(data?: IParkingRangerSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.zoneId = _data["zoneId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? LimitedUserInfoDTO.fromJS(_data["user"]) : undefined as any;
            this.sessionStartTime = _data["sessionStartTime"] ? DateTime.fromISO(_data["sessionStartTime"].toString()) : undefined as any;
            this.sessionEndTime = _data["sessionEndTime"] ? DateTime.fromISO(_data["sessionEndTime"].toString()) : undefined as any;
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(ParkingRangerSessionPositionDTO.fromJS(item));
            }
            if (Array.isArray(_data["registrations"])) {
                this.registrations = [] as any;
                for (let item of _data["registrations"])
                    this.registrations!.push(ParkerRegistrationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParkingRangerSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingRangerSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["zoneId"] = this.zoneId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["sessionStartTime"] = this.sessionStartTime ? this.sessionStartTime.toString() : undefined as any;
        data["sessionEndTime"] = this.sessionEndTime ? this.sessionEndTime.toString() : undefined as any;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.registrations)) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParkingRangerSessionDTO {
    id: number;
    clientId: number;
    zoneId: number;
    userId?: string | undefined;
    user?: LimitedUserInfoDTO | undefined;
    sessionStartTime: DateTime;
    sessionEndTime?: DateTime | undefined;
    positions?: ParkingRangerSessionPositionDTO[] | undefined;
    registrations?: ParkerRegistrationDTO[] | undefined;
}

export class ParkingRangerSessionPositionDTO implements IParkingRangerSessionPositionDTO {
    id!: number;
    lat!: number;
    lon!: number;
    dateTime?: DateTime | undefined;

    constructor(data?: IParkingRangerSessionPositionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.dateTime = _data["dateTime"] ? DateTime.fromISO(_data["dateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ParkingRangerSessionPositionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingRangerSessionPositionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["dateTime"] = this.dateTime ? this.dateTime.toString() : undefined as any;
        return data;
    }
}

export interface IParkingRangerSessionPositionDTO {
    id: number;
    lat: number;
    lon: number;
    dateTime?: DateTime | undefined;
}

export class ExtendedParkingRangerSessionDTO implements IExtendedParkingRangerSessionDTO {
    id!: number;
    clientId!: number;
    userId?: string | undefined;
    user?: LimitedUserInfoDTO | undefined;
    sessionStartTime!: DateTime;
    sessionEndTime?: DateTime | undefined;
    positions?: ParkingRangerSessionPositionDTO[] | undefined;
    registrations?: ParkerRegistrationWithParkerInfoDTO[] | undefined;

    constructor(data?: IExtendedParkingRangerSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? LimitedUserInfoDTO.fromJS(_data["user"]) : undefined as any;
            this.sessionStartTime = _data["sessionStartTime"] ? DateTime.fromISO(_data["sessionStartTime"].toString()) : undefined as any;
            this.sessionEndTime = _data["sessionEndTime"] ? DateTime.fromISO(_data["sessionEndTime"].toString()) : undefined as any;
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(ParkingRangerSessionPositionDTO.fromJS(item));
            }
            if (Array.isArray(_data["registrations"])) {
                this.registrations = [] as any;
                for (let item of _data["registrations"])
                    this.registrations!.push(ParkerRegistrationWithParkerInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtendedParkingRangerSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedParkingRangerSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["sessionStartTime"] = this.sessionStartTime ? this.sessionStartTime.toString() : undefined as any;
        data["sessionEndTime"] = this.sessionEndTime ? this.sessionEndTime.toString() : undefined as any;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.registrations)) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExtendedParkingRangerSessionDTO {
    id: number;
    clientId: number;
    userId?: string | undefined;
    user?: LimitedUserInfoDTO | undefined;
    sessionStartTime: DateTime;
    sessionEndTime?: DateTime | undefined;
    positions?: ParkingRangerSessionPositionDTO[] | undefined;
    registrations?: ParkerRegistrationWithParkerInfoDTO[] | undefined;
}

export class ActiveParkingRangerSessionDTO implements IActiveParkingRangerSessionDTO {
    session?: ParkingRangerSessionDTO | undefined;

    constructor(data?: IActiveParkingRangerSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.session = _data["session"] ? ParkingRangerSessionDTO.fromJS(_data["session"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActiveParkingRangerSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveParkingRangerSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["session"] = this.session ? this.session.toJSON() : undefined as any;
        return data;
    }
}

export interface IActiveParkingRangerSessionDTO {
    session?: ParkingRangerSessionDTO | undefined;
}

export class PagedResultDTOOfParkingRangerSessionDTO implements IPagedResultDTOOfParkingRangerSessionDTO {
    items?: ParkingRangerSessionDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkingRangerSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkingRangerSessionDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkingRangerSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkingRangerSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkingRangerSessionDTO {
    items?: ParkingRangerSessionDTO[] | undefined;
    totalNumberOfItems: number;
}

export class CreateParkingRangerSessionDTO implements ICreateParkingRangerSessionDTO {
    lastKnownGPSPositionLat?: number | undefined;
    lastKnownGPSPositionLon?: number | undefined;
    clientId!: number;
    zoneId!: number;

    constructor(data?: ICreateParkingRangerSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastKnownGPSPositionLat = _data["lastKnownGPSPositionLat"];
            this.lastKnownGPSPositionLon = _data["lastKnownGPSPositionLon"];
            this.clientId = _data["clientId"];
            this.zoneId = _data["zoneId"];
        }
    }

    static fromJS(data: any): CreateParkingRangerSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkingRangerSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastKnownGPSPositionLat"] = this.lastKnownGPSPositionLat;
        data["lastKnownGPSPositionLon"] = this.lastKnownGPSPositionLon;
        data["clientId"] = this.clientId;
        data["zoneId"] = this.zoneId;
        return data;
    }
}

export interface ICreateParkingRangerSessionDTO {
    lastKnownGPSPositionLat?: number | undefined;
    lastKnownGPSPositionLon?: number | undefined;
    clientId: number;
    zoneId: number;
}

export class UpdateParkingRangerSessionDTO implements IUpdateParkingRangerSessionDTO {
    id!: number;
    lastKnownGPSPositionLat?: number | undefined;
    lastKnownGPSPositionLon?: number | undefined;

    constructor(data?: IUpdateParkingRangerSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastKnownGPSPositionLat = _data["lastKnownGPSPositionLat"];
            this.lastKnownGPSPositionLon = _data["lastKnownGPSPositionLon"];
        }
    }

    static fromJS(data: any): UpdateParkingRangerSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParkingRangerSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastKnownGPSPositionLat"] = this.lastKnownGPSPositionLat;
        data["lastKnownGPSPositionLon"] = this.lastKnownGPSPositionLon;
        return data;
    }
}

export interface IUpdateParkingRangerSessionDTO {
    id: number;
    lastKnownGPSPositionLat?: number | undefined;
    lastKnownGPSPositionLon?: number | undefined;
}

export class PagedResultDTOOfParkingSessionDTO implements IPagedResultDTOOfParkingSessionDTO {
    items?: ParkingSessionDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkingSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkingSessionDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkingSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkingSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkingSessionDTO {
    items?: ParkingSessionDTO[] | undefined;
    totalNumberOfItems: number;
}

export class AdjustSessionStartTimeDTO implements IAdjustSessionStartTimeDTO {
    parkingSessionId!: number;
    startDateTime!: DateTime;

    constructor(data?: IAdjustSessionStartTimeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parkingSessionId = _data["parkingSessionId"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdjustSessionStartTimeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustSessionStartTimeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parkingSessionId"] = this.parkingSessionId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        return data;
    }
}

export interface IAdjustSessionStartTimeDTO {
    parkingSessionId: number;
    startDateTime: DateTime;
}

export class AdjustSessionEndTimeDTO implements IAdjustSessionEndTimeDTO {
    parkingSessionId!: number;
    endDateTime!: DateTime;

    constructor(data?: IAdjustSessionEndTimeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parkingSessionId = _data["parkingSessionId"];
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdjustSessionEndTimeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustSessionEndTimeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parkingSessionId"] = this.parkingSessionId;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        return data;
    }
}

export interface IAdjustSessionEndTimeDTO {
    parkingSessionId: number;
    endDateTime: DateTime;
}

export class ParkingSessionInfoShortDTO implements IParkingSessionInfoShortDTO {
    id!: number;
    timeStamp!: DateTime;

    constructor(data?: IParkingSessionInfoShortDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timeStamp = _data["timeStamp"] ? DateTime.fromISO(_data["timeStamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ParkingSessionInfoShortDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingSessionInfoShortDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toString() : undefined as any;
        return data;
    }
}

export interface IParkingSessionInfoShortDTO {
    id: number;
    timeStamp: DateTime;
}

export class GetParkingSessionIdsForParkerDTO implements IGetParkingSessionIdsForParkerDTO {
    clientId!: number;
    parkerId!: number;
    dateRange!: DateRangeParameterDTO;
    subscriptionId?: number | undefined;

    constructor(data?: IGetParkingSessionIdsForParkerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeParameterDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.parkerId = _data["parkerId"];
            this.dateRange = _data["dateRange"] ? DateRangeParameterDTO.fromJS(_data["dateRange"]) : new DateRangeParameterDTO();
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): GetParkingSessionIdsForParkerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetParkingSessionIdsForParkerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["parkerId"] = this.parkerId;
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface IGetParkingSessionIdsForParkerDTO {
    clientId: number;
    parkerId: number;
    dateRange: DateRangeParameterDTO;
    subscriptionId?: number | undefined;
}

export class CreateParkingSubscriptionDTO implements ICreateParkingSubscriptionDTO {
    clientId!: number;
    active!: boolean;
    assignable!: boolean;
    name?: string | undefined;
    type!: ParkingSubscriptionType;
    description?: string | undefined;
    multipleCarsPerUserTreatAs!: MultipleCarsPerUserTreatAs;
    chargeCap?: number | undefined;
    chargeCapPerMonth!: boolean;
    chargeInRelationToEmploymentPercentage!: boolean;
    fixPricePerMonth?: number | undefined;
    basePricePerDay?: number | undefined;
    denyForeignParkingSubscriptionFallback!: boolean;
    sessionIsExtendable!: boolean;
    maxParkingDurationInMin?: number | undefined;
    currency!: Currency;
    structuralEntryId?: number | undefined;
    roundSessionFeeToXCents!: number;
    usage!: ParkingSubscriptionUsage;
    paidBy!: ParkingSubscriptionPaidBy;
    parkingCardConfirmationTimeInMinutes!: number;
    tariffIds?: number[] | undefined;
    parkingQuotaHours?: number | undefined;
    parkingQuotaDuration!: ParkingQuotaDuration;
    companyId?: number | undefined;
    orderWeight!: number;
    validationFallbackSubscriptionId?: number | undefined;

    constructor(data?: ICreateParkingSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.active = _data["active"];
            this.assignable = _data["assignable"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.multipleCarsPerUserTreatAs = _data["multipleCarsPerUserTreatAs"];
            this.chargeCap = _data["chargeCap"];
            this.chargeCapPerMonth = _data["chargeCapPerMonth"];
            this.chargeInRelationToEmploymentPercentage = _data["chargeInRelationToEmploymentPercentage"];
            this.fixPricePerMonth = _data["fixPricePerMonth"];
            this.basePricePerDay = _data["basePricePerDay"];
            this.denyForeignParkingSubscriptionFallback = _data["denyForeignParkingSubscriptionFallback"];
            this.sessionIsExtendable = _data["sessionIsExtendable"];
            this.maxParkingDurationInMin = _data["maxParkingDurationInMin"];
            this.currency = _data["currency"];
            this.structuralEntryId = _data["structuralEntryId"];
            this.roundSessionFeeToXCents = _data["roundSessionFeeToXCents"];
            this.usage = _data["usage"];
            this.paidBy = _data["paidBy"];
            this.parkingCardConfirmationTimeInMinutes = _data["parkingCardConfirmationTimeInMinutes"];
            if (Array.isArray(_data["tariffIds"])) {
                this.tariffIds = [] as any;
                for (let item of _data["tariffIds"])
                    this.tariffIds!.push(item);
            }
            this.parkingQuotaHours = _data["parkingQuotaHours"];
            this.parkingQuotaDuration = _data["parkingQuotaDuration"];
            this.companyId = _data["companyId"];
            this.orderWeight = _data["orderWeight"];
            this.validationFallbackSubscriptionId = _data["validationFallbackSubscriptionId"];
        }
    }

    static fromJS(data: any): CreateParkingSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkingSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["active"] = this.active;
        data["assignable"] = this.assignable;
        data["name"] = this.name;
        data["type"] = this.type;
        data["description"] = this.description;
        data["multipleCarsPerUserTreatAs"] = this.multipleCarsPerUserTreatAs;
        data["chargeCap"] = this.chargeCap;
        data["chargeCapPerMonth"] = this.chargeCapPerMonth;
        data["chargeInRelationToEmploymentPercentage"] = this.chargeInRelationToEmploymentPercentage;
        data["fixPricePerMonth"] = this.fixPricePerMonth;
        data["basePricePerDay"] = this.basePricePerDay;
        data["denyForeignParkingSubscriptionFallback"] = this.denyForeignParkingSubscriptionFallback;
        data["sessionIsExtendable"] = this.sessionIsExtendable;
        data["maxParkingDurationInMin"] = this.maxParkingDurationInMin;
        data["currency"] = this.currency;
        data["structuralEntryId"] = this.structuralEntryId;
        data["roundSessionFeeToXCents"] = this.roundSessionFeeToXCents;
        data["usage"] = this.usage;
        data["paidBy"] = this.paidBy;
        data["parkingCardConfirmationTimeInMinutes"] = this.parkingCardConfirmationTimeInMinutes;
        if (Array.isArray(this.tariffIds)) {
            data["tariffIds"] = [];
            for (let item of this.tariffIds)
                data["tariffIds"].push(item);
        }
        data["parkingQuotaHours"] = this.parkingQuotaHours;
        data["parkingQuotaDuration"] = this.parkingQuotaDuration;
        data["companyId"] = this.companyId;
        data["orderWeight"] = this.orderWeight;
        data["validationFallbackSubscriptionId"] = this.validationFallbackSubscriptionId;
        return data;
    }
}

export interface ICreateParkingSubscriptionDTO {
    clientId: number;
    active: boolean;
    assignable: boolean;
    name?: string | undefined;
    type: ParkingSubscriptionType;
    description?: string | undefined;
    multipleCarsPerUserTreatAs: MultipleCarsPerUserTreatAs;
    chargeCap?: number | undefined;
    chargeCapPerMonth: boolean;
    chargeInRelationToEmploymentPercentage: boolean;
    fixPricePerMonth?: number | undefined;
    basePricePerDay?: number | undefined;
    denyForeignParkingSubscriptionFallback: boolean;
    sessionIsExtendable: boolean;
    maxParkingDurationInMin?: number | undefined;
    currency: Currency;
    structuralEntryId?: number | undefined;
    roundSessionFeeToXCents: number;
    usage: ParkingSubscriptionUsage;
    paidBy: ParkingSubscriptionPaidBy;
    parkingCardConfirmationTimeInMinutes: number;
    tariffIds?: number[] | undefined;
    parkingQuotaHours?: number | undefined;
    parkingQuotaDuration: ParkingQuotaDuration;
    companyId?: number | undefined;
    orderWeight: number;
    validationFallbackSubscriptionId?: number | undefined;
}

export class PagedResultDTOOfParkingSubscriptionDTO implements IPagedResultDTOOfParkingSubscriptionDTO {
    items?: ParkingSubscriptionDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkingSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkingSubscriptionDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkingSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkingSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkingSubscriptionDTO {
    items?: ParkingSubscriptionDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UpdateParkingSubscriptionDTO implements IUpdateParkingSubscriptionDTO {
    id!: number;
    active?: boolean | undefined;
    assignable?: boolean | undefined;
    name?: string | undefined;
    type!: ParkingSubscriptionType;
    description?: string | undefined;
    multipleCarsPerUserTreatAs!: MultipleCarsPerUserTreatAs;
    chargeCap?: number | undefined;
    chargeCapPerMonth!: boolean;
    chargeInRelationToEmploymentPercentage!: boolean;
    fixPricePerMonth?: number | undefined;
    basePricePerDay?: number | undefined;
    currency!: Currency;
    denyForeignParkingSubscriptionFallback!: boolean;
    sessionIsExtendable!: boolean;
    maxParkingDurationInMin?: number | undefined;
    roundSessionFeeToXCents?: number | undefined;
    usage?: ParkingSubscriptionUsage | undefined;
    paidBy?: ParkingSubscriptionPaidBy | undefined;
    parkingCardConfirmationTimeInMinutes?: number | undefined;
    parkingQuotaHours?: number | undefined;
    parkingQuotaDuration!: ParkingQuotaDuration;
    companyId?: number | undefined;
    orderWeight!: number;
    validationFallbackSubscriptionId?: number | undefined;

    constructor(data?: IUpdateParkingSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.assignable = _data["assignable"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.multipleCarsPerUserTreatAs = _data["multipleCarsPerUserTreatAs"];
            this.chargeCap = _data["chargeCap"];
            this.chargeCapPerMonth = _data["chargeCapPerMonth"];
            this.chargeInRelationToEmploymentPercentage = _data["chargeInRelationToEmploymentPercentage"];
            this.fixPricePerMonth = _data["fixPricePerMonth"];
            this.basePricePerDay = _data["basePricePerDay"];
            this.currency = _data["currency"];
            this.denyForeignParkingSubscriptionFallback = _data["denyForeignParkingSubscriptionFallback"];
            this.sessionIsExtendable = _data["sessionIsExtendable"];
            this.maxParkingDurationInMin = _data["maxParkingDurationInMin"];
            this.roundSessionFeeToXCents = _data["roundSessionFeeToXCents"];
            this.usage = _data["usage"];
            this.paidBy = _data["paidBy"];
            this.parkingCardConfirmationTimeInMinutes = _data["parkingCardConfirmationTimeInMinutes"];
            this.parkingQuotaHours = _data["parkingQuotaHours"];
            this.parkingQuotaDuration = _data["parkingQuotaDuration"];
            this.companyId = _data["companyId"];
            this.orderWeight = _data["orderWeight"];
            this.validationFallbackSubscriptionId = _data["validationFallbackSubscriptionId"];
        }
    }

    static fromJS(data: any): UpdateParkingSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParkingSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["assignable"] = this.assignable;
        data["name"] = this.name;
        data["type"] = this.type;
        data["description"] = this.description;
        data["multipleCarsPerUserTreatAs"] = this.multipleCarsPerUserTreatAs;
        data["chargeCap"] = this.chargeCap;
        data["chargeCapPerMonth"] = this.chargeCapPerMonth;
        data["chargeInRelationToEmploymentPercentage"] = this.chargeInRelationToEmploymentPercentage;
        data["fixPricePerMonth"] = this.fixPricePerMonth;
        data["basePricePerDay"] = this.basePricePerDay;
        data["currency"] = this.currency;
        data["denyForeignParkingSubscriptionFallback"] = this.denyForeignParkingSubscriptionFallback;
        data["sessionIsExtendable"] = this.sessionIsExtendable;
        data["maxParkingDurationInMin"] = this.maxParkingDurationInMin;
        data["roundSessionFeeToXCents"] = this.roundSessionFeeToXCents;
        data["usage"] = this.usage;
        data["paidBy"] = this.paidBy;
        data["parkingCardConfirmationTimeInMinutes"] = this.parkingCardConfirmationTimeInMinutes;
        data["parkingQuotaHours"] = this.parkingQuotaHours;
        data["parkingQuotaDuration"] = this.parkingQuotaDuration;
        data["companyId"] = this.companyId;
        data["orderWeight"] = this.orderWeight;
        data["validationFallbackSubscriptionId"] = this.validationFallbackSubscriptionId;
        return data;
    }
}

export interface IUpdateParkingSubscriptionDTO {
    id: number;
    active?: boolean | undefined;
    assignable?: boolean | undefined;
    name?: string | undefined;
    type: ParkingSubscriptionType;
    description?: string | undefined;
    multipleCarsPerUserTreatAs: MultipleCarsPerUserTreatAs;
    chargeCap?: number | undefined;
    chargeCapPerMonth: boolean;
    chargeInRelationToEmploymentPercentage: boolean;
    fixPricePerMonth?: number | undefined;
    basePricePerDay?: number | undefined;
    currency: Currency;
    denyForeignParkingSubscriptionFallback: boolean;
    sessionIsExtendable: boolean;
    maxParkingDurationInMin?: number | undefined;
    roundSessionFeeToXCents?: number | undefined;
    usage?: ParkingSubscriptionUsage | undefined;
    paidBy?: ParkingSubscriptionPaidBy | undefined;
    parkingCardConfirmationTimeInMinutes?: number | undefined;
    parkingQuotaHours?: number | undefined;
    parkingQuotaDuration: ParkingQuotaDuration;
    companyId?: number | undefined;
    orderWeight: number;
    validationFallbackSubscriptionId?: number | undefined;
}

export class CreateParkingTariffDTO implements ICreateParkingTariffDTO {
    clientId!: number;
    active!: boolean;
    onWeekDays?: WeekDayFlags | undefined;
    description?: string | undefined;
    startTime?: Duration | undefined;
    durationInMinutes?: number | undefined;
    maxParkingDurationInMin?: number | undefined;
    name?: string | undefined;
    tariffCurrency!: Currency;
    priceType!: TariffPriceType;
    tieredPrices?: ParkingTariffTieredPriceDTO[] | undefined;
    placeOfResidence!: PlaceOfResidence;
    fixedPrice?: number | undefined;
    pricePerHour?: number | undefined;
    maximumPrice?: number | undefined;
    linearPriceMinStepInMinutes!: number;
    subscriptionId?: number | undefined;
    assignedZoneIds?: number[] | undefined;
    isTwentyFourSevenTariff!: boolean;
    isDeviceControlTariff!: boolean;
    blacklistedLicensePlates?: BlacklistLicensePlateDTO[] | undefined;

    constructor(data?: ICreateParkingTariffDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.active = _data["active"];
            this.onWeekDays = _data["onWeekDays"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? Duration.fromISO(_data["startTime"].toString()) : undefined as any;
            this.durationInMinutes = _data["durationInMinutes"];
            this.maxParkingDurationInMin = _data["maxParkingDurationInMin"];
            this.name = _data["name"];
            this.tariffCurrency = _data["tariffCurrency"];
            this.priceType = _data["priceType"];
            if (Array.isArray(_data["tieredPrices"])) {
                this.tieredPrices = [] as any;
                for (let item of _data["tieredPrices"])
                    this.tieredPrices!.push(ParkingTariffTieredPriceDTO.fromJS(item));
            }
            this.placeOfResidence = _data["placeOfResidence"];
            this.fixedPrice = _data["fixedPrice"];
            this.pricePerHour = _data["pricePerHour"];
            this.maximumPrice = _data["maximumPrice"];
            this.linearPriceMinStepInMinutes = _data["linearPriceMinStepInMinutes"];
            this.subscriptionId = _data["subscriptionId"];
            if (Array.isArray(_data["assignedZoneIds"])) {
                this.assignedZoneIds = [] as any;
                for (let item of _data["assignedZoneIds"])
                    this.assignedZoneIds!.push(item);
            }
            this.isTwentyFourSevenTariff = _data["isTwentyFourSevenTariff"];
            this.isDeviceControlTariff = _data["isDeviceControlTariff"];
            if (Array.isArray(_data["blacklistedLicensePlates"])) {
                this.blacklistedLicensePlates = [] as any;
                for (let item of _data["blacklistedLicensePlates"])
                    this.blacklistedLicensePlates!.push(BlacklistLicensePlateDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateParkingTariffDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateParkingTariffDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["active"] = this.active;
        data["onWeekDays"] = this.onWeekDays;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["durationInMinutes"] = this.durationInMinutes;
        data["maxParkingDurationInMin"] = this.maxParkingDurationInMin;
        data["name"] = this.name;
        data["tariffCurrency"] = this.tariffCurrency;
        data["priceType"] = this.priceType;
        if (Array.isArray(this.tieredPrices)) {
            data["tieredPrices"] = [];
            for (let item of this.tieredPrices)
                data["tieredPrices"].push(item ? item.toJSON() : undefined as any);
        }
        data["placeOfResidence"] = this.placeOfResidence;
        data["fixedPrice"] = this.fixedPrice;
        data["pricePerHour"] = this.pricePerHour;
        data["maximumPrice"] = this.maximumPrice;
        data["linearPriceMinStepInMinutes"] = this.linearPriceMinStepInMinutes;
        data["subscriptionId"] = this.subscriptionId;
        if (Array.isArray(this.assignedZoneIds)) {
            data["assignedZoneIds"] = [];
            for (let item of this.assignedZoneIds)
                data["assignedZoneIds"].push(item);
        }
        data["isTwentyFourSevenTariff"] = this.isTwentyFourSevenTariff;
        data["isDeviceControlTariff"] = this.isDeviceControlTariff;
        if (Array.isArray(this.blacklistedLicensePlates)) {
            data["blacklistedLicensePlates"] = [];
            for (let item of this.blacklistedLicensePlates)
                data["blacklistedLicensePlates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateParkingTariffDTO {
    clientId: number;
    active: boolean;
    onWeekDays?: WeekDayFlags | undefined;
    description?: string | undefined;
    startTime?: Duration | undefined;
    durationInMinutes?: number | undefined;
    maxParkingDurationInMin?: number | undefined;
    name?: string | undefined;
    tariffCurrency: Currency;
    priceType: TariffPriceType;
    tieredPrices?: ParkingTariffTieredPriceDTO[] | undefined;
    placeOfResidence: PlaceOfResidence;
    fixedPrice?: number | undefined;
    pricePerHour?: number | undefined;
    maximumPrice?: number | undefined;
    linearPriceMinStepInMinutes: number;
    subscriptionId?: number | undefined;
    assignedZoneIds?: number[] | undefined;
    isTwentyFourSevenTariff: boolean;
    isDeviceControlTariff: boolean;
    blacklistedLicensePlates?: BlacklistLicensePlateDTO[] | undefined;
}

export class PagedResultDTOOfParkingTariffLimitedDTO implements IPagedResultDTOOfParkingTariffLimitedDTO {
    items?: ParkingTariffLimitedDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfParkingTariffLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParkingTariffLimitedDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfParkingTariffLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfParkingTariffLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfParkingTariffLimitedDTO {
    items?: ParkingTariffLimitedDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UpdateParkingTariffDTO implements IUpdateParkingTariffDTO {
    id!: number;
    active?: boolean | undefined;
    onWeekDays?: WeekDayFlags | undefined;
    description?: string | undefined;
    startTime?: Duration | undefined;
    durationInMinutes?: number | undefined;
    maxParkingDurationInMin?: number | undefined;
    name?: string | undefined;
    tariffCurrency!: Currency;
    priceType!: TariffPriceType;
    tieredPrices?: ParkingTariffTieredPriceDTO[] | undefined;
    placeOfResidence!: PlaceOfResidence;
    fixedPrice?: number | undefined;
    pricePerHour?: number | undefined;
    maximumPrice?: number | undefined;
    linearPriceMinStepInMinutes?: number | undefined;
    isTwentyFourSevenTariff?: boolean | undefined;
    isDeviceControlTariff?: boolean | undefined;
    blacklistedLicensePlates?: BlacklistLicensePlateDTO[] | undefined;

    constructor(data?: IUpdateParkingTariffDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.onWeekDays = _data["onWeekDays"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? Duration.fromISO(_data["startTime"].toString()) : undefined as any;
            this.durationInMinutes = _data["durationInMinutes"];
            this.maxParkingDurationInMin = _data["maxParkingDurationInMin"];
            this.name = _data["name"];
            this.tariffCurrency = _data["tariffCurrency"];
            this.priceType = _data["priceType"];
            if (Array.isArray(_data["tieredPrices"])) {
                this.tieredPrices = [] as any;
                for (let item of _data["tieredPrices"])
                    this.tieredPrices!.push(ParkingTariffTieredPriceDTO.fromJS(item));
            }
            this.placeOfResidence = _data["placeOfResidence"];
            this.fixedPrice = _data["fixedPrice"];
            this.pricePerHour = _data["pricePerHour"];
            this.maximumPrice = _data["maximumPrice"];
            this.linearPriceMinStepInMinutes = _data["linearPriceMinStepInMinutes"];
            this.isTwentyFourSevenTariff = _data["isTwentyFourSevenTariff"];
            this.isDeviceControlTariff = _data["isDeviceControlTariff"];
            if (Array.isArray(_data["blacklistedLicensePlates"])) {
                this.blacklistedLicensePlates = [] as any;
                for (let item of _data["blacklistedLicensePlates"])
                    this.blacklistedLicensePlates!.push(BlacklistLicensePlateDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateParkingTariffDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParkingTariffDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["onWeekDays"] = this.onWeekDays;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toString() : undefined as any;
        data["durationInMinutes"] = this.durationInMinutes;
        data["maxParkingDurationInMin"] = this.maxParkingDurationInMin;
        data["name"] = this.name;
        data["tariffCurrency"] = this.tariffCurrency;
        data["priceType"] = this.priceType;
        if (Array.isArray(this.tieredPrices)) {
            data["tieredPrices"] = [];
            for (let item of this.tieredPrices)
                data["tieredPrices"].push(item ? item.toJSON() : undefined as any);
        }
        data["placeOfResidence"] = this.placeOfResidence;
        data["fixedPrice"] = this.fixedPrice;
        data["pricePerHour"] = this.pricePerHour;
        data["maximumPrice"] = this.maximumPrice;
        data["linearPriceMinStepInMinutes"] = this.linearPriceMinStepInMinutes;
        data["isTwentyFourSevenTariff"] = this.isTwentyFourSevenTariff;
        data["isDeviceControlTariff"] = this.isDeviceControlTariff;
        if (Array.isArray(this.blacklistedLicensePlates)) {
            data["blacklistedLicensePlates"] = [];
            for (let item of this.blacklistedLicensePlates)
                data["blacklistedLicensePlates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateParkingTariffDTO {
    id: number;
    active?: boolean | undefined;
    onWeekDays?: WeekDayFlags | undefined;
    description?: string | undefined;
    startTime?: Duration | undefined;
    durationInMinutes?: number | undefined;
    maxParkingDurationInMin?: number | undefined;
    name?: string | undefined;
    tariffCurrency: Currency;
    priceType: TariffPriceType;
    tieredPrices?: ParkingTariffTieredPriceDTO[] | undefined;
    placeOfResidence: PlaceOfResidence;
    fixedPrice?: number | undefined;
    pricePerHour?: number | undefined;
    maximumPrice?: number | undefined;
    linearPriceMinStepInMinutes?: number | undefined;
    isTwentyFourSevenTariff?: boolean | undefined;
    isDeviceControlTariff?: boolean | undefined;
    blacklistedLicensePlates?: BlacklistLicensePlateDTO[] | undefined;
}

export class PaymentAliasDTO implements IPaymentAliasDTO {
    id!: number;
    maskedIdentification?: string | undefined;
    type!: PaymentType;
    paymentMethod?: string | undefined;
    expiry?: DateTime | undefined;
    paymentBrand?: string | undefined;
    isFavorite!: boolean;

    constructor(data?: IPaymentAliasDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.maskedIdentification = _data["maskedIdentification"];
            this.type = _data["type"];
            this.paymentMethod = _data["paymentMethod"];
            this.expiry = _data["expiry"] ? DateTime.fromISO(_data["expiry"].toString()) : undefined as any;
            this.paymentBrand = _data["paymentBrand"];
            this.isFavorite = _data["isFavorite"];
        }
    }

    static fromJS(data: any): PaymentAliasDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentAliasDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["maskedIdentification"] = this.maskedIdentification;
        data["type"] = this.type;
        data["paymentMethod"] = this.paymentMethod;
        data["expiry"] = this.expiry ? this.expiry.toString() : undefined as any;
        data["paymentBrand"] = this.paymentBrand;
        data["isFavorite"] = this.isFavorite;
        return data;
    }
}

export interface IPaymentAliasDTO {
    id: number;
    maskedIdentification?: string | undefined;
    type: PaymentType;
    paymentMethod?: string | undefined;
    expiry?: DateTime | undefined;
    paymentBrand?: string | undefined;
    isFavorite: boolean;
}

export class DeletePaymentAliasDTO implements IDeletePaymentAliasDTO {
    id!: number;

    constructor(data?: IDeletePaymentAliasDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeletePaymentAliasDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePaymentAliasDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeletePaymentAliasDTO {
    id: number;
}

export class AddPaymentAliasResultDTO implements IAddPaymentAliasResultDTO {
    paymentMethodIdent!: number;
    redirectionUrl?: string | undefined;
    successUrl?: string | undefined;
    failedUrl?: string | undefined;

    constructor(data?: IAddPaymentAliasResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethodIdent = _data["paymentMethodIdent"];
            this.redirectionUrl = _data["redirectionUrl"];
            this.successUrl = _data["successUrl"];
            this.failedUrl = _data["failedUrl"];
        }
    }

    static fromJS(data: any): AddPaymentAliasResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddPaymentAliasResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodIdent"] = this.paymentMethodIdent;
        data["redirectionUrl"] = this.redirectionUrl;
        data["successUrl"] = this.successUrl;
        data["failedUrl"] = this.failedUrl;
        return data;
    }
}

export interface IAddPaymentAliasResultDTO {
    paymentMethodIdent: number;
    redirectionUrl?: string | undefined;
    successUrl?: string | undefined;
    failedUrl?: string | undefined;
}

export class AddPaymentAliasDTO implements IAddPaymentAliasDTO {

    constructor(data?: IAddPaymentAliasDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AddPaymentAliasDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddPaymentAliasDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAddPaymentAliasDTO {
}

export class NotifyAddPaymentAliasFinishedDTO implements INotifyAddPaymentAliasFinishedDTO {
    paymentMethodIdent!: number;
    success!: boolean;

    constructor(data?: INotifyAddPaymentAliasFinishedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethodIdent = _data["paymentMethodIdent"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): NotifyAddPaymentAliasFinishedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyAddPaymentAliasFinishedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodIdent"] = this.paymentMethodIdent;
        data["success"] = this.success;
        return data;
    }
}

export interface INotifyAddPaymentAliasFinishedDTO {
    paymentMethodIdent: number;
    success: boolean;
}

export class PagedResultDTOOfPaymentReportDTO implements IPagedResultDTOOfPaymentReportDTO {
    items?: PaymentReportDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfPaymentReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaymentReportDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfPaymentReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfPaymentReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfPaymentReportDTO {
    items?: PaymentReportDTO[] | undefined;
    totalNumberOfItems: number;
}

export class PaymentReportDTO implements IPaymentReportDTO {
    id!: number;
    clientId!: number;
    clientName?: string | undefined;
    userName?: string | undefined;
    creationDateTime!: DateTime;
    parkingSessionId?: number | undefined;
    paymentState!: ParkingSessionPaymentState;
    requestId?: string | undefined;
    requestedAmount!: number;
    requestCurrency!: Currency;
    capturedAmount!: number;
    transactionBaseFeeInCHF!: number;
    transactionFeeInPercent!: number;
    ancestorPaymentId?: number | undefined;

    constructor(data?: IPaymentReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.userName = _data["userName"];
            this.creationDateTime = _data["creationDateTime"] ? DateTime.fromISO(_data["creationDateTime"].toString()) : undefined as any;
            this.parkingSessionId = _data["parkingSessionId"];
            this.paymentState = _data["paymentState"];
            this.requestId = _data["requestId"];
            this.requestedAmount = _data["requestedAmount"];
            this.requestCurrency = _data["requestCurrency"];
            this.capturedAmount = _data["capturedAmount"];
            this.transactionBaseFeeInCHF = _data["transactionBaseFeeInCHF"];
            this.transactionFeeInPercent = _data["transactionFeeInPercent"];
            this.ancestorPaymentId = _data["ancestorPaymentId"];
        }
    }

    static fromJS(data: any): PaymentReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["userName"] = this.userName;
        data["creationDateTime"] = this.creationDateTime ? this.creationDateTime.toString() : undefined as any;
        data["parkingSessionId"] = this.parkingSessionId;
        data["paymentState"] = this.paymentState;
        data["requestId"] = this.requestId;
        data["requestedAmount"] = this.requestedAmount;
        data["requestCurrency"] = this.requestCurrency;
        data["capturedAmount"] = this.capturedAmount;
        data["transactionBaseFeeInCHF"] = this.transactionBaseFeeInCHF;
        data["transactionFeeInPercent"] = this.transactionFeeInPercent;
        data["ancestorPaymentId"] = this.ancestorPaymentId;
        return data;
    }
}

export interface IPaymentReportDTO {
    id: number;
    clientId: number;
    clientName?: string | undefined;
    userName?: string | undefined;
    creationDateTime: DateTime;
    parkingSessionId?: number | undefined;
    paymentState: ParkingSessionPaymentState;
    requestId?: string | undefined;
    requestedAmount: number;
    requestCurrency: Currency;
    capturedAmount: number;
    transactionBaseFeeInCHF: number;
    transactionFeeInPercent: number;
    ancestorPaymentId?: number | undefined;
}

export enum ParkingSessionPaymentState {
    New = 0,
    Initialized = 1,
    Allocated = 2,
    Pending = 3,
    Canceled = 4,
    CanceledWhileInitialized = 5,
    Captured = 6,
    Failed = 7,
}

export class PaymentReportParameterDTO implements IPaymentReportParameterDTO {
    clientId?: number | undefined;
    dateRange!: DateRangeParameterDTO;

    constructor(data?: IPaymentReportParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeParameterDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.dateRange = _data["dateRange"] ? DateRangeParameterDTO.fromJS(_data["dateRange"]) : new DateRangeParameterDTO();
        }
    }

    static fromJS(data: any): PaymentReportParameterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentReportParameterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        return data;
    }
}

export interface IPaymentReportParameterDTO {
    clientId?: number | undefined;
    dateRange: DateRangeParameterDTO;
}

export class ZoneInfosDTO implements IZoneInfosDTO {
    zoneInfos?: ZoneInfoDTO[] | undefined;
    responseCode!: PayTillNowResponseCode;

    constructor(data?: IZoneInfosDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["zoneInfos"])) {
                this.zoneInfos = [] as any;
                for (let item of _data["zoneInfos"])
                    this.zoneInfos!.push(ZoneInfoDTO.fromJS(item));
            }
            this.responseCode = _data["responseCode"];
        }
    }

    static fromJS(data: any): ZoneInfosDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneInfosDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.zoneInfos)) {
            data["zoneInfos"] = [];
            for (let item of this.zoneInfos)
                data["zoneInfos"].push(item ? item.toJSON() : undefined as any);
        }
        data["responseCode"] = this.responseCode;
        return data;
    }
}

export interface IZoneInfosDTO {
    zoneInfos?: ZoneInfoDTO[] | undefined;
    responseCode: PayTillNowResponseCode;
}

export class ZoneInfosAndActiveParkingSessionsDTO extends ZoneInfosDTO implements IZoneInfosAndActiveParkingSessionsDTO {
    activeParkingSessions?: ActiveParkingSessionDTO[] | undefined;

    constructor(data?: IZoneInfosAndActiveParkingSessionsDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["activeParkingSessions"])) {
                this.activeParkingSessions = [] as any;
                for (let item of _data["activeParkingSessions"])
                    this.activeParkingSessions!.push(ActiveParkingSessionDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ZoneInfosAndActiveParkingSessionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneInfosAndActiveParkingSessionsDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeParkingSessions)) {
            data["activeParkingSessions"] = [];
            for (let item of this.activeParkingSessions)
                data["activeParkingSessions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IZoneInfosAndActiveParkingSessionsDTO extends IZoneInfosDTO {
    activeParkingSessions?: ActiveParkingSessionDTO[] | undefined;
}

export class ActiveParkingSessionDTO implements IActiveParkingSessionDTO {
    id!: number;
    client?: ClientLimitedDTO | undefined;
    isClosed!: boolean;
    registeredZoneId!: number;
    registeredZone?: ZoneLimitedDTO | undefined;
    sessionType!: ParkingSessionType;
    knownTag?: ParkerTagWithParkerInfoDTO | undefined;
    parkingSpaceNumber?: string | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    unknownParkerTagControlPlateType?: ControlPlateType | undefined;
    penaltyIssued!: boolean;
    maxIntendedParkingDurationMinutes?: number | undefined;
    firstEntryDateTime!: DateTime;
    lastEntryDateTime!: DateTime;
    pricingInformation?: ActiveParkingSessionPricingInformationDTO | undefined;
    parkingDuration!: number;
    subscription?: ParkingSubscriptionLimitedDTO | undefined;

    constructor(data?: IActiveParkingSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.client = _data["client"] ? ClientLimitedDTO.fromJS(_data["client"]) : undefined as any;
            this.isClosed = _data["isClosed"];
            this.registeredZoneId = _data["registeredZoneId"];
            this.registeredZone = _data["registeredZone"] ? ZoneLimitedDTO.fromJS(_data["registeredZone"]) : undefined as any;
            this.sessionType = _data["sessionType"];
            this.knownTag = _data["knownTag"] ? ParkerTagWithParkerInfoDTO.fromJS(_data["knownTag"]) : undefined as any;
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.unknownParkerTagCountryCode = _data["unknownParkerTagCountryCode"];
            this.unknownParkerTagControlPlateNumber = _data["unknownParkerTagControlPlateNumber"];
            this.unknownParkerTagControlPlateType = _data["unknownParkerTagControlPlateType"];
            this.penaltyIssued = _data["penaltyIssued"];
            this.maxIntendedParkingDurationMinutes = _data["maxIntendedParkingDurationMinutes"];
            this.firstEntryDateTime = _data["firstEntryDateTime"] ? DateTime.fromISO(_data["firstEntryDateTime"].toString()) : undefined as any;
            this.lastEntryDateTime = _data["lastEntryDateTime"] ? DateTime.fromISO(_data["lastEntryDateTime"].toString()) : undefined as any;
            this.pricingInformation = _data["pricingInformation"] ? ActiveParkingSessionPricingInformationDTO.fromJS(_data["pricingInformation"]) : undefined as any;
            this.parkingDuration = _data["parkingDuration"];
            this.subscription = _data["subscription"] ? ParkingSubscriptionLimitedDTO.fromJS(_data["subscription"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActiveParkingSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveParkingSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["isClosed"] = this.isClosed;
        data["registeredZoneId"] = this.registeredZoneId;
        data["registeredZone"] = this.registeredZone ? this.registeredZone.toJSON() : undefined as any;
        data["sessionType"] = this.sessionType;
        data["knownTag"] = this.knownTag ? this.knownTag.toJSON() : undefined as any;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["unknownParkerTagCountryCode"] = this.unknownParkerTagCountryCode;
        data["unknownParkerTagControlPlateNumber"] = this.unknownParkerTagControlPlateNumber;
        data["unknownParkerTagControlPlateType"] = this.unknownParkerTagControlPlateType;
        data["penaltyIssued"] = this.penaltyIssued;
        data["maxIntendedParkingDurationMinutes"] = this.maxIntendedParkingDurationMinutes;
        data["firstEntryDateTime"] = this.firstEntryDateTime ? this.firstEntryDateTime.toString() : undefined as any;
        data["lastEntryDateTime"] = this.lastEntryDateTime ? this.lastEntryDateTime.toString() : undefined as any;
        data["pricingInformation"] = this.pricingInformation ? this.pricingInformation.toJSON() : undefined as any;
        data["parkingDuration"] = this.parkingDuration;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined as any;
        return data;
    }
}

export interface IActiveParkingSessionDTO {
    id: number;
    client?: ClientLimitedDTO | undefined;
    isClosed: boolean;
    registeredZoneId: number;
    registeredZone?: ZoneLimitedDTO | undefined;
    sessionType: ParkingSessionType;
    knownTag?: ParkerTagWithParkerInfoDTO | undefined;
    parkingSpaceNumber?: string | undefined;
    unknownParkerTagCountryCode?: string | undefined;
    unknownParkerTagControlPlateNumber?: string | undefined;
    unknownParkerTagControlPlateType?: ControlPlateType | undefined;
    penaltyIssued: boolean;
    maxIntendedParkingDurationMinutes?: number | undefined;
    firstEntryDateTime: DateTime;
    lastEntryDateTime: DateTime;
    pricingInformation?: ActiveParkingSessionPricingInformationDTO | undefined;
    parkingDuration: number;
    subscription?: ParkingSubscriptionLimitedDTO | undefined;
}

export enum ParkingSessionType {
    Unknown = 0,
    Parker = 1,
    Visitor = 2,
    ParkerAsVisitor = 3,
    Foreign = 4,
}

export class ActiveParkingSessionPricingInformationDTO implements IActiveParkingSessionPricingInformationDTO {
    parkingPrice?: CalculateParkingPriceResultDTO | undefined;
    parkingPriceCalculationTime!: DateTime;
    alreadyPaidParkingMinutes!: number;
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;

    constructor(data?: IActiveParkingSessionPricingInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parkingPrice = _data["parkingPrice"] ? CalculateParkingPriceResultDTO.fromJS(_data["parkingPrice"]) : undefined as any;
            this.parkingPriceCalculationTime = _data["parkingPriceCalculationTime"] ? DateTime.fromISO(_data["parkingPriceCalculationTime"].toString()) : undefined as any;
            this.alreadyPaidParkingMinutes = _data["alreadyPaidParkingMinutes"];
            this.paymentAliasId = _data["paymentAliasId"];
            this.directPayPaymentType = _data["directPayPaymentType"];
        }
    }

    static fromJS(data: any): ActiveParkingSessionPricingInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveParkingSessionPricingInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parkingPrice"] = this.parkingPrice ? this.parkingPrice.toJSON() : undefined as any;
        data["parkingPriceCalculationTime"] = this.parkingPriceCalculationTime ? this.parkingPriceCalculationTime.toString() : undefined as any;
        data["alreadyPaidParkingMinutes"] = this.alreadyPaidParkingMinutes;
        data["paymentAliasId"] = this.paymentAliasId;
        data["directPayPaymentType"] = this.directPayPaymentType;
        return data;
    }
}

export interface IActiveParkingSessionPricingInformationDTO {
    parkingPrice?: CalculateParkingPriceResultDTO | undefined;
    parkingPriceCalculationTime: DateTime;
    alreadyPaidParkingMinutes: number;
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
}

export class ZoneInfoDTO implements IZoneInfoDTO {
    zone?: ZoneDTO | undefined;
    subscription?: ParkingSubscriptionDTO | undefined;
    validatingParkerId?: number | undefined;

    constructor(data?: IZoneInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zone = _data["zone"] ? ZoneDTO.fromJS(_data["zone"]) : undefined as any;
            this.subscription = _data["subscription"] ? ParkingSubscriptionDTO.fromJS(_data["subscription"]) : undefined as any;
            this.validatingParkerId = _data["validatingParkerId"];
        }
    }

    static fromJS(data: any): ZoneInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined as any;
        data["validatingParkerId"] = this.validatingParkerId;
        return data;
    }
}

export interface IZoneInfoDTO {
    zone?: ZoneDTO | undefined;
    subscription?: ParkingSubscriptionDTO | undefined;
    validatingParkerId?: number | undefined;
}

export enum PayTillNowResponseCode {
    Success = 0,
    ParkingPermitInvalid = 1,
    PriceChanged = 2,
    PaymentFailed = 3,
    NotAuthorized = 4,
    InputValidationError = 5,
}

export class GetUsersZoneInfosAndSessionsForValidationCodeDTO implements IGetUsersZoneInfosAndSessionsForValidationCodeDTO {
    validationCode?: string | undefined;

    constructor(data?: IGetUsersZoneInfosAndSessionsForValidationCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationCode = _data["validationCode"];
        }
    }

    static fromJS(data: any): GetUsersZoneInfosAndSessionsForValidationCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersZoneInfosAndSessionsForValidationCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationCode"] = this.validationCode;
        return data;
    }
}

export interface IGetUsersZoneInfosAndSessionsForValidationCodeDTO {
    validationCode?: string | undefined;
}

export class GetParkingProcessZoneInfosForValidationCodeDTO implements IGetParkingProcessZoneInfosForValidationCodeDTO {
    validationCode?: string | undefined;

    constructor(data?: IGetParkingProcessZoneInfosForValidationCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationCode = _data["validationCode"];
        }
    }

    static fromJS(data: any): GetParkingProcessZoneInfosForValidationCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetParkingProcessZoneInfosForValidationCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationCode"] = this.validationCode;
        return data;
    }
}

export interface IGetParkingProcessZoneInfosForValidationCodeDTO {
    validationCode?: string | undefined;
}

export class GetUsersZoneInfosAndSessionsForZoneDTO implements IGetUsersZoneInfosAndSessionsForZoneDTO {
    zoneId!: number;

    constructor(data?: IGetUsersZoneInfosAndSessionsForZoneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
        }
    }

    static fromJS(data: any): GetUsersZoneInfosAndSessionsForZoneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersZoneInfosAndSessionsForZoneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        return data;
    }
}

export interface IGetUsersZoneInfosAndSessionsForZoneDTO {
    zoneId: number;
}

export class HWControlledSessionInfoResultDTO implements IHWControlledSessionInfoResultDTO {
    responseCode!: PayTillNowResponseCode;
    session?: ActiveParkingSessionDTO | undefined;

    constructor(data?: IHWControlledSessionInfoResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.session = _data["session"] ? ActiveParkingSessionDTO.fromJS(_data["session"]) : undefined as any;
        }
    }

    static fromJS(data: any): HWControlledSessionInfoResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HWControlledSessionInfoResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["session"] = this.session ? this.session.toJSON() : undefined as any;
        return data;
    }
}

export interface IHWControlledSessionInfoResultDTO {
    responseCode: PayTillNowResponseCode;
    session?: ActiveParkingSessionDTO | undefined;
}

export class GetHWControlledSessionInfoForLicensePlateDTO implements IGetHWControlledSessionInfoForLicensePlateDTO {
    zoneId!: number;
    operationalLicensePlate?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    countryCode?: string | undefined;
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    validatingParkerId?: number | undefined;
    fullImageRequested!: boolean;
    licensePlateImageRequested!: boolean;

    constructor(data?: IGetHWControlledSessionInfoForLicensePlateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.operationalLicensePlate = _data["operationalLicensePlate"];
            this.controlPlateType = _data["controlPlateType"];
            this.countryCode = _data["countryCode"];
            this.paymentAliasId = _data["paymentAliasId"];
            this.directPayPaymentType = _data["directPayPaymentType"];
            this.validatingParkerId = _data["validatingParkerId"];
            this.fullImageRequested = _data["fullImageRequested"];
            this.licensePlateImageRequested = _data["licensePlateImageRequested"];
        }
    }

    static fromJS(data: any): GetHWControlledSessionInfoForLicensePlateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetHWControlledSessionInfoForLicensePlateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["operationalLicensePlate"] = this.operationalLicensePlate;
        data["controlPlateType"] = this.controlPlateType;
        data["countryCode"] = this.countryCode;
        data["paymentAliasId"] = this.paymentAliasId;
        data["directPayPaymentType"] = this.directPayPaymentType;
        data["validatingParkerId"] = this.validatingParkerId;
        data["fullImageRequested"] = this.fullImageRequested;
        data["licensePlateImageRequested"] = this.licensePlateImageRequested;
        return data;
    }
}

export interface IGetHWControlledSessionInfoForLicensePlateDTO {
    zoneId: number;
    operationalLicensePlate?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    countryCode?: string | undefined;
    paymentAliasId?: number | undefined;
    directPayPaymentType?: PaymentType | undefined;
    validatingParkerId?: number | undefined;
    fullImageRequested: boolean;
    licensePlateImageRequested: boolean;
}

export class PayTillNowStartPaymentResultDTO implements IPayTillNowStartPaymentResultDTO {
    responseCode!: PayTillNowResponseCode;
    paymentId?: number | undefined;
    paymentAltIdent?: string | undefined;
    paymentTime!: DateTime;
    subscriptionId!: number;
    validatingParkerId?: number | undefined;
    redirectionUrl?: string | undefined;
    successUrl?: string | undefined;
    failedUrl?: string | undefined;

    constructor(data?: IPayTillNowStartPaymentResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.paymentId = _data["paymentId"];
            this.paymentAltIdent = _data["paymentAltIdent"];
            this.paymentTime = _data["paymentTime"] ? DateTime.fromISO(_data["paymentTime"].toString()) : undefined as any;
            this.subscriptionId = _data["subscriptionId"];
            this.validatingParkerId = _data["validatingParkerId"];
            this.redirectionUrl = _data["redirectionUrl"];
            this.successUrl = _data["successUrl"];
            this.failedUrl = _data["failedUrl"];
        }
    }

    static fromJS(data: any): PayTillNowStartPaymentResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PayTillNowStartPaymentResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["paymentId"] = this.paymentId;
        data["paymentAltIdent"] = this.paymentAltIdent;
        data["paymentTime"] = this.paymentTime ? this.paymentTime.toString() : undefined as any;
        data["subscriptionId"] = this.subscriptionId;
        data["validatingParkerId"] = this.validatingParkerId;
        data["redirectionUrl"] = this.redirectionUrl;
        data["successUrl"] = this.successUrl;
        data["failedUrl"] = this.failedUrl;
        return data;
    }
}

export interface IPayTillNowStartPaymentResultDTO {
    responseCode: PayTillNowResponseCode;
    paymentId?: number | undefined;
    paymentAltIdent?: string | undefined;
    paymentTime: DateTime;
    subscriptionId: number;
    validatingParkerId?: number | undefined;
    redirectionUrl?: string | undefined;
    successUrl?: string | undefined;
    failedUrl?: string | undefined;
}

export class PayTillNowStartPaymentDTO implements IPayTillNowStartPaymentDTO {
    sessionId!: number;
    subscriptionId!: number;
    validatingParkerId?: number | undefined;
    email?: string | undefined;
    pricingInformation?: ActiveParkingSessionPricingInformationDTO | undefined;

    constructor(data?: IPayTillNowStartPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.subscriptionId = _data["subscriptionId"];
            this.validatingParkerId = _data["validatingParkerId"];
            this.email = _data["email"];
            this.pricingInformation = _data["pricingInformation"] ? ActiveParkingSessionPricingInformationDTO.fromJS(_data["pricingInformation"]) : undefined as any;
        }
    }

    static fromJS(data: any): PayTillNowStartPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PayTillNowStartPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["subscriptionId"] = this.subscriptionId;
        data["validatingParkerId"] = this.validatingParkerId;
        data["email"] = this.email;
        data["pricingInformation"] = this.pricingInformation ? this.pricingInformation.toJSON() : undefined as any;
        return data;
    }
}

export interface IPayTillNowStartPaymentDTO {
    sessionId: number;
    subscriptionId: number;
    validatingParkerId?: number | undefined;
    email?: string | undefined;
    pricingInformation?: ActiveParkingSessionPricingInformationDTO | undefined;
}

export class SetPayTillNowPaymentDoneResultDTO implements ISetPayTillNowPaymentDoneResultDTO {
    responseCode!: PayTillNowResponseCode;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;

    constructor(data?: ISetPayTillNowPaymentDoneResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.parkingPriceDetails = _data["parkingPriceDetails"] ? ParkingPriceDetailsDTO.fromJS(_data["parkingPriceDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): SetPayTillNowPaymentDoneResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetPayTillNowPaymentDoneResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["parkingPriceDetails"] = this.parkingPriceDetails ? this.parkingPriceDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface ISetPayTillNowPaymentDoneResultDTO {
    responseCode: PayTillNowResponseCode;
    parkingPriceDetails?: ParkingPriceDetailsDTO | undefined;
}

export class SetPayTillNowPaymentDoneDTO implements ISetPayTillNowPaymentDoneDTO {
    paymentId!: number;
    paymentCancelled!: boolean;

    constructor(data?: ISetPayTillNowPaymentDoneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.paymentCancelled = _data["paymentCancelled"];
        }
    }

    static fromJS(data: any): SetPayTillNowPaymentDoneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetPayTillNowPaymentDoneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["paymentCancelled"] = this.paymentCancelled;
        return data;
    }
}

export interface ISetPayTillNowPaymentDoneDTO {
    paymentId: number;
    paymentCancelled: boolean;
}

export class PayTillNowParkingSessionInfoDTO implements IPayTillNowParkingSessionInfoDTO {
    sessionId!: number;
    isClosed!: boolean;
    startDateTime!: DateTime;
    endDateTime?: DateTime | undefined;
    zoneName?: string | undefined;
    parkingSpaceNumber?: string | undefined;
    controlPlateNumber?: string | undefined;
    controlPlateCountryCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    totalWithVat!: number;
    currency!: Currency;
    calculatedParkingPriceDetails?: string | undefined;
    sessionClosingEventType?: SessionEventType | undefined;
    fastCheckinType?: FastCheckinType | undefined;
    timeStamp!: DateTime;
    alreadyPaidParkingMinutes!: number;

    constructor(data?: IPayTillNowParkingSessionInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.isClosed = _data["isClosed"];
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : undefined as any;
            this.zoneName = _data["zoneName"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.controlPlateCountryCode = _data["controlPlateCountryCode"];
            this.controlPlateType = _data["controlPlateType"];
            this.totalWithVat = _data["totalWithVat"];
            this.currency = _data["currency"];
            this.calculatedParkingPriceDetails = _data["calculatedParkingPriceDetails"];
            this.sessionClosingEventType = _data["sessionClosingEventType"];
            this.fastCheckinType = _data["fastCheckinType"];
            this.timeStamp = _data["timeStamp"] ? DateTime.fromISO(_data["timeStamp"].toString()) : undefined as any;
            this.alreadyPaidParkingMinutes = _data["alreadyPaidParkingMinutes"];
        }
    }

    static fromJS(data: any): PayTillNowParkingSessionInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PayTillNowParkingSessionInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["isClosed"] = this.isClosed;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : undefined as any;
        data["zoneName"] = this.zoneName;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["controlPlateCountryCode"] = this.controlPlateCountryCode;
        data["controlPlateType"] = this.controlPlateType;
        data["totalWithVat"] = this.totalWithVat;
        data["currency"] = this.currency;
        data["calculatedParkingPriceDetails"] = this.calculatedParkingPriceDetails;
        data["sessionClosingEventType"] = this.sessionClosingEventType;
        data["fastCheckinType"] = this.fastCheckinType;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toString() : undefined as any;
        data["alreadyPaidParkingMinutes"] = this.alreadyPaidParkingMinutes;
        return data;
    }
}

export interface IPayTillNowParkingSessionInfoDTO {
    sessionId: number;
    isClosed: boolean;
    startDateTime: DateTime;
    endDateTime?: DateTime | undefined;
    zoneName?: string | undefined;
    parkingSpaceNumber?: string | undefined;
    controlPlateNumber?: string | undefined;
    controlPlateCountryCode?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    totalWithVat: number;
    currency: Currency;
    calculatedParkingPriceDetails?: string | undefined;
    sessionClosingEventType?: SessionEventType | undefined;
    fastCheckinType?: FastCheckinType | undefined;
    timeStamp: DateTime;
    alreadyPaidParkingMinutes: number;
}

export class PayTillNowSessionDTO implements IPayTillNowSessionDTO {
    sessionIdent?: string | undefined;

    constructor(data?: IPayTillNowSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionIdent = _data["sessionIdent"];
        }
    }

    static fromJS(data: any): PayTillNowSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PayTillNowSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionIdent"] = this.sessionIdent;
        return data;
    }
}

export interface IPayTillNowSessionDTO {
    sessionIdent?: string | undefined;
}

export class CreateProblemReportDTO implements ICreateProblemReportDTO {
    model?: string | undefined;
    manufacturer?: string | undefined;
    deviceName?: string | undefined;
    versionString?: string | undefined;
    platform?: string | undefined;
    idiom?: string | undefined;
    deviceType?: string | undefined;
    problemMessage?: string | undefined;
    origin!: ProblemReportOrigin;
    logs?: CreateProblemReportLogDTO[] | undefined;

    constructor(data?: ICreateProblemReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"];
            this.manufacturer = _data["manufacturer"];
            this.deviceName = _data["deviceName"];
            this.versionString = _data["versionString"];
            this.platform = _data["platform"];
            this.idiom = _data["idiom"];
            this.deviceType = _data["deviceType"];
            this.problemMessage = _data["problemMessage"];
            this.origin = _data["origin"];
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(CreateProblemReportLogDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProblemReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProblemReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        data["manufacturer"] = this.manufacturer;
        data["deviceName"] = this.deviceName;
        data["versionString"] = this.versionString;
        data["platform"] = this.platform;
        data["idiom"] = this.idiom;
        data["deviceType"] = this.deviceType;
        data["problemMessage"] = this.problemMessage;
        data["origin"] = this.origin;
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateProblemReportDTO {
    model?: string | undefined;
    manufacturer?: string | undefined;
    deviceName?: string | undefined;
    versionString?: string | undefined;
    platform?: string | undefined;
    idiom?: string | undefined;
    deviceType?: string | undefined;
    problemMessage?: string | undefined;
    origin: ProblemReportOrigin;
    logs?: CreateProblemReportLogDTO[] | undefined;
}

export enum ProblemReportOrigin {
    AVPark = 0,
    AVCheck = 1,
}

export class CreateProblemReportLogDTO implements ICreateProblemReportLogDTO {
    timestamp!: DateTime;
    threadId?: string | undefined;
    level!: LogEventLevel;
    message?: string | undefined;
    exception?: string | undefined;

    constructor(data?: ICreateProblemReportLogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? DateTime.fromISO(_data["timestamp"].toString()) : undefined as any;
            this.threadId = _data["threadId"];
            this.level = _data["level"];
            this.message = _data["message"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): CreateProblemReportLogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProblemReportLogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toString() : undefined as any;
        data["threadId"] = this.threadId;
        data["level"] = this.level;
        data["message"] = this.message;
        data["exception"] = this.exception;
        return data;
    }
}

export interface ICreateProblemReportLogDTO {
    timestamp: DateTime;
    threadId?: string | undefined;
    level: LogEventLevel;
    message?: string | undefined;
    exception?: string | undefined;
}

/** Specifies the meaning and relative importance of a log event. */
export enum LogEventLevel {
    Verbose = 0,
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4,
    Fatal = 5,
}

export class PagedResultDTOOfProblemReportResponseDTO implements IPagedResultDTOOfProblemReportResponseDTO {
    items?: ProblemReportResponseDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfProblemReportResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProblemReportResponseDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfProblemReportResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfProblemReportResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfProblemReportResponseDTO {
    items?: ProblemReportResponseDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ProblemReportResponseDTO implements IProblemReportResponseDTO {
    id!: number;
    userId?: string | undefined;
    user?: LimitedUserInfoDTO | undefined;
    model?: string | undefined;
    manufacturer?: string | undefined;
    deviceName?: string | undefined;
    versionString?: string | undefined;
    platform?: string | undefined;
    idiom?: string | undefined;
    deviceType?: string | undefined;
    problemMessage?: string | undefined;
    origin!: ProblemReportOrigin;
    createdOn!: DateTime;

    constructor(data?: IProblemReportResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? LimitedUserInfoDTO.fromJS(_data["user"]) : undefined as any;
            this.model = _data["model"];
            this.manufacturer = _data["manufacturer"];
            this.deviceName = _data["deviceName"];
            this.versionString = _data["versionString"];
            this.platform = _data["platform"];
            this.idiom = _data["idiom"];
            this.deviceType = _data["deviceType"];
            this.problemMessage = _data["problemMessage"];
            this.origin = _data["origin"];
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ProblemReportResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemReportResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["model"] = this.model;
        data["manufacturer"] = this.manufacturer;
        data["deviceName"] = this.deviceName;
        data["versionString"] = this.versionString;
        data["platform"] = this.platform;
        data["idiom"] = this.idiom;
        data["deviceType"] = this.deviceType;
        data["problemMessage"] = this.problemMessage;
        data["origin"] = this.origin;
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        return data;
    }
}

export interface IProblemReportResponseDTO {
    id: number;
    userId?: string | undefined;
    user?: LimitedUserInfoDTO | undefined;
    model?: string | undefined;
    manufacturer?: string | undefined;
    deviceName?: string | undefined;
    versionString?: string | undefined;
    platform?: string | undefined;
    idiom?: string | undefined;
    deviceType?: string | undefined;
    problemMessage?: string | undefined;
    origin: ProblemReportOrigin;
    createdOn: DateTime;
}

export class PagedResultDTOOfProblemReportLogResponseDTO implements IPagedResultDTOOfProblemReportLogResponseDTO {
    items?: ProblemReportLogResponseDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfProblemReportLogResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProblemReportLogResponseDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfProblemReportLogResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfProblemReportLogResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfProblemReportLogResponseDTO {
    items?: ProblemReportLogResponseDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ProblemReportLogResponseDTO implements IProblemReportLogResponseDTO {
    id!: number;
    problemReportId!: number;
    timestamp!: DateTime;
    threadId?: string | undefined;
    level!: LogEventLevel;
    message?: string | undefined;
    exception?: string | undefined;

    constructor(data?: IProblemReportLogResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.problemReportId = _data["problemReportId"];
            this.timestamp = _data["timestamp"] ? DateTime.fromISO(_data["timestamp"].toString()) : undefined as any;
            this.threadId = _data["threadId"];
            this.level = _data["level"];
            this.message = _data["message"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): ProblemReportLogResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemReportLogResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["problemReportId"] = this.problemReportId;
        data["timestamp"] = this.timestamp ? this.timestamp.toString() : undefined as any;
        data["threadId"] = this.threadId;
        data["level"] = this.level;
        data["message"] = this.message;
        data["exception"] = this.exception;
        return data;
    }
}

export interface IProblemReportLogResponseDTO {
    id: number;
    problemReportId: number;
    timestamp: DateTime;
    threadId?: string | undefined;
    level: LogEventLevel;
    message?: string | undefined;
    exception?: string | undefined;
}

export class ProxyParkerDTO extends ParkerDTO implements IProxyParkerDTO {
    validZoneIds?: number[] | undefined;

    constructor(data?: IProxyParkerDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["validZoneIds"])) {
                this.validZoneIds = [] as any;
                for (let item of _data["validZoneIds"])
                    this.validZoneIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): ProxyParkerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyParkerDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validZoneIds)) {
            data["validZoneIds"] = [];
            for (let item of this.validZoneIds)
                data["validZoneIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProxyParkerDTO extends IParkerDTO {
    validZoneIds?: number[] | undefined;
}

export class ProxySyncInfoDTO implements IProxySyncInfoDTO {
    syncTime?: string | undefined;
    additionalData?: string | undefined;

    constructor(data?: IProxySyncInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncTime = _data["syncTime"];
            this.additionalData = _data["additionalData"];
        }
    }

    static fromJS(data: any): ProxySyncInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxySyncInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncTime"] = this.syncTime;
        data["additionalData"] = this.additionalData;
        return data;
    }
}

export interface IProxySyncInfoDTO {
    syncTime?: string | undefined;
    additionalData?: string | undefined;
}

export class ProxyParkerUpdateResponseDTO implements IProxyParkerUpdateResponseDTO {
    id!: number;
    proxyId!: number;
    tags?: ParkerTagDTO[] | undefined;

    constructor(data?: IProxyParkerUpdateResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proxyId = _data["proxyId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ParkerTagDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProxyParkerUpdateResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyParkerUpdateResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proxyId"] = this.proxyId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProxyParkerUpdateResponseDTO {
    id: number;
    proxyId: number;
    tags?: ParkerTagDTO[] | undefined;
}

export class ProxyUpdateParkerDTO extends UpdateParkerDTO implements IProxyUpdateParkerDTO {
    proxyId!: number;
    companyName?: string | undefined;

    constructor(data?: IProxyUpdateParkerDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.proxyId = _data["proxyId"];
            this.companyName = _data["companyName"];
        }
    }

    static override fromJS(data: any): ProxyUpdateParkerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyUpdateParkerDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proxyId"] = this.proxyId;
        data["companyName"] = this.companyName;
        super.toJSON(data);
        return data;
    }
}

export interface IProxyUpdateParkerDTO extends IUpdateParkerDTO {
    proxyId: number;
    companyName?: string | undefined;
}

export class ProxyUpdateTagsResponseDTO implements IProxyUpdateTagsResponseDTO {
    tags?: ParkerTagDTO[] | undefined;

    constructor(data?: IProxyUpdateTagsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ParkerTagDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProxyUpdateTagsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyUpdateTagsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProxyUpdateTagsResponseDTO {
    tags?: ParkerTagDTO[] | undefined;
}

export class ProxyUpdateTagsDTO implements IProxyUpdateTagsDTO {
    tags?: UpdateParkerTagDTO[] | undefined;

    constructor(data?: IProxyUpdateTagsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(UpdateParkerTagDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProxyUpdateTagsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyUpdateTagsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProxyUpdateTagsDTO {
    tags?: UpdateParkerTagDTO[] | undefined;
}

export class ProxyAddTagRegistrationsDTO implements IProxyAddTagRegistrationsDTO {
    tags?: ProxyTagRegistrationDTO[] | undefined;

    constructor(data?: IProxyAddTagRegistrationsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ProxyTagRegistrationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProxyAddTagRegistrationsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyAddTagRegistrationsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProxyAddTagRegistrationsDTO {
    tags?: ProxyTagRegistrationDTO[] | undefined;
}

export class ProxyTagRegistrationDTO implements IProxyTagRegistrationDTO {
    tagIdentificationCode?: string | undefined;
    deviceId!: number;
    timeStamp!: DateTime;
    parkingSpaceNumber?: string | undefined;

    constructor(data?: IProxyTagRegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagIdentificationCode = _data["tagIdentificationCode"];
            this.deviceId = _data["deviceId"];
            this.timeStamp = _data["timeStamp"] ? DateTime.fromISO(_data["timeStamp"].toString()) : undefined as any;
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
        }
    }

    static fromJS(data: any): ProxyTagRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyTagRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagIdentificationCode"] = this.tagIdentificationCode;
        data["deviceId"] = this.deviceId;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toString() : undefined as any;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        return data;
    }
}

export interface IProxyTagRegistrationDTO {
    tagIdentificationCode?: string | undefined;
    deviceId: number;
    timeStamp: DateTime;
    parkingSpaceNumber?: string | undefined;
}

export class ProxyAddNonTaggedRegistrationsDTO implements IProxyAddNonTaggedRegistrationsDTO {
    registrations?: AddNonTaggedRegistrationDTO[] | undefined;

    constructor(data?: IProxyAddNonTaggedRegistrationsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["registrations"])) {
                this.registrations = [] as any;
                for (let item of _data["registrations"])
                    this.registrations!.push(AddNonTaggedRegistrationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProxyAddNonTaggedRegistrationsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyAddNonTaggedRegistrationsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.registrations)) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProxyAddNonTaggedRegistrationsDTO {
    registrations?: AddNonTaggedRegistrationDTO[] | undefined;
}

export class ProxyRequestAccessByTagResponseDTO implements IProxyRequestAccessByTagResponseDTO {
    grantAccess?: boolean | undefined;

    constructor(data?: IProxyRequestAccessByTagResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grantAccess = _data["grantAccess"];
        }
    }

    static fromJS(data: any): ProxyRequestAccessByTagResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyRequestAccessByTagResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grantAccess"] = this.grantAccess;
        return data;
    }
}

export interface IProxyRequestAccessByTagResponseDTO {
    grantAccess?: boolean | undefined;
}

export class ProxyRequestAccessByTagDTO implements IProxyRequestAccessByTagDTO {
    deviceId!: number;
    registrationTimeUtc!: DateTime;
    tid!: string;
    epc?: string | undefined;

    constructor(data?: IProxyRequestAccessByTagDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.registrationTimeUtc = _data["registrationTimeUtc"] ? DateTime.fromISO(_data["registrationTimeUtc"].toString()) : undefined as any;
            this.tid = _data["tid"];
            this.epc = _data["epc"];
        }
    }

    static fromJS(data: any): ProxyRequestAccessByTagDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyRequestAccessByTagDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["registrationTimeUtc"] = this.registrationTimeUtc ? this.registrationTimeUtc.toString() : undefined as any;
        data["tid"] = this.tid;
        data["epc"] = this.epc;
        return data;
    }
}

export interface IProxyRequestAccessByTagDTO {
    deviceId: number;
    registrationTimeUtc: DateTime;
    tid: string;
    epc?: string | undefined;
}

export class ProxyRequestAccessByPlateResponseDTO implements IProxyRequestAccessByPlateResponseDTO {
    grantAccess?: AccessGrantedType | undefined;

    constructor(data?: IProxyRequestAccessByPlateResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grantAccess = _data["grantAccess"];
        }
    }

    static fromJS(data: any): ProxyRequestAccessByPlateResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyRequestAccessByPlateResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grantAccess"] = this.grantAccess;
        return data;
    }
}

export interface IProxyRequestAccessByPlateResponseDTO {
    grantAccess?: AccessGrantedType | undefined;
}

export enum AccessGrantedType {
    Declined = 0,
    Granted = 1,
    BackPaymentNeeded = 2,
}

export class ProxyRequestAccessByPlateDTO implements IProxyRequestAccessByPlateDTO {
    deviceId!: number;
    requestTimeUtc!: DateTime;
    operationalPlateNumber!: string;
    controlPlateType?: ControlPlateType | undefined;
    countryCode?: string | undefined;
    parkingSpaceNumber?: string | undefined;
    recognitionPictureBase64?: string | undefined;
    recognitionPlateBase64?: string | undefined;

    constructor(data?: IProxyRequestAccessByPlateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.requestTimeUtc = _data["requestTimeUtc"] ? DateTime.fromISO(_data["requestTimeUtc"].toString()) : undefined as any;
            this.operationalPlateNumber = _data["operationalPlateNumber"];
            this.controlPlateType = _data["controlPlateType"];
            this.countryCode = _data["countryCode"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.recognitionPictureBase64 = _data["recognitionPictureBase64"];
            this.recognitionPlateBase64 = _data["recognitionPlateBase64"];
        }
    }

    static fromJS(data: any): ProxyRequestAccessByPlateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyRequestAccessByPlateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["requestTimeUtc"] = this.requestTimeUtc ? this.requestTimeUtc.toString() : undefined as any;
        data["operationalPlateNumber"] = this.operationalPlateNumber;
        data["controlPlateType"] = this.controlPlateType;
        data["countryCode"] = this.countryCode;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["recognitionPictureBase64"] = this.recognitionPictureBase64;
        data["recognitionPlateBase64"] = this.recognitionPlateBase64;
        return data;
    }
}

export interface IProxyRequestAccessByPlateDTO {
    deviceId: number;
    requestTimeUtc: DateTime;
    operationalPlateNumber: string;
    controlPlateType?: ControlPlateType | undefined;
    countryCode?: string | undefined;
    parkingSpaceNumber?: string | undefined;
    recognitionPictureBase64?: string | undefined;
    recognitionPlateBase64?: string | undefined;
}

export class ProxyRegisterDeviceCommandExecutionDTO implements IProxyRegisterDeviceCommandExecutionDTO {
    deviceId!: number;
    executed!: boolean;
    executedCommand!: string;
    executionContext!: CommandExecutionContextDTO;

    constructor(data?: IProxyRegisterDeviceCommandExecutionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.executionContext = new CommandExecutionContextDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.executed = _data["executed"];
            this.executedCommand = _data["executedCommand"];
            this.executionContext = _data["executionContext"] ? CommandExecutionContextDTO.fromJS(_data["executionContext"]) : new CommandExecutionContextDTO();
        }
    }

    static fromJS(data: any): ProxyRegisterDeviceCommandExecutionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyRegisterDeviceCommandExecutionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["executed"] = this.executed;
        data["executedCommand"] = this.executedCommand;
        data["executionContext"] = this.executionContext ? this.executionContext.toJSON() : undefined as any;
        return data;
    }
}

export interface IProxyRegisterDeviceCommandExecutionDTO {
    deviceId: number;
    executed: boolean;
    executedCommand: string;
    executionContext: CommandExecutionContextDTO;
}

export class CommandExecutionContextDTO implements ICommandExecutionContextDTO {
    executedUserId?: string | undefined;
    executionTimeUtc?: DateTime | undefined;
    contextData?: string | undefined;

    constructor(data?: ICommandExecutionContextDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.executedUserId = _data["executedUserId"];
            this.executionTimeUtc = _data["executionTimeUtc"] ? DateTime.fromISO(_data["executionTimeUtc"].toString()) : undefined as any;
            this.contextData = _data["contextData"];
        }
    }

    static fromJS(data: any): CommandExecutionContextDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CommandExecutionContextDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executedUserId"] = this.executedUserId;
        data["executionTimeUtc"] = this.executionTimeUtc ? this.executionTimeUtc.toString() : undefined as any;
        data["contextData"] = this.contextData;
        return data;
    }
}

export interface ICommandExecutionContextDTO {
    executedUserId?: string | undefined;
    executionTimeUtc?: DateTime | undefined;
    contextData?: string | undefined;
}

export class ProxyUpdateZoneDeviceDTO implements IProxyUpdateZoneDeviceDTO {
    deviceId!: number;
    deviceState?: ZoneDeviceState | undefined;
    devicePosition?: string | undefined;

    constructor(data?: IProxyUpdateZoneDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.deviceState = _data["deviceState"];
            this.devicePosition = _data["devicePosition"];
        }
    }

    static fromJS(data: any): ProxyUpdateZoneDeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyUpdateZoneDeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceState"] = this.deviceState;
        data["devicePosition"] = this.devicePosition;
        return data;
    }
}

export interface IProxyUpdateZoneDeviceDTO {
    deviceId: number;
    deviceState?: ZoneDeviceState | undefined;
    devicePosition?: string | undefined;
}

export class HeartBeatInfoDTO implements IHeartBeatInfoDTO {
    presentDeviceList?: number[] | undefined;
    notPresentDeviceList?: number[] | undefined;

    constructor(data?: IHeartBeatInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["presentDeviceList"])) {
                this.presentDeviceList = [] as any;
                for (let item of _data["presentDeviceList"])
                    this.presentDeviceList!.push(item);
            }
            if (Array.isArray(_data["notPresentDeviceList"])) {
                this.notPresentDeviceList = [] as any;
                for (let item of _data["notPresentDeviceList"])
                    this.notPresentDeviceList!.push(item);
            }
        }
    }

    static fromJS(data: any): HeartBeatInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HeartBeatInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.presentDeviceList)) {
            data["presentDeviceList"] = [];
            for (let item of this.presentDeviceList)
                data["presentDeviceList"].push(item);
        }
        if (Array.isArray(this.notPresentDeviceList)) {
            data["notPresentDeviceList"] = [];
            for (let item of this.notPresentDeviceList)
                data["notPresentDeviceList"].push(item);
        }
        return data;
    }
}

export interface IHeartBeatInfoDTO {
    presentDeviceList?: number[] | undefined;
    notPresentDeviceList?: number[] | undefined;
}

export class ImportTagsDTO implements IImportTagsDTO {
    tags!: ImportTagMasterDTO[];

    constructor(data?: IImportTagsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ImportTagMasterDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportTagsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTagsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportTagsDTO {
    tags: ImportTagMasterDTO[];
}

export class ImportTagMasterDTO implements IImportTagMasterDTO {
    tagId?: string | undefined;
    description?: string | undefined;

    constructor(data?: IImportTagMasterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ImportTagMasterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTagMasterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["description"] = this.description;
        return data;
    }
}

export interface IImportTagMasterDTO {
    tagId?: string | undefined;
    description?: string | undefined;
}

export class ProxyZoneDeviceDTO implements IProxyZoneDeviceDTO {
    id!: number;
    clientId!: number;
    name?: string | undefined;
    zone?: ZoneDTO | undefined;
    description?: string | undefined;
    enabled!: boolean;
    groupControllerDeviceId?: number | undefined;
    coordinates?: string | undefined;
    deviceType!: ZoneDeviceType;
    brand!: ZoneDeviceBrand;
    direction?: ZoneDeviceDirection | undefined;
    serializedParameters?: string | undefined;

    constructor(data?: IProxyZoneDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.zone = _data["zone"] ? ZoneDTO.fromJS(_data["zone"]) : undefined as any;
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.groupControllerDeviceId = _data["groupControllerDeviceId"];
            this.coordinates = _data["coordinates"];
            this.deviceType = _data["deviceType"];
            this.brand = _data["brand"];
            this.direction = _data["direction"];
            this.serializedParameters = _data["serializedParameters"];
        }
    }

    static fromJS(data: any): ProxyZoneDeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyZoneDeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["groupControllerDeviceId"] = this.groupControllerDeviceId;
        data["coordinates"] = this.coordinates;
        data["deviceType"] = this.deviceType;
        data["brand"] = this.brand;
        data["direction"] = this.direction;
        data["serializedParameters"] = this.serializedParameters;
        return data;
    }
}

export interface IProxyZoneDeviceDTO {
    id: number;
    clientId: number;
    name?: string | undefined;
    zone?: ZoneDTO | undefined;
    description?: string | undefined;
    enabled: boolean;
    groupControllerDeviceId?: number | undefined;
    coordinates?: string | undefined;
    deviceType: ZoneDeviceType;
    brand: ZoneDeviceBrand;
    direction?: ZoneDeviceDirection | undefined;
    serializedParameters?: string | undefined;
}

export class ProxyExecuteCommandDTO implements IProxyExecuteCommandDTO {
    commandType!: ProxyExecuteCommandType;
    commandToExecute?: string | undefined;
    identification!: number;
    executionContext?: CommandExecutionContextDTO | undefined;

    constructor(data?: IProxyExecuteCommandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commandType = _data["commandType"];
            this.commandToExecute = _data["commandToExecute"];
            this.identification = _data["identification"];
            this.executionContext = _data["executionContext"] ? CommandExecutionContextDTO.fromJS(_data["executionContext"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProxyExecuteCommandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProxyExecuteCommandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandType"] = this.commandType;
        data["commandToExecute"] = this.commandToExecute;
        data["identification"] = this.identification;
        data["executionContext"] = this.executionContext ? this.executionContext.toJSON() : undefined as any;
        return data;
    }
}

export interface IProxyExecuteCommandDTO {
    commandType: ProxyExecuteCommandType;
    commandToExecute?: string | undefined;
    identification: number;
    executionContext?: CommandExecutionContextDTO | undefined;
}

export enum ProxyExecuteCommandType {
    DeviceCommand = 0,
    ProxyCommand = 1,
}

export class PagedResultDTOOfSavedReportDTO implements IPagedResultDTOOfSavedReportDTO {
    items?: SavedReportDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfSavedReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SavedReportDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfSavedReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfSavedReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfSavedReportDTO {
    items?: SavedReportDTO[] | undefined;
    totalNumberOfItems: number;
}

export class SavedReportDTO implements ISavedReportDTO {
    id!: number;
    reportName?: string | undefined;
    createdDateTime!: DateTime;
    createdBy?: LimitedUserInfoDTO | undefined;
    reportType!: ReportType;

    constructor(data?: ISavedReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportName = _data["reportName"];
            this.createdDateTime = _data["createdDateTime"] ? DateTime.fromISO(_data["createdDateTime"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"] ? LimitedUserInfoDTO.fromJS(_data["createdBy"]) : undefined as any;
            this.reportType = _data["reportType"];
        }
    }

    static fromJS(data: any): SavedReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SavedReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportName"] = this.reportName;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toString() : undefined as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["reportType"] = this.reportType;
        return data;
    }
}

export interface ISavedReportDTO {
    id: number;
    reportName?: string | undefined;
    createdDateTime: DateTime;
    createdBy?: LimitedUserInfoDTO | undefined;
    reportType: ReportType;
}

export enum ReportType {
    TagsPerParker = 0,
    ParkerRegistrations = 1,
    FalseRecordings = 2,
    ParkerTurnover = 3,
    ParkerExtract = 4,
    DeviceStatus = 5,
    AutomaticParking = 6,
    Payment = 7,
    UserExtract = 8,
    ParkingPermit = 9,
    ParkingSessionDetails = 10,
}

export class StatusClientDTO implements IStatusClientDTO {
    id!: number;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    modifiedOn!: DateTime;

    constructor(data?: IStatusClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StatusClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        return data;
    }
}

export interface IStatusClientDTO {
    id: number;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    modifiedOn: DateTime;
}

export class PagedResultDTOOfStatusClientAdminDTO implements IPagedResultDTOOfStatusClientAdminDTO {
    items?: StatusClientAdminDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfStatusClientAdminDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatusClientAdminDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfStatusClientAdminDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfStatusClientAdminDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfStatusClientAdminDTO {
    items?: StatusClientAdminDTO[] | undefined;
    totalNumberOfItems: number;
}

export class StatusClientAdminDTO implements IStatusClientAdminDTO {
    id!: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    clientId?: number | undefined;
    email?: string | undefined;
    language?: string | undefined;
    modifiedOn!: DateTime;

    constructor(data?: IStatusClientAdminDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.clientId = _data["clientId"];
            this.email = _data["email"];
            this.language = _data["language"];
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StatusClientAdminDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusClientAdminDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["clientId"] = this.clientId;
        data["email"] = this.email;
        data["language"] = this.language;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        return data;
    }
}

export interface IStatusClientAdminDTO {
    id: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    clientId?: number | undefined;
    email?: string | undefined;
    language?: string | undefined;
    modifiedOn: DateTime;
}

export class PagedResultDTOOfStatusUserDTO implements IPagedResultDTOOfStatusUserDTO {
    items?: StatusUserDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfStatusUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatusUserDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfStatusUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfStatusUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfStatusUserDTO {
    items?: StatusUserDTO[] | undefined;
    totalNumberOfItems: number;
}

export class StatusUserDTO extends StatusClientAdminDTO implements IStatusUserDTO {
    deviceInfos?: StatusDeviceInfoDTO[] | undefined;

    constructor(data?: IStatusUserDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["deviceInfos"])) {
                this.deviceInfos = [] as any;
                for (let item of _data["deviceInfos"])
                    this.deviceInfos!.push(StatusDeviceInfoDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): StatusUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusUserDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deviceInfos)) {
            data["deviceInfos"] = [];
            for (let item of this.deviceInfos)
                data["deviceInfos"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStatusUserDTO extends IStatusClientAdminDTO {
    deviceInfos?: StatusDeviceInfoDTO[] | undefined;
}

export class StatusDeviceInfoDTO implements IStatusDeviceInfoDTO {
    id!: number;
    deviceIdentifier!: string;
    devicePlatform!: MobilePlatform;
    deviceVersion?: string | undefined;
    deviceModel?: string | undefined;
    deviceName?: string | undefined;
    deviceInfoSerialization?: string | undefined;
    fcmToken?: string | undefined;
    userId?: string | undefined;
    appVersion?: string | undefined;
    modifiedOn!: DateTime;

    constructor(data?: IStatusDeviceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deviceIdentifier = _data["deviceIdentifier"];
            this.devicePlatform = _data["devicePlatform"];
            this.deviceVersion = _data["deviceVersion"];
            this.deviceModel = _data["deviceModel"];
            this.deviceName = _data["deviceName"];
            this.deviceInfoSerialization = _data["deviceInfoSerialization"];
            this.fcmToken = _data["fcmToken"];
            this.userId = _data["userId"];
            this.appVersion = _data["appVersion"];
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StatusDeviceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDeviceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["devicePlatform"] = this.devicePlatform;
        data["deviceVersion"] = this.deviceVersion;
        data["deviceModel"] = this.deviceModel;
        data["deviceName"] = this.deviceName;
        data["deviceInfoSerialization"] = this.deviceInfoSerialization;
        data["fcmToken"] = this.fcmToken;
        data["userId"] = this.userId;
        data["appVersion"] = this.appVersion;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        return data;
    }
}

export interface IStatusDeviceInfoDTO {
    id: number;
    deviceIdentifier: string;
    devicePlatform: MobilePlatform;
    deviceVersion?: string | undefined;
    deviceModel?: string | undefined;
    deviceName?: string | undefined;
    deviceInfoSerialization?: string | undefined;
    fcmToken?: string | undefined;
    userId?: string | undefined;
    appVersion?: string | undefined;
    modifiedOn: DateTime;
}

export class SystemInformationDTO implements ISystemInformationDTO {
    informationValidForPlatform!: MobilePlatform;
    minimumClientVersion?: string | undefined;
    webClientBaseUri?: string | undefined;

    constructor(data?: ISystemInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.informationValidForPlatform = _data["informationValidForPlatform"];
            this.minimumClientVersion = _data["minimumClientVersion"];
            this.webClientBaseUri = _data["webClientBaseUri"];
        }
    }

    static fromJS(data: any): SystemInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["informationValidForPlatform"] = this.informationValidForPlatform;
        data["minimumClientVersion"] = this.minimumClientVersion;
        data["webClientBaseUri"] = this.webClientBaseUri;
        return data;
    }
}

export interface ISystemInformationDTO {
    informationValidForPlatform: MobilePlatform;
    minimumClientVersion?: string | undefined;
    webClientBaseUri?: string | undefined;
}

export class PagedResultDTOOfTagMasterDTO implements IPagedResultDTOOfTagMasterDTO {
    items?: TagMasterDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfTagMasterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TagMasterDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfTagMasterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfTagMasterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfTagMasterDTO {
    items?: TagMasterDTO[] | undefined;
    totalNumberOfItems: number;
}

export class TagMasterDTO implements ITagMasterDTO {
    id!: number;
    tagId!: string;
    description!: string;
    clientId!: number;
    parkerId?: number | undefined;
    parkerName?: string | undefined;
    assignedOn?: DateTime | undefined;
    isActive!: boolean;

    constructor(data?: ITagMasterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagId = _data["tagId"];
            this.description = _data["description"];
            this.clientId = _data["clientId"];
            this.parkerId = _data["parkerId"];
            this.parkerName = _data["parkerName"];
            this.assignedOn = _data["assignedOn"] ? DateTime.fromISO(_data["assignedOn"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TagMasterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TagMasterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagId"] = this.tagId;
        data["description"] = this.description;
        data["clientId"] = this.clientId;
        data["parkerId"] = this.parkerId;
        data["parkerName"] = this.parkerName;
        data["assignedOn"] = this.assignedOn ? this.assignedOn.toString() : undefined as any;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITagMasterDTO {
    id: number;
    tagId: string;
    description: string;
    clientId: number;
    parkerId?: number | undefined;
    parkerName?: string | undefined;
    assignedOn?: DateTime | undefined;
    isActive: boolean;
}

export class PagedResultDTOOfTagsPerParkerReportDTO implements IPagedResultDTOOfTagsPerParkerReportDTO {
    items?: TagsPerParkerReportDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfTagsPerParkerReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TagsPerParkerReportDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfTagsPerParkerReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfTagsPerParkerReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfTagsPerParkerReportDTO {
    items?: TagsPerParkerReportDTO[] | undefined;
    totalNumberOfItems: number;
}

export class TagsPerParkerReportDTO implements ITagsPerParkerReportDTO {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: string | undefined;
    parkerTag?: ParkerTagDTO | undefined;

    constructor(data?: ITagsPerParkerReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.company = _data["company"];
            this.parkerTag = _data["parkerTag"] ? ParkerTagDTO.fromJS(_data["parkerTag"]) : undefined as any;
        }
    }

    static fromJS(data: any): TagsPerParkerReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TagsPerParkerReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["company"] = this.company;
        data["parkerTag"] = this.parkerTag ? this.parkerTag.toJSON() : undefined as any;
        return data;
    }
}

export interface ITagsPerParkerReportDTO {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: string | undefined;
    parkerTag?: ParkerTagDTO | undefined;
}

export class TagsPerParkerReportParameterDTO implements ITagsPerParkerReportParameterDTO {
    parkerId?: number | undefined;
    companyId?: number | undefined;
    searchText?: string | undefined;

    constructor(data?: ITagsPerParkerReportParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parkerId = _data["parkerId"];
            this.companyId = _data["companyId"];
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): TagsPerParkerReportParameterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TagsPerParkerReportParameterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parkerId"] = this.parkerId;
        data["companyId"] = this.companyId;
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface ITagsPerParkerReportParameterDTO {
    parkerId?: number | undefined;
    companyId?: number | undefined;
    searchText?: string | undefined;
}

export class ThirdPartyCheckLicensePlateResultDTO implements IThirdPartyCheckLicensePlateResultDTO {
    /** The considered number of hours */
    consideredNoOfHours!: number;
    /** The requested control plate */
    controlPlate?: string | undefined;
    /** The applied control plate type filter */
    appliedControlPlateTypeFilter?: ControlPlateType | undefined;
    /** The applied country code filter */
    appliedControlPlateCountryCodeFilter?: string | undefined;
    /** The found sessions within the considered hours */
    sessions?: ThirdPartyCheckLicensePlateSessionResultDTO[] | undefined;

    constructor(data?: IThirdPartyCheckLicensePlateResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consideredNoOfHours = _data["consideredNoOfHours"];
            this.controlPlate = _data["controlPlate"];
            this.appliedControlPlateTypeFilter = _data["appliedControlPlateTypeFilter"];
            this.appliedControlPlateCountryCodeFilter = _data["appliedControlPlateCountryCodeFilter"];
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(ThirdPartyCheckLicensePlateSessionResultDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ThirdPartyCheckLicensePlateResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyCheckLicensePlateResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consideredNoOfHours"] = this.consideredNoOfHours;
        data["controlPlate"] = this.controlPlate;
        data["appliedControlPlateTypeFilter"] = this.appliedControlPlateTypeFilter;
        data["appliedControlPlateCountryCodeFilter"] = this.appliedControlPlateCountryCodeFilter;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IThirdPartyCheckLicensePlateResultDTO {
    /** The considered number of hours */
    consideredNoOfHours: number;
    /** The requested control plate */
    controlPlate?: string | undefined;
    /** The applied control plate type filter */
    appliedControlPlateTypeFilter?: ControlPlateType | undefined;
    /** The applied country code filter */
    appliedControlPlateCountryCodeFilter?: string | undefined;
    /** The found sessions within the considered hours */
    sessions?: ThirdPartyCheckLicensePlateSessionResultDTO[] | undefined;
}

export class ThirdPartyCheckLicensePlateSessionResultDTO implements IThirdPartyCheckLicensePlateSessionResultDTO {
    /** The control plate type */
    controlPlateType?: ControlPlateType | undefined;
    /** The country code of the control plate */
    controlPlateCountryCode?: string | undefined;
    /** The start date of the session */
    sessionStartUtc!: DateTime;
    /** The endtime of the parking session. If null, the session was started without given end time or duration and runs as long the user checks out */
    sessionEndUtc?: DateTime | undefined;
    /** This session is still active */
    sessionActive!: boolean;
    /** The name of the zone */
    zoneName?: string | undefined;
    /** The parking space number if set. Null if no number is set */
    parkingSpaceNumber?: string | undefined;
    /** This session happened/is happening under foreign parker conditions */
    isForeignParker!: boolean;

    constructor(data?: IThirdPartyCheckLicensePlateSessionResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controlPlateType = _data["controlPlateType"];
            this.controlPlateCountryCode = _data["controlPlateCountryCode"];
            this.sessionStartUtc = _data["sessionStartUtc"] ? DateTime.fromISO(_data["sessionStartUtc"].toString()) : undefined as any;
            this.sessionEndUtc = _data["sessionEndUtc"] ? DateTime.fromISO(_data["sessionEndUtc"].toString()) : undefined as any;
            this.sessionActive = _data["sessionActive"];
            this.zoneName = _data["zoneName"];
            this.parkingSpaceNumber = _data["parkingSpaceNumber"];
            this.isForeignParker = _data["isForeignParker"];
        }
    }

    static fromJS(data: any): ThirdPartyCheckLicensePlateSessionResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyCheckLicensePlateSessionResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlPlateType"] = this.controlPlateType;
        data["controlPlateCountryCode"] = this.controlPlateCountryCode;
        data["sessionStartUtc"] = this.sessionStartUtc ? this.sessionStartUtc.toString() : undefined as any;
        data["sessionEndUtc"] = this.sessionEndUtc ? this.sessionEndUtc.toString() : undefined as any;
        data["sessionActive"] = this.sessionActive;
        data["zoneName"] = this.zoneName;
        data["parkingSpaceNumber"] = this.parkingSpaceNumber;
        data["isForeignParker"] = this.isForeignParker;
        return data;
    }
}

export interface IThirdPartyCheckLicensePlateSessionResultDTO {
    /** The control plate type */
    controlPlateType?: ControlPlateType | undefined;
    /** The country code of the control plate */
    controlPlateCountryCode?: string | undefined;
    /** The start date of the session */
    sessionStartUtc: DateTime;
    /** The endtime of the parking session. If null, the session was started without given end time or duration and runs as long the user checks out */
    sessionEndUtc?: DateTime | undefined;
    /** This session is still active */
    sessionActive: boolean;
    /** The name of the zone */
    zoneName?: string | undefined;
    /** The parking space number if set. Null if no number is set */
    parkingSpaceNumber?: string | undefined;
    /** This session happened/is happening under foreign parker conditions */
    isForeignParker: boolean;
}

export class ThirdPartyCheckLicensePlateDTO implements IThirdPartyCheckLicensePlateDTO {
    /** Control plate to query. Only numbers and chars (case insensitive) are allowed. No spaces or special chars are expected. Ex. 'ZH1234' */
    controlPlate!: string;
    /** If set, only the control plates of the given types are queried */
    controlPlateType?: ControlPlateType | undefined;
    /** If set, only the control plates of the given country code (ex. 'ch') are queried. If set to null, all countries are considered */
    controlPlateCountryCode?: string | undefined;
    /** Timerange to be considered in the request. 0=only active sessions are delivered */
    consideredNoOfHours!: number;

    constructor(data?: IThirdPartyCheckLicensePlateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controlPlate = _data["controlPlate"];
            this.controlPlateType = _data["controlPlateType"];
            this.controlPlateCountryCode = _data["controlPlateCountryCode"];
            this.consideredNoOfHours = _data["consideredNoOfHours"];
        }
    }

    static fromJS(data: any): ThirdPartyCheckLicensePlateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyCheckLicensePlateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlPlate"] = this.controlPlate;
        data["controlPlateType"] = this.controlPlateType;
        data["controlPlateCountryCode"] = this.controlPlateCountryCode;
        data["consideredNoOfHours"] = this.consideredNoOfHours;
        return data;
    }
}

export interface IThirdPartyCheckLicensePlateDTO {
    /** Control plate to query. Only numbers and chars (case insensitive) are allowed. No spaces or special chars are expected. Ex. 'ZH1234' */
    controlPlate: string;
    /** If set, only the control plates of the given types are queried */
    controlPlateType?: ControlPlateType | undefined;
    /** If set, only the control plates of the given country code (ex. 'ch') are queried. If set to null, all countries are considered */
    controlPlateCountryCode?: string | undefined;
    /** Timerange to be considered in the request. 0=only active sessions are delivered */
    consideredNoOfHours: number;
}

export class PagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO implements IPagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO {
    items?: ThirdPartyUserClientZoneAssignmentDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ThirdPartyUserClientZoneAssignmentDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO {
    items?: ThirdPartyUserClientZoneAssignmentDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ThirdPartyUserClientZoneAssignmentDTO implements IThirdPartyUserClientZoneAssignmentDTO {
    id!: number;
    userId!: string;
    user?: ThirdPartyUserClientZoneAssignmentUserInfoDTO | undefined;
    zoneId?: number | undefined;
    zone?: ThirdPartyUserClientZoneAssignmentZoneInfoDTO | undefined;
    clientId!: number;
    client?: ThirdPartyUserClientZoneAssignmentClientInfoDTO | undefined;

    constructor(data?: IThirdPartyUserClientZoneAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? ThirdPartyUserClientZoneAssignmentUserInfoDTO.fromJS(_data["user"]) : undefined as any;
            this.zoneId = _data["zoneId"];
            this.zone = _data["zone"] ? ThirdPartyUserClientZoneAssignmentZoneInfoDTO.fromJS(_data["zone"]) : undefined as any;
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ThirdPartyUserClientZoneAssignmentClientInfoDTO.fromJS(_data["client"]) : undefined as any;
        }
    }

    static fromJS(data: any): ThirdPartyUserClientZoneAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyUserClientZoneAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["zoneId"] = this.zoneId;
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        return data;
    }
}

export interface IThirdPartyUserClientZoneAssignmentDTO {
    id: number;
    userId: string;
    user?: ThirdPartyUserClientZoneAssignmentUserInfoDTO | undefined;
    zoneId?: number | undefined;
    zone?: ThirdPartyUserClientZoneAssignmentZoneInfoDTO | undefined;
    clientId: number;
    client?: ThirdPartyUserClientZoneAssignmentClientInfoDTO | undefined;
}

export class ThirdPartyUserClientZoneAssignmentUserInfoDTO implements IThirdPartyUserClientZoneAssignmentUserInfoDTO {
    id!: string;
    userName?: string | undefined;

    constructor(data?: IThirdPartyUserClientZoneAssignmentUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ThirdPartyUserClientZoneAssignmentUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyUserClientZoneAssignmentUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IThirdPartyUserClientZoneAssignmentUserInfoDTO {
    id: string;
    userName?: string | undefined;
}

export class ThirdPartyUserClientZoneAssignmentZoneInfoDTO implements IThirdPartyUserClientZoneAssignmentZoneInfoDTO {
    id!: number;
    name?: string | undefined;
    parentName?: string | undefined;
    grandParentName?: string | undefined;
    grandGrandParentName?: string | undefined;
    clientId!: number;
    client?: ThirdPartyUserClientZoneAssignmentClientInfoDTO | undefined;

    constructor(data?: IThirdPartyUserClientZoneAssignmentZoneInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentName = _data["parentName"];
            this.grandParentName = _data["grandParentName"];
            this.grandGrandParentName = _data["grandGrandParentName"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ThirdPartyUserClientZoneAssignmentClientInfoDTO.fromJS(_data["client"]) : undefined as any;
        }
    }

    static fromJS(data: any): ThirdPartyUserClientZoneAssignmentZoneInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyUserClientZoneAssignmentZoneInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentName"] = this.parentName;
        data["grandParentName"] = this.grandParentName;
        data["grandGrandParentName"] = this.grandGrandParentName;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        return data;
    }
}

export interface IThirdPartyUserClientZoneAssignmentZoneInfoDTO {
    id: number;
    name?: string | undefined;
    parentName?: string | undefined;
    grandParentName?: string | undefined;
    grandGrandParentName?: string | undefined;
    clientId: number;
    client?: ThirdPartyUserClientZoneAssignmentClientInfoDTO | undefined;
}

export class ThirdPartyUserClientZoneAssignmentClientInfoDTO implements IThirdPartyUserClientZoneAssignmentClientInfoDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IThirdPartyUserClientZoneAssignmentClientInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ThirdPartyUserClientZoneAssignmentClientInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyUserClientZoneAssignmentClientInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IThirdPartyUserClientZoneAssignmentClientInfoDTO {
    id: number;
    name?: string | undefined;
}

export class CreateThirdPartyUserClientZoneAssignmentDTO implements ICreateThirdPartyUserClientZoneAssignmentDTO {
    userId!: string;
    zoneIds?: number[] | undefined;
    clientId?: number | undefined;

    constructor(data?: ICreateThirdPartyUserClientZoneAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["zoneIds"])) {
                this.zoneIds = [] as any;
                for (let item of _data["zoneIds"])
                    this.zoneIds!.push(item);
            }
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): CreateThirdPartyUserClientZoneAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateThirdPartyUserClientZoneAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.zoneIds)) {
            data["zoneIds"] = [];
            for (let item of this.zoneIds)
                data["zoneIds"].push(item);
        }
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ICreateThirdPartyUserClientZoneAssignmentDTO {
    userId: string;
    zoneIds?: number[] | undefined;
    clientId?: number | undefined;
}

export class PagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO implements IPagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO {
    items?: ThirdPartyUserClientZoneAssignmentZoneInfoDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ThirdPartyUserClientZoneAssignmentZoneInfoDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfThirdPartyUserClientZoneAssignmentZoneInfoDTO {
    items?: ThirdPartyUserClientZoneAssignmentZoneInfoDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UserInfoDTO implements IUserInfoDTO {
    userId?: string | undefined;
    clientId?: number | undefined;
    client?: ClientDTO | undefined;
    companyId?: number | undefined;
    company?: ParkerCompanyDTO | undefined;
    defaultCostCenterId?: number | undefined;
    employeeNumber?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    theme?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: Role[] | undefined;
    enabled!: boolean;
    validated!: boolean;
    shouldUseTwoFactorAuth?: boolean | undefined;
    twoFactorAuthActive!: boolean;
    controlPlates?: UserControlPlateDTO[] | undefined;
    linkedParkers?: LinkedParkerDTO[] | undefined;
    fullAddress?: string | undefined;
    addressCoordinates?: string | undefined;
    showActiveParkSessions!: boolean;
    receiveClosedPush!: boolean;
    receiveWarningPush!: boolean;

    constructor(data?: IUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ClientDTO.fromJS(_data["client"]) : undefined as any;
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? ParkerCompanyDTO.fromJS(_data["company"]) : undefined as any;
            this.defaultCostCenterId = _data["defaultCostCenterId"];
            this.employeeNumber = _data["employeeNumber"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.theme = _data["theme"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.enabled = _data["enabled"];
            this.validated = _data["validated"];
            this.shouldUseTwoFactorAuth = _data["shouldUseTwoFactorAuth"];
            this.twoFactorAuthActive = _data["twoFactorAuthActive"];
            if (Array.isArray(_data["controlPlates"])) {
                this.controlPlates = [] as any;
                for (let item of _data["controlPlates"])
                    this.controlPlates!.push(UserControlPlateDTO.fromJS(item));
            }
            if (Array.isArray(_data["linkedParkers"])) {
                this.linkedParkers = [] as any;
                for (let item of _data["linkedParkers"])
                    this.linkedParkers!.push(LinkedParkerDTO.fromJS(item));
            }
            this.fullAddress = _data["fullAddress"];
            this.addressCoordinates = _data["addressCoordinates"];
            this.showActiveParkSessions = _data["showActiveParkSessions"];
            this.receiveClosedPush = _data["receiveClosedPush"];
            this.receiveWarningPush = _data["receiveWarningPush"];
        }
    }

    static fromJS(data: any): UserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : undefined as any;
        data["defaultCostCenterId"] = this.defaultCostCenterId;
        data["employeeNumber"] = this.employeeNumber;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["theme"] = this.theme;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["enabled"] = this.enabled;
        data["validated"] = this.validated;
        data["shouldUseTwoFactorAuth"] = this.shouldUseTwoFactorAuth;
        data["twoFactorAuthActive"] = this.twoFactorAuthActive;
        if (Array.isArray(this.controlPlates)) {
            data["controlPlates"] = [];
            for (let item of this.controlPlates)
                data["controlPlates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.linkedParkers)) {
            data["linkedParkers"] = [];
            for (let item of this.linkedParkers)
                data["linkedParkers"].push(item ? item.toJSON() : undefined as any);
        }
        data["fullAddress"] = this.fullAddress;
        data["addressCoordinates"] = this.addressCoordinates;
        data["showActiveParkSessions"] = this.showActiveParkSessions;
        data["receiveClosedPush"] = this.receiveClosedPush;
        data["receiveWarningPush"] = this.receiveWarningPush;
        return data;
    }
}

export interface IUserInfoDTO {
    userId?: string | undefined;
    clientId?: number | undefined;
    client?: ClientDTO | undefined;
    companyId?: number | undefined;
    company?: ParkerCompanyDTO | undefined;
    defaultCostCenterId?: number | undefined;
    employeeNumber?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    theme?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: Role[] | undefined;
    enabled: boolean;
    validated: boolean;
    shouldUseTwoFactorAuth?: boolean | undefined;
    twoFactorAuthActive: boolean;
    controlPlates?: UserControlPlateDTO[] | undefined;
    linkedParkers?: LinkedParkerDTO[] | undefined;
    fullAddress?: string | undefined;
    addressCoordinates?: string | undefined;
    showActiveParkSessions: boolean;
    receiveClosedPush: boolean;
    receiveWarningPush: boolean;
}

export class UserControlPlateDTO implements IUserControlPlateDTO {
    id!: number;
    controlPlateNumber?: string | undefined;
    originalControlPlate?: string | undefined;
    countryCode?: string | undefined;
    controlPlateType!: ControlPlateType;
    title?: string | undefined;
    isFavorite!: boolean;
    enableAutomaticPlateRecognitionParking!: boolean;
    automaticParkingPaymentAlias?: PaymentAliasDTO | undefined;

    constructor(data?: IUserControlPlateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.originalControlPlate = _data["originalControlPlate"];
            this.countryCode = _data["countryCode"];
            this.controlPlateType = _data["controlPlateType"];
            this.title = _data["title"];
            this.isFavorite = _data["isFavorite"];
            this.enableAutomaticPlateRecognitionParking = _data["enableAutomaticPlateRecognitionParking"];
            this.automaticParkingPaymentAlias = _data["automaticParkingPaymentAlias"] ? PaymentAliasDTO.fromJS(_data["automaticParkingPaymentAlias"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserControlPlateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserControlPlateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["originalControlPlate"] = this.originalControlPlate;
        data["countryCode"] = this.countryCode;
        data["controlPlateType"] = this.controlPlateType;
        data["title"] = this.title;
        data["isFavorite"] = this.isFavorite;
        data["enableAutomaticPlateRecognitionParking"] = this.enableAutomaticPlateRecognitionParking;
        data["automaticParkingPaymentAlias"] = this.automaticParkingPaymentAlias ? this.automaticParkingPaymentAlias.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserControlPlateDTO {
    id: number;
    controlPlateNumber?: string | undefined;
    originalControlPlate?: string | undefined;
    countryCode?: string | undefined;
    controlPlateType: ControlPlateType;
    title?: string | undefined;
    isFavorite: boolean;
    enableAutomaticPlateRecognitionParking: boolean;
    automaticParkingPaymentAlias?: PaymentAliasDTO | undefined;
}

export class LinkedParkerDTO implements ILinkedParkerDTO {
    parkerId!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: ParkerCompanyDTO | undefined;
    tags?: ParkerTagDTO[] | undefined;
    client?: ClientLimitedDTO | undefined;
    isClientManaged!: boolean;
    hasParkerPayedVisitorSubscriptions!: boolean;
    creationType!: ParkerCreationType;

    constructor(data?: ILinkedParkerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parkerId = _data["parkerId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.company = _data["company"] ? ParkerCompanyDTO.fromJS(_data["company"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ParkerTagDTO.fromJS(item));
            }
            this.client = _data["client"] ? ClientLimitedDTO.fromJS(_data["client"]) : undefined as any;
            this.isClientManaged = _data["isClientManaged"];
            this.hasParkerPayedVisitorSubscriptions = _data["hasParkerPayedVisitorSubscriptions"];
            this.creationType = _data["creationType"];
        }
    }

    static fromJS(data: any): LinkedParkerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedParkerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parkerId"] = this.parkerId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["company"] = this.company ? this.company.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["isClientManaged"] = this.isClientManaged;
        data["hasParkerPayedVisitorSubscriptions"] = this.hasParkerPayedVisitorSubscriptions;
        data["creationType"] = this.creationType;
        return data;
    }
}

export interface ILinkedParkerDTO {
    parkerId: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: ParkerCompanyDTO | undefined;
    tags?: ParkerTagDTO[] | undefined;
    client?: ClientLimitedDTO | undefined;
    isClientManaged: boolean;
    hasParkerPayedVisitorSubscriptions: boolean;
    creationType: ParkerCreationType;
}

export class RegisterUserResultDTO implements IRegisterUserResultDTO {
    statusCode!: RegisterUserResultStatusCode;
    errorText?: string | undefined;

    constructor(data?: IRegisterUserResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.errorText = _data["errorText"];
        }
    }

    static fromJS(data: any): RegisterUserResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["errorText"] = this.errorText;
        return data;
    }
}

export interface IRegisterUserResultDTO {
    statusCode: RegisterUserResultStatusCode;
    errorText?: string | undefined;
}

export enum RegisterUserResultStatusCode {
    Success = 0,
    InvalidUserData = 1,
    EmailAlreadyExists = 2,
    UserCreationFailed = 3,
    EmailCouldNotBeSent = 4,
}

export class CreateUserDTO implements ICreateUserDTO {
    clientId?: number | undefined;
    companyId?: number | undefined;
    email!: string;
    employeeNumber?: string | undefined;
    firstname!: string;
    lastname!: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    roles?: Role[] | undefined;
    fullAddress?: string | undefined;
    addressCompletionId?: string | undefined;
    addressAutocompleteSessionToken?: string | undefined;

    constructor(data?: ICreateUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.companyId = _data["companyId"];
            this.email = _data["email"];
            this.employeeNumber = _data["employeeNumber"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.fullAddress = _data["fullAddress"];
            this.addressCompletionId = _data["addressCompletionId"];
            this.addressAutocompleteSessionToken = _data["addressAutocompleteSessionToken"];
        }
    }

    static fromJS(data: any): CreateUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["companyId"] = this.companyId;
        data["email"] = this.email;
        data["employeeNumber"] = this.employeeNumber;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["fullAddress"] = this.fullAddress;
        data["addressCompletionId"] = this.addressCompletionId;
        data["addressAutocompleteSessionToken"] = this.addressAutocompleteSessionToken;
        return data;
    }
}

export interface ICreateUserDTO {
    clientId?: number | undefined;
    companyId?: number | undefined;
    email: string;
    employeeNumber?: string | undefined;
    firstname: string;
    lastname: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    roles?: Role[] | undefined;
    fullAddress?: string | undefined;
    addressCompletionId?: string | undefined;
    addressAutocompleteSessionToken?: string | undefined;
}

export class PagedResultDTOOfUserInfoDTO implements IPagedResultDTOOfUserInfoDTO {
    items?: UserInfoDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserInfoDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfUserInfoDTO {
    items?: UserInfoDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UpdateUserInfoDTO implements IUpdateUserInfoDTO {
    userId!: string;
    clientId?: number | undefined;
    companyId?: number | undefined;
    defaultCostCenterId?: number | undefined;
    email?: string | undefined;
    employeeNumber?: string | undefined;
    enabled?: boolean | undefined;
    validated?: boolean | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    theme?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    roles?: Role[] | undefined;
    fullAddress?: string | undefined;
    addressCompletionId?: string | undefined;
    addressAutocompleteSessionToken?: string | undefined;

    constructor(data?: IUpdateUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.companyId = _data["companyId"];
            this.defaultCostCenterId = _data["defaultCostCenterId"];
            this.email = _data["email"];
            this.employeeNumber = _data["employeeNumber"];
            this.enabled = _data["enabled"];
            this.validated = _data["validated"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.theme = _data["theme"];
            this.phoneNumber = _data["phoneNumber"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.fullAddress = _data["fullAddress"];
            this.addressCompletionId = _data["addressCompletionId"];
            this.addressAutocompleteSessionToken = _data["addressAutocompleteSessionToken"];
        }
    }

    static fromJS(data: any): UpdateUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["companyId"] = this.companyId;
        data["defaultCostCenterId"] = this.defaultCostCenterId;
        data["email"] = this.email;
        data["employeeNumber"] = this.employeeNumber;
        data["enabled"] = this.enabled;
        data["validated"] = this.validated;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["theme"] = this.theme;
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["fullAddress"] = this.fullAddress;
        data["addressCompletionId"] = this.addressCompletionId;
        data["addressAutocompleteSessionToken"] = this.addressAutocompleteSessionToken;
        return data;
    }
}

export interface IUpdateUserInfoDTO {
    userId: string;
    clientId?: number | undefined;
    companyId?: number | undefined;
    defaultCostCenterId?: number | undefined;
    email?: string | undefined;
    employeeNumber?: string | undefined;
    enabled?: boolean | undefined;
    validated?: boolean | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    theme?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    roles?: Role[] | undefined;
    fullAddress?: string | undefined;
    addressCompletionId?: string | undefined;
    addressAutocompleteSessionToken?: string | undefined;
}

export class UpdateUserNotificationSettingsDTO implements IUpdateUserNotificationSettingsDTO {
    showActiveParkSessions!: boolean;
    receiveClosedPush!: boolean;
    receiveWarningPush!: boolean;

    constructor(data?: IUpdateUserNotificationSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showActiveParkSessions = _data["showActiveParkSessions"];
            this.receiveClosedPush = _data["receiveClosedPush"];
            this.receiveWarningPush = _data["receiveWarningPush"];
        }
    }

    static fromJS(data: any): UpdateUserNotificationSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserNotificationSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showActiveParkSessions"] = this.showActiveParkSessions;
        data["receiveClosedPush"] = this.receiveClosedPush;
        data["receiveWarningPush"] = this.receiveWarningPush;
        return data;
    }
}

export interface IUpdateUserNotificationSettingsDTO {
    showActiveParkSessions: boolean;
    receiveClosedPush: boolean;
    receiveWarningPush: boolean;
}

export class CreateMobileUserDTO implements ICreateMobileUserDTO {
    clientId!: number;
    email!: string;
    employeeNumber?: string | undefined;
    firstname!: string;
    lastname!: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ICreateMobileUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.email = _data["email"];
            this.employeeNumber = _data["employeeNumber"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateMobileUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMobileUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["email"] = this.email;
        data["employeeNumber"] = this.employeeNumber;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateMobileUserDTO {
    clientId: number;
    email: string;
    employeeNumber?: string | undefined;
    firstname: string;
    lastname: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
}

export class CreateProxyUserDTO implements ICreateProxyUserDTO {
    clientId!: number;
    firstname!: string;
    userName!: string;
    password!: string;

    constructor(data?: ICreateProxyUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.firstname = _data["firstname"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateProxyUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProxyUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["firstname"] = this.firstname;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateProxyUserDTO {
    clientId: number;
    firstname: string;
    userName: string;
    password: string;
}

export class UpdateProxyUserDTO implements IUpdateProxyUserDTO {
    userId!: string;
    password?: string | undefined;
    enabled?: boolean | undefined;

    constructor(data?: IUpdateProxyUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.password = _data["password"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): UpdateProxyUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProxyUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["password"] = this.password;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IUpdateProxyUserDTO {
    userId: string;
    password?: string | undefined;
    enabled?: boolean | undefined;
}

export class CreateThirdPartyUserDTO implements ICreateThirdPartyUserDTO {
    clientId?: number | undefined;
    userName!: string;
    password!: string;

    constructor(data?: ICreateThirdPartyUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateThirdPartyUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateThirdPartyUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateThirdPartyUserDTO {
    clientId?: number | undefined;
    userName: string;
    password: string;
}

export class UpdateThirdPartyUserDTO implements IUpdateThirdPartyUserDTO {
    userId!: string;
    password?: string | undefined;
    enabled?: boolean | undefined;

    constructor(data?: IUpdateThirdPartyUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.password = _data["password"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): UpdateThirdPartyUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateThirdPartyUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["password"] = this.password;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IUpdateThirdPartyUserDTO {
    userId: string;
    password?: string | undefined;
    enabled?: boolean | undefined;
}

export class ChangePasswordDTO implements IChangePasswordDTO {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDTO {
    oldPassword: string;
    newPassword: string;
}

export class SetPasswordDTO implements ISetPasswordDTO {
    newPassword!: string;
    verificationToken!: string;
    userId!: string;
    forgotPasswordProcess?: boolean | undefined;

    constructor(data?: ISetPasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.verificationToken = _data["verificationToken"];
            this.userId = _data["userId"];
            this.forgotPasswordProcess = _data["forgotPasswordProcess"];
        }
    }

    static fromJS(data: any): SetPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["verificationToken"] = this.verificationToken;
        data["userId"] = this.userId;
        data["forgotPasswordProcess"] = this.forgotPasswordProcess;
        return data;
    }
}

export interface ISetPasswordDTO {
    newPassword: string;
    verificationToken: string;
    userId: string;
    forgotPasswordProcess?: boolean | undefined;
}

export class ForgotPasswordDTO implements IForgotPasswordDTO {
    username!: string;

    constructor(data?: IForgotPasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ForgotPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IForgotPasswordDTO {
    username: string;
}

export class UserDeletionResultDTO implements IUserDeletionResultDTO {
    userDeletionCode!: UserDeletionCode;

    constructor(data?: IUserDeletionResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDeletionCode = _data["userDeletionCode"];
        }
    }

    static fromJS(data: any): UserDeletionResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeletionResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDeletionCode"] = this.userDeletionCode;
        return data;
    }
}

export interface IUserDeletionResultDTO {
    userDeletionCode: UserDeletionCode;
}

export enum UserDeletionCode {
    Deleted = 0,
    DeletionRejectedCauseNonUserRole = 1,
    DeletionRejectedCauseUserLocked = 2,
    DeletionRejectedCauseUserHasOpenSessions = 3,
}

export class Request2FARegistrationCodeResponseDTO implements IRequest2FARegistrationCodeResponseDTO {
    code!: string;
    qrCode!: string;

    constructor(data?: IRequest2FARegistrationCodeResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.qrCode = _data["qrCode"];
        }
    }

    static fromJS(data: any): Request2FARegistrationCodeResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Request2FARegistrationCodeResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["qrCode"] = this.qrCode;
        return data;
    }
}

export interface IRequest2FARegistrationCodeResponseDTO {
    code: string;
    qrCode: string;
}

export class Request2FARegistrationCodeDTO implements IRequest2FARegistrationCodeDTO {
    userName?: string | undefined;
    userId?: string | undefined;
    password!: string;
    recoveryCode?: string | undefined;

    constructor(data?: IRequest2FARegistrationCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.password = _data["password"];
            this.recoveryCode = _data["recoveryCode"];
        }
    }

    static fromJS(data: any): Request2FARegistrationCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Request2FARegistrationCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["password"] = this.password;
        data["recoveryCode"] = this.recoveryCode;
        return data;
    }
}

export interface IRequest2FARegistrationCodeDTO {
    userName?: string | undefined;
    userId?: string | undefined;
    password: string;
    recoveryCode?: string | undefined;
}

export class Verify2FARegistrationCodeResponseDTO implements IVerify2FARegistrationCodeResponseDTO {
    success!: boolean;

    constructor(data?: IVerify2FARegistrationCodeResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): Verify2FARegistrationCodeResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Verify2FARegistrationCodeResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IVerify2FARegistrationCodeResponseDTO {
    success: boolean;
}

export class Verify2FARegistrationCodeDTO implements IVerify2FARegistrationCodeDTO {
    userName?: string | undefined;
    userId?: string | undefined;
    password!: string;
    code!: string;

    constructor(data?: IVerify2FARegistrationCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.password = _data["password"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Verify2FARegistrationCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Verify2FARegistrationCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["password"] = this.password;
        data["code"] = this.code;
        return data;
    }
}

export interface IVerify2FARegistrationCodeDTO {
    userName?: string | undefined;
    userId?: string | undefined;
    password: string;
    code: string;
}

export class RequestSelfReset2FARegistrationDTO implements IRequestSelfReset2FARegistrationDTO {
    userName!: string;
    password!: string;

    constructor(data?: IRequestSelfReset2FARegistrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): RequestSelfReset2FARegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestSelfReset2FARegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IRequestSelfReset2FARegistrationDTO {
    userName: string;
    password: string;
}

export class UpdateControlPlatesDTO implements IUpdateControlPlatesDTO {
    controlPlates?: UserControlPlateDTO[] | undefined;

    constructor(data?: IUpdateControlPlatesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["controlPlates"])) {
                this.controlPlates = [] as any;
                for (let item of _data["controlPlates"])
                    this.controlPlates!.push(UserControlPlateDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateControlPlatesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateControlPlatesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.controlPlates)) {
            data["controlPlates"] = [];
            for (let item of this.controlPlates)
                data["controlPlates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateControlPlatesDTO {
    controlPlates?: UserControlPlateDTO[] | undefined;
}

export class PagedResultDTOOfUserExtractReportDTO implements IPagedResultDTOOfUserExtractReportDTO {
    items?: UserExtractReportDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfUserExtractReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserExtractReportDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfUserExtractReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfUserExtractReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfUserExtractReportDTO {
    items?: UserExtractReportDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UserExtractReportDTO implements IUserExtractReportDTO {
    entryDate!: DateTime;
    exitDate!: DateTime;
    durationInMinutes!: number;
    zoneName?: string | undefined;
    clientName?: string | undefined;
    parkingPrice!: number;
    totalPrice!: number;
    detailedPriceInformation?: ParkingPriceDetailsDTO | undefined;
    currency!: Currency;
    sessionOpeningEventType!: SessionEventType;
    sessionClosingEventType!: SessionEventType;
    controlPlateNumber?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    subscriptionName?: string | undefined;
    isFallbackSubscriptionApplied!: boolean;
    paidBy!: ParkingSubscriptionPaidBy;
    isValidatedByParkingCard!: boolean;
    validationWasRequired!: boolean;

    constructor(data?: IUserExtractReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : undefined as any;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : undefined as any;
            this.durationInMinutes = _data["durationInMinutes"];
            this.zoneName = _data["zoneName"];
            this.clientName = _data["clientName"];
            this.parkingPrice = _data["parkingPrice"];
            this.totalPrice = _data["totalPrice"];
            this.detailedPriceInformation = _data["detailedPriceInformation"] ? ParkingPriceDetailsDTO.fromJS(_data["detailedPriceInformation"]) : undefined as any;
            this.currency = _data["currency"];
            this.sessionOpeningEventType = _data["sessionOpeningEventType"];
            this.sessionClosingEventType = _data["sessionClosingEventType"];
            this.controlPlateNumber = _data["controlPlateNumber"];
            this.controlPlateType = _data["controlPlateType"];
            this.subscriptionName = _data["subscriptionName"];
            this.isFallbackSubscriptionApplied = _data["isFallbackSubscriptionApplied"];
            this.paidBy = _data["paidBy"];
            this.isValidatedByParkingCard = _data["isValidatedByParkingCard"];
            this.validationWasRequired = _data["validationWasRequired"];
        }
    }

    static fromJS(data: any): UserExtractReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserExtractReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : undefined as any;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : undefined as any;
        data["durationInMinutes"] = this.durationInMinutes;
        data["zoneName"] = this.zoneName;
        data["clientName"] = this.clientName;
        data["parkingPrice"] = this.parkingPrice;
        data["totalPrice"] = this.totalPrice;
        data["detailedPriceInformation"] = this.detailedPriceInformation ? this.detailedPriceInformation.toJSON() : undefined as any;
        data["currency"] = this.currency;
        data["sessionOpeningEventType"] = this.sessionOpeningEventType;
        data["sessionClosingEventType"] = this.sessionClosingEventType;
        data["controlPlateNumber"] = this.controlPlateNumber;
        data["controlPlateType"] = this.controlPlateType;
        data["subscriptionName"] = this.subscriptionName;
        data["isFallbackSubscriptionApplied"] = this.isFallbackSubscriptionApplied;
        data["paidBy"] = this.paidBy;
        data["isValidatedByParkingCard"] = this.isValidatedByParkingCard;
        data["validationWasRequired"] = this.validationWasRequired;
        return data;
    }
}

export interface IUserExtractReportDTO {
    entryDate: DateTime;
    exitDate: DateTime;
    durationInMinutes: number;
    zoneName?: string | undefined;
    clientName?: string | undefined;
    parkingPrice: number;
    totalPrice: number;
    detailedPriceInformation?: ParkingPriceDetailsDTO | undefined;
    currency: Currency;
    sessionOpeningEventType: SessionEventType;
    sessionClosingEventType: SessionEventType;
    controlPlateNumber?: string | undefined;
    controlPlateType?: ControlPlateType | undefined;
    subscriptionName?: string | undefined;
    isFallbackSubscriptionApplied: boolean;
    paidBy: ParkingSubscriptionPaidBy;
    isValidatedByParkingCard: boolean;
    validationWasRequired: boolean;
}

export class UserExtractReportSummaryDTO implements IUserExtractReportSummaryDTO {
    totalAmounts!: AmountWithCurrencyDTO[];
    totalNumberOfParkings!: number;

    constructor(data?: IUserExtractReportSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.totalAmounts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totalAmounts"])) {
                this.totalAmounts = [] as any;
                for (let item of _data["totalAmounts"])
                    this.totalAmounts!.push(AmountWithCurrencyDTO.fromJS(item));
            }
            this.totalNumberOfParkings = _data["totalNumberOfParkings"];
        }
    }

    static fromJS(data: any): UserExtractReportSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserExtractReportSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totalAmounts)) {
            data["totalAmounts"] = [];
            for (let item of this.totalAmounts)
                data["totalAmounts"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfParkings"] = this.totalNumberOfParkings;
        return data;
    }
}

export interface IUserExtractReportSummaryDTO {
    totalAmounts: AmountWithCurrencyDTO[];
    totalNumberOfParkings: number;
}

export class CreateZoneDTO implements ICreateZoneDTO {
    parentZoneId?: number | undefined;
    clientId!: number;
    name!: string;
    isGroupingElement!: boolean;
    separateNFCCode!: boolean;
    nfcCode?: string | undefined;
    enableGPSDetection!: boolean;
    zoneGPSArea?: string | undefined;
    maxPassageTime!: number;
    parkingSpaceNumberDefinition?: string | undefined;
    parkingSpaceCapacity?: number | undefined;
    currentParkerCount!: number;
    useBlacklistArea!: boolean;
    blacklistGPSArea?: string | undefined;
    sessionControlType!: ParkingSessionControlType;

    constructor(data?: ICreateZoneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentZoneId = _data["parentZoneId"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.isGroupingElement = _data["isGroupingElement"];
            this.separateNFCCode = _data["separateNFCCode"];
            this.nfcCode = _data["nfcCode"];
            this.enableGPSDetection = _data["enableGPSDetection"];
            this.zoneGPSArea = _data["zoneGPSArea"];
            this.maxPassageTime = _data["maxPassageTime"];
            this.parkingSpaceNumberDefinition = _data["parkingSpaceNumberDefinition"];
            this.parkingSpaceCapacity = _data["parkingSpaceCapacity"];
            this.currentParkerCount = _data["currentParkerCount"];
            this.useBlacklistArea = _data["useBlacklistArea"];
            this.blacklistGPSArea = _data["blacklistGPSArea"];
            this.sessionControlType = _data["sessionControlType"];
        }
    }

    static fromJS(data: any): CreateZoneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateZoneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentZoneId"] = this.parentZoneId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["isGroupingElement"] = this.isGroupingElement;
        data["separateNFCCode"] = this.separateNFCCode;
        data["nfcCode"] = this.nfcCode;
        data["enableGPSDetection"] = this.enableGPSDetection;
        data["zoneGPSArea"] = this.zoneGPSArea;
        data["maxPassageTime"] = this.maxPassageTime;
        data["parkingSpaceNumberDefinition"] = this.parkingSpaceNumberDefinition;
        data["parkingSpaceCapacity"] = this.parkingSpaceCapacity;
        data["currentParkerCount"] = this.currentParkerCount;
        data["useBlacklistArea"] = this.useBlacklistArea;
        data["blacklistGPSArea"] = this.blacklistGPSArea;
        data["sessionControlType"] = this.sessionControlType;
        return data;
    }
}

export interface ICreateZoneDTO {
    parentZoneId?: number | undefined;
    clientId: number;
    name: string;
    isGroupingElement: boolean;
    separateNFCCode: boolean;
    nfcCode?: string | undefined;
    enableGPSDetection: boolean;
    zoneGPSArea?: string | undefined;
    maxPassageTime: number;
    parkingSpaceNumberDefinition?: string | undefined;
    parkingSpaceCapacity?: number | undefined;
    currentParkerCount: number;
    useBlacklistArea: boolean;
    blacklistGPSArea?: string | undefined;
    sessionControlType: ParkingSessionControlType;
}

export class PagedResultDTOOfZoneDTO implements IPagedResultDTOOfZoneDTO {
    items?: ZoneDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfZoneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ZoneDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfZoneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfZoneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfZoneDTO {
    items?: ZoneDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UpdateZoneDTO implements IUpdateZoneDTO {
    id!: number;
    name?: string | undefined;
    isGroupingElement?: boolean | undefined;
    separateNFCCode?: boolean | undefined;
    nfcCode?: string | undefined;
    enableGPSDetection?: boolean | undefined;
    zoneGPSArea?: string | undefined;
    foreignParkersAllowed?: boolean | undefined;
    foreignParkingSubscriptionId?: number | undefined;
    fastCheckinSubscriptionId?: number | undefined;
    maxPassageTime?: number | undefined;
    parkingSpaceNumberDefinition?: string | undefined;
    parkingSpaceCapacity?: number | undefined;
    useBlacklistArea!: boolean;
    blacklistGPSArea?: string | undefined;
    sessionControlType?: ParkingSessionControlType | undefined;

    constructor(data?: IUpdateZoneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isGroupingElement = _data["isGroupingElement"];
            this.separateNFCCode = _data["separateNFCCode"];
            this.nfcCode = _data["nfcCode"];
            this.enableGPSDetection = _data["enableGPSDetection"];
            this.zoneGPSArea = _data["zoneGPSArea"];
            this.foreignParkersAllowed = _data["foreignParkersAllowed"];
            this.foreignParkingSubscriptionId = _data["foreignParkingSubscriptionId"];
            this.fastCheckinSubscriptionId = _data["fastCheckinSubscriptionId"];
            this.maxPassageTime = _data["maxPassageTime"];
            this.parkingSpaceNumberDefinition = _data["parkingSpaceNumberDefinition"];
            this.parkingSpaceCapacity = _data["parkingSpaceCapacity"];
            this.useBlacklistArea = _data["useBlacklistArea"];
            this.blacklistGPSArea = _data["blacklistGPSArea"];
            this.sessionControlType = _data["sessionControlType"];
        }
    }

    static fromJS(data: any): UpdateZoneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateZoneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isGroupingElement"] = this.isGroupingElement;
        data["separateNFCCode"] = this.separateNFCCode;
        data["nfcCode"] = this.nfcCode;
        data["enableGPSDetection"] = this.enableGPSDetection;
        data["zoneGPSArea"] = this.zoneGPSArea;
        data["foreignParkersAllowed"] = this.foreignParkersAllowed;
        data["foreignParkingSubscriptionId"] = this.foreignParkingSubscriptionId;
        data["fastCheckinSubscriptionId"] = this.fastCheckinSubscriptionId;
        data["maxPassageTime"] = this.maxPassageTime;
        data["parkingSpaceNumberDefinition"] = this.parkingSpaceNumberDefinition;
        data["parkingSpaceCapacity"] = this.parkingSpaceCapacity;
        data["useBlacklistArea"] = this.useBlacklistArea;
        data["blacklistGPSArea"] = this.blacklistGPSArea;
        data["sessionControlType"] = this.sessionControlType;
        return data;
    }
}

export interface IUpdateZoneDTO {
    id: number;
    name?: string | undefined;
    isGroupingElement?: boolean | undefined;
    separateNFCCode?: boolean | undefined;
    nfcCode?: string | undefined;
    enableGPSDetection?: boolean | undefined;
    zoneGPSArea?: string | undefined;
    foreignParkersAllowed?: boolean | undefined;
    foreignParkingSubscriptionId?: number | undefined;
    fastCheckinSubscriptionId?: number | undefined;
    maxPassageTime?: number | undefined;
    parkingSpaceNumberDefinition?: string | undefined;
    parkingSpaceCapacity?: number | undefined;
    useBlacklistArea: boolean;
    blacklistGPSArea?: string | undefined;
    sessionControlType?: ParkingSessionControlType | undefined;
}

export class ZoneForUserDTO implements IZoneForUserDTO {
    id!: number;
    name?: string | undefined;
    clientId!: number;
    enableGPSDetection!: boolean;
    zoneGPSArea?: string | undefined;
    parkingSpaceNumberDefinition?: string | undefined;
    foreignParkingSubscriptions!: ParkingSubscriptionLimitedWithTariffsDTO[];
    parkerSubscriptionAssignments!: ParkerSubscriptionAssignmentDTO[];

    constructor(data?: IZoneForUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.foreignParkingSubscriptions = [];
            this.parkerSubscriptionAssignments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            this.enableGPSDetection = _data["enableGPSDetection"];
            this.zoneGPSArea = _data["zoneGPSArea"];
            this.parkingSpaceNumberDefinition = _data["parkingSpaceNumberDefinition"];
            if (Array.isArray(_data["foreignParkingSubscriptions"])) {
                this.foreignParkingSubscriptions = [] as any;
                for (let item of _data["foreignParkingSubscriptions"])
                    this.foreignParkingSubscriptions!.push(ParkingSubscriptionLimitedWithTariffsDTO.fromJS(item));
            }
            if (Array.isArray(_data["parkerSubscriptionAssignments"])) {
                this.parkerSubscriptionAssignments = [] as any;
                for (let item of _data["parkerSubscriptionAssignments"])
                    this.parkerSubscriptionAssignments!.push(ParkerSubscriptionAssignmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZoneForUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneForUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        data["enableGPSDetection"] = this.enableGPSDetection;
        data["zoneGPSArea"] = this.zoneGPSArea;
        data["parkingSpaceNumberDefinition"] = this.parkingSpaceNumberDefinition;
        if (Array.isArray(this.foreignParkingSubscriptions)) {
            data["foreignParkingSubscriptions"] = [];
            for (let item of this.foreignParkingSubscriptions)
                data["foreignParkingSubscriptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parkerSubscriptionAssignments)) {
            data["parkerSubscriptionAssignments"] = [];
            for (let item of this.parkerSubscriptionAssignments)
                data["parkerSubscriptionAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IZoneForUserDTO {
    id: number;
    name?: string | undefined;
    clientId: number;
    enableGPSDetection: boolean;
    zoneGPSArea?: string | undefined;
    parkingSpaceNumberDefinition?: string | undefined;
    foreignParkingSubscriptions: ParkingSubscriptionLimitedWithTariffsDTO[];
    parkerSubscriptionAssignments: ParkerSubscriptionAssignmentDTO[];
}

export class GetAllZonesForUserDataDTO implements IGetAllZonesForUserDataDTO {
    latMin!: number;
    latMax!: number;
    lonMin!: number;
    lonMax!: number;

    constructor(data?: IGetAllZonesForUserDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latMin = _data["latMin"];
            this.latMax = _data["latMax"];
            this.lonMin = _data["lonMin"];
            this.lonMax = _data["lonMax"];
        }
    }

    static fromJS(data: any): GetAllZonesForUserDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllZonesForUserDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latMin"] = this.latMin;
        data["latMax"] = this.latMax;
        data["lonMin"] = this.lonMin;
        data["lonMax"] = this.lonMax;
        return data;
    }
}

export interface IGetAllZonesForUserDataDTO {
    latMin: number;
    latMax: number;
    lonMin: number;
    lonMax: number;
}

export class SearchZonesForUserDataDTO implements ISearchZonesForUserDataDTO {
    query!: string;

    constructor(data?: ISearchZonesForUserDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
        }
    }

    static fromJS(data: any): SearchZonesForUserDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchZonesForUserDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        return data;
    }
}

export interface ISearchZonesForUserDataDTO {
    query: string;
}

export class GeneratedQrCodesDTO implements IGeneratedQrCodesDTO {
    zipName?: string | undefined;
    contentBase64?: string | undefined;

    constructor(data?: IGeneratedQrCodesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zipName = _data["zipName"];
            this.contentBase64 = _data["contentBase64"];
        }
    }

    static fromJS(data: any): GeneratedQrCodesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratedQrCodesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zipName"] = this.zipName;
        data["contentBase64"] = this.contentBase64;
        return data;
    }
}

export interface IGeneratedQrCodesDTO {
    zipName?: string | undefined;
    contentBase64?: string | undefined;
}

export class ZoneQrCodeInfosDTO implements IZoneQrCodeInfosDTO {
    zoneId!: number;
    isStickerMode!: boolean;
    parkingSpaceNumbers?: string | undefined;

    constructor(data?: IZoneQrCodeInfosDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.isStickerMode = _data["isStickerMode"];
            this.parkingSpaceNumbers = _data["parkingSpaceNumbers"];
        }
    }

    static fromJS(data: any): ZoneQrCodeInfosDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneQrCodeInfosDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["isStickerMode"] = this.isStickerMode;
        data["parkingSpaceNumbers"] = this.parkingSpaceNumbers;
        return data;
    }
}

export interface IZoneQrCodeInfosDTO {
    zoneId: number;
    isStickerMode: boolean;
    parkingSpaceNumbers?: string | undefined;
}

export class ZoneDamageDTO implements IZoneDamageDTO {
    id!: number;
    clientId!: number;
    deviceId!: number;
    device?: ZoneDeviceDTO | undefined;
    reportTime!: DateTime;
    damageDescription?: string | undefined;
    reportPositionLatitude!: number;
    reportPositionLongitude!: number;
    reporter?: DamageReporterDTO | undefined;
    state!: ZoneDamageState;
    mediaFiles?: string[] | undefined;
    zone?: ZoneDTO | undefined;

    constructor(data?: IZoneDamageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.deviceId = _data["deviceId"];
            this.device = _data["device"] ? ZoneDeviceDTO.fromJS(_data["device"]) : undefined as any;
            this.reportTime = _data["reportTime"] ? DateTime.fromISO(_data["reportTime"].toString()) : undefined as any;
            this.damageDescription = _data["damageDescription"];
            this.reportPositionLatitude = _data["reportPositionLatitude"];
            this.reportPositionLongitude = _data["reportPositionLongitude"];
            this.reporter = _data["reporter"] ? DamageReporterDTO.fromJS(_data["reporter"]) : undefined as any;
            this.state = _data["state"];
            if (Array.isArray(_data["mediaFiles"])) {
                this.mediaFiles = [] as any;
                for (let item of _data["mediaFiles"])
                    this.mediaFiles!.push(item);
            }
            this.zone = _data["zone"] ? ZoneDTO.fromJS(_data["zone"]) : undefined as any;
        }
    }

    static fromJS(data: any): ZoneDamageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDamageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["deviceId"] = this.deviceId;
        data["device"] = this.device ? this.device.toJSON() : undefined as any;
        data["reportTime"] = this.reportTime ? this.reportTime.toString() : undefined as any;
        data["damageDescription"] = this.damageDescription;
        data["reportPositionLatitude"] = this.reportPositionLatitude;
        data["reportPositionLongitude"] = this.reportPositionLongitude;
        data["reporter"] = this.reporter ? this.reporter.toJSON() : undefined as any;
        data["state"] = this.state;
        if (Array.isArray(this.mediaFiles)) {
            data["mediaFiles"] = [];
            for (let item of this.mediaFiles)
                data["mediaFiles"].push(item);
        }
        data["zone"] = this.zone ? this.zone.toJSON() : undefined as any;
        return data;
    }
}

export interface IZoneDamageDTO {
    id: number;
    clientId: number;
    deviceId: number;
    device?: ZoneDeviceDTO | undefined;
    reportTime: DateTime;
    damageDescription?: string | undefined;
    reportPositionLatitude: number;
    reportPositionLongitude: number;
    reporter?: DamageReporterDTO | undefined;
    state: ZoneDamageState;
    mediaFiles?: string[] | undefined;
    zone?: ZoneDTO | undefined;
}

export class DamageReporterDTO implements IDamageReporterDTO {
    id?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IDamageReporterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): DamageReporterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DamageReporterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IDamageReporterDTO {
    id?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    phoneNumber?: string | undefined;
}

export enum ZoneDamageState {
    New = 1,
    Acknowledged = 2,
    RepairInProgress = 4,
    Invalid = 8,
    Repaired = 16,
}

export class CreateZoneDamageDTO implements ICreateZoneDamageDTO {
    clientId!: number;
    deviceId!: number;
    damageDescription?: string | undefined;
    reportPositionLatitude!: number;
    reportPositionLongitude!: number;

    constructor(data?: ICreateZoneDamageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.deviceId = _data["deviceId"];
            this.damageDescription = _data["damageDescription"];
            this.reportPositionLatitude = _data["reportPositionLatitude"];
            this.reportPositionLongitude = _data["reportPositionLongitude"];
        }
    }

    static fromJS(data: any): CreateZoneDamageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateZoneDamageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["deviceId"] = this.deviceId;
        data["damageDescription"] = this.damageDescription;
        data["reportPositionLatitude"] = this.reportPositionLatitude;
        data["reportPositionLongitude"] = this.reportPositionLongitude;
        return data;
    }
}

export interface ICreateZoneDamageDTO {
    clientId: number;
    deviceId: number;
    damageDescription?: string | undefined;
    reportPositionLatitude: number;
    reportPositionLongitude: number;
}

export class PagedResultDTOOfZoneDamageDTO implements IPagedResultDTOOfZoneDamageDTO {
    items?: ZoneDamageDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfZoneDamageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ZoneDamageDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfZoneDamageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfZoneDamageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfZoneDamageDTO {
    items?: ZoneDamageDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UpdateZoneDamageDTO implements IUpdateZoneDamageDTO {
    id!: number;
    clientId!: number;
    deviceId?: number | undefined;
    zoneId?: number | undefined;
    damageDescription?: string | undefined;
    reportPositionLatitude?: number | undefined;
    reportPositionLongitude?: number | undefined;
    state?: ZoneDamageState | undefined;

    constructor(data?: IUpdateZoneDamageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.deviceId = _data["deviceId"];
            this.zoneId = _data["zoneId"];
            this.damageDescription = _data["damageDescription"];
            this.reportPositionLatitude = _data["reportPositionLatitude"];
            this.reportPositionLongitude = _data["reportPositionLongitude"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): UpdateZoneDamageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateZoneDamageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["deviceId"] = this.deviceId;
        data["zoneId"] = this.zoneId;
        data["damageDescription"] = this.damageDescription;
        data["reportPositionLatitude"] = this.reportPositionLatitude;
        data["reportPositionLongitude"] = this.reportPositionLongitude;
        data["state"] = this.state;
        return data;
    }
}

export interface IUpdateZoneDamageDTO {
    id: number;
    clientId: number;
    deviceId?: number | undefined;
    zoneId?: number | undefined;
    damageDescription?: string | undefined;
    reportPositionLatitude?: number | undefined;
    reportPositionLongitude?: number | undefined;
    state?: ZoneDamageState | undefined;
}

export class AddZoneDamageImageDTO implements IAddZoneDamageImageDTO {
    damageId!: number;
    imageBase64?: string | undefined;

    constructor(data?: IAddZoneDamageImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.damageId = _data["damageId"];
            this.imageBase64 = _data["imageBase64"];
        }
    }

    static fromJS(data: any): AddZoneDamageImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddZoneDamageImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["damageId"] = this.damageId;
        data["imageBase64"] = this.imageBase64;
        return data;
    }
}

export interface IAddZoneDamageImageDTO {
    damageId: number;
    imageBase64?: string | undefined;
}

export class UpdateZoneDamageImageDTO implements IUpdateZoneDamageImageDTO {
    damageId!: number;
    mediaId?: string | undefined;
    imageBase64?: string | undefined;

    constructor(data?: IUpdateZoneDamageImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.damageId = _data["damageId"];
            this.mediaId = _data["mediaId"];
            this.imageBase64 = _data["imageBase64"];
        }
    }

    static fromJS(data: any): UpdateZoneDamageImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateZoneDamageImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["damageId"] = this.damageId;
        data["mediaId"] = this.mediaId;
        data["imageBase64"] = this.imageBase64;
        return data;
    }
}

export interface IUpdateZoneDamageImageDTO {
    damageId: number;
    mediaId?: string | undefined;
    imageBase64?: string | undefined;
}

export class DeleteZoneDamageImageDTO implements IDeleteZoneDamageImageDTO {
    damageId!: number;
    mediaId?: string | undefined;

    constructor(data?: IDeleteZoneDamageImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.damageId = _data["damageId"];
            this.mediaId = _data["mediaId"];
        }
    }

    static fromJS(data: any): DeleteZoneDamageImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteZoneDamageImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["damageId"] = this.damageId;
        data["mediaId"] = this.mediaId;
        return data;
    }
}

export interface IDeleteZoneDamageImageDTO {
    damageId: number;
    mediaId?: string | undefined;
}

export class CreateZoneDeviceDTO implements ICreateZoneDeviceDTO {
    clientId!: number;
    name!: string;
    zoneId!: number;
    description?: string | undefined;
    enabled!: boolean;
    groupControllerDeviceId?: number | undefined;
    coordinates?: string | undefined;
    deviceType!: ZoneDeviceType;
    brand!: ZoneDeviceBrand;
    direction!: ZoneDeviceDirection;
    proxyUserId?: string | undefined;
    parameters?: ZoneDeviceParameterDTO[] | undefined;

    constructor(data?: ICreateZoneDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.zoneId = _data["zoneId"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.groupControllerDeviceId = _data["groupControllerDeviceId"];
            this.coordinates = _data["coordinates"];
            this.deviceType = _data["deviceType"];
            this.brand = _data["brand"];
            this.direction = _data["direction"];
            this.proxyUserId = _data["proxyUserId"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ZoneDeviceParameterDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateZoneDeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateZoneDeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["zoneId"] = this.zoneId;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["groupControllerDeviceId"] = this.groupControllerDeviceId;
        data["coordinates"] = this.coordinates;
        data["deviceType"] = this.deviceType;
        data["brand"] = this.brand;
        data["direction"] = this.direction;
        data["proxyUserId"] = this.proxyUserId;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateZoneDeviceDTO {
    clientId: number;
    name: string;
    zoneId: number;
    description?: string | undefined;
    enabled: boolean;
    groupControllerDeviceId?: number | undefined;
    coordinates?: string | undefined;
    deviceType: ZoneDeviceType;
    brand: ZoneDeviceBrand;
    direction: ZoneDeviceDirection;
    proxyUserId?: string | undefined;
    parameters?: ZoneDeviceParameterDTO[] | undefined;
}

export class UpdateZoneDeviceDTO implements IUpdateZoneDeviceDTO {
    id!: number;
    deviceType?: ZoneDeviceType | undefined;
    brand?: ZoneDeviceBrand | undefined;
    name?: string | undefined;
    description?: string | undefined;
    enabled?: boolean | undefined;
    groupControllerDeviceId?: number | undefined;
    coordinates?: string | undefined;
    state?: ZoneDeviceState | undefined;
    direction?: ZoneDeviceDirection | undefined;
    proxyUserId?: string | undefined;
    parameters?: ZoneDeviceParameterDTO[] | undefined;

    constructor(data?: IUpdateZoneDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deviceType = _data["deviceType"];
            this.brand = _data["brand"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.groupControllerDeviceId = _data["groupControllerDeviceId"];
            this.coordinates = _data["coordinates"];
            this.state = _data["state"];
            this.direction = _data["direction"];
            this.proxyUserId = _data["proxyUserId"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ZoneDeviceParameterDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateZoneDeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateZoneDeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceType"] = this.deviceType;
        data["brand"] = this.brand;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["groupControllerDeviceId"] = this.groupControllerDeviceId;
        data["coordinates"] = this.coordinates;
        data["state"] = this.state;
        data["direction"] = this.direction;
        data["proxyUserId"] = this.proxyUserId;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateZoneDeviceDTO {
    id: number;
    deviceType?: ZoneDeviceType | undefined;
    brand?: ZoneDeviceBrand | undefined;
    name?: string | undefined;
    description?: string | undefined;
    enabled?: boolean | undefined;
    groupControllerDeviceId?: number | undefined;
    coordinates?: string | undefined;
    state?: ZoneDeviceState | undefined;
    direction?: ZoneDeviceDirection | undefined;
    proxyUserId?: string | undefined;
    parameters?: ZoneDeviceParameterDTO[] | undefined;
}

export class PagedResultDTOOfZoneDeviceDTO implements IPagedResultDTOOfZoneDeviceDTO {
    items?: ZoneDeviceDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfZoneDeviceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ZoneDeviceDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfZoneDeviceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfZoneDeviceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfZoneDeviceDTO {
    items?: ZoneDeviceDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ZoneDeviceSpecificationDTO implements IZoneDeviceSpecificationDTO {
    deviceType!: ZoneDeviceType;
    brand!: ZoneDeviceBrand;
    execLocation!: ExecutionLocation;

    constructor(data?: IZoneDeviceSpecificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceType = _data["deviceType"];
            this.brand = _data["brand"];
            this.execLocation = _data["execLocation"];
        }
    }

    static fromJS(data: any): ZoneDeviceSpecificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDeviceSpecificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceType"] = this.deviceType;
        data["brand"] = this.brand;
        data["execLocation"] = this.execLocation;
        return data;
    }
}

export interface IZoneDeviceSpecificationDTO {
    deviceType: ZoneDeviceType;
    brand: ZoneDeviceBrand;
    execLocation: ExecutionLocation;
}

export enum ExecutionLocation {
    RunOnProxy = 0,
    RunInCloud = 1,
}

export class ExecuteZoneDeviceCommandDTO implements IExecuteZoneDeviceCommandDTO {
    deviceId!: number;
    command?: ZoneDeviceCommandDTO | undefined;

    constructor(data?: IExecuteZoneDeviceCommandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.command = _data["command"] ? ZoneDeviceCommandDTO.fromJS(_data["command"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExecuteZoneDeviceCommandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteZoneDeviceCommandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["command"] = this.command ? this.command.toJSON() : undefined as any;
        return data;
    }
}

export interface IExecuteZoneDeviceCommandDTO {
    deviceId: number;
    command?: ZoneDeviceCommandDTO | undefined;
}

export class DashboardDTO implements IDashboardDTO {
    id!: number;
    name!: string;
    imageData?: string | undefined;
    tabGroupIndex?: number | undefined;
    dashboardPanels?: DashboardPanelDTO[] | undefined;

    constructor(data?: IDashboardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageData = _data["imageData"];
            this.tabGroupIndex = _data["tabGroupIndex"];
            if (Array.isArray(_data["dashboardPanels"])) {
                this.dashboardPanels = [] as any;
                for (let item of _data["dashboardPanels"])
                    this.dashboardPanels!.push(DashboardPanelDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageData"] = this.imageData;
        data["tabGroupIndex"] = this.tabGroupIndex;
        if (Array.isArray(this.dashboardPanels)) {
            data["dashboardPanels"] = [];
            for (let item of this.dashboardPanels)
                data["dashboardPanels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDashboardDTO {
    id: number;
    name: string;
    imageData?: string | undefined;
    tabGroupIndex?: number | undefined;
    dashboardPanels?: DashboardPanelDTO[] | undefined;
}

export class DashboardPanelDTO implements IDashboardPanelDTO {
    id!: number;
    sizeX!: number;
    sizeY!: number;
    row!: number;
    col!: number;
    widgetType?: string | undefined;
    widgetParameters?: string | undefined;

    constructor(data?: IDashboardPanelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sizeX = _data["sizeX"];
            this.sizeY = _data["sizeY"];
            this.row = _data["row"];
            this.col = _data["col"];
            this.widgetType = _data["widgetType"];
            this.widgetParameters = _data["widgetParameters"];
        }
    }

    static fromJS(data: any): DashboardPanelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardPanelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sizeX"] = this.sizeX;
        data["sizeY"] = this.sizeY;
        data["row"] = this.row;
        data["col"] = this.col;
        data["widgetType"] = this.widgetType;
        data["widgetParameters"] = this.widgetParameters;
        return data;
    }
}

export interface IDashboardPanelDTO {
    id: number;
    sizeX: number;
    sizeY: number;
    row: number;
    col: number;
    widgetType?: string | undefined;
    widgetParameters?: string | undefined;
}

export class UpdateDashboardPanelsDTO implements IUpdateDashboardPanelsDTO {
    dashboardId!: number;
    addedPanels?: DashboardPanelDTO[] | undefined;
    changedPanels?: DashboardPanelDTO[] | undefined;
    removedPanelIds?: number[] | undefined;

    constructor(data?: IUpdateDashboardPanelsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardId = _data["dashboardId"];
            if (Array.isArray(_data["addedPanels"])) {
                this.addedPanels = [] as any;
                for (let item of _data["addedPanels"])
                    this.addedPanels!.push(DashboardPanelDTO.fromJS(item));
            }
            if (Array.isArray(_data["changedPanels"])) {
                this.changedPanels = [] as any;
                for (let item of _data["changedPanels"])
                    this.changedPanels!.push(DashboardPanelDTO.fromJS(item));
            }
            if (Array.isArray(_data["removedPanelIds"])) {
                this.removedPanelIds = [] as any;
                for (let item of _data["removedPanelIds"])
                    this.removedPanelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateDashboardPanelsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDashboardPanelsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardId"] = this.dashboardId;
        if (Array.isArray(this.addedPanels)) {
            data["addedPanels"] = [];
            for (let item of this.addedPanels)
                data["addedPanels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.changedPanels)) {
            data["changedPanels"] = [];
            for (let item of this.changedPanels)
                data["changedPanels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.removedPanelIds)) {
            data["removedPanelIds"] = [];
            for (let item of this.removedPanelIds)
                data["removedPanelIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateDashboardPanelsDTO {
    dashboardId: number;
    addedPanels?: DashboardPanelDTO[] | undefined;
    changedPanels?: DashboardPanelDTO[] | undefined;
    removedPanelIds?: number[] | undefined;
}

export class CreateDashboardDTO implements ICreateDashboardDTO {
    name?: string | undefined;
    imageData?: string | undefined;
    tabGroupIndex?: number | undefined;

    constructor(data?: ICreateDashboardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.imageData = _data["imageData"];
            this.tabGroupIndex = _data["tabGroupIndex"];
        }
    }

    static fromJS(data: any): CreateDashboardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDashboardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["imageData"] = this.imageData;
        data["tabGroupIndex"] = this.tabGroupIndex;
        return data;
    }
}

export interface ICreateDashboardDTO {
    name?: string | undefined;
    imageData?: string | undefined;
    tabGroupIndex?: number | undefined;
}

export class UpdateDashboardDTO implements IUpdateDashboardDTO {
    id!: number;
    name?: string | undefined;
    imageData?: string | undefined;
    tabGroupIndex?: number | undefined;

    constructor(data?: IUpdateDashboardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageData = _data["imageData"];
            this.tabGroupIndex = _data["tabGroupIndex"];
        }
    }

    static fromJS(data: any): UpdateDashboardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDashboardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageData"] = this.imageData;
        data["tabGroupIndex"] = this.tabGroupIndex;
        return data;
    }
}

export interface IUpdateDashboardDTO {
    id: number;
    name?: string | undefined;
    imageData?: string | undefined;
    tabGroupIndex?: number | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}